
  function ssFrameGo(f,u){if(!f)return;var a=new URL(u,location.href).href;f.__ssHref=a;try{if(f.getAttribute("src")&&f.contentWindow){f.contentWindow.location.replace(a);return}}catch(e){}f.src=a}
function ssFrameHref(f){return f.__ssHref||f.src}
  function spaceTitle(value){return String(value==null?'':value).replace(/&(#(?:[xX][0-9a-fA-F]+|[0-9]+)|[a-zA-Z][a-zA-Z0-9]*);/g,function(whole,name){if(name[0]==='#'){var n=name[1].toLowerCase()==='x'?parseInt(name.slice(2),16):Number(name.slice(1));return n>0&&n<=0x10ffff&&!(n>=0xd800&&n<=0xdfff)?String.fromCodePoint(n):whole}var d=document.createElement('textarea');d.innerHTML=whole;return d.value})}
  var commentAuthor=function commentAuthor(c) {
  const marker = c.via === "claude" ? "AI" : c.via === "co-shepherd" ? "AGENT" : c.via === "session" ? "SESSION" : null;
  if (marker) {
    const source = c.via === "session" ? /^session:([a-z0-9-]+):/.exec(String(c.run_id || ""))?.[1] : void 0;
    const harness = source === "claude-code" ? "Claude Code" : source === "codex" ? "Codex" : source === "gemini-cli" ? "Gemini CLI" : source === "antigravity" ? "Antigravity" : null;
    if (c.via === "session") return { name: c.agent_label?.trim() || harness || "Coding session", marker };
    if (c.via === "co-shepherd") return { name: "Shepherd", marker };
    const name = c.agent_label?.trim() || c.author_name?.trim() || c.author_username?.trim() || c.author_email?.split("@")[0].trim() || "An agent";
    return { name, marker };
  }
  return { name: c.author_name || c.author_email?.split("@")[0] || "Someone", marker: null };
};
  (function(){
    var V=JSON.parse((document.currentScript&&document.currentScript.getAttribute("data-v"))||"{}");
    var t=V.ticket,co=V.co,spaceId=V.id,myEmail=V.email,myUser=V.user,myName=V.name||null,myPic=V.pic||null,used=false,ANON=V.anon;
    var SHEEP="<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"13.26 13.26 133.48 133.48\" aria-hidden=\"true\" focusable=\"false\"><path fill=\"#43434b\" d=\"M28.48 42.52H71.98V27.89H86.61V42.52H131.52V71.77H116.89V117.48H101.24V146.74H57.35V117.48H43.11V71.77H28.48Z\"/><path fill=\"#d58e9e\" d=\"M57.35 13.26h14.63v29.26H57.35zM86.61 13.26h14.63v29.26H86.61zM71.98 117.48h14.63v14.63H71.98z\"/><path fill=\"#ebeae6\" d=\"M57.35 71.77h14.63v14.63H57.35zM86.61 71.77h14.63v14.63H86.61z\"/></svg>";
    // "@session" in a comment reaches the coding session that made the page — for its
    // owner with Talk on (V.talk); its answer lands as a reply via "session".
    var TALK=V.talk===true,PROMPT_ICON="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 16 16\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M3 4.5l3.5 3.5L3 11.5M8.5 11.5h4.5\"/></svg>";
    var SESS_ICONS={"claude-code":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"currentColor\" aria-hidden=\"true\"><path d=\"m4.7144 15.9555 4.7174-2.6471.079-.2307-.079-.1275h-.2307l-.7893-.0486-2.6956-.0729-2.3375-.0971-2.2646-.1214-.5707-.1215-.5343-.7042.0546-.3522.4797-.3218.686.0608 1.5179.1032 2.2767.1578 1.6514.0972 2.4468.255h.3886l.0546-.1579-.1336-.0971-.1032-.0972L6.973 9.8356l-2.55-1.6879-1.3356-.9714-.7225-.4918-.3643-.4614-.1578-1.0078.6557-.7225.8803.0607.2246.0607.8925.686 1.9064 1.4754 2.4893 1.8336.3643.3035.1457-.1032.0182-.0728-.164-.2733-1.3539-2.4467-1.445-2.4893-.6435-1.032-.17-.6194c-.0607-.255-.1032-.4674-.1032-.7285L6.287.1335 6.6997 0l.9957.1336.419.3642.6192 1.4147 1.0018 2.2282 1.5543 3.0296.4553.8985.2429.8318.091.255h.1579v-.1457l.1275-1.706.2368-2.0947.2307-2.6957.0789-.7589.3764-.9107.7468-.4918.5828.2793.4797.686-.0668.4433-.2853 1.8517-.5586 2.9021-.3643 1.9429h.2125l.2429-.2429.9835-1.3053 1.6514-2.0643.7286-.8196.85-.9046.5464-.4311h1.0321l.759 1.1293-.34 1.1657-1.0625 1.3478-.8804 1.1414-1.2628 1.7-.7893 1.36.0729.1093.1882-.0183 2.8535-.607 1.5421-.2794 1.8396-.3157.8318.3886.091.3946-.3278.8075-1.967.4857-2.3072.4614-3.4364.8136-.0425.0304.0486.0607 1.5482.1457.6618.0364h1.621l3.0175.2247.7892.522.4736.6376-.079.4857-1.2142.6193-1.6393-.3886-3.825-.9107-1.3113-.3279h-.1822v.1093l1.0929 1.0686 2.0035 1.8092 2.5075 2.3314.1275.5768-.3218.4554-.34-.0486-2.2039-1.6575-.85-.7468-1.9246-1.621h-.1275v.17l.4432.6496 2.3436 3.5214.1214 1.0807-.17.3521-.6071.2125-.6679-.1214-1.3721-1.9246L14.38 17.959l-1.1414-1.9428-.1397.079-.674 7.2552-.3156.3703-.7286.2793-.6071-.4614-.3218-.7468.3218-1.4753.3886-1.9246.3157-1.53.2853-1.9004.17-.6314-.0121-.0425-.1397.0182-1.4328 1.9672-2.1796 2.9446-1.7243 1.8456-.4128.164-.7164-.3704.0667-.6618.4008-.5889 2.386-3.0357 1.4389-1.882.929-1.0868-.0062-.1579h-.0546l-6.3385 4.1164-1.1293.1457-.4857-.4554.0608-.7467.2307-.2429 1.9064-1.3114Z\"/></svg>",codex:"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"currentColor\" aria-hidden=\"true\"><path d=\"M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z\"/></svg>"};
    var SESS_AGENT={"claude-code":"Claude Code",codex:"Codex","gemini-cli":"Gemini CLI",antigravity:"Antigravity"};
    // The agent that answers comments has one name and one handle the composer offers
    // (shared/comment-author.ts); any of AGENT_HANDLES asks it, and each draws as its name.
    var AGENT_NAME="Shepherd",AGENT_HANDLE="shepherd",AGENT_HANDLES=["shepherd","spacesheep","co-shepherd"];
    var comments=[],reactions=[],anchorReactions=[],sidebarOpen=false;
    
    function ssSidebarState(spaceId,panel){
      var key="ss-sidebar-"+spaceId+"-"+panel;
      return {
        read:function(){
          try{var value=localStorage.getItem(key);return value==="1"?true:value==="0"?false:null}catch(e){return null}
        },
        changed:function(open,source){
          if(source==="temporary")return;
          if(!source){try{localStorage.setItem(key,open?"1":"0")}catch(e){}}
          if(window.mixpanel)try{mixpanel.track(source==="restore"?"Viewer Sidebar Restored":open?"Viewer Sidebar Opened":"Viewer Sidebar Closed",{space_id:spaceId,panel:panel,open:open,source:source||"interaction"})}catch(e){}
        }
      };
    }

    var sidebarState=ssSidebarState(spaceId,"comments");
    // The comment button and live commenting (comment-corner-flag.ts). The arm rides
    // every Mixpanel event from this page, so the comment rate splits by it. The state
    // the corner and the live layer share is declared here, before anything can call
    // into it: the corner's Annotate, a held button's dictation, when each comment
    // arrived live, whose pin shows with the rail shut until when, and who is writing.
    var CORNER=V.corner,corner={on:false},voice=null,peekReply=null,arrived={},livePin={},liveReply={},drafts={};
    // The Co-shepherd tab experiment's arm rides along the same way, so "AI Chat
    // Message" and the drawer's other events split by it too; so does the ⋯ test's
    // (more-tint), so "UI Control Used" splits by it.
    if(window.mixpanel)try{mixpanel.register({comment_corner:V.cornerArm,coshepherd_tab:V.coshTab,more_tint:V.moreTint})}catch(x){}
    // May this reader change the page? Only what the hint in the composer says
    // when they address the Co-shepherd — the route decides for real.
    var CAN_EDIT=V.canEdit;
    // Lifecycle email links (docs/superpowers/specs/2026-09-27-lifecycle-series-design.md):
    // ?ask= fills a composer and never sends; ?at= pins it to a block (step 3). Only an
    // editor gets the prefill. The params leave the address bar at once, so a reload or a
    // forwarded link doesn't reopen anything.
    var lcQs=new URLSearchParams(location.search),lcAsk=(lcQs.get("ask")||"").slice(0,500),lcAt=lcQs.get("at")||"",lcLe=lcQs.get("le")||"";
    // ?chat=1 — the dashboard composer sent the person here to watch a build: the
    // Co-shepherd panel opens on its own once the shell is up (desktop; on a phone
    // the page is the whole screen). A shell-only parameter like the others: the
    // document never sees it, and it leaves the address at once.
    var lcChat=lcQs.get("chat")==="1";window.__ssWantChat=lcChat;
    // Signed out (the owner on another browser): the ask would be dropped, so sign in
    // first and come back to this exact address, ask/at/le included.
    if(lcAsk&&ANON){location.replace("/signin?next="+encodeURIComponent(location.pathname+location.search+location.hash));return}
    if(lcLe&&window.mixpanel)try{var lcP=lcLe.split(".");mixpanel.track("Lifecycle Email Clicked",{send_id:lcP[0],card:lcP[1]||"",step:Number((lcQs.get("utm_content")||"").replace("step",""))||null,space_id:spaceId})}catch(x){}
    if(lcAsk||lcAt||lcLe||lcChat){["ask","at","le","chat"].forEach(function(k){lcQs.delete(k)});var lcQ=lcQs.toString();history.replaceState(history.state,"",location.pathname+(lcQ?"?"+lcQ:"")+location.hash)}
    var lcPendingPin=null,lcOrderTimer=null;
    if(lcAsk&&CAN_EDIT){
      if(lcAt)lcPendingPin={at:lcAt,text:lcAsk};
      else (function tryAsk(n){if(window.ssChatAsk)window.ssChatAsk(lcAsk);else if(n<50)setTimeout(function(){tryAsk(n+1)},100)})(0);
    }
    // The frame is cross-origin, so we can't look at its DOM to see whether the
    // block ?at= names still exists — but ss-anchor-order (sent in reply to the
    // ss-comment-markers we push right after ss-anchor-ready) already carries
    // every data-ss-id on the page. Wait for the first one (or 3s, whichever
    // comes first) before deciding: pin the composer to the block if it's still
    // there, otherwise fall back to the whole-page composer rather than opening
    // a pin on a block that's gone — and the same fallback covers a draft
    // already open (openCompose refuses and shakes rather than replacing it).
    function lcWholePage(text){
      if(!sidebarOpen)toggleSidebar(true);
      composeText.value=text;window.ssAutoGrow(composeText);composeSend.disabled=!composeText.value.trim();composeText.focus();
    }
    function lcApplyPin(){
      if(!lcPendingPin)return;
      clearTimeout(lcOrderTimer);
      var lcp=lcPendingPin;lcPendingPin=null;
      if(compose&&cmpText.value.trim()){lcWholePage(lcp.text);return}
      if(anchorOrder.hasOwnProperty(lcp.at))openCompose({anchorId:lcp.at,tag:"",x:1,y:0,quote:"",near:"",anchorText:"",path:"",px:0,py:0,rect:null,via:"email",seed:lcp.text});
      else lcWholePage(lcp.text);
    }
    var PHONE_MQ=window.matchMedia("(max-width: 640px)");
    // Pin comments (Annotate in the code): on, a click on the page pins a comment.
    // The corner button, the rail's switch and C turn it on and off; opening the
    // rail leaves it off so the page reads and its links work; closing the rail ends it.
    var annotate=false,away=false;
    // Reading order of the page's blocks (ss-anchor-order), which pin the rail's
    // card is hovering or holding, and the composer open on a spot right now.
    var anchorOrder={},hotId=null,focusId=null,compose=null;
    // Co-shepherd turns asked for from a thread: run id → {root, status, message}.
    var pending={};
    var REACTIONS=["👍","👎","❤️","🎉","🚀","👀","💯","🔥","⚡","✅","❌","😂","🤔","😍","🙏","💡","⭐","🌮","📌","💬","🐑"];
    var IS_OWNER=V.owner;
    // Owner or invited: who may resolve someone else's thread (see onRoster above).
    var ON_ROSTER=V.roster;
    // The four the frame shows first on a block's hover pill and section strip.
    var QUICK=["👍","❤️","🔥","🤔"];
    // "Allow reactions on the page" (owner preference, per space). It rides down with
    // every markers message, so the frame locks or unlocks live. Off is a freeze, not
    // an erase: existing reactions stay on the page as plain counts and only new ones
    // are refused (the route enforces the same, in case of a stale tab). The palette
    // keeps arming the comment affordances either way, so this never costs a reader
    // the way in to a comment.
    var ELEM_RX=V.elemRx;
    // The hover pill switched off platform-wide (BLOCK_REACTIONS): no palette goes
    // down, which is what arms the pill, and none of the existing reactions ride down,
    // so no chip is drawn for them either.
    var BLOCK_RX=false;
    // Anonymous open space: nothing in this closure applies. Still answer the frame's
    // auth-request — with "no session" rather than silence, so it stops waiting out its
    // timeout and mounting a floating "Sign in to comment" pill next to the header's own
    // Sign in button. auth-none is additive; a frame too old to know it just times out.
    // Door-to-door: navigation start → the framed document's anchor script says hello.
    // That is the moment the reader has the page, whatever it took to get there (the
    // shell, a first-visit ticket handshake, the content serve). Reported once per
    // load, by beacon, into the same latency ledger the workers write; edits and
    // version swaps re-announce the frame and are not loads.
    (function(){
      var sent=false;
      window.addEventListener("message",function(e){
        if(sent||e.origin!==co||!e.data||e.data.type!=="ss-anchor-ready")return;
        sent=true;
        try{
          // A message the early frame sent before this shell listened was held and
          // handed over later (early-frame.ts): its time is when it arrived.
          var ms=Math.round(e.ssAt||performance.now());
          var body=JSON.stringify({ms:ms,tier:V.tier,hs:window.__ssHandshake===true,ef:!!(window.__ssEarly&&window.__ssEarly.used)});
          if(navigator.sendBeacon)navigator.sendBeacon("/api/load-timing",new Blob([body],{type:"application/json"}));
          else fetch("/api/load-timing",{method:"POST",headers:{"Content-Type":"application/json"},body:body,keepalive:true}).catch(function(){});
        }catch(_){}
      });
    })();
    // ===== Which page of the space is open =====
    // The frame's own URL is the content origin's — a uuid host, version-pinned —
    // which is not an address to show anyone. So the frame reports its position
    // inside the space (anchor.js, ss-path) and that is mirrored here as
    // /@handle/slug/-/<page>. "-" can never be a slug (slugify strips dashes at both
    // ends), so the separator stays unambiguous however deep the namespace grows.
    // replaceState, not pushState: the frame navigation already pushed its own entry
    // onto the joint session history, so Back works — pushing again would need two.
    var VIEWBASE=V.viewBase,FRAMEBASE=V.frameBase,SUBPATH=V.subPath;
    // A space that gets its name while open (sheep.new's first ask) moves address;
    // a later page report must build on the new one, not put the id back.
    window.addEventListener("ss:renamed",function(e){var u=e.detail&&e.detail.url;if(VIEWBASE&&VIEWBASE.indexOf("/@")===0&&typeof u==="string"&&u.indexOf("/@")===0)VIEWBASE=u});
    // "View as a visitor": the row opens the page you're on now (the frame may have
    // moved since the render), the pill measures how long the look lasted.
    (function(){
      var vb=document.getElementById("visitorBtn");
      if(vb)vb.addEventListener("click",function(){
        try{var u=new URL(location.href);u.searchParams.set("visitor","1");vb.href=u.pathname+u.search+u.hash}catch(_){}
        try{if(window.mixpanel)mixpanel.track("Visitor View Opened",{space_id:V.id,tier:V.tier})}catch(_){}
      });
      var vx=document.getElementById("visitorExit"),t0=Date.now();
      if(vx)vx.addEventListener("click",function(){
        try{var u=new URL(location.href);u.searchParams.delete("visitor");vx.href=u.pathname+u.search+u.hash}catch(_){}
        try{if(window.mixpanel)mixpanel.track("Visitor View Exited",{space_id:V.id,ms:Date.now()-t0})}catch(_){}
      });
    })();
    // The client half of joinSub() — keep the two in step.
    function withSub(base){
      if(!SUBPATH)return base;
      var q=base.indexOf("?"),head=q<0?base:base.slice(0,q),tail=q<0?"":base.slice(q+1);
      var u=head.replace(/\/$/,"")+"/"+SUBPATH;
      return tail?u+(u.indexOf("?")<0?"?":"&")+tail:u;
    }
    (function(){
      if(!VIEWBASE)return;
      // A reported path only ever builds a same-origin URL, never a fetch — but it
      // comes from the framed document, so it is checked before it reaches the
      // address bar: nothing that could carry a scheme, a host, or a climb out.
      function clean(v){
        var p=String(v||"").replace(/^\/+/,"");
        if(!p)return "";
        if(p.length>512||p.indexOf("\\")>=0||p.indexOf("//")>=0||/(^|\/)\.\.(\/|$)/.test(p))return null;
        if(!/^[A-Za-z0-9._~!$&'()*+,;=:@%\/?-]+$/.test(p))return null;
        return p;
      }
      window.addEventListener("message",function(e){
        if(e.origin!==co||!e.data||e.data.type!=="ss-path")return;
        var p=clean(e.data.path);
        // The beta frame's routing mark (shared/release.ts BETA_PARAM) is not part of
        // the page: an older page script reports it, and it must not reach the address bar.
        // So is a visitor preview's (shared/visitor-preview.ts); the address keeps ?visitor=1.
        var bi=p?p.indexOf("?"):-1;
        if(bi>=0&&(p.indexOf("ss_beta=",bi)>=0||p.indexOf("ss_visitor=",bi)>=0)){var bq=new URLSearchParams(p.slice(bi));bq.delete("ss_beta");bq.delete("ss_visitor");p=p.slice(0,bi)+(bq.toString()?"?"+bq.toString():"")}
        if(p===null||p===SUBPATH)return;
        SUBPATH=p;
        // The page's own query rides in the outer query: a URL has one "?", and the
        // path half is what /-/ carries.
        var i=p.indexOf("?"),path=i<0?p:p.slice(0,i),search=i<0?"":p.slice(i);
        // Keep the workspace when a document changes page or the viewer reloads.
        var params=new URLSearchParams(search);
        params.delete("from_team");
        if(V.fromTeam)params.set("from_team",V.fromTeam);
        if(V.visitor)params.set("visitor","1");
        search=params.toString()?"?"+params.toString():"";
        try{history.replaceState(null,"",VIEWBASE+(path?"/-/"+path:"")+search+(location.hash||""))}catch(_){}
      });
      // Ask on every frame load. The first page's own report can only be addressed to
      // the primary app origin, so on an org host it never arrives; this probe comes
      // FROM the real host, which is how the frame learns where to answer.
      var cf=document.getElementById("content");
      if(cf)cf.addEventListener("load",function(){
        try{cf.contentWindow.postMessage({type:"ss-where"},co)}catch(_){}
      });
    })();
    // Section links belong to every reader, including the anonymous early return.
    // Deep links: the URL fragment never leaves the browser, so forward the outer
    // page's #hash into the framed document (at load and on hashchange). Spaces
    // read their own location.hash for tabs/sections.
    (function(){
      window.addEventListener("message",function(e){
        var cf=document.getElementById("content");
        if(e.origin!==co||!cf||e.source!==cf.contentWindow||!e.data||e.data.type!=="ss-hash")return;
        // The frame's native hash navigation already added a joint history entry.
        // Replace its shell URL: pushing again would make Back take two clicks.
        // replaceState also avoids bouncing the fragment back through fwdHash.
        var hh=String(e.data.hash||"");
        if(/^#[A-Za-z0-9_.=%&/-]*$/.test(hh))history.replaceState(history.state,"",location.pathname+location.search+(hh==="#"?"":hh));
      });
      function fwdHash(){var cf=document.getElementById("content");if(!cf)return;var cur=ssFrameHref(cf),parts=cur.split("#");if(("#"+(parts[1]||""))===(location.hash||"#"))return;ssFrameGo(cf,parts[0]+(location.hash||""))}
      if(location.hash)fwdHash();
      window.addEventListener("hashchange",fwdHash);
    })();
    // A frame that asked who is reading before this script ran asked nobody — a message
    // with no listener is simply gone — so say we are here once we listen, and the
    // frame asks again (packages/content/src/frame-auth.ts). Posted just before the
    // listener goes on: the frame's answer can only arrive in a later task.
    function authReady(){try{var f=document.getElementById("content");if(f&&f.contentWindow)f.contentWindow.postMessage({type:"auth-ready"},co)}catch(x){}}
    if(ANON){
      authReady();
      window.addEventListener("message",function(e){
        if(e.origin===co&&e.data&&e.data.type==="auth-request"&&e.source)e.source.postMessage({type:"auth-none"},co);
      });
      return;
    }
    var SS_AVATAR_COLORS=["#7a7aff","#ff6b6b","#51cf66","#ffd43b","#ff922b","#cc5de8","#22b8cf","#ff6b8a"];
function ssAvatarColor(seed){seed=String(seed==null?'':seed);for(var h=0,i=0;i<seed.length;i++)h+=seed.charCodeAt(i);return SS_AVATAR_COLORS[h%SS_AVATAR_COLORS.length]}
var SS_AVATAR_HOSTS=["spacesheep.dev","spacesheep.app","stagesheep.dev","stagesheep.com","localhost"],SS_AVATAR_PATH=/^\/avatar\/[A-Za-z0-9-]+$/;
function ssAvatarPhoto(url){url=String(url||'');if(url.charAt(0)==='/')return SS_AVATAR_PATH.test(url);if(url.indexOf('https://')!==0)return false;var u;try{u=new URL(url)}catch(e){return false}var h=u.hostname.toLowerCase().replace(/[.]+$/,''),ours=h==='127.0.0.1'||h==='[::1]'||h==='0.0.0.0';for(var i=0;!ours&&i<SS_AVATAR_HOSTS.length;i++){var d=SS_AVATAR_HOSTS[i];ours=h===d||h.slice(-d.length-1)==='.'+d}return !ours||(SS_AVATAR_PATH.test(u.pathname)&&!u.search&&!u.hash&&!u.username&&!u.password)}
function ssAvatarEsc(s){return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;')}
function ssAvatarInitial(name,seed){var s=String(name||seed||'?').trim().replace(/^@+ */,'')||'?',c='';try{var g=new Intl.Segmenter().segment(s)[Symbol.iterator]().next().value;c=g?g.segment:''}catch(e){}return (c||Array.from(s)[0]||'?').toUpperCase()}
function ssAvatar(o){o=o||{};
var cls='ss-av ss-av-'+(o.size||'md')+(o.team?' ss-av-team':'')+(o.className?' '+o.className:'');
var photo=ssAvatarPhoto(o.picture);
var inner=photo?'<img src="'+ssAvatarEsc(o.picture)+'" alt="" loading="lazy">':ssAvatarEsc(o.glyph||ssAvatarInitial(o.name,o.seed));
var style=(photo||o.glyph)?'':' style="background:'+ssAvatarColor(o.seed||o.name)+'"';
var id=o.id?' id="'+ssAvatarEsc(o.id)+'"':'';
return o.href?'<a class="'+cls+'"'+id+' href="'+ssAvatarEsc(o.href)+'"'+style+'>'+inner+'</a>':'<span class="'+cls+'"'+id+style+'>'+inner+'</span>'}
    // A comment's pictures open full size over the page (assets/components/lightbox.ts);
    // the link's href stays the way in with a modifier key or no script.
    (function(){
  if (window.ssLightbox) return;
  var box = null, img = null, closeBtn = null, lastFocused = null;
  var filePanel, fileTitle, download, content, pending = null, blobUrl = null, generation = 0;
  // Built once, on the first open. Before that a page carries no overlay DOM at all.
  function build(){
    if (box) return;
    box = document.createElement('div');
    box.className = 'ss-lb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Image preview');
    box.hidden = true;
    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ss-lb-close';
    closeBtn.setAttribute('aria-label', 'Close image preview');
    closeBtn.textContent = '\u00d7';
    img = document.createElement('img');
    img.alt = '';
    box.appendChild(closeBtn);
    box.appendChild(img);
    filePanel = document.createElement('section');
    filePanel.className = 'ss-lb-file'; filePanel.hidden = true;
    var toolbar = document.createElement('div'); toolbar.className = 'ss-lb-toolbar';
    fileTitle = document.createElement('span'); fileTitle.className = 'ss-lb-title';
    download = document.createElement('a'); download.className = 'ss-lb-download';
    download.textContent = 'Download'; download.setAttribute('download', '');
    toolbar.appendChild(fileTitle); toolbar.appendChild(download);
    content = document.createElement('div'); content.className = 'ss-lb-content';
    filePanel.appendChild(toolbar); filePanel.appendChild(content); box.appendChild(filePanel);
    // The backdrop is the dismiss target; a click that lands on the picture itself
    // must not close it, which is what the cursor (zoom-out vs default) promises.
    box.addEventListener('click', function(e){ if (e.target === box) close(); });
    closeBtn.addEventListener('click', close);
    document.body.appendChild(box);
  }
  function open(src, alt){
    if (!src) return;
    build();
    resetFile();
    lastFocused = document.activeElement;
    img.hidden = false; filePanel.hidden = true;
    box.setAttribute('aria-label', 'Image preview');
    closeBtn.setAttribute('aria-label', 'Close image preview');
    img.setAttribute('src', src);
    img.setAttribute('alt', alt || 'Image preview');
    box.hidden = false;
    document.body.classList.add('ss-lb-open');
    closeBtn.focus();
    if (window.mixpanel) window.mixpanel.track('Attachment Preview Opened', {media_type: 'image', surface: 'lightbox'});
  }
  function resetFile(){
    generation++;
    if (pending) pending.abort();
    pending = null;
    if (content) content.replaceChildren();
    if (blobUrl) URL.revokeObjectURL(blobUrl);
    blobUrl = null;
  }
  function openFile(src, type, name){
    var url;
    try { url = new URL(src, location.href); } catch (_) { return; }
    if (url.origin !== location.origin || ['text/plain','text/markdown','application/pdf'].indexOf(type) < 0) return;
    build();
    resetFile();
    var current = generation;
    lastFocused = document.activeElement;
    img.hidden = true; img.removeAttribute('src'); filePanel.hidden = false;
    fileTitle.textContent = name || 'Document';
    download.href = url.href;
    box.setAttribute('aria-label', name || 'Document preview');
    closeBtn.setAttribute('aria-label', 'Close document preview');
    box.hidden = false; document.body.classList.add('ss-lb-open'); closeBtn.focus();
    var status = document.createElement('div'); status.className = 'ss-lb-status';
    status.setAttribute('role', 'status'); status.textContent = 'Loading document…'; content.appendChild(status);
    pending = new AbortController();
    fetch(url.href, {signal: pending.signal}).then(function(r){
      if (!r.ok) throw new Error('Unable to load this document.');
      return r.blob();
    }).then(function(blob){
      if (current !== generation) return;
      if (type === 'application/pdf'){
        blobUrl = URL.createObjectURL(new Blob([blob], {type: 'application/pdf'}));
        var frame = document.createElement('iframe');
        frame.title = name || 'PDF preview';
        frame.src = blobUrl;
        content.replaceChildren(frame);
        // The download stays available on browsers without an embedded PDF reader.
      } else {
        // A bounded source preview keeps large logs responsive; Download keeps the full file.
        return blob.slice(0, 1024 * 1024).text().then(function(text){
          if (current !== generation) return;
          var pre = document.createElement('pre'); pre.tabIndex = 0;
          pre.textContent = text;
          content.replaceChildren(pre);
          if (blob.size > 1024 * 1024){
            status.textContent = 'Showing the first 1 MB. Download to read the full file.';
            content.prepend(status);
          }
        });
      }
    }).catch(function(error){
      if (current !== generation || error.name === 'AbortError') return;
      status.textContent = 'Unable to preview this document. Try downloading it.';
      content.replaceChildren(status);
    });
    if (window.mixpanel) window.mixpanel.track('Attachment Preview Opened', {media_type: type});
  }
  function close(){
    if (!box || box.hidden) return;
    box.hidden = true;
    resetFile();
    document.body.classList.remove('ss-lb-open');
    // Dropped so a closed overlay holds no bytes, and so reopening cannot flash the
    // previous picture while the new one decodes.
    img.removeAttribute('src');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    lastFocused = null;
  }
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && box && !box.hidden) { e.preventDefault(); close(); }
    if (e.key === 'Tab' && box && !box.hidden) {
      var focusable = Array.from(box.querySelectorAll('button,a[href],iframe,[tabindex="0"]')).filter(function(el){ return el.getClientRects().length; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  // Delegated: the trigger may be the picture, or a link wrapping it (the feed's
  // anchors keep an href so the picture is still reachable with no JS — which is
  // exactly why this preventDefault only fires once an image was actually found).
  document.addEventListener('click', function(e){
    var t = e.target;
    if (!t || !t.closest) return;
    var fileTrigger = t.closest('[data-lightbox-file]');
    if (fileTrigger && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey){
      e.preventDefault();
      openFile(fileTrigger.href, fileTrigger.getAttribute('data-lightbox-file'), fileTrigger.textContent);
      return;
    }
    var trigger = t.closest('[data-lightbox]');
    if (!trigger) return;
    var pic = trigger.tagName === 'IMG' ? trigger : trigger.querySelector('img');
    var src = pic && (pic.currentSrc || pic.getAttribute('src'));
    if (!src) return;
    e.preventDefault();
    open(src, pic.getAttribute('alt'));
  });
  window.ssLightbox = { open: open, close: close };
  window.ssLightbox.openFile = openFile;
})();
    function esc(s){var d=document.createElement("div");d.textContent=s;return d.innerHTML.replace(/"/g,"&quot;").replace(/'/g,"&#39;")}
    function relTime(iso){var d=(Date.now()-new Date(iso).getTime())/1e3;if(d<60)return"now";if(d<3600)return Math.floor(d/60)+"m";if(d<86400)return Math.floor(d/3600)+"h";return Math.floor(d/86400)+"d"}
    // Escape, then wrap @handles in a pill (highlighting a mention of yourself).
    // Pictures in a comment (comment-images.ts): pasted or dropped into any comment
    // box, uploaded the moment they land (shrunk first, as /feedback's are), and
    // posted with the words. One tray per composer; the card draws them under the text.
    var TRAY_MAX=4,TRAY_TYPES={"image/png":1,"image/jpeg":1,"image/webp":1,"image/gif":1};
    function picUrl(k){return "/api/space/"+encodeURIComponent(spaceId)+"/comment-images/"+encodeURIComponent(k)}
    function cmtPics(c){
      var ims=c.images||[];if(!ims.length)return "";
      return '<div class="cmt-pics n'+Math.min(ims.length,4)+'">'+ims.map(function(im){
        var wh=im.width&&im.height?' width="'+(+im.width)+'" height="'+(+im.height)+'"':"";
        return '<a class="cmt-pic" data-lightbox href="'+picUrl(im.key)+'" target="_blank" rel="noopener" title="Open the image"><img src="'+picUrl(im.key)+'" alt="Image in the comment" loading="lazy"'+wh+'></a>';
      }).join("")+'</div>';
    }
    function imgSize(url){return new Promise(function(res){var im=new Image();im.onload=function(){res({width:im.naturalWidth,height:im.naturalHeight})};im.onerror=function(){res(null)};im.src=url})}
    function makeTray(){
      var t={items:[],el:document.createElement("div"),onChange:null};
      t.el.className="cmt-tray";t.el.hidden=true;
      t.keys=function(){return t.items.filter(function(i){return i.key}).map(function(i){return i.key})};
      // The uploaded images as the server described them (key, size): what the
      // comment card draws before the post has answered (optimisticRow).
      t.pics=function(){return t.items.filter(function(i){return i.key}).map(function(i){return i.img||{key:i.key}})};
      t.busy=function(){return t.items.some(function(i){return!i.key})};
      t.draw=function(){
        t.el.hidden=!t.items.length;
        t.el.innerHTML=t.items.map(function(i,n){return '<span class="cmt-tray-item'+(i.key?"":" up")+'"><img src="'+i.url+'" alt=""><button type="button" class="cmt-tray-x" data-n="'+n+'" aria-label="Remove this image">&times;</button></span>'}).join("");
        if(t.onChange)t.onChange();
      };
      t.clear=function(){t.items.forEach(function(i){i.gone=true;try{URL.revokeObjectURL(i.url)}catch(x){}});t.items=[];t.draw()};
      t.el.addEventListener("click",function(e){
        var x=e.target.closest(".cmt-tray-x");if(!x)return;e.preventDefault();
        var it=t.items[+x.getAttribute("data-n")];if(!it)return;
        it.gone=true;try{URL.revokeObjectURL(it.url)}catch(y){}t.items.splice(t.items.indexOf(it),1);t.draw();
      });
      t.add=function(files){
        var n=0;
        for(var i=0;i<(files?files.length:0);i++){
          var f=files[i];if(!f||!TRAY_TYPES[f.type])continue;
          if(t.items.length>=TRAY_MAX){toast("Four images per comment");break}
          var it={url:URL.createObjectURL(f),key:null};t.items.push(it);n++;trayUpload(t,it,f);
        }
        if(n)t.draw();
        return n;
      };
      return t;
    }
    function trayUpload(t,it,f){
      var t0=Date.now();
      Promise.all([typeof ssShrinkImage==="function"?ssShrinkImage(f,f.type,{jpeg:true}):null,imgSize(it.url)]).then(function(r){
        var small=r[0],size=small&&small.width?{width:small.width,height:small.height}:r[1];
        var h={"Content-Type":small?small.type:f.type};
        if(size){h["X-Image-Width"]=String(size.width);h["X-Image-Height"]=String(size.height)}
        return fetch("/api/space/"+encodeURIComponent(spaceId)+"/comment-images",{method:"POST",headers:h,body:small?small.blob:f}).then(function(res){
          return res.json().catch(function(){return{}}).then(function(d){if(!res.ok||!d.image)throw new Error(d.error||"");return d.image});
        });
      }).then(function(img){
        if(it.gone)return;it.key=img.key;it.img=img;t.draw();
        if(window.mixpanel)try{mixpanel.track("Comment Image Attached",{space_id:spaceId,type:img.media_type,ms:Date.now()-t0})}catch(x){}
      },function(e){
        if(it.gone)return;it.gone=true;var n=t.items.indexOf(it);if(n>=0)t.items.splice(n,1);
        try{URL.revokeObjectURL(it.url)}catch(x){}t.draw();toast((e&&e.message)||"Couldn’t attach that image");
      });
    }
    function hasFiles(e){var ty=e.dataTransfer&&e.dataTransfer.types;if(!ty)return false;for(var i=0;i<ty.length;i++)if(ty[i]==="Files")return true;return false}
    function clipImages(cd){var out=[];if(!cd||!cd.items)return out;for(var i=0;i<cd.items.length;i++){var it=cd.items[i];if(it.kind==="file"){var f=it.getAsFile();if(f&&TRAY_TYPES[f.type])out.push(f)}}return out}
    // A composer's box takes a paste into its textarea and a drop anywhere on it; the
    // outline says where a dragged picture will land. A drop is stopped here, so a
    // reply box inside the rail doesn't also hand it to the page composer around it.
    function wireTray(ta,box,tray,hl){
      ta._tray=tray;hl=hl||box;
      ta.addEventListener("paste",function(e){var fs=clipImages(e.clipboardData);if(fs.length&&tray.add(fs))e.preventDefault()});
      // dragover fires every few dozen ms while a file is over the box, so the outline
      // stays while it keeps coming; counting enter/leave drifts across nested boxes.
      var off=null;
      function lit(){hl.classList.add("cmt-drop-on");clearTimeout(off);off=setTimeout(function(){hl.classList.remove("cmt-drop-on")},160)}
      box.addEventListener("dragenter",function(e){if(!hasFiles(e))return;e.preventDefault();e.stopPropagation();lit()});
      box.addEventListener("dragover",function(e){if(!hasFiles(e))return;e.preventDefault();e.stopPropagation();e.dataTransfer.dropEffect="copy";lit()});
      box.addEventListener("drop",function(e){if(!hasFiles(e))return;e.preventDefault();e.stopPropagation();clearTimeout(off);hl.classList.remove("cmt-drop-on");if(tray.add(e.dataTransfer.files))ta.focus()});
    }
    // A file dropped anywhere else in the shell would navigate the tab to it.
    window.addEventListener("dragover",function(e){if(hasFiles(e))e.preventDefault()});
    window.addEventListener("drop",function(e){if(hasFiles(e))e.preventDefault()});
    // Send is on when there are words or a picture that finished uploading, and none
    // still on its way.
    function canSend(ta){var t=ta&&ta._tray;if(t&&t.busy())return false;return!!(ta.value.trim()||(t&&t.keys().length))}
    function trayKeys(ta){return ta&&ta._tray?ta._tray.keys():[]}
    function trayPics(ta){return ta&&ta._tray?ta._tray.pics():[]}
    function trayClear(ta){if(ta&&ta._tray)ta._tray.clear()}
    // A comment reads as Markdown (the Co-shepherd panel's renderer, escape-first),
    // single newlines kept; @handles become pills in the words, never in code or a link.
    

    // Minimal, safe Markdown -> HTML. Input is HTML-escaped first, so nothing the
    // model emits can inject markup; only the tags we generate below are inserted.
    // Quotes too: the link rule below drops a URL into an href, and other people's
    // replies render here now.
    function mdEsc(s){return s.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}
    function mdInline(s){
      // One pass: code, link destinations and generated tags never get parsed again.
      return s.replace(/`([^`]+)`|(!?)\[([^\]]*)\]\((https?:\/\/[^)\s]+|\/api\/session-reply-images\/[0-9a-f]{64})\)|\*\*([^*]+)\*\*|__([^_]+)__|\*([^*\n]+)\*|https?:\/\/[^\s<>"']+/g,function(token,code,image,label,url,bold,under,em){
        if(code!==undefined)return '<code>'+code+'</code>';
        if(image==='!')return '<a data-lightbox href="'+url+'" target="_blank" rel="noopener noreferrer" aria-label="Open image: '+label+'"><img src="'+url+'" alt="'+label+'" loading="lazy" decoding="async" referrerpolicy="no-referrer"></a>';
        if(url!==undefined)return '<a href="'+url+'" target="_blank" rel="noopener noreferrer">'+label+'</a>';
        // Inside bold or emphasis the words are parsed again, so "**[title](url)**" —
        // how a model writes a list of pages — is a link, not brackets. The capture is
        // a slice of the already-escaped source and holds no asterisk, so this ends.
        if(bold!==undefined||under!==undefined)return '<strong>'+mdInline(bold===undefined?under:bold)+'</strong>';
        if(em!==undefined)return '<em>'+mdInline(em)+'</em>';
        // Sentence punctuation belongs after a bare link. Keep a URL's own
        // balanced parentheses (e.g. Wikipedia), peeling mixed tails like ").".
        var u=token,tail='',balance=(u.match(/\(/g)||[]).length-(u.match(/\)/g)||[]).length;
        while(u){
          var c=u.slice(-1);
          if(/[.,;:!?]/.test(c)){
            // mdEsc ran first: an entity's semicolon is part of its character.
            if(c===';'&&/&(?:amp|lt|gt|quot|#39);$/.test(u))break;
          }else if(c===')'&&balance<0)balance++;
          else break;
          tail=c+tail;u=u.slice(0,-1);
        }
        return '<a href="'+u+'" target="_blank" rel="noopener noreferrer">'+u+'</a>'+tail;
      });
    }
    // A table is a row with a pipe over a rule row ("|---|:--:|"), then every line
    // with a pipe until one without. Models write them for any comparison, and
    // without this their rows ran together as one paragraph of pipes.
    var MD_RULE=/^\s*\|?\s*:?-+:?\s*(\|\s*:?-+:?\s*)*\|?\s*$/;
    function mdIsTable(lines,i){return /\|/.test(lines[i])&&i+1<lines.length&&/\|/.test(lines[i+1])&&MD_RULE.test(lines[i+1])}
    function mdCells(line){
      // "\|" is a pipe inside a cell; it is held aside while the row is split.
      var s=line.trim().replace(/\\\|/g,"\u0000");
      if(s.charAt(0)==="|")s=s.slice(1);
      if(s.slice(-1)==="|")s=s.slice(0,-1);
      return s.split("|").map(function(c){return c.trim().replace(/\u0000/g,"|")});
    }
    function mdTable(rows){
      var head=mdCells(rows[0]),n=head.length;
      var al=mdCells(rows[1]).map(function(c){var l=c.charAt(0)===":",r=c.slice(-1)===":";return l&&r?' class="md-ac"':r?' class="md-ar"':""});
      function row(cs,tag){var h="<tr>";for(var x=0;x<n;x++)h+="<"+tag+(al[x]||"")+">"+mdInline(cs[x]||"")+"</"+tag+">";return h+"</tr>"}
      var body=rows.slice(2).map(function(r){return row(mdCells(r),"td")}).join("");
      return '<div class="md-table"><table><thead>'+row(head,"th")+"</thead>"+(body?"<tbody>"+body+"</tbody>":"")+"</table></div>";
    }
    // opts.breaks keeps a single newline as a line break, the way a person typing a
    // comment means it; chat and session text join wrapped lines as Markdown does.
    function mdToHtml(src,opts){
      var br=!!(opts&&opts.breaks);
      var lines=mdEsc(src||"").split(/\r?\n/);
      var html="",inCode=false,codeBuf=[],listType=null,listItems=[],paraBuf=[];
      function flushList(){if(listType){html+="<"+listType+">"+listItems.map(function(li){return "<li>"+mdInline(li)+"</li>"}).join("")+"</"+listType+">";listType=null;listItems=[]}}
      function flushPara(){if(paraBuf.length){html+="<p>"+(br?mdInline(paraBuf.join("\n")).replace(/\n/g,"<br>"):mdInline(paraBuf.join(" ")))+"</p>";paraBuf=[]}}
      for(var i=0;i<lines.length;i++){
        var line=lines[i];
        if(/^```/.test(line)){if(inCode){html+="<pre><code>"+codeBuf.join("\n")+"</code></pre>";codeBuf=[];inCode=false}else{flushPara();flushList();inCode=true}continue}
        if(inCode){codeBuf.push(line);continue}
        if(!line.trim()){flushPara();flushList();continue}
        if(mdIsTable(lines,i)){
          flushPara();flushList();
          var j=i+2;while(j<lines.length&&lines[j].trim()&&/\|/.test(lines[j])&&!/^```/.test(lines[j]))j++;
          html+=mdTable(lines.slice(i,j));i=j-1;continue;
        }
        var h=line.match(/^(#{1,6})\s+(.*)$/);
        if(h){flushPara();flushList();html+='<div class="md-h">'+mdInline(h[2])+"</div>";continue}
        var b=line.match(/^\s*[-*+]\s+(.*)$/);
        if(b){flushPara();if(listType&&listType!=="ul")flushList();listType="ul";listItems.push(b[1]);continue}
        var o=line.match(/^\s*\d+[.)]\s+(.*)$/);
        if(o){flushPara();if(listType&&listType!=="ol")flushList();listType="ol";listItems.push(o[1]);continue}
        if(listType)flushList();
        paraBuf.push(line);
      }
      if(inCode){html+="<pre><code>"+codeBuf.join("\n")+"</code></pre>"}
      flushPara();flushList();
      return html;
    }
    // Run fn over the rendered words only: never over a tag, and never inside code,
    // a code block or a link, so a pill can't land in an href or a snippet.
    function mdText(html,fn){
      var skip=0;
      return html.split(/(<[^>]*>)/).map(function(part,i){
        if(i%2){if(/^<(code|pre|a)[\s>]/.test(part))skip++;else if(/^<\/(code|pre|a)>/.test(part))skip--;return part}
        return skip?part:fn(part);
      }).join("");
    }


    
  window.ssSpaceGlyph = function(emoji, url){
    var e = String(emoji == null ? "" : emoji).replace(/[&<>"']/g, function(c){ return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; });
    if (typeof url !== "string" || !/^[/]icon[/][0-9a-f]{32}[.](svg|png|webp)$/.test(url)) return e;
    if (!/[.]svg$/.test(url)) return '<img class="space-icon-img" src="' + url + '" width="18" height="18" alt="" decoding="async">';
    return '<img class="space-icon-img is-light" src="' + url + '" width="18" height="18" alt="" decoding="async"><img class="space-icon-img is-dark" src="' + url.replace(/[.]svg$/, ".dark3.svg") + '" width="18" height="18" alt="" decoding="async" loading="lazy">';
  };(function(){
    if(window.ssCopy)return;
    var FLASH=1500;
    function host(btn){return (btn&&btn.closest('dialog[open]'))||document.body}
    function legacyCopy(text,btn){
      var ta=document.createElement("textarea"),active=document.activeElement;
      var selection=window.getSelection(),ranges=[];
      if(selection)for(var i=0;i<selection.rangeCount;i++)ranges.push(selection.getRangeAt(i));
      try{
        ta.value=text;ta.setAttribute("readonly","");
        ta.style.cssText="position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px";
        host(btn).appendChild(ta);ta.focus();ta.select();ta.setSelectionRange(0,text.length);
        return document.execCommand("copy");
      }catch(_){return false}
      finally{
        ta.remove();
        if(active&&active.focus)active.focus({preventScroll:true});
        if(selection){selection.removeAllRanges();ranges.forEach(function(r){selection.addRange(r)})}
      }
    }
    function manualCopy(text,btn){
      var previous=document.getElementById("ss-copy-manual");if(previous)previous.remove();
      var panel=document.createElement("div"),label=document.createElement("label");
      var field=document.createElement("textarea"),close=document.createElement("button");
      panel.id="ss-copy-manual";panel.setAttribute("role","region");panel.setAttribute("aria-label","Select and copy");
      panel.style.cssText="position:fixed;z-index:2147483647;bottom:16px;left:16px;width:calc(100% - 32px);max-width:560px;box-sizing:border-box;padding:16px;background:var(--ss-surface,#fff);color:var(--ss-text,#222);border:1px solid var(--ss-border-strong,#888);border-radius:10px;box-shadow:0 4px 24px #0004";
      label.textContent="Select and copy";field.value=text;field.readOnly=true;
      field.setAttribute("aria-label","Text to copy");field.style.cssText="display:block;box-sizing:border-box;width:100%;height:100px;margin:8px 0;font:16px monospace";
      close.type="button";close.textContent="Close";
      close.style.cssText="min-height:44px;padding:8px 16px;font:inherit;cursor:pointer";
      function dismiss(){panel.remove();if(btn&&btn.isConnected)btn.focus()}
      close.addEventListener("click",dismiss);
      panel.addEventListener("keydown",function(e){if(e.key==="Escape"){e.stopPropagation();dismiss()}});
      label.appendChild(field);panel.appendChild(label);panel.appendChild(close);host(btn).appendChild(panel);
      field.focus();field.select();field.setSelectionRange(0,text.length);
    }
    function flash(btn,ok,message){
      if(!btn)return;
      var live=btn.querySelector(".ss-copy-live"),lab=btn.querySelector(".ss-copy-label");
      var msg=message||(ok?(btn.getAttribute("data-copied-label")||"Copied"):"Select and copy");
      if(!btn.__ssCopyState){
        if(lab)btn.__ssCopyState={label:lab,text:lab.textContent};
        // An icon-only copy button confirms with its own check glyph and live region.
        else if(btn.querySelector(".ss-copy-ic"))btn.__ssCopyState={};
        else{
          var nodes=Array.from(btn.childNodes);nodes.forEach(function(n){n.remove()});
          lab=document.createElement("span");lab.setAttribute("role","status");btn.appendChild(lab);
          btn.__ssCopyState={label:lab,nodes:nodes};
        }
      }
      if(btn.__ssCopyState.label)btn.__ssCopyState.label.textContent=msg;
      if(live)live.textContent=msg;
      btn.classList.remove("is-copied","is-failed");btn.classList.add(ok?"is-copied":"is-failed");
      clearTimeout(btn.__ssCopyTimer);
      btn.__ssCopyTimer=setTimeout(function(){
        var state=btn.__ssCopyState;
        if(state.nodes){state.label.remove();state.nodes.forEach(function(n){btn.appendChild(n)})}
        else if(state.label)state.label.textContent=state.text;
        btn.__ssCopyState=null;btn.classList.remove("is-copied","is-failed");
        if(live)live.textContent="";
      },FLASH);
    }
    // Invoke in the click task. Promise text uses ClipboardItem immediately so
    // Safari can retain activation while a frame export or link request resolves.
    window.ssCopy=function(text,btn){
      function finish(ok){flash(btn,ok);return ok}
      function fallback(value){
        var ok=legacyCopy(value,btn);finish(ok);
        if(!ok)manualCopy(value,btn);
        return ok;
      }
      if(text&&typeof text.then==="function"){
        var ready=Promise.resolve(text).then(function(value){
          value=String(value==null?"":value);if(!value)throw new Error("empty");return value;
        });
        function failed(){return ready.then(fallback,function(){flash(btn,false,"Could not prepare text");return false})}
        if(navigator.clipboard&&navigator.clipboard.write&&window.ClipboardItem){
          var blob=ready.then(function(value){return new Blob([value],{type:"text/plain"})});blob.catch(function(){});
          try{return Promise.resolve(navigator.clipboard.write([new ClipboardItem({"text/plain":blob})])).then(function(){return finish(true)},failed)}
          catch(_){return failed()}
        }
        return failed();
      }
      text=String(text==null?"":text);
      if(!text){flash(btn,false,"Nothing to copy");return Promise.resolve(false)}
      try{
        if(navigator.clipboard&&typeof navigator.clipboard.writeText==="function")
          return Promise.resolve(navigator.clipboard.writeText(text)).then(function(){return finish(true)},function(){return fallback(text)});
      }catch(_){}
      return Promise.resolve(fallback(text));
    };
    document.addEventListener("click",function(e){
      var btn=e.target&&e.target.closest?e.target.closest(".ss-copy"):null;
      if(!btn||btn.disabled)return;
      var sel=btn.getAttribute("data-copy-target");
      var text=btn.getAttribute("data-copy");
      // Neither attribute means the host wires this button itself — leave it alone
      // rather than flashing a failure over its own handler.
      if(sel==null&&text==null)return;
      if(sel!=null){
        var el=document.querySelector(sel);
        var field=el&&(el.tagName==="INPUT"||el.tagName==="TEXTAREA");
        text=el?(field?el.value:el.textContent):"";
      }
      window.ssCopy(text,btn);
    });
  })();

    // ---- Space links drawn as the spaces they name (assets/features/link-cards.ts) ----
    var LC={cards:{},asked:{},fails:{},queue:[],qT:0,pop:null,imgs:{},showT:0,hideT:0,cur:null,shown:{}};
    var LC_COPY="<button type=\"button\" class=\"ss-copy ss-copy--md ss-lcp-copy\" data-copied-label=\"Copied\" aria-label=\"Copy link\" title=\"Copy link\" data-lc-copy=\"\"><span class=\"ss-copy-ic\" aria-hidden=\"true\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"ss-copy-g ss-copy-g-idle\" aria-hidden=\"true\"><path d=\"M19.4 20H9.6C9.26863 20 9 19.7314 9 19.4V9.6C9 9.26863 9.26863 9 9.6 9H19.4C19.7314 9 20 9.26863 20 9.6V19.4C20 19.7314 19.7314 20 19.4 20Z\"/><path d=\"M15 9V4.6C15 4.26863 14.7314 4 14.4 4H4.6C4.26863 4 4 4.26863 4 4.6V14.4C4 14.7314 4.26863 15 4.6 15H9\"/></svg><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"ss-copy-g ss-copy-g-done\" aria-hidden=\"true\"><path d=\"M5 13L9 17L19 7\"/></svg></span><span class=\"ss-copy-live\" role=\"status\" aria-live=\"polite\"></span></button>";
    function lcEsc(s){return String(s==null?"":s).replace(/[&<>"']/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]})}
    function lcEnds(h,s){return h.length>s.length&&h.slice(-s.length)===s}
    // Which links are worth asking about: this origin and spacesheep's own hosts. The
    // server parses the rest (space-url.ts); anything it can't place stays plain.
    function lcKey(a){
      if(!a||a.classList.contains("mention"))return null;
      return lcHrefKey(a.getAttribute("data-lc")||a.getAttribute("href")||"");
    }
    function lcHrefKey(h){
      var u;
      try{u=new URL(h,location.href)}catch(e){return null}
      if(u.protocol!=="https:"&&u.protocol!=="http:")return null;
      var host=u.hostname.toLowerCase();
      if(host!==location.hostname&&host!=="spacesheep.dev"&&!lcEnds(host,".spacesheep.dev")&&!lcEnds(host,".spacesheep.app"))return null;
      return h;
    }
    function lcAgo(iso){
      if(!iso)return"";var d=(Date.now()-new Date(iso).getTime())/1e3;
      if(!(d>=0))return"";if(d<60)return"just now";if(d<3600)return Math.floor(d/60)+"m ago";if(d<86400)return Math.floor(d/3600)+"h ago";if(d<604800)return Math.floor(d/86400)+"d ago";
      return new Date(iso).toLocaleDateString("en-US",{month:"short",day:"numeric",year:new Date(iso).getFullYear()===new Date().getFullYear()?undefined:"numeric"});
    }
    function lcEmoji(c){return c.emoji||(c.mode==="worker"?"💻":"📄")}
    // The emoji, or the space's generated symbol (space-glyph.ts), as HTML.
    function lcGlyph(c){return window.ssSpaceGlyph?window.ssSpaceGlyph(lcEmoji(c),c.icon_url):lcEsc(lcEmoji(c))}
    function lcOwner(c){return c.owner.you?"You":(c.owner.name||(c.owner.username?"@"+c.owner.username:"Someone"))}
    // Upgrade every link in root that has a card; queue the ones not asked about yet.
    function lcPaint(root){
      if(!root)return;
      var links=root.querySelectorAll("a[href]:not(.mention)");
      for(var i=0;i<links.length;i++){
        var a=links[i],k=lcKey(a);if(!k)continue;
        var c=LC.cards[k];
        if(c===undefined){a.setAttribute("data-lc-wait","");if(!LC.asked[k]){LC.asked[k]=1;LC.queue.push(k)}continue}
        a.removeAttribute("data-lc-wait");
        if(!c||a.classList.contains("ss-lc"))continue;
        lcUpgrade(a,k,c);
      }
      if(LC.queue.length&&!LC.qT)LC.qT=setTimeout(lcFlush,0);
    }
    function lcUpgrade(a,k,c){
      var h=(a.getAttribute("href")||"").trim(),bare=(a.textContent||"").trim()===h,raw=false;
      // The author's own link is kept (its page, query and fragment are theirs); only
      // a raw content-origin link, which opens the page without its chrome, goes to
      // the space's address instead.
      try{raw=lcEnds(new URL(h,location.href).hostname.toLowerCase(),".spacesheep.app")}catch(e){}
      a.setAttribute("data-lc",k);if(raw)a.href=c.href;a.classList.add("ss-lc");
      a.setAttribute("aria-label",c.title+(c.page?", "+c.page:"")+", a space by "+lcOwner(c)+(bare?"":" ("+(a.textContent||"").trim()+")"));
      if(bare){
        a.classList.add("ss-lc-chip");
        a.innerHTML='<span class="ss-lc-ic" aria-hidden="true">'+lcGlyph(c)+'</span><span class="ss-lc-t">'+lcEsc(c.title)+'</span>'+(c.page?'<span class="ss-lc-pg" aria-hidden="true">'+lcEsc(c.page)+'</span>':'');
      }else a.classList.add("ss-lc-label");
    }
    function lcFlush(){
      LC.qT=0;var batch=LC.queue.splice(0,12);if(!batch.length)return;
      fetch("/api/link-cards?"+batch.map(function(k){return"u="+encodeURIComponent(k)}).join("&"),{credentials:"same-origin"})
        .then(function(r){if(!r.ok)throw new Error(r.status);return r.json()})
        .then(function(d){var cards=(d&&d.cards)||{};batch.forEach(function(k){LC.cards[k]=cards[k]||null});lcRepaint()})
        // A failed ask is asked again on a later render, twice at most; the links stay plain meanwhile.
        .catch(function(){batch.forEach(function(k){LC.fails[k]=(LC.fails[k]||0)+1;if(LC.fails[k]<3)delete LC.asked[k];else LC.cards[k]=null})});
      if(LC.queue.length)LC.qT=setTimeout(lcFlush,0);
    }
    function lcRepaint(){
      var w=document.querySelectorAll("a[data-lc-wait]");
      for(var i=0;i<w.length;i++){var a=w[i],k=lcKey(a),c=k?LC.cards[k]:null;if(c===undefined)continue;a.removeAttribute("data-lc-wait");if(c&&!a.classList.contains("ss-lc"))lcUpgrade(a,k,c)}
    }
    // The page's picture, fetched once per card and kept: the image route answers
    // no-store, and a card hovered twice must not ask twice. The page's first screen
    // (the dashboard's thumbnail) when there is one, else its own picture; 204 = none.
    function lcImg(c){
      if(!c.thumb&&!c.image)return null;
      var e=LC.imgs[c.id];
      if(!e){e=LC.imgs[c.id]={ok:null,shot:!!c.thumb,el:new Image()};e.el.alt="";e.el.decoding="async";
        e.el.onload=function(){e.ok=e.el.naturalWidth>0;if(LC.cur&&LC.cur.c.id===c.id)lcHero(c)};
        // A thumbnail that won't load falls back to the page's own picture, once.
        e.el.onerror=function(){if(e.shot&&c.image){e.shot=false;e.el.src=c.image}else{e.ok=false;lcHeroGone(c)}};e.el.src=c.thumb||c.image}
      return e;
    }
    function lcHero(c){
      var p=LC.pop,h=p&&p.querySelector(".ss-lcp-hero"),e=LC.imgs[c.id];if(!h||!e||!e.ok||h.firstChild)return;
      var was=h.hidden;h.classList.toggle("is-shot",!!e.shot);h.appendChild(e.el);h.hidden=false;if(was)lcPlace();
    }
    // A screenshot's box is held from the start so the card never grows; if no picture
    // comes after all, the box goes.
    function lcHeroGone(c){
      var p=LC.pop,h=p&&p.querySelector(".ss-lcp-hero");if(!h||h.firstChild||!LC.cur||LC.cur.c.id!==c.id)return;
      h.hidden=true;lcPlace();
    }
    function lcCardHtml(c,href){
      var e=LC.imgs[c.id],shot=!!c.thumb&&!(e&&e.ok===false);
      var by="";
      if(!c.owner.you){
        var av=typeof ssAvatar==="function"?ssAvatar({seed:c.owner.username||c.id,name:c.owner.name||c.owner.username,picture:c.owner.picture,size:"xs",className:"ss-lcp-av"}):"";
        var up=lcAgo(c.updated_at);
        by='<div class="ss-lcp-by">'+av+'<span class="ss-lcp-who">'+lcEsc(lcOwner(c))+'</span>'+(up?'<span class="ss-lcp-dot" aria-hidden="true">·</span><span class="ss-lcp-up" title="'+lcEsc(c.updated_at?new Date(c.updated_at).toLocaleString():"")+'">'+lcEsc(up)+'</span>':'')+'</div>';
      }
      return '<a class="ss-lcp-main" href="'+lcEsc(href)+'" target="_blank" rel="noopener">'+
          '<div class="ss-lcp-hero'+(shot?' is-shot':'')+'"'+(shot?'':' hidden')+'></div>'+
          '<div class="ss-lcp-body">'+
            '<div class="ss-lcp-head"><span class="ss-lcp-emoji" aria-hidden="true">'+lcGlyph(c)+'</span><div class="ss-lcp-tt"><div class="ss-lcp-title">'+lcEsc(c.title)+'</div>'+(c.page?'<div class="ss-lcp-page">'+lcEsc(c.page)+'</div>':'')+'</div></div>'+
            (c.description?'<p class="ss-lcp-desc">'+lcEsc(c.description)+'</p>':'')+
            by+
          '</div>'+
        '</a>'+LC_COPY;
    }
    function lcPopEl(){
      if(LC.pop)return LC.pop;
      var p=LC.pop=document.createElement("div");p.className="ss-lcp";p.id="ssLcPop";p.setAttribute("role","dialog");p.hidden=true;
      p.addEventListener("mouseenter",function(){clearTimeout(LC.hideT)});
      p.addEventListener("mouseleave",function(){lcHideSoon()});
      p.addEventListener("focusout",function(e){if(!p.contains(e.relatedTarget)&&!(LC.cur&&e.relatedTarget===LC.cur.a))lcHideSoon()});
      p.addEventListener("click",function(e){
        var b=e.target.closest&&e.target.closest("[data-lc-copy]");
        if(b&&LC.cur){var u=new URL(LC.cur.href,location.href).href;var card=LC.cur.c;window.ssCopy(u,b).then(function(ok){if(ok)lcTrack("Space Link Card Copied",card)});return}
        if(LC.cur&&e.target.closest&&e.target.closest(".ss-lcp-main")){lcTrack("Space Link Opened",LC.cur.c,{from:"card"});lcHide()}
      });
      document.body.appendChild(p);
      return p;
    }
    function lcTrack(name,c,extra){if(window.mixpanel&&c)try{var p={space_id:c.id,own:!!c.owner.you,picture:!!(LC.imgs[c.id]&&LC.imgs[c.id].ok),where:LC.cur&&LC.cur.doc?"document":"comment"};for(var k in extra)p[k]=extra[k];mixpanel.track(name,p)}catch(x){}}
    function lcPlace(){
      var p=LC.pop,cur=LC.cur;if(!p||p.hidden||!cur)return;
      var r=cur.box();if(!r){lcHide();return}
      var vw=document.documentElement.clientWidth,vh=window.innerHeight;
      var w=Math.min(328,vw-24);p.style.width=w+"px";
      var h=p.offsetHeight,below=vh-r.bottom,top=below>=h+12||below>=r.top?r.bottom+8:r.top-h-8;
      p.style.top=Math.max(8,Math.min(top,vh-h-8))+"px";
      p.style.left=Math.max(12,Math.min(r.left,vw-w-12))+"px";
    }
    function lcShow(a,now){
      var k=a.getAttribute("data-lc"),c=k&&LC.cards[k];if(!c)return;
      lcOpen({k:a,a:a,c:c,href:a.href,box:function(){return a.isConnected?(a.getClientRects()[0]||a.getBoundingClientRect()):null}},now);
    }
    // A target is what the card points at: a link in the shell's own words (a
    // comment), or a link inside the document's frame (lcFrameHover). k is what makes
    // two hovers the same one, box() where it is now (null: gone).
    function lcOpen(t,now){
      var c=t.c;
      clearTimeout(LC.hideT);
      lcImg(c);
      if(LC.cur&&LC.cur.k===t.k&&LC.pop&&!LC.pop.hidden){LC.cur=t;lcPlace();return}
      LC.next=t;
      // Moving between the chip's own parts must not restart the wait.
      if(LC.want===t.k&&LC.showT&&!now)return;
      clearTimeout(LC.showT);LC.want=t.k;
      LC.showT=setTimeout(function(){
        LC.showT=0;LC.want=null;var t2=LC.next||t;LC.next=null;
        if(LC.cur&&LC.cur.a)LC.cur.a.removeAttribute("aria-describedby");
        var p=lcPopEl();LC.cur=t2;
        p.innerHTML=lcCardHtml(t2.c,t2.href);p.setAttribute("aria-label",t2.c.title);p.hidden=false;
        if(t2.a)t2.a.setAttribute("aria-describedby","ssLcPop");
        var e=LC.imgs[t2.c.id];if(e&&e.ok)lcHero(t2.c);
        lcPlace();requestAnimationFrame(function(){p.classList.add("on")});
        if(!LC.shown[t2.c.id]){LC.shown[t2.c.id]=1;lcTrack("Space Link Card Shown",t2.c)}
      },now?0:t.doc?500:320);
    }
    function lcHideSoon(){clearTimeout(LC.showT);LC.showT=0;LC.want=null;LC.next=null;clearTimeout(LC.hideT);LC.hideT=setTimeout(lcHide,180)}
    function lcHide(){
      clearTimeout(LC.showT);var p=LC.pop;if(!p||p.hidden)return;
      p.classList.remove("on");p.hidden=true;if(LC.cur&&LC.cur.a)LC.cur.a.removeAttribute("aria-describedby");LC.cur=null;
    }
    // A link inside the document (anchor.js posts ss-link-hover: the link's href and
    // its box in the frame's viewport; href null when the pointer left it). The card
    // is drawn here, over the frame; the page never learns what came back. The ask
    // names the document (from), whose owner narrows which links get a card
    // (docLinkMayCard in space-link-cards.ts), so these cards are kept apart from the
    // comments' under their own keys. One ask per link, remembered.
    function lcFrameHover(d,frame,from){
      if(!LC_HOVER||!frame||!from)return;
      var h=d&&typeof d.href==="string"&&d.href.length<=2048?d.href:"",k=h&&lcHrefKey(h);
      if(!k){LC.fk=null;if((LC.cur&&LC.cur.doc)||(LC.next&&LC.next.doc))lcHideSoon();return}
      var r=d.rect||{},b={x:+r.x||0,y:+r.y||0,w:Math.max(0,+r.w||0),h:Math.max(0,+r.h||0)},fk="doc "+k;
      LC.fk={k:fk,box:b,frame:frame};
      var c=LC.cards[fk];
      if(c){lcFrameShow();return}
      if(c===null||LC.asked[fk])return;
      LC.asked[fk]=1;
      fetch("/api/link-cards?from="+encodeURIComponent(from)+"&u="+encodeURIComponent(k),{credentials:"same-origin"})
        .then(function(r){if(!r.ok)throw new Error(r.status);return r.json()})
        .then(function(dd){LC.cards[fk]=(dd&&dd.cards&&dd.cards[k])||null;if(LC.fk&&LC.fk.k===fk)lcFrameShow()})
        // A failed ask is asked again on a later hover, twice at most.
        .catch(function(){LC.fails[fk]=(LC.fails[fk]||0)+1;if(LC.fails[fk]<3)delete LC.asked[fk];else LC.cards[fk]=null});
    }
    function lcFrameShow(){
      var f=LC.fk,c=f&&LC.cards[f.k];if(!c)return;
      lcOpen({k:f.k,doc:true,c:c,href:c.href,box:function(){
        if(!f.frame.isConnected)return null;
        var fr=f.frame.getBoundingClientRect(),l=fr.left+f.box.x,t=fr.top+f.box.y;
        // A link scrolled out of the frame's sight has nothing to point at.
        if(t+f.box.h<fr.top||t>fr.bottom||l+f.box.w<fr.left||l>fr.right)return null;
        return {left:l,top:t,right:l+f.box.w,bottom:t+f.box.h};
      }},false);
    }
    // The frame loaded another page under a shown card: nothing points at it now.
    function lcFrameGone(){LC.fk=null;if(LC.cur&&LC.cur.doc)lcHide()}
    // Hover and focus open the card; touch screens just follow the link.
    var LC_HOVER=!window.matchMedia||window.matchMedia("(hover:hover)").matches;
    document.addEventListener("mouseover",function(e){
      if(!LC_HOVER)return;var a=e.target.closest&&e.target.closest("a.ss-lc");
      if(a)lcShow(a,false);
    });
    document.addEventListener("mouseout",function(e){
      var a=e.target.closest&&e.target.closest("a.ss-lc");if(!a)return;
      var to=e.relatedTarget;if(to&&(a.contains(to)||(LC.pop&&LC.pop.contains(to))))return;
      lcHideSoon();
    });
    document.addEventListener("focusin",function(e){var a=e.target.closest&&e.target.closest("a.ss-lc");if(a&&e.target.matches(":focus-visible"))lcShow(a,true)});
    document.addEventListener("focusout",function(e){var a=e.target.closest&&e.target.closest("a.ss-lc");if(a&&!(LC.pop&&LC.pop.contains(e.relatedTarget)))lcHideSoon()});
    document.addEventListener("click",function(e){var a=e.target.closest&&e.target.closest("a.ss-lc"),c=a&&LC.cards[a.getAttribute("data-lc")];if(c){lcTrack("Space Link Opened",c,{from:a.classList.contains("ss-lc-chip")?"chip":"label"});lcHide()}});
    document.addEventListener("keydown",function(e){if(e.key==="Escape"&&LC.pop&&!LC.pop.hidden){lcHide()}});
    window.addEventListener("scroll",function(){if(LC.pop&&!LC.pop.hidden)lcHide()},true);
    window.addEventListener("resize",function(){lcHide()});

    // A space link inside the document gets the same card, drawn here over the frame
    // (ss-link-hover below); a page the frame moves to takes a shown one with it.
    (function(){var f=document.getElementById("content");if(f)f.addEventListener("load",lcFrameGone)})();
    function mkBody(s){return mdText(mdToHtml(s,{breaks:true}),function(t){return t.replace(/(^|[^a-zA-Z0-9_.@\/-])@([a-zA-Z0-9][a-zA-Z0-9-]{0,29})/g,function(m,pre,u){var lu=u.toLowerCase();if(AGENT_HANDLES.indexOf(lu)>=0)return pre+'<span class="mention agent">'+SHEEP+AGENT_NAME+'</span>';if(lu==="session")return pre+'<span class="mention agent sess">'+PROMPT_ICON+'session</span>';var me=myUser&&lu===String(myUser).toLowerCase();return pre+'<a href="/@'+lu+'" class="mention'+(me?" me":"")+'">@'+u+'</a>'})})}
    // "@shepherd" (or "@spacesheep", or the older "@co-shepherd") in the words is an ask for the
    // agent, "@session" one for the session that made the page — the same token
    // grammar the server's mention notifier uses (comment-anchors.ts).
    function asksAgent(t){return /(^|[^a-zA-Z0-9_.@\/-])@(?:shepherd|spacesheep|co-shepherd)(?![a-zA-Z0-9-])/i.test(String(t||""))}
    function asksSession(t){return /(^|[^a-zA-Z0-9_.@\/-])@session(?![a-zA-Z0-9-])/i.test(String(t||""))}

    // A frame reaction carries no proof of a click — any script on the author's page
    // can send ss-react — so the shell bounds it: one flip per block+emoji per second,
    // eight a rolling ten seconds. A person clicking never gets near either.
    var rxLast={},rxRecent=[];
    function rxAllowed(aid,aem){
      var now=Date.now(),k=aid+"|"+aem;
      if(rxLast[k]&&now-rxLast[k]<1000)return false;
      rxRecent=rxRecent.filter(function(t){return now-t<10000});
      if(rxRecent.length>=8)return false;
      rxLast[k]=now;rxRecent.push(now);return true;
    }
    // A page's own keys (F for full screen, Space, the arrows) work the moment it
    // opens: keys go to whatever holds focus, and a cross-origin frame holds none
    // until the reader clicks into it (@yaroslavvb, 2026-09-28). So the frame gets
    // focus when it is ready, after every load, but only when nothing of the
    // shell's own has it (a composer, the search box, a menu) and only where there
    // is a keyboard (a fine pointer). C, Escape, /, ⌘K and Speak's ⌥S still reach
    // the shell: the frame relays them as ss-hotkey.
    function focusFrame(){
      var f=document.getElementById("content"),ae=document.activeElement;
      if(!f||!window.matchMedia||!window.matchMedia("(pointer: fine)").matches)return;
      if(ae&&ae!==document.body&&ae!==f)return;
      try{f.focus({preventScroll:true})}catch(x){}
    }
    // Auth bridge. Every document the frame loads without a session asks who is
    // reading (auth-request): the first page of this view, and — in Safari, which
    // blocks third-party cookies — every page of a site after it, every
    // reload after a publish, every pinned version. The first ask gets the ticket this
    // page came with, each later one a fresh ticket from /frame-ticket, and auth-wait
    // says one is coming, so the frame waits for it instead of putting up "Sign in to
    // comment" (@yaroslavvb's iPad, 2026-09-23: only the first ask was ever answered).
    // An id already answered is the same document asking again; the frame repeats
    // its ask until anyone replies. The protocol is packages/content/src/frame-auth.ts.
    var authAsked={};
    function answerAuth(src,id){
      if(id){if(authAsked[id])return;authAsked[id]=1}
      try{src.postMessage({type:"auth-wait"},co)}catch(x){}
      if(!used&&t){used=true;window.__ssHandshake=true;var sent=false,send=function(){if(sent)return;sent=true;src.postMessage({type:"auth-ticket",ticket:t},co)};if(window.__ssTicketOk)send();else{window.addEventListener("ss-ticket",send);setTimeout(send,2000)}return}
      fetch("/api/space/"+encodeURIComponent(spaceId)+"/frame-ticket",{method:"POST"})
        .then(function(r){return r.ok?r.json():null})
        .then(function(d){src.postMessage(d&&d.ticket?{type:"auth-ticket",ticket:String(d.ticket)}:{type:"auth-fail"},co)})
        .catch(function(){try{src.postMessage({type:"auth-fail"},co)}catch(x){}});
    }
    authReady();
    window.addEventListener("message",function(e){
      if(e.origin!==co)return;
      if(e.data&&e.data.type==="auth-request"&&e.source){answerAuth(e.source,typeof e.data.id==="string"?e.data.id.slice(0,40):"");return}
      if(e.data&&e.data.type==="ss-pin-at"){
        // The page was clicked (Annotate on), selected, or its hover pill's Comment
        // pressed: the frame says where — the block, the spot inside it as
        // fractions of its box, the quote — and the composer opens there, in this
        // shell. The frame is the author's page and any script on it can send
        // this, so it only ever opens an empty composer; nothing is posted here.
        var pd=e.data,aid=String(pd.anchorId||"");
        // The held comment button's pin (ss-pin-center) that lands after the hold ended.
        if(pd.via==="voice"&&!voice)return;
        if(!/^[a-zA-Z0-9_-]{1,80}$/.test(aid))aid="";
        openCompose({anchorId:aid||null,tag:/^[a-z][a-z0-9-]{0,15}$/.test(String(pd.tag||""))?String(pd.tag):null,x:+pd.x||0,y:+pd.y||0,
          quote:pd.quote?String(pd.quote).slice(0,500):null,near:pd.near&&!/[<>]/.test(String(pd.near))?String(pd.near).slice(0,60):null,anchorText:pd.anchorText?String(pd.anchorText).slice(0,300):null,
          path:String(pd.path||"").slice(0,200),part:cleanPart(pd.part),thing:cleanThing(pd.thing),px:+pd.px||0,py:+pd.py||0,rect:pd.rect||null,via:String(pd.via||"click").slice(0,20),seed:String(pd.seed||"").slice(0,1)});
        return;
      }
      if(e.data&&e.data.type==="ss-compose-geo"){if(compose){if(e.data.gone===true){compose.gone=true;var cg=document.getElementById("cmpGone");if(cg)cg.hidden=false}else{compose.px=+e.data.px||0;compose.py=+e.data.py||0;compose.rect=e.data.rect||compose.rect}placeCompose()}return}
      if(e.data&&e.data.type==="ss-pin-hover"){var phId=e.data.id?String(e.data.id):null;setHot(phId,false);pinPeek(phId,e.data.rect,String(e.data.via||"hover"));return}
      // A space link in the document under the pointer (anchor.js): its card, when the
      // reader may see one (link-cards.ts). Signed out there is no one to ask for.
      if(e.data&&e.data.type==="ss-link-hover"){if(!ANON)lcFrameHover(e.data,document.getElementById("content"),spaceId);return}
      if(e.data&&e.data.type==="ss-pin-click"){pinPeekHide();focusThread(String(e.data.id||""),true);return}
      if(e.data&&e.data.type==="ss-anchor-order"){var ids=Array.isArray(e.data.ids)?e.data.ids:[];anchorOrder={};for(var oi=0;oi<ids.length&&oi<4000;oi++)anchorOrder[String(ids[oi])]=oi;if(lcPendingPin)lcApplyPin();renderComments();return}
      // The page's blocks on the reader's screen (anchor.js), for Speak: "this heading".
      if(e.data&&e.data.type==="ss-visible"){var vs=Array.isArray(e.data.ids)?e.data.ids:[],vo=[];for(var vi=0;vi<vs.length&&vo.length<400;vi++){var vv=String(vs[vi]);if(/^[a-zA-Z0-9_-]{1,100}$/.test(vv))vo.push(vv)}window.ssFrameVisible=vo;return}
      if(e.data&&e.data.type==="ss-hotkey"){hotkey(String(e.data.key||""));return}
      if(e.data&&e.data.type==="ss-placeholder"){placeholderMode(e.data.on===true);return}
      // The page holds focus (focusFrame), so a return to this window lands in the
      // frame and the shell's own focus event never fires: the frame says so.
      if(e.data&&e.data.type==="ss-frame-focus"){sendSeen();return}
      if(e.data&&e.data.type==="ss-react"){
        // A block reaction from the frame's pill/strip/chip. The frame already flipped
        // its own copy; we own the session so we POST, then send back what the server
        // actually wrote (or the unchanged state, so a failed flip reverts).
        var rd=e.data,aid=String(rd.anchorId||""),aem=String(rd.emoji||"");
        if(!/^[a-zA-Z0-9_-]{1,80}$/.test(aid)||REACTIONS.indexOf(aem)<0||!rxAllowed(aid,aem)){sendMarkers();return}
        fetch("/api/space/"+spaceId+"/reactions",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({anchor_id:aid,emoji:aem,anchor_text:rd.anchorText?String(rd.anchorText).slice(0,80):null})})
          .then(function(r){return r.ok?r.json():null}).then(function(d){
            if(!d){sendMarkers();return}
            var rec={anchor_id:aid,emoji:aem,author_email:d.author_email||myEmail,author_name:d.author_name||myRxName()};
            anchorReactions=d.action==="remove"?arDel(anchorReactions,rec):arAdd(anchorReactions,rec);
            sendMarkers();
            if(window.mixpanel)mixpanel.track("Block Reacted",{space_id:spaceId,emoji:aem,action:d.action,surface:String(rd.surface||"hover")});
          }).catch(function(){sendMarkers()});
        return;
      }
      // A fresh (or reloaded) frame starts in reading mode; re-send the current
      // state so a sidebar left open stays armed across the swap.
      if(e.data&&e.data.type==="ss-scroll"){frameScroll=e.data}
      if(e.data&&e.data.type==="ss-anchor-ready"&&keepScroll){keepScroll=false;var fs=frameScroll,sf=document.getElementById("content");if(fs&&fs.y>0&&sf&&sf.contentWindow)sf.contentWindow.postMessage({type:"ss-scroll-to",path:String(fs.path||""),y:fs.y,id:String(fs.id||""),off:fs.off||0},co)}
      // Speak's ⌥S (assets/shell/speak.ts) pressed in the page comes back as ss-hotkey.
      if(e.data&&e.data.type==="ss-anchor-ready"&&e.source){try{e.source.postMessage({type:"ss-shell-keys",speak:!!document.getElementById("ssSpeak"),search:!!document.getElementById("ssHSearch")},co)}catch(x){}}
      if(e.data&&e.data.type==="ss-anchor-ready"){sendMarkers();sendCommentMode();frameReady=true;shownCheck();if(lcPendingPin)lcOrderTimer=setTimeout(lcApplyPin,3000);var lq=liveQueue;liveQueue=[];lq.forEach(function(m){ssLive(m)});workFrameReady();focusFrame()}
      if(e.data&&e.data.type==="ss-work-shown"){workShown(e.data.on===true)}
      if(e.data&&e.data.type==="ss-patch-result"){finishPatch(e.data.id,e.data.missed||[],e.data.revealed===true);var lp=livePatch[e.data.id];if(lp){delete livePatch[e.data.id];ssEmit("_applied",{seq:lp.seq,mode:"patch",ms:Math.round(performance.now()-lp.t),bytes:lp.bytes,missed:(e.data.missed||[]).length})}}
      // The live layer: the page talks back. A [data-ss-emit] click or window.ss.emit()
      // from the frame, and the frame's own receipt for each live push — both go to the
      // room, which keeps them for whoever is streaming (live_events).
      if(e.data&&e.data.type==="ss-emit"){ssEmit(e.data.name,e.data.data)}
      if(e.data&&e.data.type==="ss-click-result"){ssEmit("_clicked",{nonce:String(e.data.nonce||""),ok:e.data.ok===true,reason:String(e.data.reason||""),label:String(e.data.label||"").slice(0,120)})}
      if(e.data&&e.data.type==="ss-live-result"){ssEmit("_applied",{seq:e.data.seq,mode:e.data.mode,ms:e.data.ms,bytes:e.data.bytes});ssLivePill(true)}
      if(e.data&&e.data.type==="ss-edge"&&window.__ssEdge)window.__ssEdge(e.data.near===true,typeof e.data.x==="number"?e.data.x:null);
      if(e.data&&e.data.type==="ss-screenshot-result"){var cb=window.__ssShotWaits&&window.__ssShotWaits[e.data.id];if(cb){delete window.__ssShotWaits[e.data.id];cb(e.data)}}
    });
    // A frame that loads fast reports (ss-anchor-ready, ss-placeholder) before this
    // listener exists, and its load event can fire before anyone listens for it, so
    // ask once now: ss-where makes it say where it is and whether it is a live link's
    // placeholder again.
    try{var cfAsk=document.getElementById("content");if(cfAsk&&cfAsk.contentWindow)cfAsk.contentWindow.postMessage({type:"ss-where"},co)}catch(x){}

    // Comments says what it is in words; its card is only for when the word is
    // hidden (a compact header, a phone), so each hover asks whether it shows.
    (function(){
      var ct=document.getElementById("commentToggle");if(!ct)return;
      function need(){var t=ct.querySelector(".cbtn-txt");ct.toggleAttribute("data-tip-off",!!(t&&t.offsetWidth&&t.scrollWidth<=t.clientWidth))}
      ct.addEventListener("pointerenter",need);ct.addEventListener("focus",need);
    })();

    // Presence
    var presenceEl=document.getElementById("presence"),viewers={},ws,reconnectDelay=1e3,pingInterval,wsDropped=false;
    // Keyed by seed: the room never sends an address (see presence.ts publicViewer).
    function renderPresence(){
      var seeds=Object.keys(viewers),shown=seeds.slice(0,5);
      // A reader alone (they are always in the room themselves, so one face is
      // them): "Online: you" says nothing, so the faces and the label step aside (the
      // live pill, when there is one, stays). Set before the faces change, so the
      // header's fit, which runs on that change, sees it.
      var pw=document.getElementById("presWrap");
      // With live cursors, a second tab of your own is company too: its cursor shows here.
      if(pw)pw.classList.toggle("is-solo",seeds.length<=1&&!(PC&&pcTabs>1));
      pcTell();
      ulFaces(shown);
      presenceEl.innerHTML=shown.map(function(seed){
        var u=viewers[seed];
        // A face links to that viewer's profile; ssAvatar renders an <a> when given href.
        return ssAvatar({seed:seed,name:u.name||"Someone",picture:u.picture,size:"sm",className:"pres-av",href:u.profile||undefined});
      }).join("")+(seeds.length>5?'<span class="ss-av ss-av-sm pres-av pres-more">+'+(seeds.length-5)+'</span>':"");
      // Their @handle rides in a [data-tip] card (the alias, as on the version
      // history's faces); ssAvatar only emits identity, not chrome. A face without a
      // handle (an opaque /u/<id> profile) falls back to its display name.
      shown.forEach(function(seed,i){
        var u=viewers[seed],pf=String(u.profile||""),h=pf.indexOf("/@")===0?pf.slice(2).split(/[?#]/)[0]:"";
        ssSetTip(presenceEl.children[i],h?"@"+decodeURIComponent(h):(u.name||"Someone"),{at:"below",as:"label"});
      });
    }

    // Comments
    function getThreads(){
      var roots=[],bp={};
      comments.forEach(function(c){if(!c.parent_id)roots.push(c);else{if(!bp[c.parent_id])bp[c.parent_id]=[];bp[c.parent_id].push(c)}});
      return roots.map(function(r){return{root:r,replies:bp[r.id]||[]}});
    }
    // Reaction rows come back oldest-first, so names accumulate in that order — which
    // is the order rxTitle lists them in on the chip's tooltip.
    function getRxns(cid){
      var m={};reactions.forEach(function(r){if(r.comment_id!==cid)return;if(!m[r.emoji])m[r.emoji]={emoji:r.emoji,count:0,mine:false,names:[]};m[r.emoji].count++;m[r.emoji].names.push(r.author_name||String(r.author_email||"").split("@")[0]);if(lcEmail(r.author_email)===myEmail)m[r.emoji].mine=true});
      return Object.values(m);
    }
    // "New" = posted by someone else since you last looked at this space's comments.
    // The marks hold while the rail is open, so you can see what arrived. Closing it
    // is having looked: the mark moves on and the highlight goes, so reopening shows
    // only what came after, and so does the next visit. Until 2026-09-27 the mark
    // moved only at page load, and a closed-and-reopened rail stayed lit. Opening
    // stores the mark too, so a tab shut with the rail open starts clean next time.
    var seenKey="ss_cseen_"+spaceId,seenAt=0;
    try{seenAt=parseInt(localStorage.getItem(seenKey)||"0",10)||0}catch(x){}
    function isNew(c){return seenAt>0&&lcEmail(c.author_email)!==myEmail&&new Date(c.created_at).getTime()>seenAt}
    function storeSeen(t){try{localStorage.setItem(seenKey,String(t))}catch(x){}}
    function markSeen(){storeSeen(Date.now());updateCount()}
    function seenOnClose(){seenAt=Date.now();storeSeen(seenAt);updateCount();
      // Once the rail has slid shut, so the cards don't blink white on the way out.
      setTimeout(function(){if(document.querySelector("#sbList .cmt.new"))renderComments()},220)}
    var expanded={},resolvedOpen=false; // resolved threads fold away until asked for
    var bodyOpen={}; // long comments the reader unfolded (measureFolds)
    // Marks on the page while the list is shut: a count beside each block with open
    // threads. The reader's standing choice, this browser, every space: "auto" shows
    // the blocks with something they haven't seen, "always" every one, "off" none. A
    // link decides for one visit: ?comments=show|hide, and a link to one comment shows.
    var marksPref="auto";try{var mp0=localStorage.getItem("ss_cmt_marks");if(mp0==="always"||mp0==="off")marksPref=mp0}catch(x){}
    var marksVisit=(function(){var q=new URLSearchParams(location.search),v=q.get("comments");if(v==="show"||v==="hide")return v;return q.get("comment")?"show":null})();
    // "Hide resolved threads" — yours alone, this browser, every space (like the sort
    // and the marks): it changes what you look at, not what the space holds, so it
    // never goes near the server. It was kept per space until 2026-10-28, so turning
    // it on in one space left every other space showing them; an old per-space "on"
    // still counts until the reader chooses again. One state, said one way: the box,
    // the list's "hidden" line and its Show all set it (setHideResolved).
    // revealResolved is only for a link to a resolved thread, for that visit: without
    // it that link would open a sidebar with nothing in it.
    var HIDE_RES="ss_hideres",hideResolved=false,revealResolved=false;
    try{var hr0=localStorage.getItem(HIDE_RES);hideResolved=hr0===null?localStorage.getItem("ss_hideres_"+spaceId)==="1":hr0==="1"}catch(x){}
    function setHideResolved(on,via){
      hideResolved=!!on;revealResolved=false;if(!on)resolvedOpen=true;
      try{localStorage.setItem(HIDE_RES,on?"1":"0");localStorage.removeItem("ss_hideres_"+spaceId)}catch(x){}
      var box=document.getElementById("prefHideRes");if(box)box.checked=hideResolved;
      renderComments();
      if(via==="list")toast(on?"Resolved threads hidden":"Resolved threads shown",{label:on?"Show":"Hide again",fn:function(){setHideResolved(!on,"toast")}});
      else announce(on?"Resolved threads hidden.":"Resolved threads shown.");
      if(window.mixpanel)try{mixpanel.track("Resolved Threads Hidden",{space_id:spaceId,on:hideResolved,via:via})}catch(x){}
    }
    // How the rail is ordered — the reader's own, this browser, every space. The
    // default reads like a conversation: the thread with the newest message sits at
    // the bottom, and the rail opens scrolled there. "page" is the old order (pinned
    // threads as their blocks sit on the page, then the whole page).
    var SORTS={activity:1,started:1,page:1},cmtSort="activity";
    try{var savedSort=localStorage.getItem("ss_cmt_sort");if(SORTS[savedSort])cmtSort=savedSort}catch(x){}
    // The rail opens at its newest message once per page load (railLanded); after
    // that it stays where the reader left it, except that a new message lands in
    // view when they were already at the bottom.
    var railLanded=false,commentsRead=false,lastMsgCount=0;
    // A ?comment= link lands on its thread ONCE. The rail redraws all the time (the
    // clock, page order, typing, reactions); reading the address on every redraw
    // dragged the reader back to that thread wherever they had scrolled.
    var deepCmt=new URLSearchParams(location.search).get("comment");
    function chrono(){return cmtSort!=="page"}
    function landRail(){
      if(railLanded||!sidebarOpen||!commentsRead)return;
      railLanded=true;
      if(!chrono()||new URLSearchParams(location.search).get("comment"))return;
      var list=document.getElementById("sbList");
      requestAnimationFrame(function(){list.scrollTop=list.scrollHeight});
    }
    function renderReplies(t){
      var rs=t.replies,h="";
      if(rs.length>3&&!expanded[t.root.id]){
        var hidden=rs.length-2;
        h+='<button type="button" class="more-replies" data-expand="'+t.root.id+'">Show '+hidden+' earlier '+(hidden===1?'reply':'replies')+'</button>';
        rs=rs.slice(-2);
      }
      rs.forEach(function(r){h+=renderCmt(r,true)});
      // A turn this thread asked the Co-shepherd for, still running or ended badly:
      // its reply arrives as a real reply (via co-shepherd), so this row is only
      // ever the wait, or the reason there is nothing to wait for.
      var pr=pendingFor(t.root.id);
      if(pr){
        h+='<article class="cmt reply" aria-live="polite"><div class="cmt-head"><span class="ss-av ss-av-xs cmt-avatar cmt-agent-av">'+SHEEP+'</span><span class="cmt-author">'+AGENT_NAME+'</span><span class="agent-tag">AGENT</span>'+(pr.status==="running"?'<time class="cmt-time">now</time>':'')+'</div>';
        if(pr.status==="running")h+='<div class="cmt-work">'+esc(pr.label||"Working on it")+'<span class="dots"><i></i><i></i><i></i></span></div>';
        else{
          // Only the asker may ask again: the turn runs on their key. A refusal the
          // same words can't get past (no model) offers its fix instead of Try again.
          var asker=pr.cid&&comments.find(function(c){return c.id===pr.cid});
          var mine=asker&&lcEmail(asker.author_email)===myEmail;
          // A spent allowance names the moment it frees up, in the reader's clock;
          // once that has passed, asking again works, so Try again is back.
          var whenAt=pr.when?Date.parse(pr.when.at):NaN,freed=whenAt<=Date.now();
          var msg=whenAt===whenAt?esc(pr.when.head)+(freed?' It’s free again now.':' It frees up <span class="cmt-when" data-at="'+whenAt+'">'+esc(freesWhen(whenAt))+'</span>.'):pr.message?esc(pr.message):'';
          var act=!mine?'':freed?' <button type="button" class="cmt-retry" data-retry="'+pr.cid+'">↻ Try again</button>':pr.fix&&(String(pr.fix.href||'').indexOf('/settings/')===0||pr.fix.href==='/plans')?' <a class="cmt-retry'+(pr.fix.upgrade?' cmt-upgrade':'')+'" href="'+esc(pr.fix.href)+'"'+(pr.fix.upgrade?' data-upgrade="'+esc(pr.fix.upgrade)+'"':'')+'>'+esc(pr.fix.label||"Set up")+'</a>':pr.retry===false?'':' <button type="button" class="cmt-retry" data-retry="'+pr.cid+'">↻ Try again</button>';
          h+='<div class="cmt-fail"><span>'+(pr.never?"Couldn’t start":"Couldn’t finish")+(msg?': '+msg:'')+'</span>'+act+'</div>';
          if(whenAt===whenAt&&!freed)whenTick();
        }
        h+='</article>';
      }
      if(sessPending[t.root.id])h+=sessRow(sessPending[t.root.id]);
      return h;
    }
    // A thread that asked "@session": where its message stands until the session's
    // answer lands as a reply. Keyed on the thread's root; the session, and how it
    // could be reached, come from the post's answer (askSessionFromComment).
    var sessPending={};
    function sessOf(c){if(c.via!=="session")return null;var m=/^session:([a-z0-9-]+):(.+)$/.exec(String(c.run_id||""));return{source:m?m[1]:"",id:m?m[2]:"",name:commentAuthor(c).name}}
    function sessAv(src){return '<span class="ss-av ss-av-xs cmt-avatar cmt-sess-av">'+(SESS_ICONS[src]||PROMPT_ICON)+'</span>'}
    function sessName(ref){return (ref&&SESS_AGENT[ref.source])||(ref&&ref.agent)||"Session"}
    function sessRow(sp){
      var ref=sp.session||{},m=sp.machine,dots='<span class="dots"><i></i><i></i><i></i></span>',line;
      if(sp.status==="unavailable")line='<div class="cmt-fail">'+esc(sp.message||"The session couldn’t be reached.")+'</div>';
      else if(sp.status==="sign"||sp.status==="hold")
        line='<div class="cmt-work is-idle">'+(sp.status==="hold"?'Confirm it’s you to send this one'+(sp.why?': '+esc(sp.why):'')+'.':'It goes to <b>'+esc(m.name)+'</b>'+(m.online?'':' when it’s back online')+', signed with your passkey.')+'</div>'+
          (sp.err?'<div class="cmt-fail">'+esc(sp.err)+'</div>':'')+'<button type="button" class="cmt-retry cmt-sess-act" data-sess-go="'+esc(sp.root)+'">'+(sp.status==="hold"?'Confirm with passkey':'Send with passkey')+'</button>';
      else if(sp.status==="sending")line='<div class="cmt-work">Sending'+(m?' to '+esc(m.name):'')+dots+'</div>';
      else if(sp.status==="queued")line='<div class="cmt-work is-idle">Waiting — the session isn’t listening. It gets this the next time it listens.</div>'+(window.ssTalk?'<button type="button" class="cmt-retry cmt-sess-act" data-sess-setup="'+esc(ref.session_id||"")+'">How to reach it</button>':'');
      else line='<div class="cmt-work">'+esc(sp.label||"Sent to the session")+dots+'</div>';
      var where=ref.machine?' on '+ref.machine:'';
      return '<article class="cmt reply" aria-live="polite"><div class="cmt-head">'+sessAv(ref.source)+'<span class="cmt-author">'+esc(sessName(ref))+'</span><span class="agent-tag" title="'+esc("The session that made this page"+where)+'">SESSION</span></div>'+line+'</article>';
    }
    // What the post (or an edit) answered for "@session". Through a computer the
    // message is signed here: at once when today's unlock holds, else on a press.
    function sessAsked(c,a){
      if(!a)return;var root=c.parent_id||c.id;
      if(a.status==="unavailable"){sessPending[root]={root:root,cid:c.id,status:"unavailable",message:a.message};return}
      var sp={root:root,cid:c.id,status:a.status,session:a.session||null,machine:a.machine||null,text:a.text||null};
      if(a.status==="sent")sp.label="Sent · "+sessName(a.session)+" is listening";
      sessPending[root]=sp;
      if(a.status==="sign"){
        var MC=window.ssMachine;
        if(!MC||!MC.supported){sp.status="unavailable";sp.message="This browser can’t use passkeys, so it can’t reach "+sp.machine.name+".";return}
        // The passkey prompt is readied before any press (Safari opens one only from a click).
        MC.prime().then(function(){if(sessPending[root]===sp&&sp.status==="sign"&&MC.unlocked(sp.machine.id))sessSend(sp)}).catch(function(){});
      }
    }
    function sessSend(sp){
      var MC=window.ssMachine;if(!MC||!sp.machine)return;
      // From the press: the passkey is asked before anything is awaited.
      var go=sp.status==="hold"&&sp.hold?sp.hold.confirm()
        :(MC.unlocked(sp.machine.id)?Promise.resolve():MC.hasPasskey()?MC.unlock(sp.machine.id):Promise.reject(new Error("Add a passkey for this computer first (Devices).")))
          .then(function(){return MC.send(sp.machine.id,{action:"message",session:sp.session.session_id,source:sp.session.source,text:sp.text,origin:{comment:sp.cid}})});
      var was=sp.status;sp.status="sending";sp.err="";renderComments();
      go.then(function(r){
        if(r&&r.hold){sp.status="hold";sp.hold=r.hold;sp.why=r.hold.why;renderComments();return}
        sp.status="sent";sp.hold=null;sp.label="Sent to "+sp.machine.name;renderComments();
        if(window.mixpanel)try{mixpanel.track("Comment Session Sent",{via:"machine"})}catch(x){}
      }).catch(function(e){sp.status=was==="hold"?"hold":"sign";sp.err=MC.cancelled(e)?"":(e&&e.message)||"Couldn’t send.";renderComments()});
    }
    // Where the message stands, from the session's own Talk thread (refetched on its
    // ss:talk nudge): picked up, the step it reported, its answer being written. On a
    // reload this is also what finds a thread still waiting on its session.
    var sessT=0;
    function sessRefresh(sid){
      if(!TALK)return;
      fetch("/api/space/"+spaceId+"/talk"+(sid?"?session="+encodeURIComponent(sid):"")).then(function(r){return r.ok?r.json():null}).then(function(d){
        if(!d||!d.session_id)return;
        var msgs=d.messages||[],last=null,i;
        for(i=msgs.length-1;i>=0;i--){if(msgs[i].dir==="from")return;last=msgs[i];break}
        var o=null;try{o=last&&last.origin?JSON.parse(last.origin):null}catch(x){}
        if(!o||o.kind!=="comment"||o.space_id!==spaceId||!comments.find(function(c){return c.id===o.root_id}))return;
        var sp=sessPending[o.root_id];
        if(sp&&sp.status!=="sent"&&sp.status!=="queued")return;
        var ses=(d.sessions||[]).find(function(x){return x.session_id===d.session_id})||{};
        if(!sp)sp=sessPending[o.root_id]={root:o.root_id,cid:o.comment_id,status:"sent",session:{session_id:d.session_id,source:d.source||"claude-code",agent:ses.label,machine:ses.machine||null}};
        var p=d.pending,st=d.status;
        sp.status=!last.delivered_at&&!d.listening&&!d.machine?"queued":"sent";
        sp.label=d.partial&&d.partial.text?"Writing its answer"
          :p&&p.state==="working"?(p.label||"Working on it")
          :st&&st.text&&(!p||p.state!=="waiting")?st.text.charAt(0).toUpperCase()+st.text.slice(1)
          :p&&p.state==="picked"?"Picked up · no reply yet"
          :p&&p.state==="stale"?"Picked up · no reply yet"
          :d.listening?"Sent · "+sessName(sp.session)+" is listening":"Sent";
        renderComments();
      }).catch(function(){});
    }
    window.addEventListener("ss:talk",function(e){
      var d=e.detail||{},sid=null;
      for(var k in sessPending){var sp=sessPending[k];if(sp.session&&(d.reconnected||d.session_id===sp.session.session_id))sid=sp.session.session_id}
      if(!sid)return;clearTimeout(sessT);sessT=setTimeout(function(){sessRefresh(sid)},400);
    });
    // On load: a comment of mine that asked "@session" and has no answer in its thread.
    function sessCheck(){
      if(!TALK)return;
      var need=comments.some(function(c){
        if(c.via||lcEmail(c.author_email)!==myEmail||!asksSession(c.body))return false;
        var root=c.parent_id||c.id;if(sessPending[root])return false;
        return !comments.some(function(r){return r.via==="session"&&r.parent_id===root&&r.created_at>c.created_at});
      });
      if(need)sessRefresh(null);
    }
    // "at 3:42 PM (in 23 min)", "tomorrow at 9:05 AM", "on Wed, Oct 29 at 3:42 PM":
    // when a spent allowance frees up, in the reader's own clock.
    function freesWhen(at){
      var now=new Date(),d=new Date(at),mins=Math.max(1,Math.ceil((at-now.getTime())/60000));
      var t=d.toLocaleTimeString([],{hour:"numeric",minute:"2-digit"});
      if(mins<60)return "at "+t+" (in "+mins+" min)";
      var day=function(x){return new Date(x.getFullYear(),x.getMonth(),x.getDate()).getTime()};
      var days=Math.round((day(d)-day(now))/86400000);
      if(days===0)return "at "+t;
      if(days===1)return "tomorrow at "+t;
      return "on "+d.toLocaleDateString([],{weekday:"short",month:"short",day:"numeric"})+" at "+t;
    }
    // Keeps those times current without redrawing the rail: the words change in
    // place each half minute, and the card is redrawn once, when the time comes.
    var whenTimer=0;
    function whenTick(){
      if(whenTimer)return;
      whenTimer=setTimeout(function(){
        whenTimer=0;var due=false,left=false;
        document.querySelectorAll(".cmt-when[data-at]").forEach(function(el){
          var at=+el.getAttribute("data-at");
          if(at<=Date.now())due=true;else{left=true;el.textContent=freesWhen(at)}
        });
        if(due)renderComments();else if(left)whenTick();
      },30000);
    }
    function pendingFor(rootId){for(var k in pending)if(pending[k].root===rootId)return pending[k];return null}
    function dropPending(cid){for(var k in pending)if(pending[k].cid===cid)delete pending[k]}
    // The wait says what the turn is doing, never what it might do: a question asked
    // by someone who could edit used to read "Changing the page" from the first second,
    // and nothing had changed (2026-10-13). It says "Changing" only once the run sends
    // a change (workSaw), and "Writing a reply" once its words start.
    function workLabel(c){return "Thinking"}
    function changeLabel(cid){var c=comments.find(function(x){return x.id===cid});return c&&(c.anchor_id||c.parent_id)?"Changing this spot":"Changing the page"}
    function workSaw(p,kind){
      if(!p||p.status!=="running"||p.changing)return false;
      var l;if(kind==="change"){p.changing=true;l=changeLabel(p.cid)}else l="Writing a reply";
      if(p.label===l)return false;p.label=l;return true;
    }
    var REPLY_ICON="\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M2 10C2 10 13 10 16 10C24 10 24 21 16 21M2 10L9 3M2 10L9 17\"/\u003e\u003c/svg\u003e";
    var SMILE_ICON="\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z\"/\u003e\u003cpath d=\"M16.5 14.5C16.5 14.5 15 16.5 12 16.5C9 16.5 7.5 14.5 7.5 14.5\"/\u003e\u003cpath d=\"M15.5 9C15.2239 9 15 8.77614 15 8.5C15 8.22386 15.2239 8 15.5 8C15.7761 8 16 8.22386 16 8.5C16 8.77614 15.7761 9 15.5 9Z\" fill=\"currentColor\"/\u003e\u003cpath d=\"M8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5C9 8.77614 8.77614 9 8.5 9Z\" fill=\"currentColor\"/\u003e\u003c/svg\u003e",CHECK_ICON="\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M5 13L9 17L19 7\"/\u003e\u003c/svg\u003e",MORE_ICON="\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M3.4 12a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0 -3.2 0\" fill=\"currentColor\" stroke=\"none\"/\u003e\u003cpath d=\"M10.4 12a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0 -3.2 0\" fill=\"currentColor\" stroke=\"none\"/\u003e\u003cpath d=\"M17.4 12a1.6 1.6 0 1 0 3.2 0a1.6 1.6 0 1 0 -3.2 0\" fill=\"currentColor\" stroke=\"none\"/\u003e\u003c/svg\u003e";
    function threadFoot(t){
      var who={};who[lcEmail(t.root.author_email)]=1;t.replies.forEach(function(r){who[lcEmail(r.author_email)]=1});
      var n=Object.keys(who).length;
      return '<div class="thread-foot"><button type="button" class="thread-reply"'+(t.root._tmp?' disabled':'')+' data-reply="'+t.root.id+'" aria-label="Reply to '+esc(commentAuthor(t.root).name)+'">'+REPLY_ICON+ssT("cmt.reply","Reply")+'</button><span class="thread-people">'+(n>1?n+' people in this thread':'')+'</span></div>';
    }
    // Inline reply: its own box under the thread. The main composer at the foot of
    // the rail is never touched, so a half-written root comment survives a reply.
    // The draft is kept in inlineReply so a live re-render (someone else posting)
    // rebuilds the box with the text still in it.
    var inlineReply=null;
    function announce(msg){var el=document.getElementById("sbStatus");if(el){el.textContent="";setTimeout(function(){el.textContent=msg},50)}}
    function closeInlineReply(){composingOff();if(inlineReply&&inlineReply.vs&&inlineReply.vs.cancel)inlineReply.vs.cancel(false);if(inlineReply&&inlineReply.tray)inlineReply.tray.clear();inlineReply=null;var b=document.getElementById("inlineReply");if(b)b.remove()}
    // Editing your own comment, in place. The draft lives in cmtEdit, like a reply's,
    // so a live re-render (someone else posting) rebuilds the box with the words kept.
    // The save is the route that always existed (PATCH, author only); an edit tells
    // only the people it newly mentions, never the thread again.
    var cmtEdit=null;
    function openCmtEdit(id){
      var c=comments.find(function(x){return x.id===id});if(!c)return;
      cmtEdit={id:id,text:c.body,focus:true};renderComments();
    }
    function closeCmtEdit(){var id=cmtEdit&&cmtEdit.id;cmtEdit=null;renderComments();var b=id&&document.querySelector('#sbList [data-more="'+id+'"]');if(b)b.focus()}
    function wireCmtEdit(){
      var box=document.getElementById("cmtEdit");if(!box||!cmtEdit)return;
      var ta=box.querySelector("textarea"),save=box.querySelector(".cmt-edit-save"),id=cmtEdit.id;
      ta.value=cmtEdit.text;
      function sync(){cmtEdit.text=ta.value;var v=ta.value.trim();save.disabled=!v||v.length>10000}
      sync();ta.oninput=sync;
      var menu=document.createElement("div");menu.className="mention-menu";menu.style.display="none";
      box.querySelector(".compose-row").style.position="relative";box.querySelector(".compose-row").appendChild(menu);
      bindCommentAutocomplete(ta,save,menu,"edit");
      ta.addEventListener("keydown",function(e){
        if(e.defaultPrevented)return;
        if(e.key==="Escape"){e.preventDefault();e.stopPropagation();closeCmtEdit();return}
        if(e.key==="Enter"&&!e.shiftKey&&!e.altKey){e.preventDefault();if(!save.disabled)save.click()}
      });
      box.querySelector(".cmt-edit-cancel").onclick=function(){closeCmtEdit()};
      save.onclick=function(){
        var body=ta.value.trim(),c=comments.find(function(x){return x.id===id});
        if(!body||!c)return;
        if(body===c.body){closeCmtEdit();return}
        save.disabled=true;ta.disabled=true;
        // An edit that adds @co-shepherd waits for the turn to start; say so.
        var saveLabel=save.textContent;save.textContent=asksAgent(body)&&!asksAgent(c.body)?"Asking Shepherd…":asksSession(body)&&!asksSession(c.body)?"Asking the session…":"Saving…";
        fetch("/api/space/"+spaceId+"/comments/"+encodeURIComponent(id),{method:"PATCH",headers:{"Content-Type":"application/json"},body:JSON.stringify({body:body})})
          .then(function(r){if(!r.ok)throw new Error();return r.json()}).then(function(d){
            c.body=body;c.updated_at=(d&&d.updated_at)||new Date().toISOString();
            // The edit added @co-shepherd: it asked, so the card works like a new ask's.
            var a=d&&(d.agent||(d.agent_starting?{status:"starting"}:null));
            if(a)agentAck(c,a);
            if(d&&d.session)sessAsked(c,d.session);
            if(window.mixpanel)try{mixpanel.track("Comment Edited",{space_id:spaceId,reply:!!c.parent_id,agent:!!a})}catch(x){}
            closeCmtEdit();announce(a&&(a.status==="started"||a.status==="starting")?"Comment saved — asked the Shepherd":"Comment saved");
          }).catch(function(){save.disabled=false;ta.disabled=false;save.textContent=saveLabel;toast("Couldn’t save the edit")});
      };
      window.ssAutoGrow(ta);
      if(cmtEdit.focus){cmtEdit.focus=false;ta.focus();var L=ta.value.length;try{ta.setSelectionRange(L,L)}catch(x){}}
    }
    function openInlineReply(rootId,focus){
      var th=document.querySelector('#sbList [data-thread="'+rootId+'"]');if(!th)return;
      // A re-render mid-typing (someone else posted, a live refetch) rebuilds the box:
      // keep focus and the caret where they were, or the keystrokes fall on the floor.
      var old=document.getElementById("inlineReply"),hadFocus=!!(old&&old.contains(document.activeElement));if(old)old.remove();
      if(!inlineReply||inlineReply.root!==rootId)inlineReply={root:rootId,text:""};
      var rc=comments.find(function(c){return c.id===rootId});
      var box=document.createElement("div");box.className="inline-reply";box.id="inlineReply";
      box.innerHTML='<div class="compose-row ss-pill-field"><textarea rows="1" data-ss-grow placeholder="'+ssT("cmt.reply_placeholder","Reply…")+'" aria-label="Reply to '+esc(rc?commentAuthor(rc).name:"this thread")+'" aria-describedby="composeHint"></textarea>'+
        '<button type="button" class="ss-send-enter" aria-label="Send reply" title="Send reply (Enter)" disabled>'+document.getElementById("composeSend").innerHTML+'</button></div>'+
        '<div class="inline-reply-foot"><button type="button" class="inline-cancel">Cancel</button><span class="inline-hint">Enter sends &middot; Shift+Enter new line</span></div>';
      th.appendChild(box);
      var ta=box.querySelector("textarea"),send=box.querySelector(".ss-send-enter");
      var tray=inlineReply.tray||(inlineReply.tray=makeTray());
      box.insertBefore(tray.el,box.querySelector(".compose-row"));
      tray.onChange=function(){send.disabled=!canSend(ta)};
      wireTray(ta,box,tray);
      ta.value=inlineReply.text;send.disabled=!canSend(ta);
      ta.oninput=function(){inlineReply.text=ta.value;send.disabled=!canSend(ta);if(ta.value.trim())composingOn({thread:rootId,text:ta.value},true)};
      var replyMenu=document.createElement("div");replyMenu.className="mention-menu";replyMenu.style.display="none";
      box.querySelector(".compose-row").style.position="relative";box.querySelector(".compose-row").appendChild(replyMenu);
      bindCommentAutocomplete(ta,send,replyMenu,"reply");
      voiceSend(ta,send,{box:"reply",state:inlineReply.vs||(inlineReply.vs={}),posted:function(tmp,text){voiceUndo(tmp,function(){inlineReply={root:rootId,text:text};openInlineReply(rootId,true)})}});
      ta.addEventListener("keydown",function(e){
        if(e.defaultPrevented)return;
        if(e.key==="Escape"){e.preventDefault();closeInlineReply();var rb=th.querySelector(".thread-reply");if(rb)rb.focus();return}
        if(e.key==="Enter"&&!e.shiftKey&&!e.altKey){e.preventDefault();if(!send.disabled)send.click()}
      });
      box.querySelector(".inline-cancel").onclick=function(){closeInlineReply();var rb=th.querySelector(".thread-reply");if(rb)rb.focus()};
      send.onclick=function(){
        if(!canSend(ta))return;
        var body=ta.value.trim(),payload={body:body,parent_id:rootId},imgs=trayKeys(ta),pics=trayPics(ta);if(imgs.length)payload.images=imgs;
        var wasPeek=peekReply===rootId;
        // Focus goes back to Reply for whoever reached the box by keyboard. A
        // mouse user who opened it doesn't need it, and the focus ring would sit
        // on the pill until their next click.
        var back=!(inlineReply&&inlineReply.pointer);
        peekReply=null;composingOff();tray.clear();inlineReply=null;
        // The reply is on the thread before the server has it (sendTmp's card); the
        // box closes with it, so the next thought can start at once.
        var tmp=optimisticRow(payload,pics);arrived[tmp.id]=Date.now();comments.push(tmp);renderComments();
        var rb=back&&document.querySelector('#sbList [data-thread="'+rootId+'"] .thread-reply');if(rb)rb.focus();
        sendTmp(tmp,{onOk:function(c,ms,spoken){
          if(window.mixpanel)try{mixpanel.track("Comment Posted",{reply:true,pinned:false,space_id:spaceId,images:imgs.length,agent:asksAgent(body)||!!c.agent_followup,voice:spoken,post_ms:ms})}catch(x){}
          if(wasPeek&&window.mixpanel)try{mixpanel.track("Comment Created",{space_id:spaceId,is_reply:true,has_anchor:false,pinned:false,quoted:false,agent:asksAgent(body)||!!c.agent_followup,via:"peek-reply",voice:spoken,phone:PHONE_MQ.matches,images:imgs.length})}catch(x){}
        },fail:function(){announce("Couldn't post the reply")}});
      };
      window.ssAutoGrow(ta);
      if(focus||hadFocus){ta.focus();var L=ta.value.length;try{ta.setSelectionRange(L,L)}catch(x){}}
      if(focus)box.scrollIntoView({behavior:"smooth",block:"nearest"});
    }
    function anchorOf(c){
      if(!c.anchor_id)return null;
      var a=null;try{a=c.anchor_json?JSON.parse(c.anchor_json):null}catch(x){a=null}
      // A comment pinned before pins had a place sits at its block's top-right
      // corner, where its chip used to be.
      if(!a||typeof a.x!=="number"||typeof a.y!=="number")return{x:.97,y:.08,tag:null,quote:false,legacy:true};
      return{x:Math.max(0,Math.min(1,a.x)),y:Math.max(0,Math.min(1,a.y)),tag:a.tag||null,quote:!!a.quote,near:typeof a.near==="string"?a.near:null,path:a.path||null,part:cleanPart(a.part),thing:cleanThing(a.thing)};
    }
    // The part of a block a pin sits on (a table cell, a list item): its path from
    // the block, where inside its box, and its words (comment-anchors.ts). The frame
    // is the author's page, so a part is checked here the way the server checks it —
    // one that wouldn't pass is dropped, never the comment it came with.
    var PART_STEP=/^[a-z][a-z0-9._-]{0,39}:[0-9]{1,4}$/;
    function cleanPart(p){
      if(!p||typeof p!=="object"||typeof p.at!=="string"||p.at.length>300)return null;
      var steps=p.at.split("/");if(steps.length>12)return null;
      for(var i=0;i<steps.length;i++)if(!PART_STEP.test(steps[i]))return null;
      if(typeof p.x!=="number"||typeof p.y!=="number"||!isFinite(p.x)||!isFinite(p.y))return null;
      var o={at:p.at,x:Math.max(0,Math.min(1,p.x)),y:Math.max(0,Math.min(1,p.y))};
      if(typeof p.text==="string"&&p.text&&p.text.length<=80&&!/[<>]/.test(p.text))o.text=p.text;
      return o;
    }
    // A part the page names (data-ss-thing, comment-anchors.ts parseAnchorThing): the
    // name, what the page calls it, and where inside its box. Checked the way the
    // server checks it; a bad label is dropped, a bad name drops the whole thing.
    var THING_SEG=/^[A-Za-z0-9._:~@+=-]{1,80}$/;
    function cleanThing(t){
      if(!t||typeof t!=="object"||typeof t.id!=="string"||!t.id||t.id.length>400)return null;
      var sg=t.id.split("/");if(sg.length>40)return null;
      for(var i=0;i<sg.length;i++)if(!THING_SEG.test(sg[i]))return null;
      if(typeof t.x!=="number"||typeof t.y!=="number"||!isFinite(t.x)||!isFinite(t.y))return null;
      var o={id:t.id,x:Math.max(0,Math.min(1,t.x)),y:Math.max(0,Math.min(1,t.y))};
      if(typeof t.label==="string"){var l=t.label.replace(/\s+/g," ").trim();if(l&&l.length<=80&&!/[<>\u0000-\u001f]/.test(l))o.label=l}
      return o;
    }
    var KINDS={h1:"Title",h2:"Heading",h3:"Heading",h4:"Heading",h5:"Heading",h6:"Heading",p:"Paragraph",li:"List item",figure:"Chart",svg:"Chart",canvas:"Chart",img:"Image",picture:"Image",table:"Table",tr:"Table",td:"Cell",th:"Cell",dt:"Term",dd:"Definition",figcaption:"Caption",blockquote:"Quote",pre:"Code",code:"Code",section:"Section",article:"Section",ul:"List",ol:"List",text:"Label",tspan:"Label",foreignobject:"Label",g:"Shape",rect:"Shape",circle:"Shape",ellipse:"Shape",path:"Shape",polygon:"Shape",polyline:"Shape",line:"Shape",button:"Button",a:"Link",input:"Field",select:"Field",textarea:"Field",video:"Video",audio:"Audio",summary:"Summary"};
    function kindOf(a){if(a&&a.quote)return"Quote";if(a&&a.thing)return"Part";var t=a&&a.part?a.part.at.split("/").pop().split(":")[0]:a&&a.tag;return(t&&KINDS[t])||"Block"}
    function changeOf(c){var ch=null;try{ch=c.change_json?JSON.parse(c.change_json):null}catch(x){ch=null}return ch&&ch.sha&&ch.prev_sha?ch:null}
    function shortQ(t,n){t=String(t||"").replace(/\s+/g," ").trim();return t.length>n?t.slice(0,n-1)+"…":t}
    function changeRow(c,ch){
      var v=ch.number?' · v'+ch.number:'';
      var what=(typeof ch.from==="string"&&typeof ch.to==="string")?'Changed <code>“'+esc(shortQ(ch.from,60))+'”</code> → <code>“'+esc(shortQ(ch.to,60))+'”</code>':(ch.count>1?'Changed '+ch.count+' spots':'Changed '+(ch.anchor?'#'+esc(ch.anchor):'the page'));
      if(ch.undone_sha){
        var back=(typeof ch.from==="string")?' puts back <code>“'+esc(shortQ(ch.from,60))+'”</code>':' put it back';
        return '<div class="cmt-did undone"><span>Undone.'+(ch.undone_number?' v'+ch.undone_number:' A later version')+back+'</span>'+(CAN_EDIT?'<a class="cmt-did-a" href="/space/'+encodeURIComponent(spaceId)+'/diff?from='+encodeURIComponent(ch.prev_sha)+'&to='+encodeURIComponent(ch.sha)+'" target="_blank" rel="noopener">See change</a>':'')+'</div>';
      }
      return '<div class="cmt-did"><span>'+what+v+'</span>'+(CAN_EDIT?'<button type="button" class="cmt-did-a" data-undo="'+c.id+'">'+ssT("cmt.undo","Undo")+'</button>':'')+(CAN_EDIT?'<a class="cmt-did-a" href="/space/'+encodeURIComponent(spaceId)+'/diff?from='+encodeURIComponent(ch.prev_sha)+'&to='+encodeURIComponent(ch.sha)+'" target="_blank" rel="noopener" data-see="'+c.id+'">See change</a>':'')+'</div>';
    }
    // A comment deleted while it has replies stays as a placeholder that keeps the
    // thread's place: its words, pictures and reactions go.
    function softDelete(id){
      comments.forEach(function(c){if(c.id===id){c.body="[deleted]";c.images=null}});
      reactions=reactions.filter(function(r){return r.comment_id!==id});
    }
    function isGone(c){return c.body==="[deleted]"}
    // Delete asks on the card itself, in words that say what happens to the thread:
    // a comment with replies leaves a placeholder, and the last reply under one takes
    // the placeholder with it.
    var delAsk=null;
    function delConfirm(c){
      var n=comments.filter(function(x){return x.parent_id===c.id}).length;
      var parent=c.parent_id&&comments.find(function(x){return x.id===c.parent_id});
      var last=parent&&isGone(parent)&&comments.filter(function(x){return x.parent_id===parent.id}).length===1;
      var what=n?(n===1?"Its reply stays, under “This comment was deleted.”":"Its "+n+" replies stay, under “This comment was deleted.”"):last?"This is the last reply, so the whole thread goes.":"This can’t be undone.";
      var mine=lcEmail(c.author_email)===myEmail&&c.via!=="co-shepherd"&&c.via!=="session";
      return '<div class="cmt-confirm" role="group" aria-label="Confirm delete"><p><b>Delete '+(mine?"your":"this")+' '+(c.parent_id?"reply":"comment")+'?</b> '+what+'</p><div class="cmt-confirm-row"><button type="button" class="ss-btn ss-btn--danger-solid ss-btn--sm" data-delyes="'+c.id+'">Delete</button><button type="button" class="ss-btn ss-btn--soft ss-btn--sm" data-delno="'+c.id+'">Cancel</button></div></div>';
    }
    function whereBtn(c){var a=anchorOf(c);return '<button type="button" class="cmt-where" data-go="'+c.id+'" title="Show on the page"><span class="cmt-kind">'+esc(kindOf(a))+'</span><span class="cmt-ex'+(a&&a.quote?' is-q':'')+'">'+(a&&a.quote?'“'+esc(shortQ(c.anchor_text,90))+'”':esc(shortQ(c.anchor_text||c.anchor_id,90)))+'</span><span class="cmt-go" aria-hidden="true">↗</span></button>'}
    // A missing account/handle is an inert identity; never guess from an email.
    // Agent marks describe the agent, not the person who asked it to comment.
    function commentProfile(c){return c.via!=="claude"&&c.via!=="co-shepherd"&&c.via!=="session"&&typeof c.author_username==="string"&&c.author_username.trim()?"/@"+encodeURIComponent(c.author_username):null}
    function commentIdentityLink(c,html,cls,name){var href=commentProfile(c);return href?'<a class="cmt-profile '+cls+'" href="'+esc(href)+'" aria-label="'+esc("View "+name+"’s profile")+'">'+html+'</a>':'<span class="'+cls+'">'+html+'</span>'}
    // The agent's reply written as HTML (a verdict per section, a flow, a table) is
    // drawn where it sits, by the web chats' renderer (assets/components/
    // agent-reply.ts): an empty body here, filled by paintRich once the cards are in
    // the page. People's comments stay words. Any tag counts, not only a block run:
    // words with an inline <b> went to the comment renderer, which escapes HTML, and
    // the thread showed the tags (2026-10-27).
    function richCmt(c){return !!(c&&c.via==="co-shepherd"&&c.body&&window.ssAgentReply&&/<[a-zA-Z]/.test(c.body))}
    function paintRich(root){
      var els=root.querySelectorAll("[data-rich]");
      for(var i=0;i<els.length;i++){var id=els[i].getAttribute("data-rich"),c=null;for(var j=0;j<comments.length;j++)if(comments[j].id===id){c=comments[j];break}if(c)window.ssAgentReply.render(els[i],c.body)}
    }
    function cmtWords(c){return richCmt(c)?window.ssAgentReply.preview(c.body):String(c.body||"")}
    function renderCmt(c,isReply){
      if(isGone(c))return renderGone(c,isReply);
      var rxns=getRxns(c.id),isBot=c.via==="claude",isAgent=c.via==="co-shepherd",sess=sessOf(c),fresh=isNew(c);
      // A person's own words changed after posting; an agent card's updated_at moves
      // with its change and undo, which is not an edit.
      var edited=!isBot&&!isAgent&&!sess&&!!c.updated_at&&c.updated_at!==c.created_at;
      var identity=commentAuthor(c),name=identity.name,pic=isBot||isAgent||sess?null:c.author_picture;
      // The AI authors keep their own marks; everyone else is the shared avatar.
      var av=isBot
        ? '<span class="ss-av ss-av-xs cmt-avatar is-bot-avatar">✦</span>'
        : isAgent ? '<span class="ss-av ss-av-xs cmt-avatar cmt-agent-av">'+SHEEP+'</span>'
        : sess ? sessAv(sess.source)
        : ssAvatar({seed:c.author_email,name:name,picture:pic,size:"xs",className:"cmt-avatar"});
      if(!isBot&&!isAgent&&!sess)av=commentIdentityLink(c,av,"cmt-avatar-link",name);
      var h='<article class="cmt'+(isReply?" reply":"")+(fresh?" new":"")+(arrived[c.id]&&Date.now()-arrived[c.id]<1500?" arrive":"")+(c._tmp?(c._state==="sending"?" sending":" failed"):"")+'" data-id="'+c.id+'" aria-label="'+(isReply?'Reply':'Comment')+' by '+esc(name)+'">';
      if(!isReply){
        // Where it is: the kind of block, its words (or the quote), and the way there.
        if(c.anchor_id)h+=whereBtn(c);
        else if(c.anchor_text)h+='<div class="cmt-anchor cmt-quote">&ldquo;'+esc(c.anchor_text)+'&rdquo;</div>';
        // A comment on the whole page has no place to name: the list says "Whole
        // page" once above them all (renderComments), not on every card.
      }
      h+='<div class="cmt-head">'+av+commentIdentityLink(c,esc(name),"cmt-author",name)+(isBot?'<span class="bot-badge" title="via '+esc(c.author_name||c.author_email)+'">'+identity.marker+'</span>':'')+(isAgent?'<span class="agent-tag" title="'+AGENT_NAME+', asked by '+esc(c.author_name||c.author_email.split("@")[0])+'">'+identity.marker+'</span>':'')+(sess?(IS_OWNER&&sess.id?'<a class="agent-tag" href="/sessions/'+encodeURIComponent(sess.source)+'/'+encodeURIComponent(sess.id)+'" target="_top" title="Open the session that made this page">'+identity.marker+'</a>':'<span class="agent-tag" title="The session that made this page, answering for '+esc(c.author_name||c.author_email.split("@")[0])+'">'+identity.marker+'</span>'):'')+(fresh?'<span class="new-pill" aria-label="New since you last looked">new</span>':'')+'<time class="cmt-time" datetime="'+esc(c.created_at)+'" title="'+esc(new Date(c.created_at).toLocaleString())+'">'+(c._tmp&&c._state==="sending"?ssT("cmt.sending","Sending"):relTime(c.created_at))+'</time>'+(cmtEdit&&cmtEdit.id===c.id||delAsk===c.id||c._tmp?'':cmtTools(c))+'</div>';
      if(cmtEdit&&cmtEdit.id===c.id)h+='<div class="cmt-edit" id="cmtEdit"><div class="compose-row ss-pill-field"><textarea rows="1" data-ss-grow aria-label="Edit your comment"></textarea></div><div class="cmt-edit-row"><button type="button" class="ss-btn ss-btn--sm ss-btn--primary cmt-edit-save">Save</button><button type="button" class="inline-cancel cmt-edit-cancel">Cancel</button><span class="inline-hint">Enter saves &middot; Esc cancels</span></div></div>';
      else if(isAgent&&richCmt(c))h+='<div class="cmt-body rich'+(bodyOpen[c.id]?'':' clamp')+'" data-rich="'+esc(c.id)+'"></div>'+(bodyOpen[c.id]?'':'<button type="button" class="cmt-unfold" data-unfold="'+c.id+'">'+ssT("cmt.show_more","Show more")+'</button>');
      else if(c.body||edited){var bodyHtml=mkBody(c.body),edMark=edited?'<span class="cmt-edited" title="Edited '+esc(new Date(c.updated_at).toLocaleString())+'"> (edited)</span>':'';h+='<div class="cmt-body'+(bodyOpen[c.id]?'':' clamp')+'">'+(edMark&&/<\/p>$/.test(bodyHtml)?bodyHtml.slice(0,-4)+edMark+'</p>':bodyHtml+edMark)+'</div>'+(bodyOpen[c.id]?'':'<button type="button" class="cmt-unfold" data-unfold="'+c.id+'">'+ssT("cmt.show_more","Show more")+'</button>')}
      h+=cmtPics(c);
      if(c._tmp&&c._state!=="sending")h+=cmtFail(c);
      var ch=isAgent?changeOf(c):null;
      if(ch)h+=changeRow(c,ch);
      var rx='';if(rxns.length){rx+='<div class="reactions">';rxns.forEach(function(r){rx+='<button type="button" class="rxn'+(r.mine?" mine":"")+'" data-comment="'+c.id+'" data-emoji="'+esc(r.emoji)+'" aria-pressed="'+(r.mine?"true":"false")+'" aria-label="'+esc(r.emoji)+' '+r.count+(r.mine?', you reacted':'')+'"'+rxTipAttr(r.names,r.count)+'>'+r.emoji+' <span class="rxn-count" aria-hidden="true">'+r.count+'</span></button>'});rx+='</div>'}
      // While its words are being edited, the card's own row steps aside: Save and
      // Cancel are the only actions that mean anything then.
      if(cmtEdit&&cmtEdit.id===c.id)return h+'</article>';
      if(delAsk===c.id)return h+rx+delConfirm(c)+'</article>';
      // Only reactions people actually left take a row. The card's actions are its
      // toolbar (cmtTools), and Reply is the thread's.
      if(rx)h+='<div class="cmt-foot">'+rx+'</div>';
      return h+'</article>';
    }
    // What a person may do to one comment. Two lists read the same rules: the
    // toolbar (react and resolve, shown on hover or focus) and the ⋯ menu (edit,
    // link, delete — and on a touch screen, which has no hover, react and resolve
    // too). Five buttons under every card were what made a quiet thread loud.
    function cmtCan(c){
      var mine=lcEmail(c.author_email)===myEmail,isBot=c.via==="claude",isAgent=c.via==="co-shepherd"||c.via==="session";
      return{
        resolve:!c.parent_id&&!c.resolved_at&&(ON_ROSTER||mine),
        edit:mine&&!isAgent&&!isBot,
        // Your own words, or anything on your own page — the Co-shepherd's and the
        // session's replies included, which the asker can't take back but the
        // page's owner can.
        del:(mine&&!isAgent)||IS_OWNER
      };
    }
    function cmtTools(c){
      var can=cmtCan(c),t='<div class="cmt-tools" role="group" aria-label="'+esc(ssT("cmt.actions","Comment actions"))+'">';
      t+='<button type="button" class="cmt-tool t-hov" data-react="'+c.id+'" aria-label="'+esc(ssT("cmt.react","Add a reaction"))+'" data-tip="'+esc(ssT("cmt.react","Add a reaction"))+'" data-tip-at="below">'+SMILE_ICON+'</button>';
      if(can.resolve)t+='<button type="button" class="cmt-tool t-hov" data-resolve="'+c.id+'" aria-label="'+esc(ssT("cmt.resolve","Resolve"))+'" data-tip="'+esc(ssT("cmt.resolve","Resolve"))+'" data-tip-at="below">'+CHECK_ICON+'</button>';
      t+='<button type="button" class="cmt-tool" data-more="'+c.id+'" aria-haspopup="menu" aria-expanded="false" aria-label="'+esc(ssT("cmt.more","More actions"))+'">'+MORE_ICON+'</button>';
      return t+'</div>';
    }
    // The ⋯ menu (assets/components/menu.ts): it follows its button while the list
    // scrolls and across a re-render, and goes when its button leaves the list.
    // While it's open the card keeps its hover tools up (tools-on).
    
    window.ssMenu=window.ssMenu||(function(){
      var CK="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M5 13L9 17L19 7\"/></svg>",m=null;
      function esc(s){var d=document.createElement("div");d.textContent=s==null?"":String(s);return d.innerHTML.replace(/"/g,"&quot;")}
      function rows(){return Array.prototype.filter.call(m.el.querySelectorAll(".ss-mi"),function(b){return b.offsetParent!==null&&!b.disabled})}
      function place(){
        if(!m)return;
        var r=m.btn.getBoundingClientRect(),w=m.el.offsetWidth,h=m.el.offsetHeight;
        if(!m.btn.isConnected){close(false);return}
        if(m.within){var lr=m.within.getBoundingClientRect();if(r.bottom<lr.top||r.top>lr.bottom){close(false);return}}
        var top=r.bottom+4;if(top+h>window.innerHeight-8)top=Math.max(8,r.top-h-4);
        if(m.match){m.el.style.width=r.width+"px";w=m.el.offsetWidth;m.el.style.top=top+"px";m.el.style.left=Math.max(8,Math.min(r.left,window.innerWidth-w-8))+"px";return}
        m.el.style.top=top+"px";m.el.style.left=Math.max(8,Math.min(m.start?r.left:r.right-w,window.innerWidth-w-8))+"px";
      }
      function mark(open){m.btn.setAttribute("aria-expanded",open?"true":"false");if(m.onToggle)m.onToggle(open,m.btn)}
      function close(back){
        if(!m)return;var c=m;
        if(c.btn.isConnected){mark(false);if(back)c.btn.focus()}
        m=null;c.el.remove();
        document.removeEventListener("pointerdown",c.away,true);window.removeEventListener("blur",c.blur);
        document.removeEventListener("scroll",place,true);window.removeEventListener("resize",place);
      }
      function open(btn,items,o){
        o=o||{};
        var again=m&&m.btn===btn;close(false);if(again)return;
        var checks=items.some(function(it){return typeof it.checked==="boolean"});
        var el=document.createElement("div");el.className="ss-menu"+(o.fit?" fit":"")+(o.match?" match":"");el.setAttribute("role","menu");
        if(o.label)el.setAttribute("aria-label",o.label);
        el.innerHTML=items.map(function(it){
          if(it.sep)return '<div class="ss-mi-sep" role="separator"></div>';
          if(it.note!=null)return '<div class="ss-mi-note" role="presentation">'+esc(it.note)+'</div>';
          var radio=typeof it.checked==="boolean";
          return '<button type="button" role="'+(radio?'menuitemradio':'menuitem')+'"'+(radio?' aria-checked="'+it.checked+'"':'')+' class="ss-mi'+(it.touchOnly?' m-touch':'')+(it.danger?' danger':'')+(it.sub?' has-sub':'')+'" data-k="'+esc(it.k)+'"'+(it.disabled?' disabled':'')+'>'+
            (checks?'<span class="ss-mi-ck" aria-hidden="true">'+CK+'</span>':'')+
            (it.icon?'<span class="ss-mi-ic" aria-hidden="true">'+it.icon+'</span>':'')+
            '<span class="ss-mi-t">'+esc(it.l)+(it.sub?'<span class="ss-mi-sub">'+esc(it.sub)+'</span>':'')+'</span></button>';
        }).join("");
        document.body.appendChild(el);
        m={el:el,btn:btn,key:o.key,within:o.within||null,onToggle:o.onToggle,match:!!o.match,start:!!o.start,
          away:function(e){if(m&&!m.el.contains(e.target)&&!m.btn.contains(e.target))close(false)},
          blur:function(){close(false)}};
        // Listen before placing: place() closes a menu whose button is already out of
        // its list, and close() takes these back off.
        mark(true);
        document.addEventListener("pointerdown",m.away,true);window.addEventListener("blur",m.blur);
        document.addEventListener("scroll",place,true);window.addEventListener("resize",place);
        place();if(!m)return;
        el.addEventListener("keydown",function(e){
          var bs=rows(),i=bs.indexOf(document.activeElement);
          if(e.key==="Escape"){e.preventDefault();e.stopPropagation();close(true)}
          else if(e.key==="ArrowDown"){e.preventDefault();bs[(i+1)%bs.length].focus()}
          else if(e.key==="ArrowUp"){e.preventDefault();bs[(i-1+bs.length)%bs.length].focus()}
          else if(e.key==="Home"){e.preventDefault();bs[0].focus()}
          else if(e.key==="End"){e.preventDefault();bs[bs.length-1].focus()}
          else if(e.key==="Tab")close(false);
        });
        el.addEventListener("click",function(e){
          var b=e.target.closest(".ss-mi");if(!b||b.disabled||!m)return;
          var k=b.getAttribute("data-k"),at=m.btn;close(false);if(o.onPick)o.onPick(k,at);
        });
        var bs=rows(),first=el.querySelector('.ss-mi[aria-checked="true"]:not(:disabled)')||bs[0];
        if(first&&first.offsetParent!==null)first.focus({preventScroll:true});else if(bs[0])bs[0].focus({preventScroll:true});
      }
      function reanchor(nb){
        if(!m)return;if(!nb){close(false);return}
        m.btn=nb;mark(true);place();
      }
      return{open:open,close:close,reanchor:reanchor,place:place,current:function(){return m?{btn:m.btn,key:m.key}:null}};
    })();
  
    function cmtToolsOn(open,b){var c=b.closest(".cmt");if(c)c.classList.toggle("tools-on",open)}
    function reanchorCmtMenu(list){
      var cur=ssMenu.current();if(!cur||!cur.key||cur.key.indexOf("cmt:")!==0)return;
      ssMenu.reanchor(list.querySelector('[data-more="'+cur.key.slice(4)+'"]'));
    }
    function openCmtMenu(btn,id){
      var c=comments.find(function(x){return x.id===id});if(!c)return;
      var can=cmtCan(c),items=[];
      items.push({k:"react",l:ssT("cmt.react","Add a reaction"),touchOnly:true});
      if(can.resolve)items.push({k:"resolve",l:ssT("cmt.resolve","Resolve"),touchOnly:true});
      if(can.edit)items.push({k:"edit",l:ssT("viewer.edit","Edit")});
      items.push({k:"link",l:ssT("cmt.copy_link","Copy link")});
      if(can.del)items.push({k:"delete",l:ssT("cmt.delete","Delete"),danger:true});
      ssMenu.open(btn,items,{key:"cmt:"+id,within:document.getElementById("sbList"),onToggle:cmtToolsOn,onPick:function(k,at){cmtAction(k,id,at,"menu")}});
    }
    function cmtAction(k,id,btn,from){
      if(window.mixpanel)try{mixpanel.track("Comment Action",{space_id:spaceId,action:k,from:from,phone:PHONE_MQ.matches})}catch(x){}
      if(k==="react"){openEmojiPicker(btn,REACTIONS,function(em){toggleReaction(id,em)});return}
      if(k==="resolve"){setResolved(id,true,true);return}
      if(k==="edit"){openCmtEdit(id);return}
      if(k==="delete"){delAsk=id;renderComments();var yes=document.querySelector('#sbList [data-delyes="'+id+'"]');if(yes)yes.focus();return}
      if(k==="link"){
        var url=location.origin+location.pathname+"?comment="+id;
        var done=function(){toast(ssT("cmt.link_copied","Link copied"))};
        if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(url).then(done,function(){window.ssCopy(url,btn)});
        else window.ssCopy(url,btn);
      }
    }
    // A long comment folds to its first lines so one essay can't push every other
    // thread off the rail. Which ones overflow is measured, not guessed: the rail
    // may be closed (zero wide) at render, and a link card can grow a body later,
    // so a ResizeObserver on the list and on each folded body re-reads it.
    function measureFolds(){
      var list=document.getElementById("sbList");if(!list||!list.clientWidth)return;
      list.querySelectorAll(".cmt-body.clamp").forEach(function(b){b.classList.toggle("is-cut",b.scrollHeight>b.clientHeight+4)});
    }
    var foldRO=window.ResizeObserver?new ResizeObserver(function(){measureFolds()}):null;
    function watchFolds(list){
      if(!foldRO){measureFolds();return}
      foldRO.disconnect();foldRO.observe(list);
      list.querySelectorAll(".cmt-body.clamp").forEach(function(b){foldRO.observe(b)});
    }
    // A placeholder names no one and takes no reactions: what's left is where the
    // thread was and the way to fold it away. It goes by itself with its last reply.
    function renderGone(c,isReply){
      var h='<article class="cmt gone'+(isReply?" reply":"")+'" data-id="'+c.id+'" aria-label="Deleted comment">';
      if(!isReply&&c.anchor_id)h+=whereBtn(c);
      h+='<div class="cmt-gone">'+ssT("cmt.deleted","This comment was deleted")+'</div>';
      if(!isReply&&!c.resolved_at&&(ON_ROSTER||lcEmail(c.author_email)===myEmail))h+='<div class="cmt-actions" role="group" aria-label="Actions"><button type="button" class="cmt-act" data-resolve="'+c.id+'">'+ssT("cmt.resolve","Resolve")+'</button></div>';
      return h+'</article>';
    }
    // Other people's comments, edits and reactions redraw the rail on their own clock.
    // A redraw is the whole list, and on a page of 500 comments it costs a frame of
    // 150 ms; a busy room sends several a second, which kept a tab frozen half the
    // time (scripts/comment-swarm.mjs, 2026-10-13). So their redraws wait at least
    // twice as long as the last one took, which leaves the person two thirds of the
    // time, and costs a small page nothing. A redraw for something this person did
    // still happens at once, and takes any waiting one with it.
    var redrawAt=0,redrawCost=0,redrawTimer=0;
    function renderSoon(){
      if(redrawTimer)return;
      redrawTimer=setTimeout(function(){redrawTimer=0;renderComments()},Math.max(0,redrawAt+2*redrawCost-Date.now()));
    }
    var waysDone=false;try{waysDone=localStorage.getItem("ss_cmt_ways")==="1"}catch(x){}
    var WAYS_ICON={
      pin:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s7-7.5 7-13a7 7 0 0 0-14 0c0 5.5 7 13 7 13z"/><circle cx="12" cy="9" r="2.5"/></svg>',
      quote:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><rect x="3" y="9" width="14" height="6" rx="1.5" fill="currentColor" opacity=".22" stroke="none"/><path d="M4 6h16M4 12h12M4 18h10"/></svg>',
      page:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4"/></svg>'
    };
    function waysHtml(closable){
      var tap=PHONE_MQ.matches;
      return '<div class="ways" role="note"><h4>Three ways to comment</h4>'+(closable?'<button type="button" class="ways-x" data-ways="x">Got it</button>':'')+
        '<div class="w"><span class="ic">'+WAYS_ICON.pin+'</span><span><b>Pin a spot.</b> Turn on <b>Pin comments</b>, then '+(tap?'tap':'click')+' anything: a cell, a bar, a line.<br><button type="button" class="try" data-ways="pin">Pin comments</button></span></div>'+
        '<div class="w"><span class="ic">'+WAYS_ICON.quote+'</span><span><b>Quote words.</b> Select them on the page, then press <b>Comment</b>.</span></div>'+
        '<div class="w"><span class="ic">'+WAYS_ICON.page+'</span><span><b>The whole page.</b> Write in the box at the bottom of this list.</span></div></div>';
    }
    function renderComments(){
      if(redrawTimer){clearTimeout(redrawTimer);redrawTimer=0}
      var began=Date.now();redrawAt=began;
      // What a redraw costs is its script and the frame it makes: measured to the
      // next frame, which comes after the browser has laid the list out.
      requestAnimationFrame(function(){redrawCost=Math.min(2000,Date.now()-began)});
      var list=document.getElementById("sbList"),threads=getThreads();
      // A thread someone resolves while you are writing a reply in it stays where it
      // is until you send or cancel, wearing its Resolved bar: folded away into the
      // resolved list, it took your words and your focus with it.
      var replying=inlineReply&&String(inlineReply.text||"").trim()?inlineReply.root:null;
      var unres=threads.filter(function(t){return!t.root.resolved_at||t.root.id===replying});
      var res=threads.filter(function(t){return!!t.root.resolved_at&&t.root.id!==replying});
      function resolvedBar(t){return ON_ROSTER||lcEmail(t.root.author_email)===myEmail?'<button type="button" class="resolve-bar" data-unresolve="'+t.root.id+'">&#x2714; Resolved<span class="rb-act">Reopen</span></button>':'<div class="resolve-bar done">&#x2714; Resolved</div>'}
      // Position on page: pinned threads as their blocks sit on the page (then top to
      // bottom within a block), then comments on the whole page, newest first;
      // resolved ones fold away below. The two time orders run oldest to newest, by
      // the thread's last message or by when it began, with the resolved fold ABOVE
      // the open threads so the newest message is the rail's last line.
      function ord(t){var id=t.root.anchor_id;if(!id)return Infinity;var o=anchorOrder[id];return o===undefined?1e6:o}
      function ts(c){return new Date(c.created_at).getTime()||0}
      function last(t){var m=ts(t.root);t.replies.forEach(function(r){var x=ts(r);if(x>m)m=x});return m}
      var timeKey=cmtSort==="activity"?last:function(t){return ts(t.root)};
      if(chrono()){
        unres.sort(function(a,b){return timeKey(a)-timeKey(b)});
        res.sort(function(a,b){return timeKey(a)-timeKey(b)});
      }else{
        unres.sort(function(a,b){
          var pa=!!a.root.anchor_id,pb=!!b.root.anchor_id;
          if(pa!==pb)return pa?-1:1;
          if(pa){var oa=ord(a),ob=ord(b);if(oa!==ob)return oa-ob;var ya=(anchorOf(a.root)||{}).y||0,yb=(anchorOf(b.root)||{}).y||0;if(ya!==yb)return ya-yb}
          return ts(b.root)-ts(a.root);
        });
        res.sort(function(a,b){return ts(b.root)-ts(a.root)});
      }
      // A new message keeps a reader who was at the bottom at the bottom.
      var stick=chrono()&&railLanded&&comments.length>lastMsgCount&&list.scrollHeight-list.scrollTop-list.clientHeight<60;
      lastMsgCount=comments.length;
      var html="",resHtml="";
      // A link to a resolved thread — a notification, a copied Link — has to land on
      // it. Show the resolved section for the rest of the visit and unfold it, or the
      // scroll below would target an element inside a hidden block.
      var tid=deepCmt;
      if(tid&&res.some(function(t){return t.root.id===tid||t.replies.some(function(r){return r.id===tid})})){revealResolved=true;resolvedOpen=true}
      // Pinned threads name their own spot; the rest are about the page as a whole,
      // and say so once, above the first of them — only when pinned ones sit above,
      // since a list that is all whole-page has nothing to tell apart.
      var nPage=unres.filter(function(t){return!t.root.anchor_id}).length,secDone=chrono()||nPage===unres.length;
      unres.forEach(function(t){if(!secDone&&!t.root.anchor_id){secDone=true;html+='<div class="sb-sec" role="heading" aria-level="4"><span>'+ssT("cmt.whole_page","Whole page")+'</span><span class="sb-sec-n">'+nPage+'</span></div>'}html+='<div class="thread'+(t.root.anchor_id?'':' page')+(t.root.id===hotId?' hot':'')+(t.root.id===focusId?' focus':'')+'" role="group" aria-label="Thread started by '+esc(commentAuthor(t.root).name)+'" data-thread="'+t.root.id+'">'+renderCmt(t.root,false)+renderReplies(t)+threadFoot(t)+(t.root.resolved_at?resolvedBar(t):'')+'</div>'});
      // Everything is resolved and the resolved threads are shown: say the open list is
      // empty on purpose, rather than leaving a blank drawer over a divider.
      if(!unres.length&&res.length&&(!hideResolved||revealResolved))html+='<div class="sb-allres">&#x2714; Nothing open — every thread here is resolved.</div>';
      if(res.length&&(!hideResolved||revealResolved)){resHtml+='<button type="button" class="resolved-divider" id="resolvedToggle" aria-expanded="'+(resolvedOpen?"true":"false")+'" aria-controls="resolvedList">Resolved ('+res.length+')</button><div id="resolvedList"'+(resolvedOpen?'':' hidden')+'>';res.forEach(function(t){resHtml+='<div class="thread resolved" data-thread="'+t.root.id+'">'+renderCmt(t.root,false)+renderReplies(t)+resolvedBar(t)+'</div>'});resHtml+='</div>'}
      // Hidden, with open threads beside them: a quiet line where the divider would be,
      // so hidden reads as hidden, not as gone, and the way back is right there.
      if(res.length&&unres.length&&hideResolved&&!revealResolved)resHtml='<div class="sb-reshid"><span>'+res.length+(res.length===1?' resolved thread':' resolved threads')+' hidden</span><button type="button" data-showres>Show</button></div>';
      html=chrono()?resHtml+html:html+resHtml;
      if(!threads.length)html='<div class="sb-empty"><div class="big">&#x1F4AC;</div><b>Nobody has said anything yet.</b><br>Comments land right on the page &mdash; and the author gets a notification.'+
        waysHtml(false)+
        '<div class="hint-p">Write <b>@shepherd</b> in a comment to ask Shepherd, the agent, about that spot'+(CAN_EDIT?' — it changes the page for you':'')+(TALK?', or <b>@session</b> to ask the session that made the page.':'.')+'</div>'+
        (IS_OWNER?'<div class="hint">Ask a question in the page to give readers something to answer.</div>':'<button type="button" class="starter" id="askStarter">Ask the author something</button>')+'</div>';
      // Every thread here is resolved and you asked not to see those. Say so and offer
      // the way back, rather than leaving a rail that reads as broken or as empty.
      if(!html&&res.length)html='<div class="sb-empty"><div class="big">&#x2714;</div><b>Nothing open.</b>'+
        '<div>'+res.length+(res.length===1?' resolved thread':' resolved threads')+' hidden.</div>'+
        '<button type="button" class="starter" data-showres>Show resolved</button></div>';
      // The three ways to start a comment, at the foot of the list beside the
      // whole-page box it names, until the reader says Got it.
      if(unres.length&&!waysDone)html+=waysHtml(true);
      // How many the preference acts on, beside its label.
      var prn=document.getElementById("prefResN");if(prn)prn.textContent=res.length?"("+res.length+")":"";
      var restore=railHold(list,stick);
      list.innerHTML=html;paintRich(list);updateCount();watchFolds(list);reanchorCmtMenu(list);
      // Space links become the spaces they name, for a reader who may open them.
      lcPaint(list);
      list.querySelectorAll("[data-showres]").forEach(function(b){b.onclick=function(){setHideResolved(false,"list")}});
      list.querySelectorAll("[data-ways]").forEach(function(b){b.onclick=function(){
        if(b.getAttribute("data-ways")==="x"){waysDone=true;try{localStorage.setItem("ss_cmt_ways","1")}catch(x){}renderComments();return}
        setAnnotate(true,true);
      }});
      if(inlineReply)openInlineReply(inlineReply.root,false);
      if(cmtEdit)wireCmtEdit();
      restore();
      var ask=document.getElementById("askStarter");if(ask)ask.onclick=function(){composeText.focus();if(!composeText.value)composeText.value="Question: "};
      if(tid){var el=list.querySelector('[data-thread="'+tid+'"],[data-id="'+tid+'"]');if(el&&sidebarOpen){deepCmt=null;var th=el.closest(".thread")||el;th.classList.add("flash");setTimeout(function(){th.scrollIntoView({behavior:"smooth",block:"center"})},100)}}
      if(stick)list.scrollTop=list.scrollHeight;
      landRail();
      paintTyping();
      sendMarkers();
    }
    // A thread's messages, root first.
    function threadMsgs(root){return comments.filter(function(c){return c.id===root.id||c.parent_id===root.id})}
    // Nothing seen yet in this browser: everything someone else wrote is unseen.
    function threadUnseen(root){return threadMsgs(root).some(function(c){return seenAt>0?isNew(c):lcEmail(c.author_email)!==myEmail})}
    function markShown(root){
      if(marksVisit)return marksVisit==="show";
      if(marksPref==="off")return false;
      return marksPref==="always"||threadUnseen(root);
    }
    // One mark per block (a named part, or a part of the page itself when the words sit
    // in no block), counting its open threads; a click opens the list on the newest.
    function marginAdd(margin,order,c){
      if(!markShown(c))return;
      var a=anchorOf(c),key=a.thing?"t:"+a.thing.id:c.anchor_id+(c.anchor_id==="ss-doc"&&a.part?"|"+a.part:"");
      var m=margin[key];
      if(!m){m=margin[key]={anchor:c.anchor_id,part:c.anchor_id==="ss-doc"?a.part||null:null,thing:a.thing||null,lead:c.id,leadAt:0,count:0,fresh:false,names:[]};order.push(key)}
      m.count++;
      var t=new Date(c.created_at).getTime();if(t>=m.leadAt){m.leadAt=t;m.lead=c.id}
      if(threadMsgs(c).some(isNew))m.fresh=true;
      var nm=String(commentAuthor(c).name||"").split(" ")[0];if(nm&&m.names.indexOf(nm)<0&&m.names.length<4)m.names.push(nm);
    }
    function sendMarkers(){
      var m={},pins=[];
      function mk(id){if(!m[id])m[id]={id:id,count:0,quotes:[],marks:[],reactions:[]};return m[id]}
      var replyCount={};
      comments.forEach(function(c){if(c.parent_id)replyCount[c.parent_id]=(replyCount[c.parent_id]||0)+1});
      // Pins, quote marks and the held block's outline are the rail's, drawn on the
      // page: with the rail closed the page is just the page. Reactions stay. The
      // corner button's Annotate shows them too, and so does a comment that just
      // arrived (for a few seconds, dropping in), with the rail closed.
      var allPins=sidebarOpen||corner.on,now=Date.now(),margin={},mOrder=[];
      comments.forEach(function(c){
        if(c.parent_id||c.resolved_at||!c.anchor_id)return;
        if(!allPins&&!(livePin[c.id]>now)){marginAdd(margin,mOrder,c);return}
        var x=mk(c.anchor_id),a=anchorOf(c);x.count++;
        // The words to mark on the page: a selection someone quoted (marks). A
        // comment from before pins carried the block's own text (quotes), which the
        // frame marks only when it isn't simply how the block starts.
        if(c.anchor_text&&a.quote)x.marks.push(c.anchor_text);
        else if(c.anchor_text&&a.legacy)x.quotes.push(c.anchor_text);
        var pr=pendingFor(c.id),name=commentAuthor(c).name;
        // A pin carries an initial and a colour, never an address: the frame is the author's page.
        pins.push({id:c.id,anchor:c.anchor_id,x:a.x,y:a.y,quote:a.quote?c.anchor_text:null,near:a.near||null,part:a.part||null,thing:a.thing||null,initial:ssAvatarInitial(name,c.author_email),name:name,color:ssAvatarColor(c.author_email),replies:replyCount[c.id]||0,working:!!(pr&&pr.status==="running"),
          arrive:!!arrived[c.id]&&now-arrived[c.id]<9000,flash:livePin[c.id]>now&&!!liveReply[c.id]});
      });
      // Someone else writing a comment right now: a ghost of their pin where they
      // are writing it, or on the thread they are answering.
      Object.keys(drafts).forEach(function(seed){
        var d=drafts[seed],anc=d.anchor,x=d.x,y=d.y,part=d.part;
        if(!anc&&d.thread){var r=comments.find(function(c){return c.id===d.thread});if(!r||!r.anchor_id||r.resolved_at)return;var ra=anchorOf(r);anc=r.anchor_id;x=ra.x;y=ra.y;part=ra.part}
        if(!anc)return;
        pins.push({id:"draft-"+seed,anchor:anc,x:x,y:y,part:part||null,initial:ssAvatarInitial(d.name,seed),name:d.name,color:ssAvatarColor(seed),replies:0,draft:true,reply:!!d.thread,text:d.text||""});
      });
      // Block reactions ride on the same markers: per anchor, per emoji — the count,
      // whether it's mine, and who (oldest first) for the chip's tooltip.
      if(BLOCK_RX)anchorReactions.forEach(function(r){
        var x=mk(r.anchor_id),rl=x.reactions,e=null;
        for(var i=0;i<rl.length;i++)if(rl[i].emoji===r.emoji)e=rl[i];
        if(!e){e={emoji:r.emoji,count:0,mine:false,names:[]};rl.push(e)}
        e.count++;e.names.push(r.author_name||String(r.author_email||"").split("@")[0]);
        if(lcEmail(r.author_email)===myEmail)e.mine=true;
      });
      var arr=Object.keys(m).map(function(k){return m[k]});
      var f=document.getElementById("content");
      // palette/quick arm the frame's hover pill (emoji and its Comment button); an
      // empty palette leaves every block without one. pins are the open pinned
      // threads, with which one the rail is hovering or holding.
      var marks=mOrder.map(function(k){return margin[k]});
      if(f&&f.contentWindow)f.contentWindow.postMessage({type:"ss-comment-markers",markers:arr,pins:pins,marks:marks,hot:hotId,focus:focusId,palette:BLOCK_RX?REACTIONS:[],quick:QUICK,reactions:ELEM_RX},co);
      if(pkId&&!pins.some(function(p){return p.id===pkId}))pinPeekHide();
    }
    // The rail's card and the page's pin are one thing seen twice: hovering either
    // lights the other; a click on a pin holds its card, a card's place line goes
    // to its pin.
    function setHot(id,fromRail){
      if(hotId===id)return;hotId=id;
      document.querySelectorAll("#sbList .thread.hot").forEach(function(t){t.classList.remove("hot")});
      if(id){var th=document.querySelector('#sbList [data-thread="'+id+'"]');if(th)th.classList.add("hot")}
      // A hover on a pin is drawn by the page itself (anchor.js peekStart): sending
      // the markers again would rebuild every pin under the pointer.
      if(fromRail)sendMarkers();
    }
    // --- A pin's preview: hover (or keyboard focus) on a pin shows its thread's
    // first comment beside it. One card for every pin, drawn here from the comments
    // already loaded (no request), moved with a transform. The page reports the pin
    // and its box (ss-pin-hover); 150 ms before it shows so a pointer crossing the
    // page doesn't flicker it, at once when moving from pin to pin; a leave waits
    // 140 ms so the pointer can reach the card, which holds it open. A click on the
    // card (or the pin) opens the thread; Escape closes it.
    var pk=null,pkId=null,pkRect=null,pkVia=null,pkShowT=0,pkHideT=0,pkOver=false,pkW=0,pkH=0;
    function pinPeekEl(){
      if(pk)return pk;
      pk=document.createElement("div");pk.className="pin-peek";pk.id="pinPeek";pk.hidden=true;
      pk.setAttribute("role","note");pk.setAttribute("aria-live","polite");
      pk.addEventListener("mouseenter",function(){pkOver=true;clearTimeout(pkHideT)});
      pk.addEventListener("mouseleave",function(){pkOver=false;pinPeekHideSoon()});
      pk.addEventListener("click",function(e){if(e.target.closest("a"))return;var id=pkId;pinPeekHide();if(id)focusThread(id,true)});
      document.body.appendChild(pk);
      return pk;
    }
    function pinPeekHtml(c){
      var gone=isGone(c),isBot=c.via==="claude",isAgent=c.via==="co-shepherd";
      var name=gone?"":commentAuthor(c).name;
      var av=gone?"":isBot?'<span class="ss-av ss-av-xs is-bot-avatar">✦</span>':isAgent?'<span class="ss-av ss-av-xs cmt-agent-av">'+SHEEP+'</span>':ssAvatar({seed:c.author_email,name:name,picture:c.author_picture,size:"xs"});
      var replies=0;comments.forEach(function(r){if(r.parent_id===c.id&&!isGone(r))replies++});
      var pics=(c.images||[]).length;
      var body=gone?'<div class="pin-peek-body is-empty">'+ssT("cmt.deleted","This comment was deleted")+'</div>'
        :c.body?'<div class="pin-peek-body">'+(richCmt(c)?esc(cmtWords(c).slice(0,240)):mkBody(c.body))+'</div>'
        :pics?'<div class="pin-peek-body is-empty">'+(pics>1?pics+" pictures":"A picture")+'</div>':"";
      var state=c.resolved_at?'<span class="pin-peek-state is-resolved">Resolved</span>':'<span class="pin-peek-state">Open</span>';
      return (gone?"":'<div class="pin-peek-head">'+av+'<span class="pin-peek-name">'+esc(name)+'</span><time class="pin-peek-time" datetime="'+esc(c.created_at)+'">'+relTime(c.created_at)+'</time></div>')+body+
        '<div class="pin-peek-foot">'+state+'<span>'+(replies?replies+(replies===1?" reply":" replies"):"No replies")+'</span><span class="pin-peek-open">Click to open</span></div>';
    }
    function pinPeekPlace(){
      if(!pk||pk.hidden||!pkRect)return;
      var f=document.getElementById("content");if(!f)return;
      var fr=f.getBoundingClientRect(),vw=window.innerWidth,vh=window.innerHeight,gap=6;
      var px=fr.left+(+pkRect.x||0),py=fr.top+(+pkRect.y||0),pw=+pkRect.w||0,ph=+pkRect.h||0;
      // Off the frame (scrolled out of sight): nothing to point at.
      if(py+ph<fr.top||py>fr.bottom||px+pw<fr.left||px>fr.right){pinPeekHide();return}
      // Beside the pin, inside the page's frame (never over the rail): right, else left.
      var lo=Math.max(8,fr.left+8),hi=Math.min(vw,fr.right)-8;
      var x=px+pw+gap;if(x+pkW>hi)x=px-gap-pkW;if(x<lo)x=Math.max(lo,Math.min(hi-pkW,px));
      var y=py-4;if(y+pkH>vh-8)y=vh-8-pkH;if(y<8)y=8;
      pk.style.transform="translate3d("+Math.round(x)+"px,"+Math.round(y)+"px,0)";
    }
    function pinPeek(id,rect,via){
      if(!id){if(via==="hover")pinPeekHideSoon();else pinPeekHide();return}
      clearTimeout(pkHideT);
      var c=comments.find(function(x){return x.id===id});
      if(!c||!rect){pinPeekHide();return}
      pkRect=rect;pkVia=via;
      // The same pin again: its box moved (a scroll) — follow it.
      if(pk&&!pk.hidden&&pkId===id){pinPeekPlace();return}
      pkId=id;clearTimeout(pkShowT);
      var showing=pk&&!pk.hidden;
      pkShowT=setTimeout(function(){
        if(pkId!==id)return;
        var el=pinPeekEl(),cur=comments.find(function(x){return x.id===id});
        if(!cur){pinPeekHide();return}
        el.innerHTML=pinPeekHtml(cur);el.dataset.thread=id;
        // One measure per card shown, never per scroll.
        el.hidden=false;pkW=el.offsetWidth;pkH=el.offsetHeight;
        pinPeekPlace();
        if(!el.hidden)requestAnimationFrame(function(){if(pkId===id)el.classList.add("is-on")});
      },showing||via==="focus"?0:150);
    }
    function pinPeekHideSoon(){clearTimeout(pkShowT);clearTimeout(pkHideT);pkHideT=setTimeout(function(){if(!pkOver)pinPeekHide()},140)}
    function pinPeekHide(){
      clearTimeout(pkShowT);clearTimeout(pkHideT);pkId=null;pkRect=null;pkOver=false;
      if(pk&&!pk.hidden){pk.classList.remove("is-on");pk.hidden=true}
    }
    function pinPeekOpen(){return !!(pk&&!pk.hidden)}
    window.addEventListener("resize",function(){if(pinPeekOpen())pinPeekHide()});
    function focusThread(id,flash){
      if(!id)return;
      if(!sidebarOpen)toggleSidebar(true);
      setAway(false);
      focusId=id;
      document.querySelectorAll("#sbList .thread.focus").forEach(function(t){t.classList.remove("focus")});
      var th=document.querySelector('#sbList [data-thread="'+id+'"]');
      if(th){th.classList.add("focus");th.scrollIntoView({behavior:"smooth",block:"center"});if(flash){th.classList.add("flash");setTimeout(function(){th.classList.remove("flash")},1200)}}
      sendMarkers();
    }
    // The diff's "Open thread" (viewer-diff): the rail, on that thread.
    window.ssOpenThread=function(id){if(!id)return;if(!sidebarOpen)toggleSidebar(true);goToPin(id)};
    window.ssRailOpen=function(v){if(v===undefined)return sidebarOpen;if(!!v!==sidebarOpen)toggleSidebar(!!v);return sidebarOpen};
    // A card picked in the rail: held, and its pin scrolled to — the drawer stays
    // where it is (goToPin steps a phone's drawer aside; a tap on a card shouldn't).
    function selectThread(id){
      focusId=id;
      document.querySelectorAll("#sbList .thread.focus").forEach(function(t){t.classList.remove("focus")});
      var th=document.querySelector('#sbList [data-thread="'+id+'"]');if(th)th.classList.add("focus");
      sendMarkers();
      var f=document.getElementById("content");
      if(f&&f.contentWindow)f.contentWindow.postMessage({type:"ss-scroll-pin",id:id},co);
    }
    function goToPin(id){
      focusId=id;
      document.querySelectorAll("#sbList .thread.focus").forEach(function(t){t.classList.remove("focus")});
      var th=document.querySelector('#sbList [data-thread="'+id+'"]');if(th)th.classList.add("focus");
      sendMarkers();
      var f=document.getElementById("content");
      if(f&&f.contentWindow)f.contentWindow.postMessage({type:"ss-scroll-pin",id:id},co);
      // On a phone the drawer covers the page: step aside so the pin can be seen.
      if(PHONE_MQ.matches)setAway(true,true);
    }

    // Live document patching: send AI edit ops into the iframe so it updates in
    // place (no reload, scroll preserved). If the frame doesn't confirm within 2s
    // (stale cached anchor.js) or reports missed anchors, fall back to a reload.
    // No-op while the frame is pinned to a past version (see the history dropdown) —
    // a live deploy must not yank the reader back to the latest bytes.
    // A known sha becomes the frame URL itself (the versioned form the content origin
    // caches); with no sha the current URL is cache-busted as before. Never append
    // ?v= to a /v/<sha>/ URL — that would reload the OLD version.
    window.__ssVersionSrc=V.versionSrc;
    function frameUrlFor(cf,sha){var v=window.__ssVersionSrc;if(sha&&v)return withSub(v.replace("{sha}",sha));var cb=withSub(FRAMEBASE);return cb+(cb.indexOf("?")<0?"?":"&")+"v="+(sha||Date.now())}
    // Edit mode (editScript) holds the page still: a publish that would reload the frame
    // under the person's typing waits, remembered, until they save or cancel. An editor
    // with nothing typed holds nothing (__ssEditHolds ends the mode and lets it through).
    // A reload keeps the reader's place: the frame reports where they are (ss-scroll,
    // last one as the old page goes away) and the next frame to say ready is handed it.
    function bumpFrame(sha){if(window.__ssPinnedVersion)return;if(window.__ssEditing&&window.__ssEditHolds()){window.__ssEditStale=sha||window.__ssEditStale||true;return}var cf=document.getElementById("content");if(!cf)return;if(sha&&sha===shownSha&&ssFrameHref(cf)===new URL(frameUrlFor(cf,sha),location.href).href)return;frameReady=false;liveQueue=[];keepScroll=true;ssFrameGo(cf,frameUrlFor(cf,sha)+(location.hash||""));setShown(sha)}
    window.__ssBumpFrame=bumpFrame;
    // Which saved version the frame shows: the one it was loaded on (null: whatever
    // was latest then), or the last save whose patch or deploy this tab handled. The
    // Co-shepherd's look at its own work waits for its save to be on screen, and
    // reloads onto it when the save never arrives (__ssShowSaved). On 2026-10-12 that
    // look read sections a turn had removed off a tab that never got the save, and
    // called the screenshot "taken before the change saved".
    var shownSha=null,shownWaits=[];
    function setShown(sha){shownSha=sha||null;shownCheck()}
    function shownCheck(){if(!frameReady)return;shownWaits=shownWaits.filter(function(w){if(w.sha!==shownSha)return true;clearTimeout(w.t);w.res(true);return false})}
    window.__ssShowSaved=function(sha){return new Promise(function(res){
      if(!sha||window.__ssPinnedVersion){res(false);return}
      var w={sha:sha,res:res,t:0};
      w.t=setTimeout(function(){bumpFrame(sha);w.t=setTimeout(function(){shownWaits=shownWaits.filter(function(x){return x!==w});res(false)},12000)},1500);
      shownWaits.push(w);shownCheck();
    })};
    // The live layer (shared/live-layer.ts): a page or anchored edits from whoever is
    // streaming, applied in the frame without a reload or a version. A deploy
    // message (a real publish) reloads the frame and takes the pill down.
    var livePatch={},liveQueue=[],frameReady=false,frameScroll=null,keepScroll=false;
    function ssLive(msg){
      if(msg.op==="status"){ssWork(msg);return}
      // Held while the page is being edited by hand: a change is shown after Save or
      // Cancel; a remote key or click is simply not pressed under the typing.
      if(window.__ssEditing&&window.__ssEditHolds()){if(msg.type==="live")window.__ssEditStale=window.__ssEditStale||true;return}
      if(msg.op==="set"||(msg.op==="begin"&&!msg.target))workHasPage();
      var f=document.getElementById("content");
      if(!f||!f.contentWindow)return;
      if(!frameReady){liveQueue.push(msg);return}
      // Only where a change starts, never per streamed chunk: one event per change.
      if(msg.op!=="chunk"&&msg.op!=="end")liveIn(msg.by);
      if(msg.type==="key"){f.contentWindow.postMessage({type:"ss-live-key",keys:msg.keys||[]},co);return}
      if(msg.type==="click"){f.contentWindow.postMessage({type:"ss-live-click",target:msg.target||"",nonce:msg.nonce||""},co);return}
      if(msg.op==="set"){f.contentWindow.postMessage({type:"ss-live-set",html:msg.html,mode:msg.mode||"auto",seq:msg.seq},co)}
      else if(msg.op==="patch"){var pid=window.ssPatchDoc(msg.edits||[],null,true);if(pid)livePatch[pid]={seq:msg.seq,t:performance.now(),bytes:JSON.stringify(msg.edits||[]).length};ssLivePill(true)}
      else if(msg.op==="begin"){f.contentWindow.postMessage({type:"ss-live-begin",seq:msg.seq,stream:msg.stream,target:msg.target||null,into:msg.into||"ss-replace",old:msg.old||null,node:typeof msg.node==="number"?msg.node:null,tag:msg.tag||null,text:msg.text===true},co);ssLivePill(true)}
      else if(msg.op==="chunk"){f.contentWindow.postMessage({type:"ss-live-chunk",seq:msg.seq,stream:msg.stream,text:msg.text||""},co)}
      else if(msg.op==="end"){f.contentWindow.postMessage({type:"ss-live-end",seq:msg.seq,stream:msg.stream},co)}
    }
    // A change to the page reached this tab: Speak times an ask to this moment
    // (assets/shell/speak.ts, "ss:live-in").
    // The argument is the writer's surface ("viewer" = the Co-shepherd), which a comment's
    // wait reads to say a change is landing.
    function liveIn(by){try{window.dispatchEvent(new CustomEvent("ss:live-in",{detail:{by:typeof by==="string"?by:null}}))}catch(e){}}
    function ssEmit(name,data){
      fetch("/api/space/"+spaceId+"/live/emit",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({name:name,data:data===undefined?null:data})}).catch(function(){});
    }
    function ssLivePill(on){
      var p=document.getElementById("ssLivePill");
      // In the header beside the presence faces, never over the page: a fixed pill
      // sat on top of a streamed desktop's taskbar.
      if(on&&!p){p=document.createElement("div");p.id="ssLivePill";p.textContent="live";p.title="This page is being streamed to you — what you see is not published yet";var wrap=document.getElementById("presWrap");p.style.cssText=(wrap?"position:relative;margin-right:10px;":"position:fixed;top:64px;left:14px;z-index:60;")+"padding:5px 10px 5px 22px;border-radius:99px;font:600 11px/1 system-ui,sans-serif;letter-spacing:.04em;text-transform:uppercase;color:#fff;background:var(--ss-brand);pointer-events:none;white-space:nowrap";var d=document.createElement("span");d.style.cssText="position:absolute;left:9px;top:50%;width:7px;height:7px;margin-top:-3.5px;border-radius:50%;background:#fff;animation:ssLiveBlink 1.2s ease-in-out infinite";p.appendChild(d);var st=document.createElement("style");st.textContent="@keyframes ssLiveBlink{0%,100%{opacity:1}50%{opacity:.25}}";p.appendChild(st);if(wrap)wrap.insertBefore(p,wrap.firstChild);else document.body.appendChild(p)}
      else if(!on&&p)p.remove();
    }
    // The writer's status (live op "status", shared/live-layer.ts): what the agent
    // building this page is doing right now, drawn by the shell over the frame until a
    // publish takes it down. Never queued behind the frame like the page ops — it is
    // about the page, not in it, and it has to show while the frame is still loading.
    // Every time is the room's clock: t0 is the room's "now" when it sent the message,
    // so "how long" never depends on this machine's clock being right. A step with no
    // word for ten minutes reads as quiet, and one silent for half a day is not shown:
    // stale is a reading of the room's state, never a claim the card keeps making.
    var work={el:null,st:null,skew:0,tick:null,spin:null,frame:0,min:false,bye:null,stale:null,txt:"",top:"",placed:false,hasPage:false,shut:"",quiet:false,inPage:null,wait:null,relay:null};
    var WORK_TITLE=V.title;
    var WORK_QUIET=6e5,WORK_GONE=432e5,WORK_SHUT_KEY="ss-work-shut:"+V.id,WORK_STILL=!!(window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches);
    var WORK_DOTS="\u003cspan class=\"ss-dots\" aria-hidden=\"true\"\u003e\u003ci\u003e\u003c/i\u003e\u003ci\u003e\u003c/i\u003e\u003ci\u003e\u003c/i\u003e\u003c/span\u003e",WORK_CHECK="\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M5 13L9 17L19 7\"/\u003e\u003c/svg\u003e",WORK_OK="\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M5 13L9 17L19 7\"/\u003e\u003c/svg\u003e",WORK_MIN="\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M6 9L12 15L18 9\"/\u003e\u003c/svg\u003e",WORK_X="\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M6.75827 17.2426L12.0009 12M17.2435 6.75736L12.0009 12M12.0009 12L6.75827 6.75736M12.0009 12L17.2435 17.2426\"/\u003e\u003c/svg\u003e";
    // A card that is not working (stopped, or quiet) can be closed. Closing is this
    // reader's, remembered for the run it closed (its start), so a reload or the
    // room's catch-up doesn't bring the same card back; the next run shows again.
    try{work.shut=localStorage.getItem(WORK_SHUT_KEY)||""}catch(e){}
    function workKey(st){return st?st.run_id||String(st.since):""}
    function workExpired(st){return (Date.now()-work.skew)-(st.updated||st.at)>((st.stopped||st.who==="Co-shepherd")?WORK_QUIET:WORK_GONE)}
    function workIdle(st){return !!st&&(st.stopped||(Date.now()-work.skew)-(st.updated||st.at)>WORK_QUIET)}
    function workClock(ms){var s=Math.max(0,Math.floor(ms/1e3)),m=Math.floor(s/60);return m>=60?Math.floor(m/60)+"h "+(m%60)+"m":m+":"+(s%60<10?"0":"")+(s%60)}
    function workAgo(ms){var m=Math.round(ms/6e4);return m<60?m+" min":Math.round(m/60)+" h"}
    // A card is centred on the frame, and lifted over the Speak corner button
    // (assets/shell/speak.ts) only when the two would actually meet: a narrow frame, a
    // phone. A screen covers the frame exactly.
    function workPlace(){
      var el=work.el,f=document.getElementById("content");if(!el||!f||!f.offsetWidth)return;
      if(el.classList.contains("is-screen")){el.classList.remove("is-lifted");el.style.left=f.offsetLeft+"px";el.style.top=f.offsetTop+"px";el.style.width=f.offsetWidth+"px";el.style.height=f.offsetHeight+"px";el.style.maxWidth="none";return}
      el.style.top=el.style.width=el.style.height="";
      if(!el.classList.contains("is-fixed")){el.style.left=(f.offsetLeft+f.offsetWidth/2)+"px";el.style.maxWidth=Math.max(240,f.offsetWidth-24)+"px"}
      el.classList.remove("is-lifted");
      var sp=document.querySelector(".speak");if(!sp||!sp.offsetWidth)return;
      var a=el.getBoundingClientRect(),b=sp.getBoundingClientRect();
      if(a.right>b.left&&a.left<b.right&&a.bottom+14>b.top)el.classList.add("is-lifted");
    }
    function workMake(){
      var el=document.createElement("div");el.className="ss-work";el.id="ssWork";
      el.innerHTML='<div class="ss-work-top"><span class="ss-work-sheep" aria-hidden="true"><span class="ss-work-ok">'+WORK_OK+'</span></span><div class="ss-work-head"><b class="ss-work-title"></b><span class="ss-work-sub"></span></div><span class="ss-work-clock" aria-hidden="true"></span><button type="button" class="ss-work-min">'+WORK_MIN+'</button><button type="button" class="ss-work-x" aria-label="Close" title="Close">'+WORK_X+'</button></div><div class="ss-work-now" role="status" aria-live="polite">'+WORK_DOTS+'<span class="ss-work-txt"></span></div><ol class="ss-work-steps" aria-label="Done so far"></ol><div class="ss-work-foot"></div>';
      // The flying sheep is the one the loading veil already carries: no new bytes.
      var sheep=el.querySelector(".ss-work-sheep");
      [].forEach.call(document.querySelectorAll("#ssNavLoading [data-nav-loading-frames] img"),function(f,i){var im=document.createElement("img");im.src=f.src;im.alt="";if(!i)im.className="on";sheep.appendChild(im)});
      var mb=el.querySelector(".ss-work-min");
      function setMin(){el.classList.toggle("is-min",work.min&&!el.classList.contains("is-screen"));mb.setAttribute("aria-expanded",work.min?"false":"true");mb.setAttribute("aria-label",work.min?"Show the steps":"Hide the steps")}
      mb.onclick=function(){work.min=!work.min;setMin()};setMin();
      el.querySelector(".ss-work-x").onclick=function(){work.shut=workKey(work.st);try{localStorage.setItem(WORK_SHUT_KEY,work.shut)}catch(e){}workFade()};
      var row=document.querySelector(".main-row");
      if(row)row.appendChild(el);else{el.classList.add("is-fixed");document.body.appendChild(el)}
      work.el=el;work.txt="";work.top="";work.frame=0;workPlace();
      if(!work.placed){work.placed=true;var cf=document.getElementById("content");if(cf&&window.ResizeObserver)new ResizeObserver(workPlace).observe(cf);window.addEventListener("resize",workPlace)}
      requestAnimationFrame(function(){requestAnimationFrame(function(){if(work.el===el&&work.st)el.classList.add("is-in")})});
      return el;
    }
    function workSpin(on){
      if(WORK_STILL||!work.el)on=false;
      if(on&&!work.spin){var imgs=work.el.querySelectorAll(".ss-work-sheep img");if(imgs.length<2)return;work.spin=setInterval(function(){imgs[work.frame].classList.remove("on");work.frame=(work.frame+1)%imgs.length;imgs[work.frame].classList.add("on")},125)}
      else if(!on&&work.spin){clearInterval(work.spin);work.spin=null}
    }
    function workPaint(full){
      var st=work.st,el=work.el;if(!st||!el)return;
      var now=Date.now()-work.skew,quiet=now-(st.updated||st.at);
      // In-house turns clear on settlement. If their worker vanished before it
      // could clear, retire the island after ten quiet minutes, including catch-up.
      if(workExpired(st)){workFade();return}
      var q=!st.stopped&&quiet>WORK_QUIET,who=st.who==="Co-shepherd"?"Shepherd":st.who||"An AI agent",scr=workScreen(),clock=workClock(now-st.since);
      el.classList.toggle("is-stopped",!!st.stopped);el.classList.toggle("is-quiet",q);el.classList.toggle("is-idle",!!st.stopped||q);
      if(el.classList.contains("is-screen")!==scr){el.classList.toggle("is-screen",scr);el.classList.toggle("is-min",work.min&&!scr);workPlace()}
      var news=q?"No update for "+workAgo(quiet)+" — it may have stopped.":"";
      el.querySelector(".ss-work-title").textContent=scr?(st.stopped?"Spacesheep stopped working on it":"Spacesheep is working on it"):(st.stopped?who+" stopped working on this page":who+" is working on this page");
      // The Co-shepherd changes the page in place as it writes; a writer from outside
      // (an MCP client) publishes the finished page at the end.
      el.querySelector(".ss-work-sub").textContent=scr?WORK_TITLE:(st.stopped?"What’s here is as far as it got.":news||(st.who==="Co-shepherd"?"Changes show up on the page as they’re made.":"The finished page will appear here when it’s done."));
      el.querySelector(".ss-work-foot").textContent=scr?[who,st.stopped?"":clock,st.stopped?"The page wasn’t finished.":news||"The finished page will appear right here."].filter(Boolean).join(" · "):"";
      el.querySelector(".ss-work-clock").textContent=clock;
      workSpin(!st.stopped&&!q);
      if(!full)return;
      var row=el.querySelector(".ss-work-now");
      if(work.txt!==st.text){el.querySelector(".ss-work-txt").textContent=st.text;if(work.txt){row.classList.remove("is-new");void row.offsetWidth;row.classList.add("is-new")}work.txt=st.text}
      // The steps before this one, newest first, each with how long it took.
      var ol=el.querySelector(".ss-work-steps"),steps=st.steps||[],until=st.at,top=steps.length?steps[0].text+"@"+steps[0].at:"";
      ol.innerHTML="";
      for(var i=0;i<steps.length&&i<3;i++){
        var li=document.createElement("li");
        li.innerHTML='<span class="ss-work-ck">'+WORK_CHECK+'</span><span class="ss-work-st"></span><span class="ss-work-dur"></span>';
        li.children[1].textContent=steps[i].text;li.children[1].title=steps[i].text;
        li.children[2].textContent=workClock(until-steps[i].at);until=steps[i].at;
        if(!i&&work.top&&work.top!==top)li.className="is-new";
        ol.appendChild(li);
      }
      work.top=top;
    }
    // The work is the page while the page is only a live link's placeholder — never
    // once a real page has arrived, and never over a version the reader pinned.
    function workScreen(){return !!(work.st&&work.st.screen)&&!work.hasPage&&!window.__ssPinnedVersion}
    function workHasPage(){if(work.hasPage)return;work.hasPage=true;if(work.el&&work.st&&!workToDrawer(work.st))workPaint(true);else if(work.st)workShow(work.st)}
    // A page that draws the work itself — a live link's placeholder, marked
    // data-ss-work (assets/document/live-link-page.ts) — is handed the status and
    // gets no card over it: the card only said that page's own two sentences again.
    // work.inPage is the frame's own answer (ss-work-shown, from anchor.js), null
    // until it has given one; a page without the mark, or an anchor.js too old to
    // answer, keeps the card exactly as before. A real page arriving live (a set)
    // puts the card back, as the screen used to step aside for it.
    function workDrawnInPage(){return work.inPage===true&&!work.hasPage}
    // Until a frame has said it draws the work it is asked with nothing in hand (unless
    // the status itself says this is a live link's placeholder), and once it has said
    // it doesn't it is not told at all: an ordinary page's own script, listening on its
    // window, never gets to read the writer's steps.
    function workTellFrame(st){
      if(!frameReady||work.inPage===false)return;var f=document.getElementById("content");if(!f||!f.contentWindow)return;
      var p=null;
      if(st&&(work.inPage===true||st.screen)){var now=Date.now()-work.skew,steps=st.steps||[];p={text:st.text,who:st.who==="Co-shepherd"?"Shepherd":st.who||null,stopped:!!st.stopped,elapsed:now-st.since,quiet:now-(st.updated||st.at),done:steps.length,more:steps.length>=6,current:now-st.at,steps:steps.map(function(s){return{text:String(s&&s.text||""),ago:now-(s&&s.at||0)}})}}
      try{f.contentWindow.postMessage({type:"ss-work",status:p},co)}catch(x){}
    }
    function workFrameReady(){work.inPage=null;if(!work.st)return;workTellFrame(work.st);if(work.wait){clearTimeout(work.wait);work.wait=setTimeout(workWaited,1500)}}
    // Every ss-work is answered, so the status is sent again only on the frame's first yes.
    function workShown(on){
      var was=work.inPage;work.inPage=on;if(work.wait){clearTimeout(work.wait);work.wait=null}
      if(workDrawnInPage()){if(was!==true&&work.st)workTellFrame(work.st);workAside()}
      else if(work.st&&!work.el)workShow(work.st);
    }
    // Held back for a placeholder that hasn't answered yet; one that never does gets the card.
    function workWaited(){work.wait=null;if(work.st&&!work.el&&!workDrawnInPage())workShow(work.st)}
    // The card off the screen, the status kept: the page is drawing it.
    function workAside(){if(work.bye){clearTimeout(work.bye);work.bye=null}clearInterval(work.tick);work.tick=null;workSpin(false);if(work.el){work.el.remove();work.el=null}}
    // The Co-shepherd's steps are drawn in its drawer (pages/viewer-coshepherd.ts), in
    // the thread beside the ask, for anyone who has the drawer — the card over the page
    // only said the same thing again and covered what was changing
    // (design-explorations/coshepherd-working-in-drawer.html, variant C). The card stays
    // for other writers (an MCP client, the Telegram agent), for a reader with no drawer
    // (signed out), and as a live link's placeholder screen, which is the page itself.
    // Every status is relayed whoever wrote it; the drawer keeps the Co-shepherd's.
    function workToDrawer(st){return !!(st&&st.who==="Co-shepherd"&&document.getElementById("chat"))&&!(st.screen&&!work.hasPage&&!window.__ssPinnedVersion)}
    function workRelay(st,done){work.relay={status:st||null,skew:work.skew,done:!!done};try{window.dispatchEvent(new CustomEvent("ss:work",{detail:work.relay}))}catch(e){}}
    // The drawer's script asks for the room's state when it starts: the catch-up may
    // already have arrived.
    window.ssWorkNow=function(){return work.relay};
    function ssWork(msg){
      if(work.stale){clearTimeout(work.stale);work.stale=null}
      if(typeof msg.t0==="number")work.skew=Date.now()-msg.t0;
      var st=msg.status||null;
      workTellFrame(st);
      workRelay(st);
      if(!st){workFade();return}
      if(workDrawnInPage()){work.st=st;workAside();return}
      // A live link's placeholder answers within a moment of its first step: hold the
      // card until it does, so the card doesn't flash up over the page that draws it.
      if(st.screen&&!work.hasPage&&work.inPage===null&&!work.el){work.st=st;if(!work.wait)work.wait=setTimeout(workWaited,frameReady?1500:8000);return}
      workShow(st);
    }
    function workShow(st){
      // This tab's Speak card is following the run and says the same things in the
      // corner the person spoke into: a second card over the page only covered it.
      // A live link's placeholder screen is the page itself, so it still shows.
      if(work.quiet&&!st.screen){if(work.el)workHide();return}
      if(workToDrawer(st)){if(work.el)workHide();work.st=st;return}
      if(workExpired(st)){workHide();return}
      if(work.shut&&work.shut===workKey(st)&&workIdle(st)){workHide();return}
      if(work.bye){clearTimeout(work.bye);work.bye=null}
      work.st=st;
      var fresh=!work.el,el=work.el||workMake();
      // A card already up (or on its way out after a publish) stays up.
      el.classList.remove("is-done");if(!fresh)el.classList.add("is-in");
      workPaint(true);
      if(work.st&&!work.tick)work.tick=setInterval(function(){workPaint(false)},1e3);
    }
    // A publish is the result the card promised: say so, then step aside for it.
    function workDone(){
      if(work.relay&&work.relay.status)workRelay(null,true);
      var el=work.el;
      // Drawn in the page, or not up at all: the frame reloads onto the finished page.
      if(!el){if(work.wait){clearTimeout(work.wait);work.wait=null}work.st=null;work.hasPage=false;return}
      if(!work.st)return;
      work.st=null;work.hasPage=false;clearInterval(work.tick);work.tick=null;workSpin(false);
      el.classList.remove("is-stopped","is-quiet","is-min");el.classList.add("is-done","is-in");
      el.querySelector(".ss-work-title").textContent="Done";
      el.querySelector(".ss-work-sub").textContent="Here’s the finished page.";
      work.bye=setTimeout(function(){el.classList.remove("is-in");work.bye=setTimeout(workHide,400)},2600);
    }
    // Taken down with nothing to show for it (cleared, closed, gone stale): slide out.
    function workFade(){
      var el=work.el;if(!el||work.bye){if(!el)workHide();return}
      work.st=null;clearInterval(work.tick);work.tick=null;workSpin(false);
      el.classList.remove("is-in");work.bye=setTimeout(workHide,400);
    }
    // Speak (assets/shell/speak.ts) holds the card down while it follows a run here.
    window.ssWorkQuiet=function(on){work.quiet=!!on;if(on&&work.el&&!workScreen())workHide()};
    function workHide(){
      if(work.bye){clearTimeout(work.bye);work.bye=null}
      if(work.wait){clearTimeout(work.wait);work.wait=null}
      clearInterval(work.tick);work.tick=null;workSpin(false);
      if(work.el){work.el.remove();work.el=null}
      work.st=null;work.hasPage=false;
    }
    // Every (re)connect is followed at once by the room's catch-up, which carries the
    // status if there still is one. A status still shown (on the card, or in a page
    // that draws it) when a reconnect brings none was taken down while this tab was away.
    function workReconnect(){if(!work.st)return;if(work.stale)clearTimeout(work.stale);work.stale=setTimeout(function(){work.stale=null;workTellFrame(null);if(work.relay&&work.relay.status)workRelay(null);workHide()},1500)}
    var patchSeq=0,pendingPatch={};
    // Blocks a live patch took off this page. A save this tab asked for is skipped
    // here as already drawn, but no stream draws a removal: the job takes a block off
    // at the save (LaneExecutor), so the asking tab still applies the save's removals
    // unless one of them already came live (notDrawn).
    var liveRemoved={};
    function notDrawn(edits){var out=[];for(var i=0;i<edits.length;i++){var e=edits[i];if(!e||e.op!=="ss-remove")continue;var a=String(e.anchor||"");if(liveRemoved[a]){delete liveRemoved[a];continue}out.push(e)}return out}
    window.__ssPatchMissed=false;
    window.ssPatchDoc=function(edits,sha,live){
      if(window.__ssEditing&&window.__ssEditHolds()){window.__ssEditStale=sha||window.__ssEditStale||true;return 0}
      var f=document.getElementById("content");
      if(!f||!f.contentWindow||!edits||!edits.length){if(sha)bumpFrame(sha);return 0}
      if(live===true)for(var lr=0;lr<edits.length;lr++){var le=edits[lr];if(le&&le.op==="ss-remove")liveRemoved[String(le.anchor||"")]=1}
      var id=++patchSeq;
      pendingPatch[id]={sha:sha||null,t:setTimeout(function(){finishPatch(id,["_timeout"],false)},2000)};
      f.contentWindow.postMessage({type:"ss-apply-patch",id:id,edits:edits,live:live===true},co);
      return id;
    };
    function finishPatch(id,missed,revealed){
      var p=pendingPatch[id];if(!p)return;
      clearTimeout(p.t);delete pendingPatch[id];
      // Only trust the in-place morph when the iframe positively confirms it applied
      // AND revealed the edit (revealed===true). A missed anchor, a timeout, or a
      // stale anchor.js that can't confirm -> reload so the change is never invisible.
      if((missed&&missed.length)||!revealed){if(p.sha)bumpFrame(p.sha);else window.__ssPatchMissed=true}
    }
    // Once an owner edit commits, hand its sha to any patches still in flight so a
    // late "not revealed" result reloads to the committed version (avoids the race
    // where the stream's done arrives before the iframe answers ss-apply-patch).
    window.__ssCommitPatches=function(sha){
      for(var pid in pendingPatch){if(pendingPatch.hasOwnProperty(pid))pendingPatch[pid].sha=sha;}
    };

    function updateCount(){
      // One number everywhere — header, rail, corner: the threads still open. Resolved
      // ones are counted in their own "Resolved (n)" divider; a pin's badge counts the
      // messages in its own thread.
      // A card that failed to post isn't a thread anyone else can see: it waits on its
      // own Try again, outside the count.
      var total=comments.filter(function(c){return!c.parent_id&&!c.resolved_at&&!(c._tmp&&c._state!=="sending")}).length;
      var badge=document.getElementById("commentCount"),sc=document.getElementById("sbCount");
      var tot=document.getElementById("commentTotal");
      var fresh=sidebarOpen?0:comments.filter(isNew).length;
      // The total lives in the button's label and just sits there.
      if(tot)tot.textContent=total>0?String(total):"";
      // Something new is a dot, never a second number beside the total. Opening the
      // rail clears it, and once the rail closes it lights for what arrives after.
      if(fresh>0){badge.textContent="";badge.classList.add("dot");badge.style.display="";badge.title=fresh+" new";badge.setAttribute("aria-label",fresh+" new comments")}
      else badge.style.display="none";
      cornerCount(total,fresh);
      ssSetTip(document.getElementById("commentToggle"),total>0
        ?(fresh>0?fresh+" new of "+total+" comments":total===1?"1 comment":total+" comments")
        :"Comments",{at:"below",as:"label"});
      sc.textContent="("+total+(fresh>0?", "+fresh+" new":"")+")";
    }

    // Sidebar. Opening it is what arms click-to-comment inside the document: with
    // the rail closed the page is for reading and using, so anchor.js leaves clicks
    // alone (see ss-comment-mode there). Selecting text is the exception — with the
    // rail closed it raises a small "Comment" pill, but only when this reader can
    // post (avail: signed in, rail rendered); an anonymous view stays plain. The
    // toggle button carries the same state for anyone driving this by keyboard.
    // Annotate and the viewer's Edit take turns (window.ssEdit in the edit script):
    // the frame ignores Annotate's clicks while editing, so Annotate coming on ends
    // the edit, its typed words saved first. When the edit can't end without losing
    // words, Annotate goes back off and the edit bar says why.
    var annotWasOn=false;
    function sendCommentMode(){
      var f=document.getElementById("content"),annotOn=!placeholder&&((sidebarOpen&&annotate)||corner.on);
      if(annotOn&&!annotWasOn&&window.ssEdit){var ended=window.ssEdit.yield("comments");if(ended)ended.then(function(ok){if(!ok)window.ssAnnotateOff()})}
      annotWasOn=annotOn;
      if(f&&f.contentWindow)f.contentWindow.postMessage({type:"ss-comment-mode",on:!placeholder&&(sidebarOpen||corner.on),avail:!ANON&&!placeholder,annotate:annotOn},co);
      paintCorner();paintPinBar(annotOn);
      var t=document.getElementById("commentToggle");
      if(t){t.setAttribute("aria-pressed",sidebarOpen?"true":"false");t.classList.toggle("active",sidebarOpen)}
      // An open rail is the reader looking at the comments: everything counts as seen
      // from here, and the one-time "you can comment" nudge has done its job.
      if(sidebarOpen){markSeen();dismissCoach(true)}
    }
    // Open: the rail leaves the inert set and the composer takes focus once the
    // width transition has run. Close: it goes inert again, and focus returns to
    // the header button if it was inside the rail.
    function railChanged(sb,was,source){
      sb.toggleAttribute("inert",!sidebarOpen);sb.setAttribute("aria-hidden",sidebarOpen?"false":"true");
      // A touch keyboard is half the screen: opening the drawer to read shouldn't raise it.
      // Not when a pin's composer opened it: a selection's Comment, or a click with
      // Annotate, opens the rail and its own composer together, and the rail's foot
      // taking focus 220 ms later sent what came next to a comment on the whole page
      // ("select, then type": the first letter on the words, the rest on the page).
      if(sidebarOpen&&!was&&source!=="restore"&&!(window.matchMedia&&matchMedia("(hover:none)").matches))setTimeout(function(){if(compose&&!cmpEl.hidden)return;composeText.focus()},220);
      if(!sidebarOpen&&was){var t=document.getElementById("commentToggle");if(t&&sb.contains(document.activeElement))t.focus();seenOnClose()}
    }
    // A live link's placeholder ("Spacesheep is working on it", marked data-ss-work)
    // is not a document yet: there is nothing on it to comment on. The frame says so
    // once it has read the page (ss-placeholder from anchor.js), and again after a live
    // change; while it is up the rail shuts, the corner's Annotate goes off, the
    // Comments button, the corner button and the coach tip are put away
    // (html[data-ss-placeholder] in viewer-style.ts) and "C" does nothing. The
    // finished page brings them all back.
    var placeholder=false;
    function placeholderMode(on){
      on=!!on;if(on===placeholder)return;placeholder=on;
      document.documentElement.toggleAttribute("data-ss-placeholder",on);
      // These tools need a real document, not the creation progress page. Keep
      // their seats visible and restore their original attributes after publishing.
      ["spaceCopyOpen","verBtn","statsBtn","fsBtn","dlPdf","dlHtml","signAskBtn"].forEach(function(id){
        var el=document.getElementById(id);if(!el)return;
        var attrs=["disabled","aria-disabled","href","tabindex","title"];
        if(on){
          el.__ssCreationAttrs=attrs.map(function(name){return el.getAttribute(name)});
          el.setAttribute("disabled","");el.setAttribute("aria-disabled","true");
          el.removeAttribute("href");el.setAttribute("tabindex","-1");
          el.setAttribute("title","Available once the space has content");
        }else if(el.__ssCreationAttrs){
          attrs.forEach(function(name,i){var value=el.__ssCreationAttrs[i];if(value===null)el.removeAttribute(name);else el.setAttribute(name,value)});
          delete el.__ssCreationAttrs;
        }
      });
      if(on){dismissCoach(false);if(sidebarOpen)toggleSidebar(false,"temporary");if(corner.on)setCorner(false);if(bub&&bub.tip)hideBub()}
      else if(sidebarState.read()===true)toggleSidebar(true,"restore");
      sendCommentMode();
    }
    var sbInT=0;
    function toggleSidebar(force,source){if(placeholder&&(force===undefined?!sidebarOpen:force))return;var sb=document.getElementById("sidebar"),was=sidebarOpen;sidebarOpen=force!==undefined?force:!sidebarOpen;sidebarOpen?sb.classList.remove("hidden"):sb.classList.add("hidden");clearTimeout(sbInT);sb.classList.toggle("sb-in",sidebarOpen&&!was);if(sidebarOpen&&!was)sbInT=setTimeout(function(){sb.classList.remove("sb-in")},260);railChanged(sb,was,source);
      if(sidebarOpen!==was||source==="restore")sidebarState.changed(sidebarOpen,source);
      var pinning=corner.on;
      if(sidebarOpen){corner.on=false;if(bub&&bub.annotate)hideBub();landRail()}
      // Opening the rail is for reading: pinning stays off, so the page's clicks and
      // links keep working. Pinning already on from the corner button carries over
      // on a wide screen. Closing the rail ends it, and takes an empty composer with
      // it. On a phone the drawer opens covering the page, pinning off: turning it on
      // is the one tap that slides the drawer away to make the page tappable.
      // A rail put back as the page loads doesn't end an edit that opened with it
      // (sheep.new's ?edit=1): pinning waits to be asked for.
      if(sidebarOpen&&!was){annotate=pinning&&!PHONE_MQ.matches&&!(source==="restore"&&window.ssEdit&&window.ssEdit.open());if(annotSw)annotSw.setAttribute("aria-checked",annotate?"true":"false");if(sbScrim)sbScrim.hidden=!PHONE_MQ.matches}
      if(!sidebarOpen){annotate=false;cancelCompose();setAway(false,true);if(sbScrim)sbScrim.hidden=true;focusId=null;hotId=null}
      sendCommentMode();if(sidebarOpen!==was)sendMarkers()}
    document.getElementById("sidebar").addEventListener("keydown",function(e){if(e.key==="Escape"&&!document.getElementById("inlineReply")&&!document.getElementById("cmtEdit")&&mentionMenu.style.display!=="block"){e.preventDefault();if(annotate)setAnnotate(false,true);else toggleSidebar(false)}});

    // Preferences popover. Two kinds of switch sit in it: the space's own (owner
    // only, written to the server) and the reader's own (this browser, never sent
    // anywhere). Each row's second line says which it is, in as few words as will
    // carry it — that scope is the one thing a reader cannot guess from the label. A failed space write puts the box back where it
    // was — the page must never claim a preference the space didn't take.
    (function(){
      var pop=document.getElementById("prefPop");if(!pop)return;
      var box=document.getElementById("prefElemRx"),row=document.getElementById("prefRxRow");
      // Anywhere outside closes it — including the document itself, whose clicks land
      // in the iframe and never reach this listener. Focus leaving the shell is the
      // signal that covers that case (and a click into another window, which should
      // not leave a menu hanging open either).
      document.addEventListener("mousedown",function(e){if(pop.open&&!pop.contains(e.target))pop.open=false});
      window.addEventListener("blur",function(){pop.open=false});
      pop.addEventListener("keydown",function(e){if(e.key==="Escape"){e.stopPropagation();pop.open=false;pop.querySelector("summary").focus()}});
      // The space's own switch is rendered for the OWNER only, so everyone else finds
      // nothing here. Wiring it unconditionally threw on the first reader who wasn't
      // the owner, and the throw took the rest of this script block with it — the
      // Comments button stopped toggling, loadComments never ran and a public space's
      // rail was dead for every visitor but its owner. The popover above still wires
      // for them: "Hide resolved threads" lives in it too.
      if(!box||!row)return;
      box.addEventListener("change",function(){
        var want=box.checked;row.classList.add("busy");
        fetch("/api/space/"+spaceId+"/prefs",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({element_reactions:want})}).then(function(r){
          if(!r.ok)throw new Error("prefs");
          ELEM_RX=want;sendMarkers();renderComments();
          announce(want?"Reactions on the page are on.":"Reactions on the page are off.");
          if(window.mixpanel)mixpanel.track("Element Reactions Toggled",{space_id:spaceId,on:want});
        }).catch(function(){box.checked=!want;announce("That didn't save.")}).then(function(){row.classList.remove("busy")});
      });
    })();

    // "Hide resolved threads": the box is set from storage rather than rendered
    // checked, because the server has no idea what this reader prefers.
    (function(){
      var box=document.getElementById("prefHideRes");if(!box)return;
      box.checked=hideResolved;
      box.addEventListener("change",function(){setHideResolved(box.checked,"prefs")});
    })();
    // "Comments on the page, while the list is closed": the reader's own, this browser.
    // Picking one takes over from what this visit's link said.
    (function(){
      var radios=document.querySelectorAll('input[name="prefMarks"]'),note=document.getElementById("prefMarksNote");if(!radios.length)return;
      function paintNote(){if(note)note.innerHTML=marksVisit?"This visit&rsquo;s link says <b>?comments="+marksVisit+"</b>. Picking one here takes over.":"A link ending in <b>?comments=show</b> shows them all for that visit."}
      radios.forEach(function(r){
        r.checked=r.value===marksPref;
        r.addEventListener("change",function(){
          if(!r.checked)return;
          marksPref=r.value;marksVisit=null;
          try{localStorage.setItem("ss_cmt_marks",marksPref)}catch(x){}
          paintNote();sendMarkers();
          if(window.mixpanel)try{mixpanel.track("Comment Marks Changed",{space_id:spaceId,marks:marksPref})}catch(x){}
        });
      });
      paintNote();
    })();
    // The sort picker (assets/components/menu.ts). A change lands on the newest
    // message (or the top, for page order) — the old scroll position belongs to a
    // different list.
    (function(){
      var btn=document.getElementById("sbSort"),lbl=document.getElementById("sbSortL");if(!btn)return;
      // Each order says where it starts, in words: the time orders put the newest at
      // the bottom, by the box you write in, which no icon could say at a glance.
      var SORT_ITEMS=[
        {k:"activity",l:"Latest activity",sub:"New replies at the bottom"},
        {k:"started",l:"Date started",sub:"Newest thread at the bottom"},
        {k:"page",l:"Position on page",sub:"Top of the page first"}
      ];
      function name(k){for(var i=0;i<SORT_ITEMS.length;i++)if(SORT_ITEMS[i].k===k)return SORT_ITEMS[i].l;return""}
      function showSort(){lbl.textContent=name(cmtSort)}
      showSort();
      btn.addEventListener("click",function(){
        ssMenu.open(btn,SORT_ITEMS.map(function(it){return{k:it.k,l:it.l,sub:it.sub,checked:it.k===cmtSort}}),{label:"Sort comments",onPick:function(k){
          if(!SORTS[k]||k===cmtSort)return;
          cmtSort=k;showSort();
          try{localStorage.setItem("ss_cmt_sort",cmtSort)}catch(x){}
          renderComments();
          var list=document.getElementById("sbList");list.scrollTop=chrono()?list.scrollHeight:0;
          announce("Sorted by "+name(k).toLowerCase()+".");
          if(window.mixpanel)mixpanel.track("Comment Sort Changed",{space_id:spaceId,sort:cmtSort});
        }});
      });
    })();
    // First time in this browser: point at the Comments button once. A person
    // who has already opened the rail anywhere doesn't need telling.
    var coachEl=null;
    function dismissCoach(remember){if(coachEl){coachEl.remove();coachEl=null}if(CORNER&&bub&&bub.tip)hideBub();if(remember){try{localStorage.setItem("ss_coach_comments","1")}catch(x){}}}
    (function(){
      var seen=null;try{seen=localStorage.getItem("ss_coach_comments")}catch(x){}
      // With the corner button, the button says it itself (below).
      if(seen||CORNER)return;
      var tries=0;
      setTimeout(function show(){
        // One tip at a time: the Share hint goes first, and this one follows it.
        if(window.ssShareHintDue&&!window.ssShareHintDone){addEventListener("ss:share-hint-done",function(){setTimeout(show,1200)},{once:true});return}
        // Width is read here, not at script time: a tab that hasn't laid out yet
        // (background load, prerender) reports 0 — wait for layout rather than
        // skipping the nudge for good.
        var w=document.documentElement.clientWidth||window.innerWidth;
        if(!w){if(tries++<10)setTimeout(show,1000);return}
        var t=document.getElementById("commentToggle");if(!t||sidebarOpen||placeholder||w<640)return;
        var r=t.getBoundingClientRect();
        coachEl=document.createElement("div");coachEl.className="coach";coachEl.setAttribute("role","status");
        coachEl.innerHTML='<span><b>You can comment on this page.</b> Select any text and write, or open Comments here and click the page to pin one to a spot.</span><button type="button" aria-label="Dismiss">&times;</button>';
        coachEl.style.top=(r.bottom+12)+"px";coachEl.style.right=Math.max(8,w-r.right-4)+"px";
        coachEl.querySelector("button").onclick=function(){dismissCoach(true)};
        document.body.appendChild(coachEl);
        setTimeout(function(){dismissCoach(true)},12000);
      },1800);
    })();

    // ---- The comment button, and comments arriving live (CORNER: comment-corner-flag.ts) ----
    // A round button in the bottom-right corner, over Speak's (.cfab). Tap: Pin
    // comments on, so the next click on the page pins a comment there; tap again: off.
    // While it is on with the list shut, a chip beside it ("4 comments ›") opens the
    // list. Hold (anyone with window.ssDictate, i.e. Speak's roster): say it, and it
    // pins where you are reading. Drag: anywhere, kept per browser. Its bubble peeks
    // out beside it: a comment as it arrives, the words while you talk, what just posted.
    var cf=document.getElementById("cfab"),cfBtn=document.getElementById("cfabBtn"),cfN=document.getElementById("cfabN"),cfBub=document.getElementById("cfabBub");
    var cfList=document.getElementById("cfabList"),cfListL=document.getElementById("cfabListL");
    // A page that draws its own comments turned ours off (<meta name="ss-comments"
    // content="off">, anchor.js ss-comments-mode): it gets no comment button.
    window.addEventListener("message",function(e){if(e.origin!==co||!e.data||e.data.type!=="ss-comments-mode"||!cf)return;cf.classList.toggle("is-off",!!e.data.off)});
    function canVoice(){return typeof window.ssDictate==="function"}
    function chipOn(){return!!cfList&&corner.on&&!sidebarOpen}
    function paintCorner(){
      if(!cf)return;
      // Lit while pinning is on: the corner's own, or the rail's.
      var lit=corner.on||(sidebarOpen&&annotate);
      cf.classList.toggle("is-on",lit);cf.classList.toggle("is-live",!!voice);
      cfBtn.setAttribute("aria-pressed",lit?"true":"false");
      cfBtn.setAttribute("aria-label",voice?"Listening — let go to post":lit?"Stop pinning comments":"Pin comments on the page");
      if(cfList){
        var on=chipOn();
        cfList.classList.toggle("on",on);cfList.tabIndex=on?0:-1;cfList.setAttribute("aria-hidden",on?"false":"true");
        var r=cfBtn.getBoundingClientRect();cf.classList.toggle("is-left",r.left+r.width/2<innerWidth/2);
      }
      placeBub();
    }
    function cornerCount(total,fresh){
      if(!cfN)return;
      // One number: the threads still open. Something new is a dot, not a second number.
      cfN.textContent=total>0?String(total):"";
      cf.classList.toggle("has-new",fresh>0);
      if(cfListL)cfListL.textContent=total?total+(total===1?" comment":" comments"):"Comments";
      cfBtn.title=(total?(fresh?fresh+" new of "+total+" comments. ":total===1?"1 comment. ":total+" comments. "):"")+"Pin comments: tap, then "+(PHONE_MQ.matches?"tap":"click")+" the page"+(canVoice()?"; hold to say it":"")+". Drag to move.";
    }
    function setCorner(on){
      on=!!on;if(corner.on===on)return;
      corner.on=on;
      if(!on&&compose&&compose.corner&&!cmpText.value.trim())cancelCompose();
      if(on&&bub&&bub.tip)hideBub();
      sendCommentMode();sendMarkers();
    }
    function cornerTap(){
      if(placeholder)return;
      cornerUnder(false);
      dismissCoach(true);
      if(voice)return;
      if(sidebarOpen){setAnnotate(!annotate,true);return}
      setCorner(!corner.on);
    }
    // The chip: the list. On a wide screen it sits beside the page and pinning stays
    // on; on a phone the list covers the page, so going to it ends pinning.
    if(cfList)cfList.addEventListener("click",function(){
      var keep=corner.on&&!PHONE_MQ.matches;
      if(corner.on)setCorner(false);
      toggleSidebar(true);
      if(keep&&!annotate)setAnnotate(true,false);
      if(window.mixpanel)try{mixpanel.track("Comment List Chip Clicked",{space_id:spaceId,phone:PHONE_MQ.matches})}catch(x){}
    });
    // While pinning is on, a bar over the top of the page says what a click does,
    // that selecting words still quotes them, and how to stop.
    var pinBar=document.getElementById("pinBar");
    function placePinBar(){
      if(!pinBar||pinBar.hidden)return;
      var f=document.getElementById("content");if(!f)return;
      // The header floats over the top of the page: the bar sits under it.
      var r=f.getBoundingClientRect(),h=document.querySelector(".doc-hdr"),hb=h?h.getBoundingClientRect().bottom:0;
      pinBar.style.maxWidth=Math.max(200,r.width-24)+"px";
      // Its home is under the header, on the frame's centre line; a drag moves it from
      // there (pbOff, kept per browser), never off the screen.
      var off=pbOff||{x:0,y:0},x=r.left+r.width/2+off.x,y=Math.max(r.top,hb,0)+10+off.y;
      var w=pinBar.offsetWidth||300,ht=pinBar.offsetHeight||44,m=8;
      x=Math.max(m+w/2,Math.min(innerWidth-m-w/2,x));y=Math.max(m,Math.min(innerHeight-m-ht,y));
      pinBar.style.left=x+"px";pinBar.style.top=y+"px";
    }
    // Drag it out of the way: press anywhere on the bar but Done, and move.
    var PBPOS="ss-pinbar-pos",pbOff={x:0,y:0},pbDrag=null;
    try{var pb0=JSON.parse(localStorage.getItem(PBPOS)||"null");if(pb0&&typeof pb0.x==="number"&&typeof pb0.y==="number")pbOff=pb0}catch(x){}
    if(pinBar){
      pinBar.addEventListener("pointerdown",function(e){
        if(e.button!==0||e.target.closest("button"))return;
        e.preventDefault();
        pbDrag={id:e.pointerId,x:e.clientX,y:e.clientY,ox:pbOff.x,oy:pbOff.y,moved:false};
        try{pinBar.setPointerCapture(e.pointerId)}catch(x){}
        pinBar.classList.add("is-dragging");
      });
      pinBar.addEventListener("pointermove",function(e){
        if(!pbDrag||e.pointerId!==pbDrag.id)return;
        var dx=e.clientX-pbDrag.x,dy=e.clientY-pbDrag.y;
        if(Math.abs(dx)+Math.abs(dy)>3)pbDrag.moved=true;
        pbOff={x:pbDrag.ox+dx,y:pbDrag.oy+dy};placePinBar();
      });
      var pbEnd=function(e){
        if(!pbDrag||e.pointerId!==pbDrag.id)return;
        var moved=pbDrag.moved;pbDrag=null;pinBar.classList.remove("is-dragging");
        if(!moved)return;
        // Where it really sits once clamped, so a drag past the edge isn't kept.
        var f=document.getElementById("content");if(f){var r=f.getBoundingClientRect(),h=document.querySelector(".doc-hdr"),hb=h?h.getBoundingClientRect().bottom:0;pbOff={x:parseFloat(pinBar.style.left)-(r.left+r.width/2),y:parseFloat(pinBar.style.top)-(Math.max(r.top,hb,0)+10)}}
        // Dropped back near home: forget it.
        if(Math.abs(pbOff.x)<24&&Math.abs(pbOff.y)<24){pbOff={x:0,y:0};placePinBar();try{localStorage.removeItem(PBPOS)}catch(x){}}
        else try{localStorage.setItem(PBPOS,JSON.stringify(pbOff))}catch(x){}
        if(window.mixpanel)try{mixpanel.track("Pin Bar Moved",{space_id:spaceId,home:!pbOff.x&&!pbOff.y,phone:PHONE_MQ.matches})}catch(x){}
      };
      pinBar.addEventListener("pointerup",pbEnd);pinBar.addEventListener("pointercancel",pbEnd);
    }
    function paintPinBar(on){
      if(!pinBar)return;
      on=!!on&&!placeholder;
      if(on===!pinBar.hidden)return;
      pinBar.hidden=!on;
      if(!on){pinBar.innerHTML="";return}
      var tap=PHONE_MQ.matches||!!(window.matchMedia&&matchMedia("(hover:none)").matches);
      pinBar.innerHTML='<span class="pb-grip" aria-hidden="true" title="Drag to move"></span><span class="pb-t"><b>'+(tap?"Tap":"Click")+'</b> anything to pin a comment<i> &middot; </i><b>Select words</b> to quote them'+(tap?'':'<i> &middot; </i><kbd>Esc</kbd> stops')+'</span><button type="button" id="pinBarDone">Done</button>';
      document.getElementById("pinBarDone").onclick=function(){if(corner.on)setCorner(false);if(annotate)setAnnotate(false,true)};
      placePinBar();
    }
    addEventListener("resize",placePinBar);
    function composePayload(d,body){
      var payload={body:body};
      if(d.anchorId&&!d.gone){payload.anchor_id=d.anchorId;payload.anchor_text=d.quote||d.anchorText||d.anchorId;payload.anchor={x:d.x,y:d.y,tag:d.tag||undefined,quote:!!d.quote,near:d.quote?undefined:(d.near||undefined),path:d.path||undefined,part:d.part||undefined,thing:d.thing||undefined}}
      else if(d.quote)payload.anchor_text=d.quote;
      return payload;
    }
    // Posted from the corner: the rail stays shut, the new pin drops in and stays a
    // few seconds, and a spoken one can be taken back.
    function cornerPosted(c,spoken){
      var now=Date.now();arrived[c.id]=now;livePin[c.id]=now+6000;setTimeout(sendMarkers,6100);
      sendMarkers();
      bubble({ms:spoken?10000:5000,html:"<span>"+(spoken?"🎙 ":"")+"Posted.</span>"+(spoken?'<p class="cfab-say">'+esc(String(c.body||"").slice(0,200))+"</p>":""),
        acts:[spoken?{label:"Undo",fn:function(){undoOwn(liveId(c))}}:null,{label:"See it",fn:function(){focusThread(liveId(c),true)}}].filter(Boolean)});
    }
    function undoOwn(id){
      // Still on its way: the card goes now, and whatever lands is removed then
      // (sendTmp sees _cancel). A card that failed has nothing on the server.
      var tmp=comments.find(function(c){return c.id===id&&c._tmp});
      if(tmp){tmp._cancel=true;comments=comments.filter(function(c){return c!==tmp});renderComments();toast("Removed");if(window.mixpanel)try{mixpanel.track("Voice Comment Undone",{space_id:spaceId})}catch(x){}return}
      fetch("/api/space/"+spaceId+"/comments/"+encodeURIComponent(id),{method:"DELETE"}).then(function(r){
        if(!r.ok)throw new Error("HTTP "+r.status);
        comments=comments.filter(function(c){return c.id!==id});reactions=reactions.filter(function(x){return x.comment_id!==id});
        renderComments();toast("Removed");
        if(window.mixpanel)try{mixpanel.track("Voice Comment Undone",{space_id:spaceId})}catch(x){}
      }).catch(function(){toast("Couldn’t remove it")});
    }

    // The bubble beside the button: one at a time, placed on whichever side of the
    // button has room, held open while the pointer or focus is on it.
    var bub=null,bubT=0,bubHold=false;
    function placeBub(){
      if(!cfBub||cfBub.hidden||!cfBtn)return;
      var r=cfBtn.getBoundingClientRect(),left=r.left+r.width/2<innerWidth/2,up=chipOn();
      cfBub.classList.toggle("is-left",left);cfBub.classList.toggle("is-up",up);
      // The chip takes the side beside the button: the bubble goes above it then.
      cfBub.style.bottom=(up?innerHeight-r.top+12:Math.max(8,innerHeight-r.bottom))+"px";
      if(up){if(left){cfBub.style.left=r.left+"px";cfBub.style.right=""}else{cfBub.style.right=(innerWidth-r.right)+"px";cfBub.style.left=""}}
      else if(left){cfBub.style.left=(r.right+12)+"px";cfBub.style.right=""}else{cfBub.style.right=(innerWidth-r.left+12)+"px";cfBub.style.left=""}
    }
    // The last window opened is on top: Speak's panel opening puts the button and its
    // bubble under it; anything the button does next brings them back over.
    function cornerUnder(on){if(cf)cf.classList.toggle("is-under",!!on);if(cfBub)cfBub.classList.toggle("is-under",!!on)}
    (function(){
      var sp=document.getElementById("ssSpeakPop");
      if(!sp||!cf||typeof MutationObserver!=="function")return;
      new MutationObserver(function(){if(!sp.hidden)cornerUnder(true)}).observe(sp,{attributes:true,attributeFilter:["hidden"]});
      if(!sp.hidden)cornerUnder(true);
    })();
    function bubble(o){
      if(!cfBub)return;
      clearTimeout(bubT);bub=o;cornerUnder(false);
      cfBub.className="cfab-bub"+(o.tip?" is-tip":"")+(o.voice?" is-voice":"");
      cfBub.innerHTML=o.html+(o.acts&&o.acts.length?'<div class="cfab-acts">'+o.acts.map(function(a,i){return '<button type="button" data-i="'+i+'"'+(a.go?' class="go"':"")+">"+esc(a.label)+"</button>"}).join("")+"</div>":"");
      cfBub.hidden=false;placeBub();void cfBub.offsetWidth;cfBub.classList.add("on");
      armBub();
    }
    function armBub(){clearTimeout(bubT);if(bub&&bub.ms)bubT=setTimeout(function(){if(!bubHold)hideBub()},bub.ms)}
    function hideBub(){clearTimeout(bubT);bub=null;if(!cfBub)return;cfBub.classList.remove("on");setTimeout(function(){if(!bub)cfBub.hidden=true},220)}
    if(cfBub){
      cfBub.addEventListener("click",function(e){var b=e.target.closest("button[data-i]");if(!b||!bub||!bub.acts)return;var a=bub.acts[+b.dataset.i];hideBub();if(a&&a.fn)a.fn()});
      cfBub.addEventListener("pointerenter",function(){bubHold=true});
      cfBub.addEventListener("pointerleave",function(){bubHold=false;armBub()});
      cfBub.addEventListener("focusin",function(){bubHold=true});
      cfBub.addEventListener("focusout",function(){bubHold=false;armBub()});
      addEventListener("resize",placeBub);
    }

    // A comment arriving while you are here shows up where it was left: its card
    // slides into the rail, its pin drops onto the page (and stays a few seconds with
    // the rail shut; a reply flashes its thread's pin), and the button bumps and says
    // who and what, with Reply one tap away.
    function arrive(c){
      if(!CORNER)return;
      var now=Date.now(),root=c.parent_id||c.id;
      arrived[c.id]=now;livePin[root]=now+8000;if(c.parent_id)liveReply[root]=1;
      setTimeout(sendMarkers,8100);
      if(cf){cf.classList.remove("is-bump");void cf.offsetWidth;cf.classList.add("is-bump")}
      if(sidebarOpen||voice||document.visibilityState!=="visible")return;
      var agent=c.via==="co-shepherd",ses=sessOf(c),name=commentAuthor(c).name;
      var said=cmtWords(c).trim()||(c.images&&c.images.length?"an image":"");
      var rc=c.parent_id?comments.find(function(x){return x.id===root}):c;
      bubble({ms:8000,html:'<div class="cfab-who">'+(agent?'<span class="ss-av ss-av-xs cmt-agent-av">'+SHEEP+'</span>':ses?sessAv(ses.source):commentIdentityLink(c,ssAvatar({name:name,seed:c.author_email,picture:c.author_picture,size:"xs"}),"cmt-avatar-link",name))+commentIdentityLink(c,"<b>"+esc(name)+"</b>","",name)+"<span>"+(c.parent_id?"replied":"commented")+'</span></div><p class="cfab-say">'+esc(said.slice(0,240))+"</p>",
        acts:[{label:ssT("cmt.reply","Reply"),go:true,fn:function(){peekReply=root;focusThread(root,true);setTimeout(function(){openInlineReply(root,true)},260)}},
          rc&&rc.anchor_id?{label:"Show me",fn:function(){setCorner(true);goToPin(root)}}:null].filter(Boolean)});
    }

    // Writing a comment, told to the room: who and where, never the words
    // ({t:"composing"} on the presence socket; room-posts.ts parseComposing). Sent
    // when a box opens on a spot and while it is typed in (at most every 4 s). The
    // others drop a mark they haven't heard of for 12 s, so a box left open and idle
    // stops saying so; "off" or a closed tab ends it at once.
    // In interactive mode (live cursors on, for this reader and in the room) the
    // words go too, as they are typed (text), at most ~6 a second with the last one
    // always sent, so the others watch the comment being written.
    var myDraft=null,myDraftAt=0,myDraftTextAt=0,myDraftT=0;
    function composingSend(o){try{if(ws&&ws.readyState===1)ws.send(JSON.stringify(o))}catch(x){}}
    function composingWords(){return typeof pcLive==="function"&&pcLive()}
    function composingOn(d){
      if(!CORNER)return;
      var text=composingWords()&&d.text?String(d.text).slice(0,600):"";
      var key=JSON.stringify({anchor:d.anchor,x:d.x,y:d.y,part:d.part,thread:d.thread,text:text}),now=Date.now();
      if(key===myDraft&&now-myDraftAt<4000)return;
      clearTimeout(myDraftT);myDraftT=0;
      if(text&&now-myDraftTextAt<160){myDraftT=setTimeout(function(){myDraftT=0;composingOn(d)},160-(now-myDraftTextAt));return}
      myDraft=key;myDraftAt=now;if(text)myDraftTextAt=now;
      composingSend({t:"composing",anchor:d.anchor||undefined,x:d.x||0,y:d.y||0,part:d.part||undefined,thread:d.thread||undefined,text:text||undefined});
    }
    function composingOff(){clearTimeout(myDraftT);myDraftT=0;if(!myDraft)return;myDraft=null;composingSend({t:"composing",off:true})}
    function onComposing(m){
      if(!CORNER)return;
      var seed=String(m.seed||"");if(!seed)return;
      if(m.off){if(drafts[seed]){delete drafts[seed];draftsChanged()}return}
      drafts[seed]={name:String(m.name||"Someone").slice(0,60),anchor:m.anchor||null,x:+m.x||0,y:+m.y||0,part:cleanPart(m.part),thread:m.thread||null,text:PC&&typeof m.text==="string"?m.text.slice(0,600):"",at:Date.now()};
      draftsChanged();
    }
    setInterval(function(){var now=Date.now(),ch=false;for(var k in drafts)if(now-drafts[k].at>12000){delete drafts[k];ch=true}if(ch)draftsChanged()},3000);
    function draftsChanged(){sendMarkers();paintTyping()}
    // Live cursors (the live_cursors switch: the button beside the faces is the gate,
    // and its press is this reader's own on/off, kept per device). The frame reports
    // this reader's pointer and selection (ss-cursor, ss-select) only while someone
    // else is in the room; the room relays them ({t:"cursor"}, {t:"select"},
    // room-posts.ts parsePeer) and keeps nothing; other people's come back here and go
    // down to the frame as ss-peers, with a first name and a colour, never an address.
    // Cursors are per tab, not per person (the room counts sockets, {type:"tabs"}): your
    // own other tab or device draws yours, named for that device, and two tabs of one
    // person are two cursors. peers is keyed "<seed>:<tab>".
    var pcBtn=document.getElementById("peerCursorsBtn"),PC=!!pcBtn,pcMine=true,peers={},pcTold=null,pcPaintT=0,pcSeen=false,pcTabs=0,pcDv=pcDevice();
    // No regexes here: this lives in a template literal, where a backslash is eaten.
    function pcDevice(){
      var u=navigator.userAgent||"",has=function(t){return u.indexOf(t)>=0};
      var b=has("Edg/")?"Edge":has("Firefox/")?"Firefox":has("Chrome/")||has("CriOS")?"Chrome":has("Safari/")?"Safari":"Browser";
      var o=has("iPhone")?"iPhone":has("iPad")||(has("Macintosh")&&navigator.maxTouchPoints>1)?"iPad":has("Android")?"Android":has("Macintosh")||has("Mac OS X")?"Mac":has("Windows")?"Windows":has("Linux")?"Linux":"";
      return o?b+" · "+o:b;
    }
    try{pcMine=localStorage.getItem("ss-live-cursors")!=="off"}catch(x){}
    function pcFrame(m){var f=document.getElementById("content");if(f&&f.contentWindow)try{f.contentWindow.postMessage(m,co)}catch(x){}}
    function pcSend(o){try{if(ws&&ws.readyState===1)ws.send(typeof o==="string"?o:JSON.stringify(o))}catch(x){}}
    function pcLive(){return PC&&pcMine&&(Object.keys(viewers).length>1||pcTabs>1)}
    function pcTell(force){
      if(!PC)return;var on=pcLive(),was=pcTold;
      if(on===was&&!force)return;
      pcTold=on;pcFrame({type:"ss-peers-on",on:on});pcFrame({type:"ss-ultra",on:UL&&on});if(UL&&on)ulHint();
      if(was&&!on){pcSend('{"t":"cursor","off":true}');pcSend('{"t":"select","off":true}')}
    }
    function pcFirst(n){n=String(n||"Someone").trim();var i=n.indexOf(" ");return(i>0?n.slice(0,i):n).slice(0,24)||"Someone"}
    function pcIdle(p){return!!p.cur&&Date.now()-p.curAt>10000}
    function pcQueue(){if(PC&&!pcPaintT)pcPaintT=requestAnimationFrame(pcPaint)}
    function pcPaint(){
      pcPaintT=0;var list=[],cursors=0;
      if(pcMine)for(var s in peers){var p=peers[s];if(!p.cur&&!p.sel&&!p.say)continue;if(p.cur)cursors++;p.wasIdle=pcIdle(p);list.push({seed:s,name:p.you?"You · "+(p.dv&&p.dv!==pcDv?p.dv:"other tab"):pcFirst(p.name),color:ssAvatarColor(p.seed),cur:p.cur,idle:p.wasIdle,sel:p.sel,say:UL?p.say:null,path:p.pg})}
      pcFrame({type:"ss-peers",peers:list});
      if(cursors&&!pcSeen){pcSeen=true;if(window.mixpanel)mixpanel.track("Live Cursors Seen",{space_id:spaceId,peers:cursors,people:Object.keys(viewers).length})}
    }
    function onPeer(m){
      if(!PC)return;var seed=String(m.seed||"");if(!seed)return;var s=seed+":"+String(m.tab||"");
      if(m.type==="view"){if(UL)ulOnView(seed,m);return}
      var p=peers[s]||(peers[s]={seed:seed,name:"",cur:null,curAt:0,sel:null,selAt:0,pg:""});
      p.name=String(m.name||"Someone");p.you=m.you===true;p.dv=typeof m.dv==="string"?m.dv.slice(0,32):"";
      if(m.type==="cursor"){if(m.off)p.cur=null;else{p.cur={a:String(m.a||""),x:+m.x||0,y:+m.y||0,part:m.part||null};p.curAt=Date.now();p.pg=String(m.pg||"")}}
      else if(m.type==="say"){if(!UL)return;if(m.off)p.say=null;else{p.say={text:String(m.text||"").slice(0,200),a:String(m.a||""),x:+m.x||0,y:+m.y||0,part:m.part||null,done:m.done===true};p.sayAt=Date.now();p.pg=String(m.pg||"")}}
      else{if(m.off)p.sel=null;else{p.sel={a:String(m.a||""),q:String(m.q||"").slice(0,300)};p.selAt=Date.now();p.pg=String(m.pg||"")}}
      if(!p.cur&&!p.sel&&!p.say)delete peers[s];
      pcQueue();
    }
    // A cursor that rests dims after 10 s and goes after a minute; a selection after ten.
    setInterval(function(){
      if(!PC)return;var now=Date.now(),ch=false;
      for(var s in peers){var p=peers[s];
        if(p.cur&&now-p.curAt>60000){p.cur=null;ch=true}
        if(p.sel&&now-p.selAt>600000){p.sel=null;ch=true}
        // Words said fade 8 s after they were sent, or 20 s after the last letter typed.
        if(p.say&&now-p.sayAt>(p.say.done?8000:20000)){p.say=null;ch=true}
        if(!p.cur&&!p.sel&&!p.say){delete peers[s];ch=true}else if(pcIdle(p)!==!!p.wasIdle)ch=true}
      if(ch)pcQueue();
    },2500);
    window.addEventListener("message",function(e){
      if(!PC||e.origin!==co||!e.data)return;var f=document.getElementById("content");if(!f||e.source!==f.contentWindow)return;
      var d=e.data;
      if(d.type==="ss-anchor-ready"){pcTell(true);pcQueue();return}
      if(!pcLive())return;
      // The page's path is cut to what the room keeps (room-posts.ts parsePeer): a long
      // query string would take the message past the room's size cap, and it drops those.
      if(d.type==="ss-cursor"){var c=d.cur;pcSend(c&&typeof c.a==="string"?{t:"cursor",a:c.a,x:c.x,y:c.y,part:c.part||undefined,pg:String(d.path||"").slice(0,300),dv:pcDv}:'{"t":"cursor","off":true}')}
      else if(d.type==="ss-select"){var sl=d.sel;pcSend(sl&&typeof sl.a==="string"?{t:"select",a:sl.a,q:String(sl.q||"").slice(0,300),pg:String(d.path||"").slice(0,300),dv:pcDv}:'{"t":"select","off":true}')}
      else if(UL&&d.type==="ss-view"){var v=d.view;ulPath=String(d.path||"").slice(0,300);if(v&&typeof v.a==="string")pcSend({t:"view",a:v.a,y:+v.y||0,pg:ulPath})}
      else if(UL&&d.type==="ss-say-start"){ulOpenSay(d)}
      else if(UL&&d.type==="ss-follow-stop"){ulStop("scrolled")}
    });
    // Ultra-interactive mode (the ultra_interactive switch: the hidden #ssUltra mark is
    // the gate, removed by the final HTML pass for anyone without it). On top of live
    // cursors: Enter on the page opens a box at the pointer whose words everyone sees
    // as they are typed ({t:"say"}, beside the cursor, gone 8 s after Enter), and a
    // face is a button that follows that person's screen ({t:"view"}) until you
    // scroll yourself. The box is the shell's, never the page's: the page is its
    // author's script, and only the room should hear what a reader types.
    var UL=PC&&!!document.getElementById("ssUltra"),ulBox=null,ulSent=0,ulSendT=0,ulLead=null,ulViews={},ulPath="",ulBar=null;
    function ulSayMsg(box,done){return{t:"say",text:box.input.value.slice(0,200),a:box.cur.a,x:box.cur.x,y:box.cur.y,part:box.cur.part||undefined,pg:box.path,done:done||undefined,dv:pcDv}}
    function ulSendNow(done){if(!ulBox)return;clearTimeout(ulSendT);ulSendT=0;ulSent=Date.now();var v=ulBox.input.value;pcSend(v.trim()?ulSayMsg(ulBox,done):'{"t":"say","off":true}')}
    function ulTyped(){if(!ulBox)return;var now=Date.now();if(now-ulSent>=160){ulSendNow(false);return}if(!ulSendT)ulSendT=setTimeout(function(){ulSendT=0;ulSendNow(false)},160-(now-ulSent))}
    function ulClose(send){
      if(!ulBox)return;var b=ulBox,v=b.input.value.trim();
      // Sent before the box lets go: the last message (done) is what starts the 8 s fade.
      if(send&&v){ulSendNow(true);if(window.mixpanel)mixpanel.track("Ultra Say Sent",{space_id:spaceId,chars:v.length,people:Object.keys(viewers).length})}
      else{clearTimeout(ulSendT);ulSendT=0;pcSend('{"t":"say","off":true}')}
      ulBox=null;b.el.remove();var f=document.getElementById("content");if(f)try{f.focus({preventScroll:true})}catch(x){}
    }
    function ulOpenSay(d){
      if(!pcLive()||!d.cur||typeof d.cur.a!=="string")return;
      if(ulBox)ulClose(false);
      var f=document.getElementById("content");if(!f)return;var r=f.getBoundingClientRect();
      var el=document.createElement("div");el.className="ul-say";
      el.innerHTML='<input type="text" maxlength="200" autocomplete="off" aria-label="Say something at your cursor" placeholder="Say something…"><span class="ul-say-hint">Enter to send · Esc</span>';
      var x=Math.max(8,Math.min(window.innerWidth-300,r.left+(+d.x||0)+14)),y=Math.max(8,Math.min(window.innerHeight-60,r.top+(+d.y||0)+18));
      el.style.left=x+"px";el.style.top=y+"px";el.style.setProperty("--ul-c",ssAvatarColor(String(myUser||"me")));
      document.body.appendChild(el);
      var input=el.querySelector("input");
      ulBox={el:el,input:input,cur:{a:d.cur.a,x:+d.cur.x||0,y:+d.cur.y||0,part:d.cur.part||null},path:String(d.path||"").slice(0,300)};
      input.addEventListener("input",ulTyped);
      input.addEventListener("keydown",function(ev){if(ev.isComposing)return;if(ev.key==="Enter"){ev.preventDefault();ulClose(true)}else if(ev.key==="Escape"){ev.preventDefault();ulClose(false)}});
      input.addEventListener("blur",function(){setTimeout(function(){if(ulBox&&ulBox.input===input)ulClose(true)},0)});
      input.focus();
    }
    // Faces become "follow" buttons. A face keeps its profile link everywhere else.
    // data-nav-inline: the sheep veil raises on a link's click before this handler can
    // prevent it (nav-loading.ts), and a follow never navigates.
    function ulFaces(shown){
      if(!UL)return;
      setTimeout(function(){var avs=presenceEl.querySelectorAll(".pres-av");for(var i=0;i<avs.length&&i<shown.length;i++){var sd=shown[i],u=viewers[sd]||{};avs[i].setAttribute("data-ul-seed",sd);avs[i].setAttribute("data-nav-inline","");avs[i].setAttribute("title",ulLead===sd?"Stop following "+pcFirst(u.name):"Follow "+pcFirst(u.name)+"’s screen");avs[i].classList.toggle("ul-lead",ulLead===sd)}},0);
    }
    if(UL)presenceEl.addEventListener("click",function(ev){
      var av=ev.target&&ev.target.closest&&ev.target.closest("[data-ul-seed]");if(!av||ev.metaKey||ev.ctrlKey||ev.shiftKey)return;
      ev.preventDefault();var sd=av.getAttribute("data-ul-seed");
      if(ulLead===sd){ulStop("face");return}
      ulLead=sd;var u=viewers[sd]||{};ulBarShow("Following "+pcFirst(u.name),true);
      if(ulViews[sd])ulApply(ulViews[sd]);else pcFrame({type:"ss-follow",on:true});
      renderPresence();if(window.mixpanel)mixpanel.track("Ultra Follow Started",{space_id:spaceId,people:Object.keys(viewers).length});
    },true);
    function ulOnView(seed,m){
      if(m.off){delete ulViews[seed];return}
      var v={a:String(m.a||""),y:+m.y||0,pg:String(m.pg||""),name:String(m.name||"")};ulViews[seed]=v;
      if(ulLead===seed)ulApply(v);
    }
    function ulApply(v){
      var u=viewers[ulLead]||{};
      if(ulPath&&v.pg!==ulPath){ulBarShow(pcFirst(u.name||v.name)+" is on another page of this space",true);return}
      ulBarShow("Following "+pcFirst(u.name||v.name),true);
      pcFrame({type:"ss-follow",a:v.a,y:v.y});
    }
    function ulStop(how){
      if(!ulLead)return;var u=viewers[ulLead]||{};ulLead=null;pcFrame({type:"ss-follow",on:false});
      ulBarShow(how==="left"?pcFirst(u.name)+" left the page":"Stopped following",false);renderPresence();
      if(window.mixpanel)mixpanel.track("Ultra Follow Stopped",{space_id:spaceId,how:how});
    }
    function ulBarShow(text,stay){
      if(!ulBar){ulBar=document.createElement("div");ulBar.className="ul-bar";ulBar.setAttribute("role","status");document.body.appendChild(ulBar)}
      ulBar.innerHTML="";var t=document.createElement("span");t.textContent=text;ulBar.appendChild(t);
      if(ulLead){var b=document.createElement("button");b.type="button";b.textContent="Stop";b.addEventListener("click",function(){ulStop("button")});ulBar.appendChild(b)}
      var f=document.getElementById("content"),r=f?f.getBoundingClientRect():null;if(r){ulBar.style.left=(r.left+r.width/2)+"px";ulBar.style.top=(r.top+10)+"px"}
      ulBar.classList.add("on");clearTimeout(ulBar.__t);if(!stay)ulBar.__t=setTimeout(function(){if(!ulLead)ulBar.classList.remove("on")},3500);
    }
    // Once per device: what the mode adds, the first time someone else is here.
    function ulHint(){
      try{if(localStorage.getItem("ss-ultra-hint"))return;localStorage.setItem("ss-ultra-hint","1")}catch(x){return}
      ulBarShow("Ultra-interactive: press Enter to say something at your cursor · click a face to follow their screen",false);
    }
    if(pcBtn){
      var pcBtnSync=function(){var t=pcMine?"Live cursors are on":"Live cursors are off";pcBtn.setAttribute("aria-pressed",pcMine?"true":"false");pcBtn.setAttribute("data-tip",t);pcBtn.setAttribute("aria-label",t)};
      pcBtnSync();
      pcBtn.addEventListener("click",function(){pcMine=!pcMine;try{localStorage.setItem("ss-live-cursors",pcMine?"on":"off")}catch(x){}pcBtnSync();pcTell();pcQueue();if(window.mixpanel)mixpanel.track("Live Cursors Switched",{space_id:spaceId,on:pcMine})});
    }
    // The list is drawn again on every change, and with a room full of people that is
    // several times a second; a "… is replying" line comes and goes with every
    // keystroke pause in a thread above you. Whoever is typing in a reply or an edit
    // keeps the box, its focus, its caret and its place on the screen, and whoever
    // has scrolled into the list keeps the card at the top of it where it was — the
    // browser's own scroll anchoring can't, since the card it would hold is replaced.
    // A list at its very top is left to move, as the browser leaves it: what lands
    // there is meant to be seen. Returns the function that puts them back.
    function railHold(list,stick){
      var typing=null,held=null,ae=document.activeElement;
      if(ae&&list.contains(ae)&&ae.tagName==="TEXTAREA"){var box=ae.closest("#inlineReply,#cmtEdit");if(box)typing={sel:"#"+box.id+" textarea",s:ae.selectionStart,e:ae.selectionEnd,d:ae.selectionDirection,top:ae.getBoundingClientRect().top}}
      // The card at the top edge, found by asking what is drawn there: walking every
      // card's box cost a page of 500 comments 50 ms a redraw.
      if(!stick&&!typing&&list.scrollTop>0){var lr=list.getBoundingClientRect();
        for(var dy=4;dy<160&&!held;dy+=24){var hit=document.elementFromPoint(lr.left+lr.width/2,lr.top+dy),card=hit&&list.contains(hit)&&hit.closest("article.cmt[data-id]");
          if(card)held={id:card.getAttribute("data-id"),top:card.getBoundingClientRect().top}}}
      return function(){
        var nt=typing&&list.querySelector(typing.sel);
        if(nt&&document.activeElement!==nt){nt.focus({preventScroll:true});try{nt.setSelectionRange(typing.s,typing.e,typing.d)}catch(x){}}
        if(stick)list.scrollTop=list.scrollHeight;
        else if(nt)list.scrollTop+=nt.getBoundingClientRect().top-typing.top;
        else if(held){var hc=list.querySelector('article.cmt[data-id="'+held.id+'"]');if(hc)list.scrollTop+=hc.getBoundingClientRect().top-held.top}
      };
    }
    function paintTyping(){
      var list=document.getElementById("sbList");if(!list)return;
      var restore=railHold(list,chrono()&&list.scrollHeight-list.scrollTop-list.clientHeight<60);
      list.querySelectorAll(".thread-typing").forEach(function(el){el.remove()});
      Object.keys(drafts).forEach(function(seed){
        var d=drafts[seed];if(!d.thread)return;
        var foot=list.querySelector('[data-thread="'+d.thread+'"] .thread-foot');if(!foot)return;
        var el=document.createElement("div");el.className="thread-typing";
        if(d.text){var b=document.createElement("b");b.textContent=d.name+": ";el.appendChild(b);el.appendChild(document.createTextNode(d.text));el.classList.add("has-words")}
        else el.textContent=d.name+" is replying";
        foot.parentNode.insertBefore(el,foot);
      });
      restore();
    }

    // Hold to talk. The page is asked for the block in the middle of the screen
    // (anchor.js pinCenter), the composer opens on it without taking focus (no
    // keyboard), the words stream into it, and letting go posts it, with Undo in the
    // bubble for a slip. No block (a page with none, or a frame too old to answer):
    // it goes on the page as a whole.
    function voiceStart(){
      if(voice||!canVoice())return;
      var lv=window.ssComposeMic&&window.ssComposeMic.live();if(lv)lv.cancel(false);
      dismissCoach(true);
      if(compose&&cmpText.value.trim()){cmpEl.classList.remove("shake");void cmpEl.offsetWidth;cmpEl.classList.add("shake");return}
      cancelCompose();
      var mine={t0:Date.now(),text:"",compose:null};voice=mine;
      paintCorner();
      bubble({voice:true,html:'<div class="cfab-voice"><i></i>Listening — let go to post</div><p class="cfab-say" id="cfabSay"></p>'});
      var f=document.getElementById("content");
      if(f&&f.contentWindow)f.contentWindow.postMessage({type:"ss-pin-center"},co);
      mine.d=window.ssDictate({
        onText:function(fin,int,said){
          if(voice!==mine)return;
          mine.text=said;
          var say=document.getElementById("cfabSay");if(say)say.textContent=mine.text;
          if(mine.compose&&compose===mine.compose){cmpText.value=mine.text;window.ssAutoGrow(cmpText);placeCompose();composingOn({anchor:compose.anchorId,x:compose.x,y:compose.y,part:compose.part})}
        },
        // Ended by the page rather than the person (the tab hidden, the speech service
        // gone): what was said is kept, and never posted by itself. A composer opened on
        // a block keeps the words with Post ready; with no block they wait in the bubble
        // until the person posts them or lets them go.
        onFail:function(msg){
          if(voice!==mine)return;
          var said=String(mine.text||"").trim(),inBox=!!(said&&mine.compose&&compose===mine.compose);
          voiceEnd(true,inBox);
          if(!said||inBox){bubble({ms:6000,html:"<span>"+esc(msg)+"</span>"});return}
          bubble({html:"<span>"+esc(msg)+'</span><p class="cfab-say">'+esc(said)+"</p>",acts:[{label:"Post it",go:true,fn:function(){postHeard(null,said)}},{label:"Discard"}]});
        }
      });
      if(window.ssVoiceMeter&&mine.d.levels)mine.meter=window.ssVoiceMeter(cfBtn,function(){return mine.d.levels()});
      if(window.mixpanel)try{mixpanel.track("Voice Comment Started",{space_id:spaceId,phone:PHONE_MQ.matches})}catch(x){}
    }
    // keep: a cancel that leaves the block's composer open with the words (see onFail).
    function voiceEnd(cancelled,keep){
      var v=voice;if(!v)return;voice=null;if(v.meter)v.meter();paintCorner();
      if(cancelled){try{v.d&&v.d.cancel()}catch(x){}if(v.compose&&compose===v.compose){if(keep)updateCmpHint();else cancelCompose()}if(bub&&bub.voice)hideBub();return}
      var held=Date.now()-v.t0;
      bubble({voice:true,html:'<div class="cfab-voice"><i></i>Posting…</div><p class="cfab-say">'+esc(v.text)+"</p>"});
      v.d.stop().then(function(text){
        text=String(text||v.text||"").trim();
        var d=v.compose&&compose===v.compose?v.compose:null;
        if(!text){if(d)cancelCompose();bubble({ms:4000,html:"<span>"+(held<900?"Hold the button while you talk.":"Didn’t catch anything.")+"</span>"});return}
        postHeard(d,text);
      });
    }
    // What a hold heard, posted: on the block its composer is pinned to, or (no d) on
    // the page as a whole.
    function postHeard(d,text){
      if(d){cmpText.value=text;cmpSend.disabled=true;cmpText.disabled=true}
      voiceNext="corner";
      postComment(d?composePayload(d,text):{body:text},"corner-voice",function(c){
        cmpText.disabled=false;if(d)cancelCompose();
        // With the rail open the card in it is the confirmation; the "Posting…"
        // bubble goes (it was left behind, orphaned, until a reload).
        if(sidebarOpen){if(bub&&bub.voice)hideBub();focusThread(c.id,true)}else cornerPosted(c,true);
      },function(lost){
        cmpText.disabled=false;
        // The words are on the rail's card, with Try again and Discard on it.
        bubble({ms:8000,html:"<span>"+(lost?esc(LOST_ACCESS):"Couldn’t post that — it’s on the rail: Try again or Discard.")+"</span>",acts:[{label:"See it",fn:function(){toggleSidebar(true)}}]});
      });
    }

    // Press, hold, drag. A press that moves 6 px is a drag; one that stays put for
    // 380 ms is a hold (with dictation); anything shorter is a tap (the click). The
    // pointer is captured at once so a hold still ends when the finger slides off.
    // A place is kept per browser ("ss-cfab-pos": px from the right and bottom edges)
    // and applied inline; a drop back near the corner forgets it.
    var CPOS="ss-cfab-pos",cpos=null,press=null,swallowUntil=0;
    function cClamp(p){var w=cfBtn.offsetWidth||52,h=cfBtn.offsetHeight||52,m=8;return{r:Math.max(m,Math.min(innerWidth-w-m,p.r)),b:Math.max(m,Math.min(innerHeight-h-m,p.b))}}
    function cPlace(){if(!cpos){cf.style.right=cf.style.bottom=""}else{var p=cClamp(cpos);cf.style.right=p.r+"px";cf.style.bottom=p.b+"px"}paintCorner()}
    if(cf){
      try{var cp0=JSON.parse(localStorage.getItem(CPOS)||"null");if(cp0&&typeof cp0.r==="number"&&typeof cp0.b==="number"){cpos=cp0;cPlace()}}catch(x){}
      addEventListener("resize",function(){if(cpos)cPlace()});
      cfBtn.addEventListener("pointerdown",function(e){
        if(e.button!==0)return;
        // While a hold is listening, another pointer is not a new press. A second
        // finger brushing the button used to overwrite the one press, and the holding
        // finger's own pointerup then no longer matched it (pressEnd keys on the
        // pointer id): voiceEnd never ran and the microphone stayed captured for the
        // life of the tab. Any other press a new one still replaces, as it always did,
        // which is how the button recovers from a gesture whose end it never saw.
        if(press&&press.voice&&voice)return;
        var r=cf.getBoundingClientRect();
        press={x:e.clientX,y:e.clientY,r:innerWidth-r.right,b:innerHeight-r.bottom,moved:false,id:e.pointerId,hold:0,voice:false};
        cornerUnder(false);
        try{cfBtn.setPointerCapture(e.pointerId)}catch(x){}
        cf.classList.add("is-press");
        if(canVoice()){var p0=press;p0.hold=setTimeout(function(){if(press===p0&&!p0.moved){p0.voice=true;cf.classList.remove("is-press");voiceStart()}},380)}
      });
      cfBtn.addEventListener("pointermove",function(e){
        if(!press||e.pointerId!==press.id||press.voice)return;
        var dx=e.clientX-press.x,dy=e.clientY-press.y;
        if(!press.moved){if(Math.abs(dx)+Math.abs(dy)<6)return;press.moved=true;clearTimeout(press.hold);cf.classList.remove("is-press");cf.classList.add("is-dragging");if(bub&&!bub.voice)hideBub()}
        cpos=cClamp({r:press.r-dx,b:press.b-dy});cPlace();
      });
      var pressEnd=function(e){
        if(!press||e.pointerId!==press.id)return;
        var p=press;press=null;clearTimeout(p.hold);cf.classList.remove("is-press","is-dragging");
        if(p.voice){swallowUntil=Date.now()+600;voiceEnd(false);return}
        if(!p.moved)return;
        swallowUntil=Date.now()+600;
        var saved=cpos;cpos=null;cPlace();var home=cf.getBoundingClientRect();
        if(Math.abs(innerWidth-home.right-saved.r)<32&&Math.abs(innerHeight-home.bottom-saved.b)<32){try{localStorage.removeItem(CPOS)}catch(x){}}
        else{cpos=saved;cPlace();try{localStorage.setItem(CPOS,JSON.stringify(cpos))}catch(x){}}
        if(window.mixpanel)try{mixpanel.track("Comment Button Moved",{space_id:spaceId,home:!cpos,phone:PHONE_MQ.matches})}catch(x){}
      };
      cfBtn.addEventListener("pointerup",pressEnd);
      cfBtn.addEventListener("pointercancel",pressEnd);
      // And from anywhere on the page: a release that missed the button (its capture
      // refused) still ends its press. pressEnd keys on the pointer id, and the
      // button's own listener has already cleared an ordinary press by the time the
      // event bubbles up to here.
      document.addEventListener("pointerup",pressEnd);
      document.addEventListener("pointercancel",pressEnd);
      // Capture taken away without a release: end the press as a pointercancel does,
      // so a hold can never outlive the gesture that started it. After an ordinary
      // pointerup this fires with the press already cleared and does nothing.
      cfBtn.addEventListener("lostpointercapture",pressEnd);
      cfBtn.addEventListener("contextmenu",function(e){e.preventDefault()});
      // The click a drag or a hold ends on is not a tap. Window capture runs before
      // the usage count's listener, so it isn't counted as one either.
      window.addEventListener("click",function(e){if(Date.now()<swallowUntil&&cf.contains(e.target)){e.stopImmediatePropagation();e.preventDefault()}},true);
      cfBtn.addEventListener("click",cornerTap);
      paintCorner();
      // First time in this browser: the button says what it does, once.
      (function(){
        var seen=null;try{seen=localStorage.getItem("ss_coach_comments")}catch(x){}
        if(seen)return;
        setTimeout(function tip(){
          if(window.ssShareHintDue&&!window.ssShareHintDone){addEventListener("ss:share-hint-done",function(){setTimeout(tip,1200)},{once:true});return}
          var spp=document.getElementById("ssSpeakPop");
          if(placeholder||sidebarOpen||corner.on||voice||bub||!cf.offsetWidth||(spp&&!spp.hidden))return;
          try{localStorage.setItem("ss_coach_comments","1")}catch(x){}
          bubble({tip:true,ms:9000,html:"<span><b>You can comment on this page.</b> "+(PHONE_MQ.matches?"Tap":"Click")+" here, then the spot."+(canVoice()?" Hold to say it.":"")+"</span>"});
        },1800);
      })();
    }
    document.getElementById("commentToggle").onclick=function(){toggleSidebar()};
    document.getElementById("sbClose").onclick=function(){toggleSidebar(false)};

    // Compose. Two composers, one way of posting: the rail's foot for a comment
    // on the whole page, and the pill that opens on the page (openCompose) for a
    // pinned one. Both @mention the same people — and the Co-shepherd.
    var composeText=document.getElementById("composeText"),composeSend=document.getElementById("composeSend");
    composeText.oninput=function(){composeSend.disabled=!canSend(composeText)};
    (function(){
      var tray=makeTray(),sb=document.getElementById("sbCompose");
      sb.insertBefore(tray.el,sb.querySelector(".compose-row"));
      tray.onChange=function(){composeSend.disabled=!canSend(composeText)};
      // The whole rail takes a dropped picture for a comment on the page; a reply box
      // inside it keeps its own.
      wireTray(composeText,document.getElementById("sidebar"),tray,sb);
    })();
    var cmpEl=document.getElementById("cmp"),cmpText=document.getElementById("cmpText"),cmpSend=document.getElementById("cmpSend"),cmpQ=document.getElementById("cmpQ"),cmpAgent=document.getElementById("cmpAgent"),cmpHint=document.getElementById("cmpHint"),cmpGone=document.getElementById("cmpGone"),cmpPage=document.getElementById("cmpPage"),cmpMenu=document.getElementById("cmpMenu");
    // An optional action ({label, fn}) rides in the toast — Undo after Resolve — and
    // keeps it up long enough to reach.
    function toast(t,act){var el=document.getElementById("sbToast");if(!el)return;el.textContent=t;
      el.classList.toggle("has-act",!!act);
      if(act){var b=document.createElement("button");b.type="button";b.textContent=act.label;b.onclick=function(){clearTimeout(toast.t);el.classList.remove("on");act.fn()};el.appendChild(b)}
      el.classList.add("on");clearTimeout(toast.t);toast.t=setTimeout(function(){el.classList.remove("on")},act?6000:2600);announce(t)}

    // @mention autocomplete — the Co-shepherd first, then members with a @handle
    // who can access this space.
    var mentionMenu=document.getElementById("mentionMenu");
    var members=null,membersRequest=null;
    function loadMembers(){
      if(!membersRequest)membersRequest=fetch("/api/space/"+spaceId+"/members").then(function(r){if(!r.ok)throw new Error();return r.json()}).then(function(d){members=d.members||[]}).catch(function(){membersRequest=null});
      return membersRequest;
    }
    var AGENT={agent:true,username:AGENT_HANDLE,name:AGENT_NAME},SESSION={session:true,username:"session"};
    function agentMatches(q){if(!q)return true;return["shepherd","spacesheep","sheep","co-shepherd","co","agent","ai","assistant"].some(function(w){return w.indexOf(q)===0})}
    // "@session" is offered to the owner with Talk on, once the Session pane's own read
    // says a session of theirs published this page (and whether it's listening).
    var sessInfo=null,sessInfoReq=null;
    function loadSessInfo(){
      if(!TALK)return Promise.resolve(null);
      if(!sessInfoReq)sessInfoReq=fetch("/api/space/"+spaceId+"/talk").then(function(r){return r.ok?r.json():null}).then(function(d){
        var x=d&&(d.sessions||[])[0];sessInfo=x?{label:x.label,machine:x.machine,listening:!!d.listening,via:d.machine&&!d.listening?d.machine.name:null}:false;return sessInfo;
      }).catch(function(){sessInfoReq=null;return null});
      return sessInfoReq;
    }
    function sessMatches(q){if(!sessInfo)return false;if(!q)return true;return["session","claude","codex","made"].some(function(w){return w.indexOf(q)===0})}
    function bindCommentAutocomplete(composeText,composeSend,mentionMenu,composer){
    window.ssEmojiAutocomplete(composeText,{onSelect:function(selection){
      if(window.mixpanel)try{mixpanel.track("Emoji Inserted",{space_id:spaceId,surface:"comment",composer:composer,method:selection.method})}catch(x){}
    }});
    var mentionActive=0,mentionMatches=[],mentionStart=-1;
    composeText.addEventListener("input",function(){
      renderMentionMenu();
      loadMembers().then(function(){if(document.activeElement===composeText)renderMentionMenu()});
      if(TALK&&sessInfo===null)loadSessInfo().then(function(){if(document.activeElement===composeText)renderMentionMenu()});
    });
    function closeMention(){mentionMenu.style.display="none";mentionMatches=[];mentionActive=0;mentionStart=-1}
    function mentionQuery(){
      var v=composeText.value,pos=composeText.selectionStart,upto=v.slice(0,pos);
      var m=upto.match(/(^|[^a-zA-Z0-9_.@\/-])@([a-zA-Z0-9-]{0,29})$/);
      if(!m)return null;mentionStart=pos-m[2].length-1;return m[2].toLowerCase();
    }
    function hlMention(){var o=mentionMenu.querySelectorAll(".mention-opt");for(var i=0;i<o.length;i++)o[i].classList.toggle("active",i===mentionActive)}
    function renderMentionMenu(){
      var q=mentionQuery();
      if(q===null){closeMention();return}
      var ppl=(members||[]).filter(function(mm){var h=(mm.username||"").toLowerCase(),n=(mm.name||"").toLowerCase();return h.indexOf(q)===0||(q&&n.indexOf(q)>=0)}).slice(0,6);
      mentionMatches=(agentMatches(q)?[AGENT]:[]).concat(sessMatches(q)?[SESSION]:[]).concat(ppl);
      if(!mentionMatches.length){closeMention();return}
      mentionActive=0;
      var h="",sec="",asec="";
      mentionMatches.forEach(function(mm,i){
        if((mm.agent||mm.session)&&!asec){asec="1";h+='<div class="mention-sec">Agents</div>'}
        if(mm.agent){h+='<div class="mention-opt agent'+(i===0?" active":"")+'" data-i="'+i+'"><span class="ss-av ss-av-xs mo-av agent">'+SHEEP+'</span><span class="mo-h">@'+AGENT_HANDLE+'</span><span class="mo-s">Agent · '+(CAN_EDIT?"edits this spot":"answers here")+'</span></div>';return}
        if(mm.session){var si=sessInfo||{};h+='<div class="mention-opt agent sess'+(i===0?" active":"")+'" data-i="'+i+'" title="'+esc("The "+(si.label||"coding")+" session that made this page"+(si.machine?", on "+si.machine:""))+'"><span class="ss-av ss-av-xs mo-av sess">'+PROMPT_ICON+'</span><span class="mo-h">@session</span><span class="mo-s">'+esc((si.label||"Session")+(si.listening?" · listening":si.via?" · via "+si.via:" · not listening"))+'</span></div>';return}
        if(!sec){sec="1";h+='<div class="mention-sec">People on this space</div>'}
        // Seed on email like every other surface — seeding on username here gave the
        // same person a different color in this menu than in the comments beside it.
        var av=ssAvatar({seed:mm.seed||mm.email,name:mm.name||mm.username,picture:mm.picture,size:"xs",className:"mo-av"});
        h+='<div class="mention-opt'+(i===0?" active":"")+'" data-i="'+i+'">'+av+'<span class="mo-h">@'+esc(mm.username)+'</span>'+(mm.name?'<span class="mo-n">'+esc(mm.name)+'</span>':'')+'</div>';
      });
      mentionMenu.innerHTML=h;
      mentionMenu.style.display="block";
    }
    function pickMention(i){
      var mm=mentionMatches[i];if(!mm)return;
      var v=composeText.value,pos=composeText.selectionStart;
      var before=v.slice(0,mentionStart),after=v.slice(pos),ins="@"+mm.username+" ";
      composeText.value=before+ins+after;
      var np=(before+ins).length;composeText.setSelectionRange(np,np);
      closeMention();composeText.focus();composeSend.disabled=!canSend(composeText);
      if(composeText.oninput)composeText.oninput();
      composeText.dispatchEvent(new Event("change"));
    }
    mentionMenu.addEventListener("mousedown",function(e){var o=e.target.closest(".mention-opt");if(o){e.preventDefault();pickMention(parseInt(o.dataset.i,10))}});
    composeText.addEventListener("keydown",function(e){
      var menuOpen=mentionMenu.style.display==="block"&&mentionMatches.length>0;
      // Enter sends (Shift+Enter for a new line); with the @mention menu open, Enter
      // picks the highlighted person instead.
      if(e.key==="Enter"&&!e.shiftKey&&!e.altKey&&!menuOpen){e.preventDefault();if(!composeSend.disabled)composeSend.click();return}
      if(!menuOpen)return;
      if(e.key==="ArrowDown"){e.preventDefault();mentionActive=(mentionActive+1)%mentionMatches.length;hlMention()}
      else if(e.key==="ArrowUp"){e.preventDefault();mentionActive=(mentionActive-1+mentionMatches.length)%mentionMatches.length;hlMention()}
      else if(e.key==="Enter"||e.key==="Tab"){e.preventDefault();pickMention(mentionActive)}
      else if(e.key==="Escape"){e.preventDefault();e.stopPropagation();closeMention()}
    });
    composeText.addEventListener("blur",function(){setTimeout(closeMention,150)});
    return{open:function(){return mentionMenu.style.display==="block"},insertAt:function(){
      composeText.focus();var v=composeText.value,pos=composeText.selectionStart||v.length,before=v.slice(0,pos),ins=(before&&!/\s$/.test(before)?" @":"@");
      composeText.value=before+ins+v.slice(pos);composeText.setSelectionRange(pos+ins.length,pos+ins.length);composeText.dispatchEvent(new Event("input"));
    }};
    }
    bindCommentAutocomplete(composeText,composeSend,mentionMenu,"page");
    var cmpMentions=bindCommentAutocomplete(cmpText,cmpSend,cmpMenu,"pin");

    // The mic beside each comment box's send (assets/shell/compose-mic.ts, the same
    // one every composer carries). A tap listens and the words land in the box; a tap
    // on ■ stops, so a misheard word can be fixed before ↵. A hold listens and
    // letting go posts, as the corner button's hold does, with Undo. Without
    // dictation (Speak's gate) the box is exactly what it was. o.state keeps a reply
    // box's listening across a live re-render of the thread.
    var voiceNext=null;
    function voiceSay(msg){if(sidebarOpen)toast(msg);else if(cf)bubble({ms:5000,html:"<span>"+esc(msg)+"</span>"});else announce(msg)}
    // Posted by a hold: Undo takes the comment back and, where the box is still there,
    // puts the words back in it.
    function voiceUndo(tmp,restore){
      var act={label:"Undo",fn:function(){undoOwn(liveId(tmp));if(restore)restore()}};
      if(sidebarOpen)toast("Posted",act);
      else if(cf)bubble({ms:10000,html:"<span>🎙 Posted.</span>",acts:[act,{label:"See it",fn:function(){focusThread(liveId(tmp),true)}}]});
    }
    function voiceSend(ta,send,o){
      if(!canVoice()||typeof window.ssComposeMic!=="function"||!ta||!send)return null;
      o=o||{};
      var s=window.ssComposeMic(ta,send,{box:o.box,state:o.state,verb:"post",say:voiceSay,track:{space_id:spaceId},
        busy:function(){return!!voice},
        post:function(text,mode){
          var n=comments.length;send.click();
          var tmp=comments.length>n?comments[comments.length-1]:null;
          if(tmp&&tmp._tmp&&mode==="hold"&&o.posted)o.posted(tmp,text);
        }});
      if(!s)return null;
      // How the words got in, for the post's analytics (sendTmp reads it once).
      send.addEventListener("click",function(){voiceNext=ta._voiceKind||null;ta._voiceKind=null;setTimeout(function(){voiceNext=null},0)},true);
      return s;
    }
    voiceSend(composeText,composeSend,{box:"page",posted:function(tmp,text){voiceUndo(tmp,function(){composeText.value=text;window.ssAutoGrow(composeText);composeText.dispatchEvent(new Event("input"));composeText.focus()})}});
    var cmpVoice=voiceSend(cmpText,cmpSend,{box:"pin",posted:function(tmp){voiceUndo(tmp,null)}});

    // Post from either composer. The people named are told (the route notifies);
    // "@co-shepherd" starts the agent's turn on the spot and the card shows it.
    // A 403/404 means the reader lost access (removed from the team, the page made
    // private) — fail() is told, so the words say that instead of "try again".
    var LOST_ACCESS="You no longer have access to this document, so it can't take comments from you.";
    // What a new comment asked, as the post answered it: the Co-shepherd's turn
    // ("@spacesheep") and the session's message ("@session"). Every composer runs it.
    function askedOn(c){
      if(c.agent_starting){agentAck(c,{status:"starting"});delete c.agent_starting}
      if(c.agent){agentAck(c,c.agent);delete c.agent}
      if(c.session){sessAsked(c,c.session);delete c.session}
    }
    // The agent's answer to an ask. The turn starts after the post answers
    // ("starting"): the card says it's working at once, and the run takes the row over
    // when it arrives as an update of the comment (or says why it couldn't start).
    function agentAck(c,a){
      var root=c.parent_id||c.id;
      if(a.status==="starting"){
        // The turn's own word can beat the post's answer (a refusal takes
        // milliseconds): whatever it already said stands.
        for(var k in pending)if(pending[k].cid===c.id)return;
        var known=comments.find(function(x){return x.id===c.id});
        if(known&&known.run_id){c.run_id=known.run_id;pending[known.run_id]={root:root,cid:c.id,status:"running",label:workLabel(c)};return}
        var ph=pending["s"+c.id]={root:root,cid:c.id,status:"running",label:workLabel(c),starting:true};
        // An update that never came (a dropped socket): read the rail again.
        setTimeout(function(){if(pending["s"+c.id]!==ph)return;loadComments().then(function(){
          if(pending["s"+c.id]!==ph)return;delete pending["s"+c.id];
          var rc=comments.find(function(x){return x.id===c.id});
          if(!rc||!rc.run_id)pending["x"+c.id]={never:true,root:root,cid:c.id,status:"failed",message:"the Shepherd didn’t start"};
          renderComments();checkPending();
        })},15000);
      }
      else if(a.status==="started"&&a.run_id){dropPending(c.id);c.run_id=a.run_id;pending[a.run_id]={root:root,cid:c.id,status:"running",label:workLabel(c)}}
      else{dropPending(c.id);pending["x"+c.id]={never:true,root:root,cid:c.id,status:"failed",message:a.message||"the Shepherd could not start",retry:a.retry,fix:a.fix,when:a.when}}
    }
    // A comment is on the rail the moment Send is pressed, as a card of its own
    // (_tmp) whose time reads "Sending"; the server's row takes its place when the
    // post answers (settleTmp), and the live echo of the same words — which can get
    // here first — settles it too (tmpFor). Nothing waits on the round trip: the
    // composer is clear for the next thought, the thread has focus, the count has
    // moved. A post that fails keeps the card, with Try again and Discard on it, so
    // the words are never lost and never typed twice.
    var tmpN=0;
    function optimisticRow(payload,pics){
      var now=new Date().toISOString(),pin=!payload.parent_id&&payload.anchor_id?payload.anchor||null:null;
      return{id:"tmp-"+(++tmpN)+"-"+Math.random().toString(36).slice(2,8),_tmp:true,_state:"sending",_payload:payload,_t:Date.now(),
        space_id:spaceId,parent_id:payload.parent_id||null,author_email:myEmail,author_username:myUser||null,author_name:myName,author_picture:myPic,
        body:payload.body||"",anchor_id:payload.parent_id?null:(payload.anchor_id||null),anchor_text:payload.anchor_text||null,anchor_version_sha:null,
        anchor_json:pin?JSON.stringify(pin):null,via:null,run_id:null,change_json:null,resolved_at:null,resolved_by:null,created_at:now,updated_at:now,
        images:pics&&pics.length?pics:undefined};
    }
    function liveId(c){return c._real||c.id}
    // The echo (or a re-read) of a comment this tab sent: the card already on the rail.
    function tmpFor(data){
      if(lcEmail(data.author_email)!==myEmail)return null;
      return comments.find(function(x){return x._tmp&&x.body===String(data.body||"")&&(x.parent_id||null)===(data.parent_id||null)&&(x.anchor_id||null)===(data.anchor_id||null)})||null;
    }
    function settleTmp(tmp,real){
      var i=comments.indexOf(tmp),dup=comments.find(function(x){return x.id===real.id&&x!==tmp});
      if(dup){if(i>=0)comments.splice(i,1);real=dup}
      else{real._t=tmp._t;if(i>=0)comments[i]=real;else comments.push(real)}
      tmp._real=real.id;
      // What the rail knew about the card follows it to its real id — except
      // "arrived", which would drop the pin and slide the card in a second time.
      if(focusId===tmp.id)focusId=real.id;if(hotId===tmp.id)hotId=real.id;
      if(bodyOpen[tmp.id]){bodyOpen[real.id]=true;delete bodyOpen[tmp.id]}
      if(expanded[tmp.id]){expanded[real.id]=true;delete expanded[tmp.id]}
      if(livePin[tmp.id]){livePin[real.id]=livePin[tmp.id];delete livePin[tmp.id]}
      if(liveReply[tmp.id]){liveReply[real.id]=liveReply[tmp.id];delete liveReply[tmp.id]}
      delete arrived[tmp.id];
      if(inlineReply&&inlineReply.root===tmp.id)inlineReply.root=real.id;
      if(peekReply===tmp.id)peekReply=real.id;
      return real;
    }
    // The settled card is drawn once its slide-in is over, so the swap is invisible.
    function renderSettled(tmp){var wait=600-(Date.now()-tmp._t);if(wait>0)setTimeout(renderComments,wait);else renderComments()}
    function cmtFail(c){
      var lost=c._state==="lost";
      return '<div class="cmt-fail" role="alert"><span>'+(lost?esc(LOST_ACCESS):ssT("cmt.post_failed","Couldn’t post this."))+'</span>'+
        (lost?'':'<button type="button" data-retry-tmp="'+c.id+'">'+ssT("cmt.try_again","Try again")+'</button>')+
        '<button type="button" data-discard-tmp="'+c.id+'">'+ssT("cmt.discard","Discard")+'</button></div>';
    }
    function discardTmp(id){comments=comments.filter(function(c){return c.id!==id});renderComments()}
    // The post itself. o.via tracks a Comment Created (the page's and the corner's
    // composers); a reply's own events are its caller's (o.onOk). post_ms: Send to
    // the server's answer — the time the card spends saying "Sending".
    function sendTmp(tmp,o){
      var t0=Date.now(),payload=tmp._payload,spoken=voiceNext||"none";voiceNext=null;
      tmp._state="sending";tmp._o=o;
      fetch("/api/space/"+spaceId+"/comments",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(payload)})
        .then(function(r){if(!r.ok){var er=new Error("HTTP "+r.status);er.lost=r.status===403||r.status===404;throw er}return r.json()}).then(function(c){
          var ms=Date.now()-t0;
          // Taken back while in flight (a spoken comment's Undo): remove what landed.
          if(tmp._cancel){comments=comments.filter(function(x){return x!==tmp&&x.id!==c.id});renderComments();fetch("/api/space/"+spaceId+"/comments/"+encodeURIComponent(c.id),{method:"DELETE"}).catch(function(){});return}
          var real=settleTmp(tmp,c);askedOn(c);renderSettled(tmp);
          if(o.via){
            if(window.mixpanel)try{mixpanel.track("Comment Created",{space_id:spaceId,is_reply:!!payload.parent_id,has_anchor:!!payload.anchor_id,pinned:!!payload.anchor,quoted:!!(payload.anchor&&payload.anchor.quote),thing:!!(payload.anchor&&payload.anchor.thing),agent:asksAgent(payload.body)||!!c.agent_followup,session:asksSession(payload.body),via:o.via,voice:spoken,post_ms:ms,phone:PHONE_MQ.matches,images:(payload.images||[]).length,retried:!!o.retried,ask:o.ask})}catch(x){}
            if(window.mixpanel)try{mixpanel.track("Comment Posted",{reply:!!payload.parent_id,pinned:!!payload.anchor_id,space_id:spaceId,agent:asksAgent(payload.body)||!!c.agent_followup,voice:spoken,post_ms:ms})}catch(x){}
          }
          if(o.onOk)o.onOk(c,ms,spoken);
          var who=namedPeople(payload.body);
          if(who.length)toast(who.join(" and ")+" will be notified");else announce(payload.parent_id?"Reply posted":"Comment posted");
          if(o.done)o.done(real);
        }).catch(function(e){try{console.error("[comments] post failed",e)}catch(x){}
          var lost=!!(e&&e.lost);
          // Settled by the echo meanwhile: the post landed, whatever the answer said.
          if(comments.indexOf(tmp)>=0){tmp._state=lost?"lost":"failed";renderComments()}
          if(o.fail)o.fail(lost)});
    }
    // landed(tmp) runs at once, with the card already on the rail: the caller clears
    // its composer and puts the thread in view. fail(lost) runs only if the post did.
    // ask: how a pin's ask was made ("button" or "typed"), for Comment Created.
    function postComment(payload,via,landed,fail,pics,ask){
      var tmp=optimisticRow(payload,pics);
      arrived[tmp.id]=Date.now();comments.push(tmp);renderComments();
      if(landed)landed(tmp);
      sendTmp(tmp,{via:via,fail:fail,ask:ask||undefined});
    }
    // Who a body names, for the toast: handles that are members here (the route
    // resolves the same list; the agent is not a person to notify).
    function namedPeople(body){
      var out=[],re=/(^|[^a-zA-Z0-9_.@\/-])@([a-zA-Z0-9][a-zA-Z0-9-]{0,29})/g,m;
      while((m=re.exec(body||""))){var u=m[2].toLowerCase();if(AGENT_HANDLES.indexOf(u)>=0||u==="session")continue;var mm=(members||[]).find(function(p){return(p.username||"").toLowerCase()===u});if(mm&&out.indexOf(mm.name||"@"+mm.username)<0)out.push(mm.name||"@"+mm.username)}
      return out;
    }
    composeSend.onclick=function(){
      if(!canSend(composeText))return;
      var body=composeText.value.trim(),payload={body:body},imgs=trayKeys(composeText),pics=trayPics(composeText);if(imgs.length)payload.images=imgs;
      var cErr=document.getElementById("composeErr");if(cErr)cErr.hidden=true;
      postComment(payload,"page",function(c){
        composeText.value="";window.ssAutoGrow(composeText);trayClear(composeText);composeSend.disabled=true;
        focusThread(c.id,true);
      },function(lost){if(cErr){cErr.textContent=lost?LOST_ACCESS:"Couldn’t post that. It’s still on the rail — Try again or Discard.";cErr.hidden=false}announce(lost?LOST_ACCESS:"Couldn't post the comment")},pics);
    };

    // The pill on the page. It opens where the frame said (a click, a selection,
    // the hover pill's Comment), keeps a draft safe from a second click (a shake
    // says so), follows its spot as the page scrolls, and on a phone docks above
    // the keyboard with the drawer slid away.
    function openCompose(d){
      if(compose&&(cmpText.value.trim()||trayKeys(cmpText).length||(cmpText._tray&&cmpText._tray.busy()))){cmpEl.classList.remove("shake");void cmpEl.offsetWidth;cmpEl.classList.add("shake");return}
      var byVoice=d.via==="voice"&&!!voice;
      if(!sidebarOpen&&!corner.on&&!byVoice)toggleSidebar(true);
      if(!d.anchorId&&!d.quote){cancelCompose();if(!byVoice){if(!sidebarOpen)toggleSidebar(true);composeText.focus()}return}
      d.corner=!sidebarOpen;
      if(bub&&bub.annotate)hideBub();
      compose=d;focusId=null;
      document.querySelectorAll("#sbList .thread.focus").forEach(function(t){t.classList.remove("focus")});
      cmpGone.hidden=true;
      // No block, only words: the comment can go only on the page as a whole, and says so before Send.
      cmpPage.hidden=!!d.anchorId;
      showCmpOn();
      setAsk(null);cmpText.value=d.seed||"";window.ssAutoGrow(cmpText);cmpSend.disabled=!canSend(cmpText);
      cmpEl.hidden=false;cmpEl.classList.remove("shake");
      if(PHONE_MQ.matches)setAway(true,false);
      placeCompose();updateCmpHint();
      if(byVoice){cmpSend.disabled=true;voice.compose=d}
      else setTimeout(function(){cmpText.focus();var L=cmpText.value.length;try{cmpText.setSelectionRange(L,L)}catch(x){}placeCompose()},PHONE_MQ.matches?60:0);
      if(d.anchorId)composingOn({anchor:d.anchorId,x:d.x,y:d.y,part:d.part});
      sendMarkers();
    }
    // "On the cell “$42k” · Change": what the comment being written goes on, always
    // said, and the menu that moves it wider: the part or the words, the whole block,
    // the whole page. The frame redraws its pin and marks (ss-compose-scope); the whole
    // page is the rail's own composer, which takes the words typed so far.
    var cmpOn=document.getElementById("cmpOn"),cmpOnWhat=document.getElementById("cmpOnWhat"),cmpWide=document.getElementById("cmpWide"),cmpScope=document.getElementById("cmpScope");
    function cmpScopes(d){
      var o=d.orig||d,out=[],blk=d.anchorId&&d.anchorId!=="ss-doc"?kindOf({tag:d.tag}).toLowerCase():"";
      if(d.thing)out.push({k:"thing",label:d.thing.label?"“"+shortQ(d.thing.label,40)+"”":"this part",menu:"Just "+(d.thing.label?"“"+shortQ(d.thing.label,24)+"”":"this part")});
      else if(o.quote)out.push({k:"quote",label:"the words “"+shortQ(o.quote,36)+"”",menu:"Just these words"});
      else if(o.part){var pk=kindOf({part:o.part}).toLowerCase();out.push({k:"part",label:"the "+pk+(o.part.text?" “"+shortQ(o.part.text,28)+"”":""),menu:"Just the "+pk})}
      if(blk&&!d.thing)out.push({k:"block",label:"the "+blk,menu:"The whole "+blk});
      out.push({k:"page",label:"the whole page",menu:"The whole page"});
      return out;
    }
    function cmpScopeNow(d){return d.thing?"thing":d.quote?"quote":d.part?"part":d.anchorId?"block":"page"}
    function showCmpOn(){
      var d=compose;cmpScope.hidden=true;cmpWide.setAttribute("aria-expanded","false");
      if(!d){cmpOn.hidden=true;return}
      var sc=cmpScopes(d),now=cmpScopeNow(d),cur=sc.filter(function(x){return x.k===now})[0]||sc[0];
      cmpOnWhat.textContent=cur.label;cmpOnWhat.title=d.quote||"";
      cmpQ.hidden=true;cmpWide.hidden=sc.length<2;cmpOn.hidden=false;
    }
    cmpWide.addEventListener("click",function(){
      if(!compose)return;
      if(!cmpScope.hidden){cmpScope.hidden=true;cmpWide.setAttribute("aria-expanded","false");return}
      var now=cmpScopeNow(compose);
      cmpScope.innerHTML=cmpScopes(compose).map(function(x){return '<button type="button" role="menuitemradio" aria-checked="'+(x.k===now)+'" data-k="'+x.k+'">'+esc(x.menu)+'</button>'}).join("");
      cmpScope.hidden=false;cmpWide.setAttribute("aria-expanded","true");
      var first=cmpScope.querySelector('[aria-checked="true"]')||cmpScope.firstChild;if(first)first.focus();
    });
    cmpScope.addEventListener("keydown",function(e){
      if(e.key==="Escape"){e.preventDefault();e.stopPropagation();cmpScope.hidden=true;cmpWide.setAttribute("aria-expanded","false");cmpWide.focus();return}
      if(e.key!=="ArrowDown"&&e.key!=="ArrowUp")return;
      e.preventDefault();var bs=[].slice.call(cmpScope.querySelectorAll("button")),i=bs.indexOf(document.activeElement);
      var n=bs[(i+(e.key==="ArrowDown"?1:bs.length-1))%bs.length];if(n)n.focus();
    });
    cmpScope.addEventListener("click",function(e){
      var b=e.target.closest&&e.target.closest("button[data-k]");if(!b||!compose)return;
      setCmpScope(b.getAttribute("data-k"));
    });
    function setCmpScope(k){
      var d=compose;if(!d)return;
      if(k==="page"){
        // The rail's foot is the comment on the whole page: the words go there.
        var t=cmpText.value;cancelCompose();
        if(!sidebarOpen)toggleSidebar(true);
        if(t&&!composeText.value.trim())composeText.value=t;
        window.ssAutoGrow(composeText);composeText.focus();
        if(window.mixpanel)mixpanel.track("Comment Scope Changed",{space_id:spaceId,to:"page"});
        return;
      }
      if(!d.orig)d.orig={part:d.part,quote:d.quote};
      d.part=k==="part"?d.orig.part:null;d.quote=k==="quote"?d.orig.quote:null;
      showCmpOn();placeCompose();
      var f=document.getElementById("content");
      if(f&&f.contentWindow){
        // ss-compose-widen for a frame from before ss-compose-scope: it drops only the part.
        if(!d.part)f.contentWindow.postMessage({type:"ss-compose-widen"},co);
        f.contentWindow.postMessage({type:"ss-compose-scope",part:!!d.part,quote:!!d.quote},co);
      }
      if(d.anchorId)composingOn({anchor:d.anchorId,x:d.x,y:d.y,part:d.part});
      if(window.mixpanel)mixpanel.track("Comment Scope Changed",{space_id:spaceId,to:k});
      cmpText.focus();
    }
    function placeCompose(){
      if(!compose||cmpEl.hidden)return;
      if(PHONE_MQ.matches){
        // Docked above the keyboard: the visual viewport is what the keyboard leaves.
        var vv=window.visualViewport,bottom=8;
        if(vv)bottom=Math.max(8,window.innerHeight-(vv.height+vv.offsetTop)+8);
        // A long draft still needs room for the document when the keyboard opens.
        cmpText.style.maxHeight=Math.max(38,Math.floor((vv?vv.height:window.innerHeight)*.35))+"px";
        cmpText.style.overflowY="auto";
        cmpEl.style.maxWidth="";
        cmpEl.style.left="";cmpEl.style.top="";cmpEl.style.bottom=bottom+"px";
        // Leave the document a scrollable viewport above the composer/keyboard.
        // Otherwise its final lines can never be brought out from under the pill.
        document.getElementById("content").style.setProperty("--cmp-space",(bottom+cmpEl.offsetHeight+8)+"px");
        return;
      }
      var f=document.getElementById("content"),row=f&&f.parentNode;if(!f||!row)return;
      f.style.removeProperty("--cmp-space");
      cmpText.style.maxHeight="";
      var fr=f.getBoundingClientRect(),rr=row.getBoundingClientRect();
      cmpEl.style.maxWidth=Math.max(0,fr.width-16)+"px";
      var w=cmpEl.offsetWidth||400,h=cmpEl.offsetHeight||120;
      var px=compose.px,py=compose.py,rect=compose.rect||{top:py,height:0};
      // Below the spot — or below the block when the spot is near its foot, so the
      // pill never covers the words it is about; above it when there is no room.
      var top=(rect.top+rect.height-py<90)?rect.top+rect.height+14:py+14;
      if(top+h>fr.height-8)top=Math.max(8,py-h-16);
      top=Math.max(8,Math.min(top,fr.height-h-8));
      var left=Math.max(8,Math.min(px-18,fr.width-w-8));
      cmpEl.style.bottom="";cmpEl.style.left=(fr.left-rr.left+left)+"px";cmpEl.style.top=(fr.top-rr.top+top)+"px";
    }
    // Typing, quotes, and the agent hint all change the pill's height after it
    // opened. Reposition after layout so its send/close controls remain reachable.
    new ResizeObserver(placeCompose).observe(cmpEl);
    if(window.visualViewport){window.visualViewport.addEventListener("resize",placeCompose);window.visualViewport.addEventListener("scroll",placeCompose)}
    window.addEventListener("resize",placeCompose);
    // Ask Shepherd: the button does what typing @shepherd does. Typing the handle
    // presses it ("typed"); pressed by hand ("button") it stays on until pressed again,
    // which also takes the handle back out. The post carries the handle either way, so
    // the route starts the same turn (startCommentTurnLater) — nothing new server-side.
    var cmpAsk=document.getElementById("cmpAsk"),cmpAskNew=document.getElementById("cmpAskNew"),cmpChips=document.getElementById("cmpChips");
    var askBy=null,ASK_SEEN="ss-ask-seen";
    var HANDLE_RE=/(^|[^a-zA-Z0-9_.@\/-])@(?:shepherd|spacesheep|co-shepherd)(?![a-zA-Z0-9-])[ \t]?/ig;
    function stripHandle(t){return String(t||"").replace(HANDLE_RE,"$1")}
    try{cmpAskNew.hidden=!!localStorage.getItem(ASK_SEEN)}catch(x){}
    if(!CAN_EDIT)cmpAsk.title="Ask "+AGENT_NAME+" about this spot";
    // Suggestions shaped by what the pin sits on. Readers can't change the page, so theirs are questions.
    function askSuggestions(){
      var d=compose,k=!d?"Block":kindOf(d.quote?{quote:1}:d.thing?{thing:1}:d.part?{part:d.part}:{tag:d.tag});
      var nums=k==="Chart"||k==="Table"||k==="Cell";
      if(!CAN_EDIT)return["Explain this",nums?"Where do these numbers come from?":"Summarize this"];
      if(k==="Title"||k==="Heading")return["Make it punchier","Shorter"];
      if(k==="Paragraph"||k==="Quote"||k==="Caption"||k==="Definition")return["Make it shorter","Turn it into a list","Friendlier tone"];
      if(k==="List"||k==="List item")return["Number the steps","Make it shorter"];
      if(k==="Chart")return["Make it easier to read","Label the values"];
      if(k==="Table"||k==="Cell")return["Sort it","Make it easier to read"];
      return["Make it clearer","Shorter"];
    }
    function setAsk(by){
      var was=!!askBy;askBy=by;var on=!!by;
      cmpAsk.setAttribute("aria-pressed",on?"true":"false");cmpEl.classList.toggle("ask-on",on);
      cmpText.placeholder=on?(CAN_EDIT?"What should change here?":"What do you want to know about this?"):ssT("cmt.spot_placeholder","Comment… (@ to mention)");
      if(on===was&&!(on&&cmpChips.hidden))return;
      cmpChips.innerHTML="";cmpChips.hidden=!on;
      if(on)askSuggestions().forEach(function(t){
        var b=document.createElement("button");b.type="button";b.className="cmp-chip";b.textContent=t;
        b.onclick=function(){cmpText.value=t;askBy="button";window.ssAutoGrow(cmpText);cmpText.dispatchEvent(new Event("input"));cmpText.focus()};
        cmpChips.appendChild(b);
      });
    }
    cmpAsk.addEventListener("mousedown",function(e){e.preventDefault()});
    cmpAsk.addEventListener("click",function(){
      if(askBy){cmpText.value=stripHandle(cmpText.value).replace(/^\s+/,"");window.ssAutoGrow(cmpText);setAsk(null)}
      else{setAsk("button");cmpAskNew.hidden=true;try{localStorage.setItem(ASK_SEEN,"1")}catch(x){}}
      updateCmpHint();placeCompose();cmpText.focus();
    });
    // An ask needs words besides the handle (or an image) before it can go.
    function cmpCanSend(){return canSend(cmpText)&&(!askBy||!!(stripHandle(cmpText.value).trim()||trayKeys(cmpText).length))}
    function updateCmpHint(){
      var typed=asksAgent(cmpText.value);
      if(typed&&!askBy)setAsk("typed");else if(!typed&&askBy==="typed")setAsk(null);
      var agent=!!askBy;
      cmpAgent.hidden=!agent;cmpHint.hidden=agent;
      // Short: it shares the row with the button, which already says who is asked.
      cmpAgent.innerHTML=agent?(CAN_EDIT?'Changes this spot':'Answers here <span>· you can’t edit</span>'):"";
      cmpSend.disabled=!cmpCanSend();
      cmpSend.setAttribute("aria-label",agent?"Send to Shepherd":"Post");
    }
    cmpText.addEventListener("input",function(){updateCmpHint();placeCompose();if(compose&&compose.anchorId&&cmpText.value.trim())composingOn({anchor:compose.anchorId,x:compose.x,y:compose.y,part:compose.part,text:cmpText.value},true)});
    (function(){
      var tray=makeTray();cmpEl.insertBefore(tray.el,cmpEl.querySelector(".compose-row"));
      tray.onChange=function(){updateCmpHint();placeCompose()};
      wireTray(cmpText,cmpEl,tray);
    })();
    cmpText.addEventListener("change",updateCmpHint);
    function cancelCompose(){
      if(!compose)return;
      if(cmpVoice)cmpVoice.cancel(false);
      composingOff();
      document.getElementById("content").style.removeProperty("--cmp-space");
      compose=null;cmpEl.hidden=true;cmpText.value="";trayClear(cmpText);setAsk(null);cmpQ.hidden=true;cmpGone.hidden=true;cmpPage.hidden=true;
      var f=document.getElementById("content");if(f&&f.contentWindow)f.contentWindow.postMessage({type:"ss-compose-end"},co);
      if(PHONE_MQ.matches)setAway(false);
    }
    cmpSend.onclick=function(){
      if(!cmpCanSend()||!compose)return;
      var body=cmpText.value.trim(),ask=askBy;
      if(ask&&!asksAgent(body))body="@"+AGENT_HANDLE+" "+body;
      var d=compose,payload=composePayload(d,body),imgs=trayKeys(cmpText),pics=trayPics(cmpText);if(imgs.length)payload.images=imgs;
      var via=d.gone?"page":(d.quote?(d.via==="select-typed"?"quote-typed":"quote"):d.thing?"thing":(d.via==="hover-pill"?"pin-hover":"pin"));
      if(d.corner)via="corner-"+via;
      postComment(payload,via,function(c){
        cancelCompose();
        // From the corner button: the rail stays shut, the pin stays on the page, and
        // the next tap on the page is the next comment.
        if(d.corner&&!sidebarOpen){cornerPosted(c,false);return}
        // One tap, one pin: on a phone the drawer comes back with the comment in it
        // and Annotate rests until it is asked for again.
        if(PHONE_MQ.matches)setAnnotate(false,false);
        focusThread(c.id,true);
      },function(lost){toast(lost?LOST_ACCESS:"Couldn’t post that — it’s on the rail: Try again or Discard")},pics,ask);
    };
    // Escape closes the composer and hands the page its keys back, so the next Escape
    // (relayed by the frame) leaves Pin comments. Not while an input method composes:
    // its Escape drops the word being composed, not the comment.
    cmpText.addEventListener("keydown",function(e){if(e.key==="Escape"&&!e.isComposing&&e.keyCode!==229&&!cmpMentions.open()){e.preventDefault();e.stopPropagation();cmpText.blur();cancelCompose();focusFrame()}});
    document.getElementById("cmpX").onclick=cancelCompose;
    document.getElementById("cmpAt").addEventListener("mousedown",function(e){e.preventDefault();cmpMentions.insertAt()});

    // Annotate: the switch, the key, the frame's flag. On a phone, on means the
    // drawer steps aside so the page can be tapped; a tab on the edge brings it back.
    var annotSw=document.getElementById("annotSw"),sbTab=document.getElementById("sbTab"),sbScrim=document.getElementById("sbScrim");
    // Edit opening turns Annotate off, the rail's and the corner's; the rail stays.
    window.ssAnnotateOff=function(){if(corner.on)setCorner(false);if(annotate)setAnnotate(false,false)};
    function setAnnotate(on,remember){
      on=!!on&&sidebarOpen;
      annotate=on;
      if(annotSw){annotSw.setAttribute("aria-checked",on?"true":"false");annotSw.title=on?"Pin comments is on: click the page to pin a comment to a spot. Turn off to read and follow links. (C)":"Turn on, then click the page to pin a comment to a spot. (C)"}
      if(!on&&compose&&!cmpText.value.trim())cancelCompose();
      if(PHONE_MQ.matches)setAway(on&&!!sidebarOpen,false);
      sendCommentMode();
    }
    function setAway(on,keepAnnotate){
      on=!!on&&PHONE_MQ.matches&&sidebarOpen;
      if(away===on)return;away=on;
      var sb=document.getElementById("sidebar");
      sb.classList.toggle("away",on);
      if(sbTab){sbTab.hidden=!on;var n=document.getElementById("sbTabN");if(n)n.textContent=String(comments.filter(function(c){return!c.parent_id&&!c.resolved_at}).length||"")}
      if(sbScrim)sbScrim.hidden=on||!sidebarOpen;
      if(!on&&!keepAnnotate&&annotate&&!compose)setAnnotate(false,false);
    }
    if(annotSw)annotSw.addEventListener("click",function(){setAnnotate(!annotate,true)});
    if(sbTab)sbTab.addEventListener("click",function(){if(compose&&cmpText.value.trim()){cmpEl.classList.add("shake");return}cancelCompose();setAway(false,false)});
    if(sbScrim)sbScrim.addEventListener("click",function(){toggleSidebar(false)});
    // C: open Comments, then toggle Annotate. Escape: the composer, then
    // Annotate, then the held card, then the rail.
    function hotkey(key){
      // "/" pressed in the page: the header search's own listener opens it, as if
      // it had been typed here. A page without the search ignores it.
      if(key==="/"){try{document.dispatchEvent(new KeyboardEvent("keydown",{key:"/",bubbles:true,cancelable:true}))}catch(x){}return}
      // ⌘K / Ctrl+K pressed in the page: the header search's own listener takes it, as
      // if pressed here (a key the shell saw is also what lets its box take focus). Like
      // ⌥S, only right after the reader really pressed something: the page can post this.
      if(key==="search"){var sa=navigator.userActivation;if(sa&&!sa.isActive)return;var mk=/Mac|iPhone|iPad/.test(navigator.platform||navigator.userAgent||"");try{document.dispatchEvent(new KeyboardEvent("keydown",{key:"k",code:"KeyK",metaKey:mk,ctrlKey:!mk,bubbles:true,cancelable:true}))}catch(x){}return}
      // ⌥S pressed in the page: Speak's own listener takes it, as if pressed here.
      // The page is its author's script and can post ss-hotkey by itself, so this
      // opens the mic only right after the reader really pressed something: a key or
      // click in the frame activates this window too (user activation reaches every
      // ancestor), a bare postMessage never does.
      if(key==="speak"){var ua=navigator.userActivation;if(ua&&!ua.isActive)return;try{document.dispatchEvent(new KeyboardEvent("keydown",{key:"s",code:"KeyS",altKey:true,bubbles:true,cancelable:true}))}catch(x){}return}
      if(key==="c"){if(placeholder)return;if(cf)cornerTap();else if(!sidebarOpen)toggleSidebar(true);else setAnnotate(!annotate,true);return}
      if(key==="Escape"){
        if(pinPeekOpen())pinPeekHide();
        else if(voice)voiceEnd(true);
        else if(compose){if(document.activeElement===cmpText)cmpText.blur();cancelCompose();focusFrame()}
        // Leaving Pin comments is Done on the pin bar: both switches, and on a phone the
        // drawer comes back.
        else if(corner.on||annotate){if(corner.on)setCorner(false);if(annotate)setAnnotate(false,true)}
        else if(focusId){focusId=null;renderComments()}
        else if(sidebarOpen&&PHONE_MQ.matches)toggleSidebar(false);
      }
    }
    function escFree(t){
      if(document.querySelector("dialog[open]"))return false;
      return !t||t===document.body||t===document.documentElement||t.id==="content"||!!(t.closest&&t.closest("#cfab,#pinBar"));
    }
    document.addEventListener("keydown",function(e){
      if(e.metaKey||e.ctrlKey||e.altKey)return;
      // An open picture takes the keys: Escape closes it and nothing else.
      if(document.body.classList.contains("ss-lb-open"))return;
      var t=e.target,inField=t&&(t.isContentEditable||/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName));
      if(inField)return;
      if(e.key==="c"||e.key==="C"){e.preventDefault();hotkey("c")}
      // Escape with nothing of the shell's in focus (the page's body after the composer
      // closed, the corner button just tapped, the pin bar): out of Pin comments, the
      // corner's or the rail's. Anything else in focus (a menu, a dialog, Shepherd's
      // drawer, the rail with its own handler) keeps its Escape.
      else if(e.key==="Escape"&&!e.defaultPrevented&&!e.isComposing&&(corner.on||annotate||voice||pinPeekOpen())&&escFree(t)){e.preventDefault();hotkey("Escape")}
    });

    // Shared emoji reaction picker (assets/components/emoji-picker.ts)
    function closeEmojiPicker(){var pk=document.querySelector(".emoji-picker");if(!pk)return;if(pk.__epDismiss)document.removeEventListener("click",pk.__epDismiss);pk.remove();}
    function openEmojiPicker(anchor,emojis,onPick){
      var existing=document.querySelector(".emoji-picker");
      if(existing){var wasFor=existing.__epAnchor;closeEmojiPicker();if(wasFor===anchor)return;}
      var pk=document.createElement("div");pk.className="emoji-picker";pk.__epAnchor=anchor;
      emojis.forEach(function(em){var b=document.createElement("button");b.type="button";b.textContent=em;b.addEventListener("click",function(ev){ev.stopPropagation();closeEmojiPicker();onPick(em);});pk.appendChild(b);});
      document.body.appendChild(pk);
      // Inside a panel that marks itself [data-ep-bounds] (the viewer's comment
      // drawer), the picker stays within that panel rather than the whole window.
      var box=anchor.closest("[data-ep-bounds]"),bx=box?box.getBoundingClientRect():null;
      var minL=bx?Math.max(8,bx.left+8):8,maxR=bx?Math.min(window.innerWidth,bx.right)-8:window.innerWidth-8;
      if(pk.offsetWidth>maxR-minL)pk.style.width=Math.max(160,maxR-minL)+"px";
      var r=anchor.getBoundingClientRect(),ph=pk.offsetHeight,pw=pk.offsetWidth;
      var top=r.top-ph-6;if(top<8)top=r.bottom+6;
      var left=Math.min(Math.max(minL,r.left+r.width/2-pw/2),Math.max(minL,maxR-pw));
      pk.style.top=top+"px";pk.style.left=left+"px";
      function dismiss(ev){if(pk.contains(ev.target)||anchor.contains(ev.target))return;closeEmojiPicker();}
      pk.__epDismiss=dismiss;
      setTimeout(function(){document.addEventListener("click",dismiss);},0);
    }
    // Shared reaction tooltip formatter (assets/components/reaction-names.ts)
    function ssTipEsc(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;")}
    function ssTipAttr(text,o){
      var t=String(text==null?"":text).trim();
      if(!t)return "";
      var e=ssTipEsc(t);
      return ' data-tip="'+e+'"'+((o&&o.at)==="below"?' data-tip-at="below"':"")+(o&&o.now?" data-tip-now":"")+
        ((o&&o.as)==="label"?' aria-label="':' aria-description="')+e+'"';
    }
    function ssSetTip(el,text,o){
      if(!el)return;
      var t=String(text==null?"":text).trim();
      var aria=(o&&o.as)==="label"?"aria-label":"aria-description";
      if(t){
        el.setAttribute("data-tip",t);
        el.setAttribute(aria,t);
        if((o&&o.at)==="below")el.setAttribute("data-tip-at","below");
        if(o&&o.now)el.setAttribute("data-tip-now","");
      } else {
        el.removeAttribute("data-tip");el.removeAttribute("data-tip-at");el.removeAttribute("data-tip-now");el.removeAttribute(aria);
      }
    }
    function rxTitle(names,count){
      var shown=(names||[]).slice(0,5);
      if(!shown.length)return "";
      var rest=Math.max(0,(count||0)-shown.length);
      return shown.join(", ")+(rest>0?" and "+rest+" more":"");
    }
    function rxAttr(text){ return ssTipAttr(text); }
    function rxTipAttr(names,count){ return rxAttr(rxTitle(names,count)); }
    // My own label in a reaction tooltip — same ladder as reactorNameSql server-side.
    function myRxName(){return myUser?"@"+myUser:(myEmail||"").split("@")[0]}

    // Resolve and Reopen are one toggle on the server. Set the state it answered,
    // never flip it: the room's broadcast of the same change can land first, and a
    // flip on top of it undid a Reopen. The toast offers the way back.
    // Says which way: Resolve and Reopen each send what they mean. A bare toggle
    // reopened a thread when two people pressed Resolve at the same moment, or when
    // the card was a beat behind someone else's press.
    function setResolved(rid,want,offerUndo){
      fetch("/api/space/"+spaceId+"/comments/"+rid+"/resolve",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({resolved:want})}).then(function(r){return r.ok?r.json():null}).then(function(d){
        if(!d){toast("Couldn’t change it — try again");return}
        comments.forEach(function(c){if(c.id===rid){c.resolved_at=d.resolved_at||null;c.resolved_by=d.resolved_by||null}});renderComments();
        if(offerUndo)toast(d.resolved_at?(hideResolved&&!revealResolved?"Resolved and hidden":"Resolved"):"Reopened",{label:"Undo",fn:function(){setResolved(rid,!want,false)}});
      }).catch(function(){toast("Couldn’t reach the server — try again")});
    }

    // Sidebar event delegation
    document.getElementById("sbList").addEventListener("click",function(e){
      var rt=e.target.closest("#resolvedToggle");
      if(rt){resolvedOpen=!resolvedOpen;renderComments();var nrt=document.getElementById("resolvedToggle");nrt.focus({preventScroll:true});
        // Opening the section brings what it opened into view; below the fold it
        // looked like the tap did nothing.
        var first=resolvedOpen&&document.querySelector("#resolvedList .thread");
        if(first)first.scrollIntoView({behavior:matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth",block:"nearest"});
        return}
      var tb=e.target.closest("[data-retry-tmp],[data-discard-tmp]");
      if(tb){var tbId=tb.dataset.retryTmp||tb.dataset.discardTmp,tc=comments.find(function(c){return c.id===tbId&&c._tmp}),ce=document.getElementById("composeErr");if(ce)ce.hidden=true;
        if(tc&&tb.dataset.retryTmp){var o2=tc._o||{};o2.retried=true;sendTmp(tc,o2);renderComments()}else if(tc)discardTmp(tbId);return}
      var go=e.target.closest("[data-go]");
      if(go){goToPin(go.dataset.go);return}
      var undo=e.target.closest("[data-undo]");
      if(undo){undoChange(undo.dataset.undo,undo);return}
      var retry=e.target.closest("[data-retry]");
      if(retry){retryAgent(retry.dataset.retry,retry);return}
      var upg=e.target.closest("[data-upgrade]");
      if(upg&&window.mixpanel)try{mixpanel.track("Upgrade Clicked",{feature:"comment_agent",plan:upg.getAttribute("data-upgrade"),space_id:spaceId})}catch(x){}
      var sgo=e.target.closest("[data-sess-go]");
      if(sgo){var ssp=sessPending[sgo.getAttribute("data-sess-go")];if(ssp)sessSend(ssp);return}
      var sset=e.target.closest("[data-sess-setup]");
      if(sset){if(window.ssTalk)window.ssTalk(sset.getAttribute("data-sess-setup")||null);return}
      var see=e.target.closest("[data-see]");
      if(see){var sc=comments.find(function(c){return c.id===see.dataset.see});if(sc&&sc.parent_id)goToPin(sc.parent_id)}
      var uf=e.target.closest("[data-unfold]");
      if(uf){var ub=uf.previousElementSibling;bodyOpen[uf.dataset.unfold]=true;if(ub)ub.classList.remove("clamp","is-cut");uf.remove();return}
      var btn=e.target.closest("[data-reply],[data-resolve],[data-unresolve],[data-delyes],[data-delno],[data-react],[data-expand],[data-more]");
      if(!btn){var rxn=e.target.closest(".rxn");if(rxn){toggleReaction(rxn.dataset.comment,rxn.dataset.emoji);return}
        // A click anywhere else on a card selects it: its quote takes the held
        // colour on the page and comes into view. Not a click on a control or a
        // link, and not the end of a drag that selected the card's words.
        var sth=e.target.closest(".thread[data-thread]");
        if(sth&&!sth.classList.contains("resolved")&&!e.target.closest("a,button,textarea,input,select,label,[contenteditable]")&&!String(window.getSelection()||"")){
          var sid=sth.dataset.thread,sc2=comments.find(function(c){return c.id===sid});
          if(sc2&&sc2.anchor_id&&focusId!==sid)selectThread(sid)}
        return}
      if(btn.dataset.expand){expanded[btn.dataset.expand]=true;renderComments();return}
      if(btn.dataset.more){openCmtMenu(btn,btn.dataset.more);return}
      if(btn.dataset.reply){openInlineReply(btn.dataset.reply,true);if(inlineReply)inlineReply.pointer=e.detail>0}
      if(btn.dataset.resolve){cmtAction("resolve",btn.dataset.resolve,btn,"toolbar");return}
      if(btn.dataset.unresolve)setResolved(btn.dataset.unresolve,false,true);
      if(btn.dataset.delno){var back=btn.dataset.delno;delAsk=null;renderComments();var db=document.querySelector('#sbList [data-more="'+back+'"]');if(db)db.focus();return}
      if(btn.dataset.delyes){var did=btn.dataset.delyes;delAsk=null;fetch("/api/space/"+spaceId+"/comments/"+did,{method:"DELETE"}).then(function(r){return r.ok?r.json():null}).then(function(d){if(!d)return;
        // The server says what went: this comment, and the placeholder above it when
        // this was its last reply. A comment with replies stays as a placeholder.
        var gone=Array.isArray(d.removed)?d.removed:[];
        if(d.soft)softDelete(did);
        comments=comments.filter(function(c){return gone.indexOf(c.id)<0});reactions=reactions.filter(function(r2){return gone.indexOf(r2.comment_id)<0});
        renderComments();toast(gone.length>1?"Deleted, with the empty thread":d.soft?"Deleted — replies kept":"Deleted")})}
      if(btn.dataset.react)cmtAction("react",btn.dataset.react,btn,"toolbar");
    });
    // Hovering a card lifts its pin on the page and outlines its block.
    document.getElementById("sbList").addEventListener("mouseover",function(e){var th=e.target.closest(".thread");if(th&&!th.classList.contains("resolved"))setHot(th.dataset.thread,true)});
    document.getElementById("sbList").addEventListener("mouseleave",function(){setHot(null,true)});
    // Undo the Co-shepherd's edit from its card: the version it made goes back to
    // the head it was built on (a restore, under the space's turn). The route
    // refuses if the page moved since; the card says so.
    function undoChange(id,btn){
      if(btn)btn.disabled=true;
      fetch("/api/space/"+spaceId+"/comments/"+encodeURIComponent(id)+"/undo",{method:"POST",headers:{"Content-Type":"application/json"},body:"{}"})
        .then(function(r){return r.json().then(function(d){return{ok:r.ok,d:d}})}).then(function(x){
          if(!x.ok){if(btn)btn.disabled=false;toast(x.d&&x.d.message?x.d.message:"Couldn’t undo that");return}
          comments.forEach(function(c){if(c.id===id)c.change_json=JSON.stringify(x.d.change)});
          renderComments();toast("Undone"+(x.d.number?" — v"+x.d.number+" puts the old words back":""));
        }).catch(function(){if(btn)btn.disabled=false;toast("Couldn’t undo that")});
    }
    // Ask again after a turn that couldn't start or didn't finish: the same turn,
    // from the comment's own words and place. The card goes back to working, or
    // says why it still can't.
    function retryAgent(cid,btn){
      if(btn)btn.disabled=true;
      var c=comments.find(function(x){return x.id===cid});if(!c)return;
      fetch("/api/space/"+spaceId+"/comments/"+encodeURIComponent(cid)+"/retry",{method:"POST",headers:{"Content-Type":"application/json"},body:"{}"})
        .then(function(r){return r.json().catch(function(){return{}}).then(function(d){return{ok:r.ok,d:d}})}).then(function(x){
          var a=x.d&&x.d.agent,root=c.parent_id||c.id;
          dropPending(cid);
          if(x.ok&&a&&a.status==="started"&&a.run_id){c.run_id=a.run_id;pending[a.run_id]={root:root,cid:cid,status:"running",label:workLabel(c)};announce("Asked the Shepherd again")}
          else pending["x"+cid]={never:true,root:root,cid:cid,status:"failed",message:(a&&a.message)||(x.d&&x.d.message)||"the Shepherd could not start",retry:a&&a.retry,fix:a&&a.fix,when:a&&a.when};
          renderComments();
          if(window.mixpanel)try{mixpanel.track("Comment Agent Retried",{space_id:spaceId,started:!!(a&&a.status==="started"),status:a&&a.status||"http"})}catch(e){}
        }).catch(function(){if(btn)btn.disabled=false;toast("Couldn’t reach the server — try again")});
    }
    // A reaction is identified by (comment, emoji, author) — the same triple the
    // server uses as its primary key — so these are set operations, not list edits.
    // Both writers below (this viewer's own POST and the live echo of it) apply the
    // SAME add/remove, and the DO broadcasts to every socket including the actor's.
    // Making both idempotent is what keeps the count right: applying an add twice is
    // the same as applying it once, and neither ordering can drift.
    // Compared field by field rather than via a joined key string: a separator would
    // have to survive this template literal, and an escape that does not is how the
    // viewer script got broken before.
    function lcEmail(e){return String(e||"").toLowerCase()}
    function rxSame(a,b){return a.comment_id===b.comment_id&&a.emoji===b.emoji&&lcEmail(a.author_email)===lcEmail(b.author_email)}
    function rxAdd(list,r){for(var i=0;i<list.length;i++)if(rxSame(list[i],r))return list;return list.concat([r])}
    function rxDel(list,r){return list.filter(function(x){return !rxSame(x,r)})}
    // Same idea for block reactions, keyed (anchor, emoji, author) like their table.
    function arSame(a,b){return a.anchor_id===b.anchor_id&&a.emoji===b.emoji&&lcEmail(a.author_email)===lcEmail(b.author_email)}
    function arAdd(list,r){for(var i=0;i<list.length;i++)if(arSame(list[i],r))return list;return list.concat([r])}
    function arDel(list,r){return list.filter(function(x){return !arSame(x,r)})}
    function toggleReaction(cid,emoji){fetch("/api/space/"+spaceId+"/comments/"+cid+"/reactions",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({emoji:emoji})}).then(function(r){return r.ok?r.json():null}).then(function(d){if(!d)return;
      // The server decided add-or-remove; apply THAT rather than toggling blind, so a
      // live echo that lands before this response can't invert the outcome.
      // The server names the author it wrote the row for; fall back to what we know.
      var rec={comment_id:cid,emoji:emoji,author_email:d.author_email||myEmail,author_name:d.author_name||myRxName()};
      reactions=d.action==="remove"?rxDel(reactions,rec):rxAdd(reactions,rec);renderComments()})}

    // Real-time comment events
    function handleCommentEvent(action,data){
      heardAt=Date.now();
      if(reading)heardWhileReading.push([heardAt,action,data]);
      if(action==="create"){if(!comments.find(function(c){return c.id===data.id})){data._t=Date.now();var own=tmpFor(data);if(own)settleTmp(own,data);else comments.push(data);
          // The Co-shepherd's reply to a thread that asked it: the wait is over.
          if(data.via==="co-shepherd"&&data.run_id)delete pending[data.run_id];
          if(data.via==="co-shepherd")for(var pk in pending)if(pending[pk].starting&&pending[pk].root===data.parent_id)delete pending[pk];
          // The session's answer to a thread that asked "@session": the same.
          if(data.via==="session"&&data.parent_id)delete sessPending[data.parent_id];
          var byAgent=data.via==="co-shepherd"||data.via==="session";
          if(lcEmail(data.author_email)!==myEmail||byAgent)arrive(data);
          if(own)renderSettled(own);else renderSoon();if(lcEmail(data.author_email)!==myEmail||byAgent)announce(commentAuthor(data).name+(data.parent_id?" replied":" commented")+": "+(cmtWords(data).slice(0,80)||(data.images&&data.images.length?"an image":"")))}}
      else if(action==="update"){comments.forEach(function(c){if(c.id===data.id){if(typeof data.body==="string")c.body=data.body;if(data.change_json!==undefined)c.change_json=data.change_json;c.updated_at=data.updated_at}});
        // Asked again (…/retry): the old ending is stale; the new run says how it's going.
        if(data.run_id){var rc=comments.find(function(c){return c.id===data.id});
          // The turn a just-posted ask started: it takes over the "working" row as is.
          var ph=pending["s"+data.id];
          if(ph){delete pending["s"+data.id];ph.starting=false;pending[data.run_id]=ph;if(rc)rc.run_id=data.run_id}
          else if(rc&&rc.run_id!==data.run_id){rc.run_id=data.run_id;dropPending(data.id);checkPending()}}
        // A turn that couldn't start: said on its author's card, as the post used to.
        if(data.agent&&data.agent.status&&data.agent.status!=="started"){var ac=comments.find(function(c){return c.id===data.id});if(ac&&lcEmail(ac.author_email)===myEmail)agentAck(ac,data.agent)}
        renderSoon()}
      else if(action==="delete"){if(data.soft)softDelete(data.id);else{comments=comments.filter(function(c){return c.id!==data.id});reactions=reactions.filter(function(r){return r.comment_id!==data.id})}renderSoon()}
      else if(action==="resolve"){comments.forEach(function(c){if(c.id===data.id){c.resolved_at=data.resolved_at;c.resolved_by=data.resolved_by}});renderSoon()}
      else if(action==="react"){var rec={comment_id:data.comment_id,emoji:data.emoji,author_email:data.author_email,author_name:data.author_name};reactions=data.action==="add"?rxAdd(reactions,rec):rxDel(reactions,rec);renderSoon()}
      else if(action==="anchor_react"){var ar={anchor_id:data.anchor_id,emoji:data.emoji,author_email:data.author_email,author_name:data.author_name};anchorReactions=data.action==="add"?arAdd(anchorReactions,ar):arDel(anchorReactions,ar);sendMarkers()}
    }

    // When the room last told this tab about a comment. The re-read below goes to the
    // nearest D1 replica, which can be behind the primary the room's news came from; a
    // tab that heard something in the last two minutes asks the primary (?fresh=1), or
    // switching back to the tab drops a comment it already shows until a reload.
    var heardAt=0;
    // What the room said while a re-read was on its way. The read's answer was taken
    // before some of it (and a reply can be a round trip to the far coast), so laid
    // down as it is, it would undo it: a comment someone deleted came back, an edit
    // went back to its old words, a thread resolved a moment ago opened again — until
    // a reload (2026-10-13, scripts/comment-swarm.mjs). Each event heard since the
    // read was asked is applied again on top of its answer, in the order it came;
    // every one of them sets a value, so one the answer already has changes nothing.
    var reading=0,heardWhileReading=[];
    function replayEvent(action,d){
      if(action==="create"){if(!comments.some(function(c){return c.id===d.id}))comments.push(d)}
      else if(action==="update")comments.forEach(function(c){if(c.id===d.id){if(typeof d.body==="string")c.body=d.body;if(d.change_json!==undefined)c.change_json=d.change_json;c.updated_at=d.updated_at;if(d.run_id)c.run_id=d.run_id}});
      else if(action==="delete"){if(d.soft)softDelete(d.id);else{comments=comments.filter(function(c){return c.id!==d.id});reactions=reactions.filter(function(r){return r.comment_id!==d.id})}}
      else if(action==="resolve")comments.forEach(function(c){if(c.id===d.id){c.resolved_at=d.resolved_at;c.resolved_by=d.resolved_by}});
      else if(action==="react"){var rec={comment_id:d.comment_id,emoji:d.emoji,author_email:d.author_email,author_name:d.author_name};reactions=d.action==="add"?rxAdd(reactions,rec):rxDel(reactions,rec)}
      else if(action==="anchor_react"){var ar={anchor_id:d.anchor_id,emoji:d.emoji,author_email:d.author_email,author_name:d.author_name};anchorReactions=d.action==="add"?arAdd(anchorReactions,ar):arDel(anchorReactions,ar)}
    }
    // Authoritative re-read of the rail. Comment events are delivered live, but a
    // socket that drops (sleep, tunnel, flaky wifi) misses whatever happened while it
    // was down — so every reconnect re-reads instead of trusting the in-memory copy.
    function loadComments(){
      // A comment that arrived while this read was in flight (a post answers in
      // milliseconds) isn't in it yet: it stays, rather than vanishing until a reload.
      var asked=Date.now();reading++;
      function done(){if(!--reading)heardWhileReading=[]}
      return fetch("/api/space/"+spaceId+"/comments"+(asked-heardAt<12e4?"?fresh=1":"")).then(function(r){return r.ok?r.json():null}).then(function(data){
        if(!data){done();return}
        var got=data.comments||[],have={};got.forEach(function(c){have[c.id]=1});
        // A card still on its way stays too — unless the read already has its row (its
        // answer was lost on the way back): then the row is the card.
        var late=comments.filter(function(c){if(have[c.id])return false;if(c._tmp)return!got.some(function(g){return lcEmail(g.author_email)===myEmail&&g.body===c.body&&(g.parent_id||null)===(c.parent_id||null)&&(g.anchor_id||null)===(c.anchor_id||null)&&Date.now()-new Date(g.created_at).getTime()<6e5});return c._t>=asked});
        comments=got.concat(late);reactions=data.reactions||[];anchorReactions=data.anchor_reactions||[];commentsRead=true;
        heardWhileReading.forEach(function(e){if(e[0]>=asked)replayEvent(e[1],e[2])});
        done();renderComments();
        checkPending();sessCheck();
      }).catch(function(e){done();try{console.error("[comments] load failed",e)}catch(x){}});
    }
    // Threads that asked the Co-shepherd and have no answer yet: the asking row
    // carries the run; the run row says whether it is still going or how it ended.
    function checkPending(){
      var answered={};comments.forEach(function(c){if(c.via==="co-shepherd"&&c.run_id)answered[c.run_id]=1});
      comments.forEach(function(c){
        if(!c.run_id||c.via==="co-shepherd"||c.via==="session"||answered[c.run_id]||pending[c.run_id])return;
        var root=c.parent_id||c.id;
        fetch("/api/space/"+spaceId+"/ai/runs/"+encodeURIComponent(c.run_id)).then(function(r){return r.ok?r.json():null}).then(function(d){
          var run=d&&d.run;if(!run)return;
          if(run.status==="running")pending[c.run_id]={root:root,cid:c.id,status:"running",label:workLabel(c)};
          else if(run.status==="failed"||run.status==="cancelled")pending[c.run_id]={root:root,cid:c.id,status:"failed",message:run.error||(run.status==="cancelled"?"stopped":"")};
          else return;
          renderComments();
        }).catch(function(){});
      });
    }
    // The turn's own events, over the room: an ending without a reply row is
    // told on the card; a reply row (comment create) clears the wait itself.
    // The protocol job streams its change to the room, not as an op event. A space
    // takes one editing turn at a time, so a Co-shepherd change arriving while a
    // comment's turn runs is that turn's.
    window.addEventListener("ss:live-in",function(e){
      if(!CAN_EDIT||!e.detail||e.detail.by!=="viewer")return;
      var any=false;for(var k in pending)if(workSaw(pending[k],"change"))any=true;
      if(any)renderComments();
    });
    window.addEventListener("ss:chat",function(e){
      var d=e.detail||{};if(!d.run_id||!pending[d.run_id])return;
      if(d.type==="delta"){if(d.text&&workSaw(pending[d.run_id],"reply"))renderComments()}
      else if(d.type==="op"){if(workSaw(pending[d.run_id],"change"))renderComments()}
      else if(d.type==="error"){pending[d.run_id].status="failed";pending[d.run_id].message=d.message||"";renderComments()}
      else if(d.type==="done"){var rid=d.run_id;setTimeout(function(){if(pending[rid]&&pending[rid].status==="running"){delete pending[rid];renderComments()}},6000)}
    });

    // Viewing the space is independent of whether the Co-shepherd panel is open.
    // Refresh while visible and explicitly stand down on hide/navigation.
    var pageAway=false;
    function sendViewing(){try{if(ws&&ws.readyState===1)ws.send(JSON.stringify({t:"viewing",on:!pageAway&&document.visibilityState==="visible"}))}catch(e){}}
    document.addEventListener("visibilitychange",sendViewing);
    window.addEventListener("pagehide",function(){pageAway=true;sendViewing()});
    window.addEventListener("pageshow",function(){pageAway=false;sendViewing()});
    // Preserve the legacy panel-specific watch report for older room callers.
    var watching=false;
    function sendWatch(){try{if(ws&&ws.readyState===1)ws.send(JSON.stringify({t:"watch",on:watching}))}catch(e){}}
    // When this tab comes to the front, the room hears it: a remote click (the
    // Telegram doc lane's "start round") lands in the tab looked at last.
    function sendSeen(){try{if(ws&&ws.readyState===1&&document.visibilityState==="visible")ws.send('{"t":"seen"}')}catch(e){}}
    window.addEventListener("focus",sendSeen);
    document.addEventListener("visibilitychange",sendSeen);
    window.__ssWatch=function(on){on=!!on;if(on===watching)return;watching=on;sendWatch()};

    // A save this tab made and already applied: the Co-shepherd's nonce, or one of
    // the document tools' (__ssOwnNonces).
    function ownEcho(n){return!!n&&(n===window.__ssAiNonce||(window.__ssOwnNonces||[]).indexOf(n)!==-1)}
    // WebSocket
    function connect(){
      var proto=location.protocol==="https:"?"wss:":"ws:";
      ws=new WebSocket(proto+"//"+location.host+"/space/"+spaceId+"/ws");
      ws.onopen=function(){var missed=wsDropped;reconnectDelay=1e3;wsDropped=false;sendViewing();sendWatch();sendSeen();if(missed){loadComments();window.dispatchEvent(new CustomEvent("ss:chat",{detail:{reconnected:true}}))}};
      ws.onmessage=function(e){
        var msg=JSON.parse(e.data);
        if(msg.type==="viewers"){viewers={};msg.viewers.forEach(function(v){viewers[v.seed]=v});renderPresence();workReconnect();window.dispatchEvent(new CustomEvent("ss:turn",{detail:{holder:msg.turn||null}}))}
        else if(msg.type==="turn"){window.dispatchEvent(new CustomEvent("ss:turn",{detail:{holder:msg.holder||null}}))}
        else if(msg.type==="sign"){window.dispatchEvent(new CustomEvent("ss:sign",{detail:msg}))}
        else if(msg.type==="chat"&&msg.data){window.dispatchEvent(new CustomEvent("ss:chat",{detail:msg.data}))}
        else if(msg.type==="join"){viewers[msg.user.seed]=msg.user;renderPresence()}
        else if(msg.type==="leave"){delete viewers[msg.seed];renderPresence();if(drafts[msg.seed]){delete drafts[msg.seed];draftsChanged()}var pcGone=false;for(var pk in peers)if(pk.indexOf(msg.seed+":")===0){delete peers[pk];pcGone=true}if(pcGone)pcQueue();if(UL){delete ulViews[msg.seed];if(ulLead===msg.seed)ulStop("left")}}
        else if(msg.type==="tabs"){pcTabs=+msg.n||0;if(msg.gone&&msg.gone.seed){var gk=msg.gone.seed+":"+msg.gone.tab;if(peers[gk]){delete peers[gk];pcQueue()}}renderPresence()}
        else if(msg.type==="composing"){onComposing(msg)}
        else if(msg.type==="cursor"||msg.type==="select"||msg.type==="say"||msg.type==="view"){onPeer(msg)}
        else if(msg.type==="ownership"){if(!document.getElementById("spaceOwnershipChanged")){var ssNotice=(function(){
  var CSS="#ssNotices{position:fixed;left:max(20px,env(safe-area-inset-left,0px));bottom:calc(20px + env(safe-area-inset-bottom,0px));z-index:2147483001;display:flex;flex-direction:column-reverse;align-items:flex-start;gap:8px;max-width:calc(100vw - 40px);pointer-events:none}\n.ss-notice{pointer-events:auto;display:flex;align-items:center;gap:6px;max-width:100%;box-sizing:border-box;min-height:30px;padding:2px 3px 2px 8px;border:1px solid var(--ss-border);border-radius:7px;background:var(--ss-surface);background:color-mix(in srgb,var(--ss-bg) 92%,var(--ss-text));color:var(--ss-text-muted);font:400 11px/1.4 var(--ss-font-sans);box-shadow:var(--ss-elev-1)}\n.ss-notice-i{display:flex;flex:none;width:11px;height:11px;color:var(--ss-text-subtle)}\n.ss-notice-t{min-width:0;color:inherit;text-decoration:none;font-variant-numeric:tabular-nums}\na.ss-notice-t:hover{color:var(--ss-text)}\n.ss-notice button{box-sizing:border-box;font-family:inherit;line-height:inherit;cursor:pointer}\n.ss-notice-a{flex:none;min-height:24px;border:0;padding:4px 2px;background:none;color:var(--ss-text-muted);font-size:10.5px;font-weight:600;text-decoration:underline;text-decoration-color:var(--ss-border-strong);text-underline-offset:3px}\n.ss-notice-a:hover{text-decoration-color:currentColor;color:var(--ss-text)}\n.ss-notice-x{flex:none;display:grid;place-items:center;width:24px;height:24px;padding:0;border:0;border-radius:5px;background:none;color:var(--ss-text-subtle);font-size:15px;font-weight:400}\n.ss-notice-x:hover{background:var(--ss-surface-muted);color:var(--ss-text)}\n.ss-notice a:focus-visible,.ss-notice button:focus-visible{outline:2px solid var(--ss-focus);outline-offset:3px}\n.ss-notice-warning{background:var(--ss-warn-tint);border-color:var(--ss-warn-tint-border);color:var(--ss-text)}\n.ss-notice-warning .ss-notice-i{color:var(--ss-warn)}\n.ss-notice-error{background:var(--ss-danger-tint);border-color:var(--ss-danger-tint-border);color:var(--ss-text)}\n.ss-notice-error .ss-notice-i{color:var(--ss-danger)}\n.ss-notice-warning .ss-notice-a,.ss-notice-error .ss-notice-a{color:var(--ss-text);text-decoration-color:currentColor}\n.ss-notice-warning .ss-notice-x,.ss-notice-error .ss-notice-x{color:var(--ss-text-muted)}\n.ss-notice-warning .ss-notice-x:hover,.ss-notice-error .ss-notice-x:hover{background:color-mix(in srgb,currentColor 10%,transparent)}\n@media(max-width:640px){#ssNotices{left:max(16px,env(safe-area-inset-left,0px));bottom:calc(16px + env(safe-area-inset-bottom,0px));max-width:calc(100vw - 32px)}}\n@media print{#ssNotices{display:none}}",ICONS={};
  function stack(){
    if(!document.getElementById("ssNoticeCss")){var st=document.createElement("style");st.id="ssNoticeCss";st.textContent=CSS;document.head.appendChild(st)}
    var s=document.getElementById("ssNotices");
    if(!s){s=document.createElement("div");s.id="ssNotices";(document.body||document.documentElement).appendChild(s)}
    return s;
  }
  return function(o){
    var tone=o.tone==="warning"||o.tone==="error"?o.tone:"";
    var el=document.createElement("div");el.className="ss-notice"+(tone?" ss-notice-"+tone:"");if(o.id)el.id=o.id;el.setAttribute("role",o.role||(tone==="error"?"alert":"status"));
    if(o.icon&&ICONS[o.icon]){var i=document.createElement("span");i.className="ss-notice-i";i.setAttribute("aria-hidden","true");i.innerHTML=ICONS[o.icon];el.appendChild(i)}
    var t=document.createElement("span");t.className="ss-notice-t";t.textContent=o.text;el.appendChild(t);
    if(o.action){var a=document.createElement("button");a.type="button";a.className="ss-notice-a";a.textContent=o.action;a.addEventListener("click",function(){o.onAction&&o.onAction()});el.appendChild(a)}
    var x=document.createElement("button");x.type="button";x.className="ss-notice-x";x.setAttribute("aria-label",o.dismissLabel||"Dismiss");x.textContent="\u00d7";
    x.addEventListener("click",function(){if(o.onDismiss)o.onDismiss();el.remove()});el.appendChild(x);
    stack().appendChild(el);
    return el;
  };
})();ssNotice({id:"spaceOwnershipChanged",text:"Ownership changed. Refresh to update controls.",action:"Refresh",onAction:function(){location.reload()}})}}
        else if(msg.type==="deploy"){ssLivePill(false);workDone();if(!ownEcho(msg.nonce)){liveIn();bumpFrame(msg.sha);if(window.ssTabSignal)ssTabSignal("update")}else setShown(msg.sha)}
        else if(msg.type==="renamed"){if(typeof msg.title==="string"){msg.title=spaceTitle(msg.title);var rt=document.getElementById("spaceTitle");if(rt)rt.textContent=msg.title;document.title=msg.title+" — spacesheep"}if(typeof msg.url==="string"&&msg.url.charAt(0)==="/"&&location.pathname.indexOf("/-/")<0){try{history.replaceState(history.state,"",msg.url+location.search+location.hash)}catch(e){}}window.dispatchEvent(new CustomEvent("ss:renamed",{detail:{title:msg.title,url:msg.url}}))}
        else if(msg.type==="patch"){if(msg.sha){ssLivePill(false);workDone()}var own=ownEcho(msg.nonce),pe=own?notDrawn(msg.edits||[]):(msg.edits||[]);if(!own||pe.length){liveIn();window.ssPatchDoc(pe,msg.sha)}if(msg.sha){setShown(msg.sha);if(!own&&window.ssTabSignal)ssTabSignal("update")}}
        else if(msg.type==="live"||msg.type==="key"||msg.type==="click"){ssLive(msg)}
        else if(msg.type==="emit"){window.dispatchEvent(new CustomEvent("ss:emit",{detail:msg.event}))}
        else if(msg.type==="comment"){handleCommentEvent(msg.action,msg.data)}
        else if(msg.type==="discussion"){window.dispatchEvent(new CustomEvent("ss:discussion",{detail:{at:msg.at}}))}
        else if(msg.type==="copy"){window.dispatchEvent(new CustomEvent("ss:copy",{detail:{allowed:!!msg.allowed,revision:msg.revision}}))}
      };
      ws.onclose=function(){wsDropped=true;clearInterval(pingInterval);setTimeout(function(){reconnectDelay=Math.min(reconnectDelay*2,3e4);connect()},(reconnectDelay+Math.random()*Math.max(reconnectDelay,4000)))};
      pingInterval=setInterval(function(){if(ws.readyState===1){ws.send("ping");sendViewing()}},3e4);
    }

    // Share
    var isOwner=V.owner;
    var shareDd=document.getElementById("accessDd"),shareBtnEl=document.getElementById("accessBtn");
    var shareListEl=document.getElementById("shareList");
    var shareEmailInput=document.getElementById("shareEmailInput"),shareAddBtn=document.getElementById("shareAddBtn");
    var shareAddSec=document.getElementById("shareAddSec");
    // Add is pressable only when there is someone to add and no add in flight.
    var addBusy=false;
    function syncAdd(){if(shareAddBtn)shareAddBtn.disabled=addBusy||!shareEmailInput||!shareEmailInput.value.trim()}
    // General access: the level everyone not listed above is on, picked from a menu
    // (the owner's) whose choices each say what they mean.
    var shGen=document.getElementById("shGen"),shGenBtn=document.getElementById("shGenBtn"),shGenMenu=document.getElementById("shGenMenu");
    var shGenLabel=document.getElementById("shGenLabel"),shGenSub=document.getElementById("shGenSub"),shGenIc=document.getElementById("shGenIc"),shGenRole=document.getElementById("shGenRole");
    // Lives in: Personal or one of the owner's teams (spaces.team_org_id).
    var shPlace=document.getElementById("shPlace"),shPlaceNote=document.getElementById("shPlaceNote");
    var shGear=document.getElementById("shGear"),shSettings=document.getElementById("shSettings");
    var visInviteRow=document.getElementById("visInviteRow"),visMayInvite=document.getElementById("visMayInvite");
    var visEditRow=document.getElementById("visEditRow"),visMayEdit=document.getElementById("visMayEdit");
    var visListedRow=document.getElementById("visListedRow"),visListed=document.getElementById("visListed"),curListed=V.listed;
    // The gallery box stays hidden until /sharing says what the owner chose: painting
    // it ticked before then could show "allowed" over an opt-out.
    var visGalleryRow=document.getElementById("visGalleryRow"),visGallery=document.getElementById("visGallery"),visGalleryLink=document.getElementById("visGalleryLink"),curGallery=null;
    var visBarRow=document.getElementById("visBarRow"),visBar=document.getElementById("visBar"),curHideBar=V.hideBar;
    var shareRosterNote=document.getElementById("shareRosterNote"),shareRole=document.getElementById("shareRole");
    var curTier=V.tier||"invite",curMayInvite=false,curMayEdit=true,curTeamMayEdit=true;
    // The team the page lives in ({id, name, picture}), or null for a personal page. A
    // team keeps its access at every level of General access; only moving the page to
    // Personal takes it away.
    var curTeam=V.team||null,inTeam=!!curTeam;
    // What /sharing said about each team the dialog can name: its domains and size.
    var teamInfo={};
    var GEN_TEXT={"invite":{"label":"Restricted","sub":"Only the people with access can open it"},"signed_in":{"label":"Anyone who signs in","sub":"Anyone with the link, once they sign in"},"link":{"label":"Anyone with the link","sub":"Public: anyone on the internet, no sign-in"}},GEN_ICONS={"invite":"\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M16 12H17.4C17.7314 12 18 12.2686 18 12.6V19.4C18 19.7314 17.7314 20 17.4 20H6.6C6.26863 20 6 19.7314 6 19.4V12.6C6 12.2686 6.26863 12 6.6 12H8M16 12V8C16 6.66667 15.2 4 12 4C8.8 4 8 6.66667 8 8V12M16 12H8\"/\u003e\u003c/svg\u003e","signed_in":"\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z\"/\u003e\u003cpath d=\"M4.271 18.3457C4.271 18.3457 6.50002 15.5 12 15.5C17.5 15.5 19.7291 18.3457 19.7291 18.3457\"/\u003e\u003cpath d=\"M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z\"/\u003e\u003c/svg\u003e","link":"\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z\"/\u003e\u003cpath d=\"M13 2.04932C13 2.04932 16 5.99994 16 11.9999C16 17.9999 13 21.9506 13 21.9506\"/\u003e\u003cpath d=\"M11 21.9506C11 21.9506 8 17.9999 8 11.9999C8 5.99994 11 2.04932 11 2.04932\"/\u003e\u003cpath d=\"M2.62964 15.5H21.3704\"/\u003e\u003cpath d=\"M2.62964 8.5H21.3704\"/\u003e\u003c/svg\u003e"};
    function wideTier(t){return t==="link"||t==="signed_in"}
    // A work page (shared/work-pages.ts): General access is Restricted, the company
    // ("team": the page lives in the company's team) or Anyone with the link, as in
    // Google Workspace. Its words come from the server (workGenText).
    var WORK=V.work||null,WORK_TEXT=V.workText||null;
    var WORK_ICONS={team:"\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M10 9.01L10.01 8.99889\"/\u003e\u003cpath d=\"M14 9.01L14.01 8.99889\"/\u003e\u003cpath d=\"M10 13.01L10.01 12.9989\"/\u003e\u003cpath d=\"M14 13.01L14.01 12.9989\"/\u003e\u003cpath d=\"M10 17.01L10.01 16.9989\"/\u003e\u003cpath d=\"M14 17.01L14.01 16.9989\"/\u003e\u003cpath d=\"M6 20.4V5.6C6 5.26863 6.26863 5 6.6 5H12V3.6C12 3.26863 12.2686 3 12.6 3H17.4C17.7314 3 18 3.26863 18 3.6V20.4C18 20.7314 17.7314 21 17.4 21H6.6C6.26863 21 6 20.7314 6 20.4Z\"/\u003e\u003c/svg\u003e",other:"\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M1 20V19C1 15.134 4.13401 12 8 12C11.866 12 15 15.134 15 19V20\"/\u003e\u003cpath d=\"M13 14C13 11.2386 15.2386 9 18 9C20.7614 9 23 11.2386 23 14V14.5\"/\u003e\u003cpath d=\"M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z\"/\u003e\u003cpath d=\"M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.65685 16.3431 9 18 9Z\"/\u003e\u003c/svg\u003e"};
    var shGenTeamRole=document.getElementById("shGenTeamRole");
    // The level the row shows: the tier, or on a work page which of Restricted / the
    // company / another team the page is on.
    function genNow(){if(!WORK||curTier!=="invite")return curTier;return inTeam&&curTeam?(curTeam.id===WORK.id?"team":"other"):"invite"}
    function genText(g){return WORK&&WORK_TEXT&&WORK_TEXT[g]?WORK_TEXT[g]:(GEN_TEXT[g]||GEN_TEXT.invite)}
    // The team or org the page belongs to right now, by name ("" for a personal page).
    function homeNow(){return inTeam&&curTeam?curTeam.name:(V.org?V.home||"":"")}
    // The tip under Share: who can open the page, shown after the pointer rests a
    // second (or the button is tabbed to). Gone on the press, so it never sits over
    // the dialog it describes.
    var accessTip=document.getElementById("accessTip"),ACCESS_TIPS={"link":"Public","signed_in":"Anyone signed in","team":"Team","invite":"Private"},accessTipT=0;
    function paintAccessTip(){var vb=document.getElementById("visitorBtn");if(vb&&curTier)vb.hidden=curTier!=="link";if(accessTip&&curTier)accessTip.textContent=ACCESS_TIPS[curTier==="invite"&&inTeam?"team":curTier]||ACCESS_TIPS.invite}
    function accessTipShow(on){clearTimeout(accessTipT);accessTipT=0;if(!accessTip)return;if(on)accessTipFit();accessTip.classList.toggle("on",!!on&&!(shareDd&&shareDd.classList.contains("open")))}
    // Centred under Share unless that would cross the window's edge: Share sits at
    // the header's right end, so "Anyone signed in" ran off the screen. Slide it back
    // inside, 8px clear, measured from the centred position.
    function accessTipFit(){
      accessTip.style.setProperty("--tip-dx","0px");
      var b=shareBtnEl.getBoundingClientRect(),w=accessTip.offsetWidth,vw=document.documentElement.clientWidth,mid=b.left+b.width/2;
      var dx=Math.min(0,vw-8-(mid+w/2))+Math.max(0,8-(mid-w/2));
      accessTip.style.setProperty("--tip-dx",Math.round(dx)+"px");
    }
    function accessTipLater(){clearTimeout(accessTipT);accessTipT=setTimeout(function(){accessTipShow(true)},1000)}
    if(accessTip&&shareBtnEl){
      shareBtnEl.addEventListener("pointerenter",function(e){if(e.pointerType==="mouse")accessTipLater()});
      shareBtnEl.addEventListener("pointerleave",function(){accessTipShow(false)});
      shareBtnEl.addEventListener("focus",function(){try{if(shareBtnEl.matches(":focus-visible"))accessTipLater()}catch(_){}});
      shareBtnEl.addEventListener("blur",function(){accessTipShow(false)});
      shareBtnEl.addEventListener("pointerdown",function(){accessTipShow(false)});
      document.addEventListener("keydown",function(e){if(e.key==="Escape")accessTipShow(false)});
    }
    // Every picker in the dialog opens the app's own menu (assets/components/menu.ts),
    // not the browser's native list. The <select> stays as the value: the code below
    // reads and sets .value, .hidden and .disabled on it and listens for "change",
    // and the button beside it follows all three.
    
    window.ssMenu=window.ssMenu||(function(){
      var CK="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M5 13L9 17L19 7\"/></svg>",m=null;
      function esc(s){var d=document.createElement("div");d.textContent=s==null?"":String(s);return d.innerHTML.replace(/"/g,"&quot;")}
      function rows(){return Array.prototype.filter.call(m.el.querySelectorAll(".ss-mi"),function(b){return b.offsetParent!==null&&!b.disabled})}
      function place(){
        if(!m)return;
        var r=m.btn.getBoundingClientRect(),w=m.el.offsetWidth,h=m.el.offsetHeight;
        if(!m.btn.isConnected){close(false);return}
        if(m.within){var lr=m.within.getBoundingClientRect();if(r.bottom<lr.top||r.top>lr.bottom){close(false);return}}
        var top=r.bottom+4;if(top+h>window.innerHeight-8)top=Math.max(8,r.top-h-4);
        if(m.match){m.el.style.width=r.width+"px";w=m.el.offsetWidth;m.el.style.top=top+"px";m.el.style.left=Math.max(8,Math.min(r.left,window.innerWidth-w-8))+"px";return}
        m.el.style.top=top+"px";m.el.style.left=Math.max(8,Math.min(m.start?r.left:r.right-w,window.innerWidth-w-8))+"px";
      }
      function mark(open){m.btn.setAttribute("aria-expanded",open?"true":"false");if(m.onToggle)m.onToggle(open,m.btn)}
      function close(back){
        if(!m)return;var c=m;
        if(c.btn.isConnected){mark(false);if(back)c.btn.focus()}
        m=null;c.el.remove();
        document.removeEventListener("pointerdown",c.away,true);window.removeEventListener("blur",c.blur);
        document.removeEventListener("scroll",place,true);window.removeEventListener("resize",place);
      }
      function open(btn,items,o){
        o=o||{};
        var again=m&&m.btn===btn;close(false);if(again)return;
        var checks=items.some(function(it){return typeof it.checked==="boolean"});
        var el=document.createElement("div");el.className="ss-menu"+(o.fit?" fit":"")+(o.match?" match":"");el.setAttribute("role","menu");
        if(o.label)el.setAttribute("aria-label",o.label);
        el.innerHTML=items.map(function(it){
          if(it.sep)return '<div class="ss-mi-sep" role="separator"></div>';
          if(it.note!=null)return '<div class="ss-mi-note" role="presentation">'+esc(it.note)+'</div>';
          var radio=typeof it.checked==="boolean";
          return '<button type="button" role="'+(radio?'menuitemradio':'menuitem')+'"'+(radio?' aria-checked="'+it.checked+'"':'')+' class="ss-mi'+(it.touchOnly?' m-touch':'')+(it.danger?' danger':'')+(it.sub?' has-sub':'')+'" data-k="'+esc(it.k)+'"'+(it.disabled?' disabled':'')+'>'+
            (checks?'<span class="ss-mi-ck" aria-hidden="true">'+CK+'</span>':'')+
            (it.icon?'<span class="ss-mi-ic" aria-hidden="true">'+it.icon+'</span>':'')+
            '<span class="ss-mi-t">'+esc(it.l)+(it.sub?'<span class="ss-mi-sub">'+esc(it.sub)+'</span>':'')+'</span></button>';
        }).join("");
        document.body.appendChild(el);
        m={el:el,btn:btn,key:o.key,within:o.within||null,onToggle:o.onToggle,match:!!o.match,start:!!o.start,
          away:function(e){if(m&&!m.el.contains(e.target)&&!m.btn.contains(e.target))close(false)},
          blur:function(){close(false)}};
        // Listen before placing: place() closes a menu whose button is already out of
        // its list, and close() takes these back off.
        mark(true);
        document.addEventListener("pointerdown",m.away,true);window.addEventListener("blur",m.blur);
        document.addEventListener("scroll",place,true);window.addEventListener("resize",place);
        place();if(!m)return;
        el.addEventListener("keydown",function(e){
          var bs=rows(),i=bs.indexOf(document.activeElement);
          if(e.key==="Escape"){e.preventDefault();e.stopPropagation();close(true)}
          else if(e.key==="ArrowDown"){e.preventDefault();bs[(i+1)%bs.length].focus()}
          else if(e.key==="ArrowUp"){e.preventDefault();bs[(i-1+bs.length)%bs.length].focus()}
          else if(e.key==="Home"){e.preventDefault();bs[0].focus()}
          else if(e.key==="End"){e.preventDefault();bs[bs.length-1].focus()}
          else if(e.key==="Tab")close(false);
        });
        el.addEventListener("click",function(e){
          var b=e.target.closest(".ss-mi");if(!b||b.disabled||!m)return;
          var k=b.getAttribute("data-k"),at=m.btn;close(false);if(o.onPick)o.onPick(k,at);
        });
        var bs=rows(),first=el.querySelector('.ss-mi[aria-checked="true"]:not(:disabled)')||bs[0];
        if(first&&first.offsetParent!==null)first.focus({preventScroll:true});else if(bs[0])bs[0].focus({preventScroll:true});
      }
      function reanchor(nb){
        if(!m)return;if(!nb){close(false);return}
        m.btn=nb;mark(true);place();
      }
      return{open:open,close:close,reanchor:reanchor,place:place,current:function(){return m?{btn:m.btn,key:m.key}:null}};
    })();
  
    var SH_CHEV="\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M6 9L12 15L18 9\"/\u003e\u003c/svg\u003e";
    function shSel(sel){
      if(!sel||sel.__ssBtn)return;
      var b=document.createElement("button");b.type="button";
      b.className=sel.className+" sh-sel";if(sel.id)b.id=sel.id+"Btn";
      b.setAttribute("aria-haspopup","menu");b.setAttribute("aria-expanded","false");
      b.innerHTML='<span class="sh-sel-t"></span>'+(sel.classList.contains("sh-place-sel")||sel.classList.contains("share-role-quiet")?"":'<span class="sh-sel-chev" aria-hidden="true">'+SH_CHEV+'</span>');
      sel.classList.add("sh-sel-native");sel.tabIndex=-1;sel.setAttribute("aria-hidden","true");
      sel.parentNode.insertBefore(b,sel.nextSibling);sel.__ssBtn=b;
      var lb=sel.id&&document.querySelector('label[for="'+sel.id+'"]');if(lb)lb.htmlFor=b.id;
      function paint(){
        var o=sel.options[sel.selectedIndex],t=o?o.textContent:"";
        b.querySelector(".sh-sel-t").textContent=t;
        b.setAttribute("aria-label",(sel.getAttribute("aria-label")||"")+(t?": "+t:""));
        b.hidden=sel.hidden;b.disabled=sel.disabled;
      }
      var d=Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype,"value");
      Object.defineProperty(sel,"value",{configurable:true,get:function(){return d.get.call(this)},set:function(v){d.set.call(this,v);paint()}});
      new MutationObserver(paint).observe(sel,{attributes:true,attributeFilter:["hidden","disabled"]});
      sel.addEventListener("change",paint);
      b.addEventListener("click",function(e){
        e.stopPropagation();
        ssMenu.open(b,Array.prototype.map.call(sel.options,function(o){return{k:o.value,l:o.textContent,checked:o.selected,disabled:o.disabled}}),{fit:true,
          label:sel.getAttribute("aria-label")||"",
          onPick:function(k){if(k===sel.value)return;sel.value=k;sel.dispatchEvent(new Event("change"))}
        });
      });
      paint();
    }
    [shPlace,shareRole,shGenTeamRole].forEach(shSel);
    function syncInvite(){if(visMayInvite)visMayInvite.checked=!!curMayInvite}
    // The role the add row would hand out right now.
    function addRole(){return shareRole&&!shareRole.hidden?shareRole.value:"view"}
    // Who is in each team (from /sharing, only teams the reader is in): lets "Add
    // people" suggest teammates and say of every suggestion and guest whether they
    // are inside the page's team or outside it.
    var teamRosters={};
    // Share lists (Settings → Share lists; "groups" in the API): the ones this space is
    // shared with, and the owner's own to add. A list is @mentioned by name in "Add
    // people"; picking one fills the box and locks the role to Can view (a list only
    // ever views). pickedList is the one picked from the suggestions, so "@f26" means
    // that list even when someone has the handle f26.
    var shareGroups=[],myGroups=[],pickedList=null;
    // The way to a first list: once, for an owner with no lists who has just added a
    // third person by hand, a line pointing to Settings (the dialog never makes or
    // edits a list). Followed or dismissed, it stays away on this device.
    var listHint=document.getElementById("shareListHint"),listHintAfterAdd=false,LIST_HINT_KEY="ss-sh-list-hint";
    function listHintDone(){try{return localStorage.getItem(LIST_HINT_KEY)==="1"}catch(e){return false}}
    function listHintEnd(how){
      try{localStorage.setItem(LIST_HINT_KEY,"1")}catch(e){}
      if(listHint)listHint.hidden=true;
      if(window.mixpanel)mixpanel.track("Share List Hint "+how,{space_id:spaceId});
    }
    function maybeListHint(people){
      var after=listHintAfterAdd;listHintAfterAdd=false;
      if(!listHint)return;
      if(myGroups.length){listHint.hidden=true;return}
      if(!after||people<3||!listHint.hidden||listHintDone())return;
      listHint.hidden=false;
      if(window.mixpanel)mixpanel.track("Share List Hint Shown",{space_id:spaceId,people:people});
    }
    if(listHint){
      document.getElementById("shareListHintGo").addEventListener("click",function(){listHintEnd("Followed")});
      document.getElementById("shareListHintX").addEventListener("click",function(){listHintEnd("Dismissed")});
    }
    function refTeam(){
      if(!inTeam||!curTeam||!teamRosters[curTeam.id])return null;
      return {id:curTeam.id,name:curTeam.name||"your team"};
    }
    function inRefTeam(em){
      var t=refTeam();if(!t||!em)return null;
      em=String(em).toLowerCase();
      return teamRosters[t.id].some(function(p){return p.email.toLowerCase()===em});
    }
    // A teammate of a page that lives in their team can open it now: adding them with
    // the role the team already has changes nothing, so the dialog says so instead of
    // hiding them — a search for someone you know is on the team that comes back empty
    // reads as broken. With a different role it is a real change (their own row wins
    // over the team's): a team that reads and one teammate who edits is exactly what
    // the add row is for.
    function viaTeam(em){return inTeam&&inRefTeam(em)===true&&addRole()===(curTeamMayEdit?"edit":"view")}
    function teamTag(em,cls){
      var t=refTeam(),inside=inRefTeam(em);if(inside===null)return null;
      var tag=document.createElement("span");tag.className=cls+(inside?" in":" out");
      tag.textContent=inside?(viaTeam(em)&&cls==="sug-team"?"Has access · "+t.name:t.name):"Outside "+t.name;
      tag.title=inside?"On the "+t.name+" team":"Not on the "+t.name+" team";
      if(!inside)tag.hidden=!inTeam;
      return tag;
    }
    var shareAddNote=document.getElementById("shareAddNote"),noteTimer=0;
    function addNote(msg){
      if(!shareAddNote)return;
      shareAddNote.textContent=msg||"";shareAddNote.hidden=!msg;
      clearTimeout(noteTimer);if(msg)noteTimer=setTimeout(function(){shareAddNote.hidden=true},6000);
    }
    // The roster entry for a typed "@handle" or email, when that person is on the team.
    function mateFor(v){
      var t=refTeam();if(!t)return null;
      var h=v.charAt(0)==="@"?v.slice(1):null;
      return teamRosters[t.id].filter(function(p){return h?(p.username||"").toLowerCase()===h:p.email.toLowerCase()===v})[0]||null;
    }
    function alreadyViaTeam(p){
      var t=refTeam();
      addNote((p.name||(p.username?"@"+p.username:p.email))+" already has access through the "+t.name+" team.");
    }
    // Restricted on an org's own space still lets the org in, so it says so.
    function genSub(t){
      if(t==="invite"&&V.org&&V.home)return "Only "+V.home+" and the people added can open it";
      return (GEN_TEXT[t]||GEN_TEXT.invite).sub;
    }
    function paintVis(){
      paintAccessTip();
      if(shGen){
        var g=genNow();
        shGen.setAttribute("data-v",g);
        if(shGenLabel)shGenLabel.textContent=genText(g).label;
        if(shGenSub)shGenSub.textContent=WORK?genText(g).sub:genSub(curTier);
        if(shGenIc)shGenIc.innerHTML=WORK_ICONS[g]||GEN_ICONS[g]||GEN_ICONS.invite;
        if(shGenRole)shGenRole.hidden=curTier==="invite"||g==="team";
        // The company's own Can edit / Can view sits on its row, as Workspace puts it.
        if(shGenTeamRole){shGenTeamRole.hidden=g!=="team";shGenTeamRole.value=curTeamMayEdit?"edit":"view"}
        if(shGenMenu)shGenMenu.querySelectorAll(".sh-gen-opt").forEach(function(o){
          var v=o.getAttribute("data-v");o.setAttribute("aria-checked",String(v===g));
          // "Anyone who signs in" is listed on a work page only while the page is on it.
          if(WORK&&v==="signed_in")o.hidden=v!==curTier;
        });
      }
      // Listing is the link level's own modifier: the profile and world search both
      // already require it, so elsewhere the box would say nothing.
      if(visListedRow)visListedRow.classList.toggle("on",curTier==="link");
      if(visBarRow)visBarRow.classList.toggle("on",curTier==="link");
      // The gallery picks only from spaces on a profile. Leaving that takes a space out
      // (the database resets the pick), so the "In the gallery" link goes with it.
      if(curGallery&&(curTier!=="link"||!curListed))curGallery.selected=false;
      if(visGalleryRow)visGalleryRow.classList.toggle("on",!!curGallery&&curTier==="link"&&!!curListed);
      if(visGalleryLink)visGalleryLink.hidden=!(curGallery&&curGallery.allowed&&curGallery.selected);
      if(visEditRow)visEditRow.classList.toggle("on",!inTeam);
      var here=inTeam&&curTeam?curTeam.id:"";
      if(shPlace&&shPlace.value!==here)shPlace.value=here;
      if(shPlaceNote)shPlaceNote.textContent=inTeam&&curTeam?"On "+curTeam.name+"’s home":"On your dashboard";
      // Each row carries its own "Can edit / Can view"; the note only speaks when the
      // switch behind the gear has made the whole guest list read-only, and then the
      // row controls (and the role on the add row) have nothing to say.
      if(shareRosterNote)shareRosterNote.textContent=curMayEdit?"":"— view only by default";
      if(shareRole)shareRole.hidden=!curMayEdit;
      document.querySelectorAll(".team-tag.out,.sug-team.out").forEach(function(t){t.hidden=!inTeam});
    }
    // Members can invite too (members tier) — loadSharing reveals the section via
    // the server's can_invite flag; default hidden for non-owners until it loads.
    if(!isOwner)shareAddSec.style.display="none";

    // Click title to rename (owner only). Enter or clicking away saves, Escape cancels.
    (function(){
      var titleEl=document.getElementById("spaceTitle");
      if(!titleEl||!isOwner)return;
      function startEdit(){
        if(titleEl.querySelector("input"))return;
        // Co-shepherd may have renamed it since this viewer opened.
        var current=titleEl.textContent||"";
        var input=document.createElement("input");
        input.type="text";
        input.className="title-input title-rename-input";
        input.value=current;
        input.maxLength=200;
        input.setAttribute("aria-label","Rename space");
        titleEl.textContent="";
        titleEl.appendChild(input);
        input.focus();
        input.setSelectionRange(0,0);
        var done=false;
        function finish(save){
          if(done)return;
          done=true;
          var next=(input.value||"").trim();
          if(!save||!next||next===current){titleEl.textContent=current;return}
          input.disabled=true;
          fetch("/api/space/"+spaceId,{method:"PATCH",headers:{"Content-Type":"application/json"},body:JSON.stringify({title:next})})
            .then(function(r){return r.json().then(function(d){return{ok:r.ok,d:d}})})
            .then(function(res){
              if(!res.ok){titleEl.textContent=current;return}
              current=res.d.title||next;
              titleEl.textContent=current;
              document.title=current+" — spacesheep";
              if(res.d.url&&location.pathname.indexOf("/@")===0&&location.pathname!==res.d.url){
                history.replaceState(null,"",res.d.url+location.search+location.hash);
              }
              if(window.mixpanel)mixpanel.track("Space Renamed",{space_id:spaceId});
            })
            .catch(function(){titleEl.textContent=current});
        }
        input.addEventListener("keydown",function(e){
          if(e.key==="Enter"){e.preventDefault();finish(true)}
          else if(e.key==="Escape"){e.preventDefault();finish(false)}
        });
        input.addEventListener("blur",function(){finish(true)});
      }
      titleEl.addEventListener("click",startEdit);
    })();

    var shareOv=document.getElementById("accessOverlay");
    function toggleShare(open){var o=open!==undefined?open:!shareDd.classList.contains("open");if(o){try{localStorage.setItem(HINT_KEY,"1");if(!localStorage.getItem("ss_share_opened_at"))localStorage.setItem("ss_share_opened_at",String(Date.now()))}catch(_){}hintHide("opened");if(!shareDd.classList.contains("open")&&window.mixpanel)mixpanel.track("Share Opened",{space_id:spaceId,surface:"viewer"});var tn=document.getElementById("shTitleName"),st=document.getElementById("spaceTitle");if(tn&&st&&st.textContent)tn.textContent=st.textContent;shareDd.classList.add("open");shareOv.classList.add("open");setVisErr("");loadSharing();if(window.ssAiLinkLoad)window.ssAiLinkLoad()}else{shareDd.classList.remove("open");shareOv.classList.remove("open");if(typeof genMenu==="function")genMenu(false);if(typeof closeAsk==="function")closeAsk()}}
    shareBtnEl.onclick=function(e){e.stopPropagation();toggleShare()};

    // "For AI assistants" (reader-links.ts): the owner's link to the page as plain text,
    // for an assistant that can't sign in or run the page's script. Read each time the
    // dialog opens, so its read count is fresh.
    var aiSec=document.getElementById("shAi");
    if(aiSec){
      var aiOn=document.getElementById("shAiOn"),aiCopy=document.getElementById("shAiCopy"),aiReads=document.getElementById("shAiReads"),
        aiErr=document.getElementById("shAiErr"),aiCreate=document.getElementById("shAiCreate"),aiMore=document.getElementById("shAiMore"),
        aiSubOff=document.getElementById("shAiSubOff"),aiSubOn=document.getElementById("shAiSubOn"),aiLink=null,aiBusy=false;
      var aiPaint=function(link){
        aiLink=link||null;aiCreate.hidden=!!link;aiOn.hidden=!link;aiSubOff.hidden=!!link;aiSubOn.hidden=!link;aiErr.textContent="";
        if(!link){if(ssMenu.current()&&ssMenu.current().btn===aiMore)ssMenu.close();return}
        aiCopy.setAttribute("data-copy",link.url);
        aiReads.textContent=link.reads?(link.reads===1?"1 read":link.reads+" reads"):"0 reads";
      };
      var aiSend=function(body,ev){
        if(aiBusy)return;aiBusy=true;
        fetch("/api/space/"+spaceId+"/reader-link",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(body)})
          .then(function(r){return r.ok?r.json():Promise.reject(r.status)})
          .then(function(d){aiBusy=false;aiPaint(d.link);if(d.link&&body.on)aiCopy.focus();else if(!d.link)aiCreate.focus();if(window.mixpanel)mixpanel.track(ev,{space_id:spaceId})})
          .catch(function(){aiBusy=false;aiErr.textContent="That didn't work. Try again."});
      };
      window.ssAiLinkLoad=function(){
        fetch("/api/space/"+spaceId+"/reader-link").then(function(r){return r.ok?r.json():null}).then(function(d){if(d)aiPaint(d.link)}).catch(function(){});
      };
      aiCreate.onclick=function(){aiSend({on:true},"Reader Link Create Clicked")};
      aiMore.onclick=function(e){
        e.stopPropagation();if(!aiLink)return;
        ssMenu.open(aiMore,[
          {note:ssT("share.ai_why","Gemini, ChatGPT and other assistants can't sign in, so they read this text copy instead.")},
          {note:aiLink.url},
          {sep:true},
          {k:"renew",l:ssT("share.ai_renew","New link"),sub:ssT("share.ai_renew_sub","The old link stops working")},
          {k:"off",l:ssT("share.ai_off","Turn off"),danger:true}
        ],{key:"ai-link",onToggle:function(open){aiMore.setAttribute("aria-expanded",open?"true":"false")},onPick:function(k){
          if(k==="renew")aiSend({on:true,renew:true},"Reader Link Renew Clicked");
          else if(k==="off")aiSend({on:false},"Reader Link Off Clicked");
        }});
      };
    }
    shareOv.onclick=function(){toggleShare(false)};

    // The Share hint (variant F of design-explorations/first-publish-next-steps.html;
    // Natalie, 2026-10-22: "OK, and now what?"). It is for an owner who has never
    // shared a space: the server answers that for the account (share-tip.ts), so a
    // second device doesn't start over, and this browser remembers the dialog opened
    // or "Not now". Until then it points at Share once the page is a page, with one
    // jiggle of the button. ?share_tip=1 shows it to anyone signed in, whatever was
    // shared or remembered, for testing (=0 hides it).
    // The comment tip waits for it (ssShareHintDue / ss:share-hint-done).
    var HINT_KEY="ss_share_opened",hintEl=document.getElementById("accessHint"),hintUp=false,hintT=0,hintForced=null;
    try{
      var hintQ=new URLSearchParams(location.search);
      if(hintQ.has("share_tip")){
        hintForced=hintQ.get("share_tip")!=="0";hintQ.delete("share_tip");var hintQs=hintQ.toString();
        history.replaceState(null,"",location.pathname+(hintQs?"?"+hintQs:"")+location.hash);
      }
    }catch(_){}
    function hintOpenedBefore(){try{return localStorage.getItem(HINT_KEY)==="1"}catch(_){return false}}
    function hintRemember(){try{localStorage.setItem(HINT_KEY,"1")}catch(_){}}
    var hintDue=!!hintEl&&!V.visitor&&(hintForced===null?!!V.owner&&!hintOpenedBefore():hintForced);
    window.ssShareHintDue=hintDue;
    function hintDone(){if(window.ssShareHintDone)return;window.ssShareHintDone=true;try{dispatchEvent(new Event("ss:share-hint-done"))}catch(_){}}
    // Under Share, its arrow on the button's middle, kept 8px inside the window.
    function hintPlace(){
      if(!hintUp)return;
      var b=shareBtnEl.getBoundingClientRect(),vw=document.documentElement.clientWidth,right=Math.max(8,vw-b.right-4);
      hintEl.style.top=Math.round(b.bottom+12)+"px";hintEl.style.right=Math.round(right)+"px";
      var ar=(vw-right)-(b.left+b.width/2)-6;
      hintEl.style.setProperty("--hint-ar",Math.round(Math.max(10,Math.min(hintEl.offsetWidth-22,ar)))+"px");
    }
    function hintShow(){
      if(hintUp||!hintDue)return;
      if(typeof placeholder!=="undefined"&&placeholder){hintT=setTimeout(hintShow,1500);return}
      // Never over the edit bar: it opens where Save is (2026-10-27). It waits for Done.
      if(window.__ssEditing){hintT=setTimeout(hintShow,1500);return}
      if(shareDd.classList.contains("open")||!shareBtnEl.offsetWidth){hintDone();return}
      hintUp=true;hintEl.hidden=false;accessTipShow(false);hintPlace();
      shareBtnEl.classList.remove("is-jiggle");void shareBtnEl.offsetWidth;shareBtnEl.classList.add("is-jiggle");
      if(window.mixpanel)mixpanel.track("Share Tip Shown",{space_id:spaceId,forced:hintForced===true,tier:curTier,phone:innerWidth<=640});
    }
    // Edit mode opened under the tip: it steps aside, unanswered, and comes back after.
    window.ssShareHintPause=function(){if(!hintUp)return;hintUp=false;hintEl.hidden=true;shareBtnEl.classList.remove("is-jiggle");clearTimeout(hintT);hintT=setTimeout(hintShow,1500)};
    function hintHide(how){
      clearTimeout(hintT);
      if(!hintUp){if(how)hintDone();return}
      hintUp=false;hintEl.hidden=true;shareBtnEl.classList.remove("is-jiggle");
      if(window.mixpanel)mixpanel.track("Share Tip Answered",{space_id:spaceId,answer:how,forced:hintForced===true});
      hintDone();
    }
    if(hintEl){
      document.getElementById("accessHintGo").onclick=function(e){
        e.stopPropagation();hintHide("share_it");toggleShare(true);
        setTimeout(function(){if(shareEmailInput&&shareEmailInput.offsetWidth)try{shareEmailInput.focus({preventScroll:true})}catch(_){}},60);
      };
      document.getElementById("accessHintNo").onclick=function(e){e.stopPropagation();hintRemember();hintHide("not_now")};
      document.addEventListener("keydown",function(e){if(e.key==="Escape")hintHide("escape")});
      addEventListener("resize",hintPlace);
      if(hintDue){
        // Asked beside the 1.5 s wait. Shared before → remembered here and never
        // shown; no answer → not shown this time (a tip is never worth a guess).
        var hintAsk=hintForced?Promise.resolve(false):fetch("/api/account/shared-before",{credentials:"same-origin"})
          .then(function(r){return r.ok?r.json():null}).then(function(d){return d?!!d.shared:null}).catch(function(){return null});
        hintT=setTimeout(function(){hintAsk.then(function(shared){
          if(window.ssShareHintDone)return;
          if(shared!==false){if(shared)hintRemember();hintDue=false;hintDone();return}
          hintShow();
        })},1500);
      }
    }
    document.addEventListener("click",function(e){if(!shareDd.contains(e.target)&&!(e.target.closest&&e.target.closest(".ss-menu"))&&e.target!==shareBtnEl&&!shareBtnEl.contains(e.target))toggleShare(false)});
    // Escape closes it too, and hands focus back to the button that opened it —
    // otherwise a keyboard user is left with focus inside a menu that's gone.
    document.addEventListener("keydown",function(e){
      if(e.key!=="Escape"||!shareDd.classList.contains("open"))return;
      toggleShare(false);shareBtnEl.focus();
    });

    var SHARE_X="\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M6.75827 17.2426L12.0009 12M17.2435 6.75736L12.0009 12M12.0009 12L6.75827 6.75736M12.0009 12L17.2435 17.2426\"/\u003e\u003c/svg\u003e",SHARE_GROUP="\u003csvg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"\u003e\u003cpath d=\"M8 6H20M8 12H20M8 18H20\"/\u003e\u003cpath d=\"M4 6.01L4.01 5.99889M4 12.01L4.01 11.9989M4 18.01L4.01 17.9989\"/\u003e\u003c/svg\u003e";
    // "Ask to edit" (edit-requests.ts): a quiet link beside Copy link for a reader who
    // can't change the page. The ask is the owner's to answer, in their bell or email.
    var shAskEdit=document.getElementById("shAskEdit");
    function paintAsked(on){if(!shAskEdit)return;shAskEdit.classList.toggle("is-asked",on);shAskEdit.setAttribute("aria-disabled",on?"true":"false")}
    if(shAskEdit)shAskEdit.onclick=function(){
      if(shAskEdit.classList.contains("is-asked"))return;
      paintAsked(true);
      fetch("/api/space/"+spaceId+"/edit-request",{method:"POST",headers:{"Content-Type":"application/json"},body:"{}"}).then(function(r){
        if(r.ok){if(window.mixpanel)mixpanel.track("Edit Access Requested",{space_id:spaceId});return}
        paintAsked(false);
        // Already an editor (the owner just let them), or the page changed: read it again.
        if(r.status===409)loadSharing();
      }).catch(function(){paintAsked(false)});
    };
    function loadSharing(){
      shareListEl.innerHTML='<div class="share-empty">Loading...</div>';
      fetch("/api/space/"+spaceId+"/sharing").then(function(r){
        if(!r.ok)throw new Error(r.status);return r.json();
      }).then(function(data){
        // Older responses only carry the legacy visibility enum; derive the rung
        // from it so a half-deployed fleet still paints the dialog correctly.
        curTier=data.tier||(data.visibility==="public"?"link":data.visibility==="signed_in"?"signed_in":"invite");
        // Refresh the logo after a move or upload; null means it was removed. Only
        // older responses without picture may reuse the same team's cached logo.
        curTeam=data.team?{id:data.team.id,name:data.team.name,picture:data.team.picture!==undefined?data.team.picture:curTeam&&curTeam.id===data.team.id?curTeam.picture:null}:null;inTeam=!!curTeam;
        teamInfo={};(data.teams||[]).concat(data.team?[data.team]:[]).forEach(function(t){if(t&&t.id)teamInfo[t.id]={name:t.name,domains:t.domains||[],members:t.members}});
        curMayInvite=typeof data.members_may_invite==="boolean"?data.members_may_invite:data.visibility==="members";
        // Absent on an older response → sharing meant editing, as it always had.
        curMayEdit=typeof data.members_may_edit==="boolean"?data.members_may_edit:true;
        // Absent on an older response → not listed. The safe direction: a half-deployed
        // fleet paints the box unchecked rather than claiming a space is on a profile.
        curListed=typeof data.listed==="boolean"?data.listed:false;
        curHideBar=typeof data.hide_bar==="boolean"?data.hide_bar:false;
        curGallery=data.gallery&&typeof data.gallery.allowed==="boolean"?{allowed:data.gallery.allowed,selected:!!data.gallery.selected}:null;
        if(visGallery&&curGallery)visGallery.checked=curGallery.allowed;
        // Absent on an older response → the team edits, as sharing with one always meant.
        curTeamMayEdit=typeof data.team_may_edit==="boolean"?data.team_may_edit:true;
        teamRosters=data.team_members||{};
        shareGroups=data.groups||[];myGroups=data.my_groups||[];
        maybeListHint((data.emails||[]).length);
        if(shareEmailInput)shareEmailInput.placeholder=myGroups.length?ssT("share.email_group_placeholder","@username, email or a share list"):ssT("share.email_placeholder","@username or email");
        paintVis();
        syncInvite();
        if(visMayEdit)visMayEdit.checked=!!curMayEdit;
        if(visListed)visListed.checked=!!curListed;
        if(visBar)visBar.checked=!!curHideBar;
        var canInvite=!!data.can_invite||!!data.is_owner;
        shareAddSec.style.display=canInvite?"":"none";
        if(shAskEdit){shAskEdit.hidden=!data.can_ask_edit;paintAsked(!!data.edit_requested)}
        // The link level is static-only: a worker space's way to share widely is the
        // sign-in level.
        var linkOpt=shGenMenu&&shGenMenu.querySelector('.sh-gen-opt[data-v="link"]');
        if(linkOpt){linkOpt.disabled=!!data.is_worker;var linkSub=linkOpt.querySelector(".sh-gen-opt-t span");if(linkSub)linkSub.textContent=data.is_worker?ssT("share.worker_needs_signin","Worker spaces need sign-in — use the option below."):GEN_TEXT.link.sub}
        shareListEl.innerHTML="";
        // One row per person: avatar, who they are (name over @handle when we have
        // both), and on the right what they may do and the ×. Every row is the same
        // height whether it carries a picker or a quiet label, so the list reads as a
        // column instead of a staircase.
        function rosterRow(av,primary,secondary,title){
          var item=document.createElement("div");item.className="share-email-item";
          item.insertAdjacentHTML("beforeend",av);
          var who=document.createElement("span");who.className="share-who";
          var nm=document.createElement("span");nm.className="share-who-name";nm.textContent=primary;if(title)nm.title=title;who.appendChild(nm);
          if(secondary){var sub=document.createElement("span");sub.className="share-who-sub";sub.textContent=secondary;who.appendChild(sub)}
          item.appendChild(who);
          var ctl=document.createElement("span");ctl.className="share-item-ctl";item.appendChild(ctl);
          return {item:item,who:who,ctl:ctl};
        }
        function roleLabel(ctl,text){var t=document.createElement("span");t.className="role-tag";t.textContent=text;ctl.appendChild(t)}
        function rmBtn(ctl,aria,fn){var rm=document.createElement("button");rm.type="button";rm.className="share-rm";rm.innerHTML=SHARE_X;rm.title=aria;rm.setAttribute("aria-label",aria);rm.onclick=fn;ctl.appendChild(rm)}
        function nameLines(name,uname,em){
          var h=uname?"@"+uname:"";
          if(name&&h)return [name,h];
          if(name&&em)return [name,em];
          return [h||name||em||"",uname&&em?em:""];
        }
        // The team the page lives in is one row among the people: who it is (its email
        // domain while it lets people in by one, else its size) and what it may do.
        // On a work page the company is General access itself (with its own role there),
        // so it isn't listed twice.
        if(data.team&&!(WORK&&data.team.id===WORK.id)){
          var tm=data.team,dom=tm.domains||[];
          var tSub=dom.length?"Anyone who signs in with "+dom.map(function(d){return "@"+d}).join(", "):(tm.members?(tm.members===1?"1 person":tm.members+" people"):"Team");
          var tr=rosterRow(ssAvatar({seed:tm.id,name:tm.name,picture:curTeam&&curTeam.picture,team:true,size:"sm",className:"share-av"}),tm.name,tSub);
          tr.item.classList.add("share-team-row");
          var tTag=document.createElement("span");tTag.className="share-team-kind";tTag.textContent="Team";tr.who.querySelector(".share-who-name").appendChild(tTag);
          if(isOwner){
            var tSel=document.createElement("select");tSel.className="share-role share-role-quiet";tSel.id="shTeamRole";tSel.setAttribute("aria-label","What "+tm.name+" may do");
            tSel.innerHTML='<option value="edit">'+ssT("share.can_edit","Can edit")+'</option><option value="view">'+ssT("share.can_view","Can view")+'</option>';
            tSel.value=curTeamMayEdit?"edit":"view";
            tSel.onchange=function(){saveTeamEdit(tSel.value==="edit",tSel)};
            tr.ctl.appendChild(tSel);shSel(tSel);
          }else roleLabel(tr.ctl,curTeamMayEdit?ssT("share.can_edit","Can edit"):ssT("share.can_view","Can view"));
          shareListEl.appendChild(tr.item);
        }
        var oL=nameLines(data.owner_name,data.owner_username,data.owner_email);
        var oSeed=data.owner_seed||data.owner_email||data.owner_username||"";
        var oRow=rosterRow(ssAvatar({seed:oSeed,name:data.owner_name||data.owner_username||data.owner_email,picture:data.owner_picture,size:"sm",className:"share-av"}),oL[0],oL[1]);
        roleLabel(oRow.ctl,ssT("share.owner","Owner"));
        shareListEl.appendChild(oRow.item);
        // A group reads, whatever the rung and the roster's edit switch: one row each,
        // its size, and for the owner an × that takes it off.
        shareGroups.forEach(function(g){
          var r=rosterRow('<span class="ss-av ss-av-sm share-av share-av-group" aria-hidden="true">'+SHARE_GROUP+'</span>',g.name,"Share list \u00b7 "+g.count+(g.count===1?" person":" people"));
          roleLabel(r.ctl,ssT("share.can_view","Can view"));
          if(isOwner)rmBtn(r.ctl,"Stop sharing with "+g.name,function(){fetch("/api/space/"+spaceId+"/groups/remove",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({group:g.id})}).then(function(r){if(r.ok){loadSharing();if(window.mixpanel)mixpanel.track("Space Group Removed",{space_id:spaceId})}})});
          shareListEl.appendChild(r.item);
        });
        sharedEmails={};sharedEmails[(data.owner_email||"").toLowerCase()]=1;
        // A reader without the roster right gets handles only (email null) — see the route.
        if(data.emails)data.emails.forEach(function(entry){var e=typeof entry==="string"?entry:entry.email;if(e)sharedEmails[e.toLowerCase()]=1});
        if(data.emails&&data.emails.length>0){
          data.emails.forEach(function(entry){
            var em=typeof entry==="string"?entry:entry.email;
            var uname=typeof entry==="object"?entry.username:null;
            var pname=typeof entry==="object"?entry.name:null;
            var label=uname?"@"+uname:(em||"");
            var L=nameLines(pname,uname,em);
            var r=rosterRow(ssAvatar({seed:(typeof entry==="object"&&entry.seed)||em||uname||"",name:pname||uname||em,picture:typeof entry==="object"?entry.picture:null,size:"sm",className:"share-av"}),L[0],L[1],em&&L[1]!==em?em:"");
            var tt=teamTag(em,"team-tag");if(tt)r.who.appendChild(tt);
            var role=(typeof entry==="object"&&entry.role==="view")?"view":"edit";
            var ctl=r.ctl;
            if(entry.handoff_editor&&!curMayEdit){var hint=document.createElement("span");hint.className="share-who-sub";hint.textContent="Former owner · Individual editor access";r.who.appendChild(hint);}
            var canTransfer=isOwner&&data.transfer_enabled&&!!(uname||em)&&!!window.ssSpaceTransferOpen;
            if(isOwner&&(curMayEdit||entry.handoff_editor||canTransfer)){
              // The owner sets each person's role in place; a failed save snaps back.
              var sel=document.createElement("select");sel.className="share-role share-role-quiet";sel.setAttribute("aria-label","What "+label+" may do");
              sel.innerHTML='<option value="edit">'+ssT("share.can_edit","Can edit")+'</option><option value="view">'+ssT("share.can_view","Can view")+'</option>';
              if(!curMayEdit&&!entry.handoff_editor){sel.options[0].disabled=true;role='view'}
              if(canTransfer){var transferOpt=document.createElement('option');transferOpt.value='transfer';transferOpt.textContent='Make owner…';sel.appendChild(transferOpt)}
              sel.value=role;
              sel.onchange=(function(sel,em){return function(){
                var prev=role,next=sel.value;
                if(next==='transfer'){
                  sel.value=prev;toggleShare(false);
                  window.ssSpaceTransferOpen(spaceId,shareBtnEl,uname?'@'+uname:em);
                  return;
                }
                sel.disabled=true;
                fetch("/api/space/"+spaceId+"/sharing",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({role_email:em,role:next})})
                  .then(function(r){sel.disabled=false;if(!r.ok){sel.value=prev;return}role=next;loadSharing();if(window.mixpanel)mixpanel.track("Access Role Changed",{space_id:spaceId,role:next})})
                  .catch(function(){sel.disabled=false;sel.value=prev});
              }})(sel,em);
              ctl.appendChild(sel);shSel(sel);
            }else if(curMayEdit||entry.handoff_editor){
              roleLabel(ctl,role==="view"?ssT("share.can_view","Can view"):ssT("share.can_edit","Can edit"));
            }else{
              roleLabel(ctl,ssT("share.can_view","Can view"));
            }
            if(isOwner)rmBtn(ctl,"Remove "+label,function(){fetch("/api/space/"+spaceId+"/sharing",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({remove_email:em})}).then(function(r){if(r.ok)loadSharing()})});
            shareListEl.appendChild(r.item);
          });
        }
        // People the response didn't name (no public handle, and this reader can't see addresses).
        var unnamed=(typeof data.guest_count==="number"?data.guest_count:0)-(data.emails?data.emails.length:0);
        if(unnamed>0){var more=document.createElement("div");more.className="share-email-item share-more";var ms=document.createElement("span");ms.textContent=(data.emails&&data.emails.length?"and ":"")+unnamed+(unnamed===1?" other person":" other people");more.appendChild(ms);shareListEl.appendChild(more)}
        // The list always shows, the owner first: General access below speaks of "the
        // people with access", and this is who they are.
      }).catch(function(err){
        shareListEl.innerHTML='<div class="share-empty">Failed to load</div>';
      });
    }

    // Post this space to the flock: one bleat carrying a space attachment, exactly
    // what the feed composer's space picker sends. The server re-checks both fences
    // (flock membership, and that the space is yours or this org's), so a stale page
    // can't post something the menu shouldn't have offered.
    (function(){
      var postBtn=document.getElementById("postBtn"),postMsg=document.getElementById("postMsg"),postNote=document.getElementById("postNote");
      if(!postBtn)return;
      var FEED_HREF=V.feedHref;
      var postCta=document.getElementById("postCta"),postBody=document.getElementById("postBody");
      // Expand on the CTA, and drop the writer straight into the message box. A draft
      // survives closing the menu — reopening it shouldn't eat what you typed.
      postCta.onclick=function(){
        var open=postCta.getAttribute("aria-expanded")==="true";
        postCta.setAttribute("aria-expanded",open?"false":"true");
        postBody.classList.toggle("open",!open);
        if(!open)postMsg.focus();
      };
      function note(text,isErr,href){
        postNote.className="post-note"+(isErr?" err":"");
        postNote.textContent="";
        postNote.appendChild(document.createTextNode(text));
        if(href){
          postNote.appendChild(document.createTextNode(" "));
          var a=document.createElement("a");a.href=href;a.textContent="See it";postNote.appendChild(a);
        }
      }
      function post(){
        postBtn.disabled=true;note(ssT("share.posting","Posting…"),false);
        fetch("/api/bleats",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({
          body:(postMsg.value||"").trim(),
          attachments:[{kind:"space",space_id:spaceId}]
        })}).then(function(r){return r.json().then(function(d){return{ok:r.ok,d:d}})})
        .then(function(res){
          postBtn.disabled=false;
          if(!res.ok||!res.d.bleat){note((res.d&&res.d.error)||ssT("share.post_failed","That did not post."),true);return}
          postMsg.value="";
          note(ssT("share.posted","Posted to the flock."),false,FEED_HREF);
          if(window.mixpanel)mixpanel.track("Space Posted To Flock",{space_id:spaceId});
        }).catch(function(){postBtn.disabled=false;note(ssT("share.post_failed","That did not post."),true)});
      }
      postBtn.onclick=post;
      postMsg.addEventListener("keydown",function(e){if((e.metaKey||e.ctrlKey)&&e.key==="Enter"){e.preventDefault();post()}});
    })();

    var visErr=document.getElementById("visErr");
    function setVisErr(msg){if(!visErr)return;visErr.textContent=msg||"";visErr.hidden=!msg}
    function saveFailed(r){
      if(!r){setVisErr(ssT("share.unreachable","Couldn’t reach the server — your change wasn’t saved."));return}
      r.json().then(function(d){
        // Rate limiting is the failure a person actually meets here, and the
        // limiter's own message names the rule and the window ("invite/3600,
        // limit 20") — true, and meaningless to someone holding a share dialog.
        // retry_after is the part they can act on, so that is what we say.
        if(d&&d.error==="rate_limited"&&d.retry_after){
          var m=Math.ceil(d.retry_after/60);
          setVisErr("Too many sharing changes just now — this one wasn't saved. Try again in "+(m>1?m+" minutes":"a minute")+".");
          return;
        }
        setVisErr((d&&d.message)||ssT("share.not_saved","That didn’t save. Try again."));
      }).catch(function(){setVisErr(ssT("share.not_saved","That didn’t save. Try again."))});
    }
    function saveVis(tier,mayInvite){
      var prevTier=curTier,prevMay=curMayInvite;
      curTier=tier;curMayInvite=mayInvite;paintVis();
      function revert(){curTier=prevTier;curMayInvite=prevMay;paintVis();syncInvite()}
      // General access only: the page stays where it lives, its team keeps its access.
      fetch("/api/space/"+spaceId+"/sharing",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({tier:tier,members_may_invite:mayInvite})}).then(function(r){
        if(!r.ok){revert();saveFailed(r);return}
        setVisErr("");
        if(window.mixpanel)mixpanel.track("Visibility Changed",{space_id:spaceId,tier:tier,members_may_invite:mayInvite,home:homeNow()?(inTeam?"team":"org"):"personal",in_team:inTeam});
      }).catch(function(){revert();saveFailed(null)});
    }
    // On a page with a home (a team, or an org's own space), every level past it asks
    // first: the choice opens a confirm under the row, and only its button saves. That
    // includes public → "Anyone who signs in": still outside the team, and one click
    // there left a page open to every account when its owner meant private
    // (2026-10-10). Back to Restricted never asks. A personal page saves on the pick.
    var visConfirm=document.getElementById("visConfirm"),visConfirmText=document.getElementById("visConfirmText");
    var visConfirmGo=document.getElementById("visConfirmGo"),visConfirmNo=document.getElementById("visConfirmNo");
    var pendingTier=null;
    function confirmCopy(v){
      var home=homeNow(),t=(document.querySelector("#spaceTitle")||{}).textContent||V.title||"this page";
      var keep=inTeam?" "+home+" keeps its access.":"";
      return v==="link"
        ?"Anyone with the link can read “"+t+"”, not just "+home+". No sign-in needed."+keep
        :"Anyone with a Spacesheep account and the link can read “"+t+"”, not just "+home+"."+keep;
    }
    function askWide(v){
      pendingTier=v;
      visConfirmText.textContent=confirmCopy(v);
      var lbl=v==="link"?"Make public":"Open to anyone signed in";
      visConfirmGo.textContent=lbl;visConfirmGo.setAttribute("aria-label",lbl);
      visConfirm.hidden=false;
      if(window.mixpanel)mixpanel.track("Share Outside Asked",{space_id:spaceId,tier:v,home:inTeam?"team":"org"});
    }
    function closeAsk(){pendingTier=null;if(visConfirm)visConfirm.hidden=true}
    if(visConfirmGo)visConfirmGo.addEventListener("click",function(){
      var v=pendingTier;closeAsk();if(!v)return;
      saveVis(v,curMayInvite);copyShareUrl();
      if(window.mixpanel)mixpanel.track("Share Outside Confirmed",{space_id:spaceId,tier:v,home:inTeam?"team":"org"});
    });
    if(visConfirmNo)visConfirmNo.addEventListener("click",closeAsk);
    // Picking a level is almost always a prelude to sending someone the link, so a pick
    // that saves copies it too (one that asks copies when the ask is answered).
    function onVisChange(v){
      if(!v)return;
      if(WORK){
        var was=genNow();closeAsk();
        if(v===was){copyShareUrl();return}
        var done=function(ok){if(!ok)return;copyShareUrl();if(window.mixpanel)mixpanel.track("Work Access Changed",{space_id:spaceId,from:was,to:v})};
        if(v==="team")place(WORK.id,"invite").then(done);
        else if(v==="invite"){if(inTeam)place(null,"invite").then(done);else{saveVis("invite",curMayInvite);done(true)}}
        // Anyone with the link: the company keeps its access, so a page in its team asks first.
        else if(v==="link"){if(homeNow()&&visConfirm){askWide(v);return}saveVis("link",curMayInvite);done(true)}
        return;
      }
      if(v===curTier){closeAsk();copyShareUrl();return}
      if(homeNow()&&visConfirm&&wideTier(v)){askWide(v);return}
      closeAsk();
      saveVis(v,curMayInvite);copyShareUrl();
    }
    // The menu opens below the row, over what follows it, as Workspace's does; it used to
    // open above and covered the people list on a phone (2026-10-21). Short of room below,
    // it slides up over its own row (as a native select does) but never past the row's
    // top; only when even that won't fit, and there is more room above, does it open above.
    function placeGenMenu(){
      shGenMenu.classList.remove("up");shGenMenu.style.top="";
      var box=shGenMenu.parentElement;
      while(box&&box!==document.body){var ov=getComputedStyle(box).overflowY;if(ov==="auto"||ov==="scroll"||ov==="hidden")break;box=box.parentElement}
      var r=box&&box!==document.body?box.getBoundingClientRect():{top:0,bottom:innerHeight};
      var row=shGenMenu.parentElement.getBoundingClientRect(),h=shGenMenu.offsetHeight;
      var bottom=Math.min(r.bottom,innerHeight)-8,over=row.bottom+2+h-bottom;
      if(over<=0)return;
      if(over<=row.height+2){shGenMenu.style.top="calc(100% + 2px - "+Math.ceil(over)+"px)";return}
      if(row.top-Math.max(r.top,0)>bottom-row.bottom)shGenMenu.classList.add("up");
    }
    function genMenu(open){
      if(!shGenMenu||!shGenBtn)return;
      shGenMenu.hidden=!open;shGenBtn.setAttribute("aria-expanded",open?"true":"false");
      if(open)placeGenMenu();
      if(open){var at=shGenMenu.querySelector('.sh-gen-opt[aria-checked="true"]:not([disabled])')||shGenMenu.querySelector(".sh-gen-opt:not([disabled]):not([hidden])");if(at)at.focus()}
    }
    if(shGenBtn)shGenBtn.addEventListener("click",function(e){e.stopPropagation();genMenu(shGenMenu.hidden)});
    if(shGenMenu){
      shGenMenu.addEventListener("click",function(e){
        var o=e.target.closest(".sh-gen-opt");if(!o||o.disabled)return;
        e.stopPropagation();genMenu(false);shGenBtn.focus();
        onVisChange(o.getAttribute("data-v"));
      });
      shGenMenu.addEventListener("keydown",function(e){
        var opts=[].slice.call(shGenMenu.querySelectorAll(".sh-gen-opt:not([disabled]):not([hidden])")),i=opts.indexOf(document.activeElement);
        if(e.key==="ArrowDown"||e.key==="ArrowUp"){e.preventDefault();var n=opts[(i+(e.key==="ArrowDown"?1:opts.length-1))%opts.length];if(n)n.focus()}
        else if(e.key==="Escape"){e.preventDefault();e.stopPropagation();genMenu(false);shGenBtn.focus()}
        else if(e.key==="Tab")genMenu(false);
      });
    }
    // Anywhere else in the dialog closes the menu (outside it, the dialog closes).
    if(shareDd)shareDd.addEventListener("click",function(e){if(shGenMenu&&!shGenMenu.hidden&&!(e.target.closest&&e.target.closest("#shGenMenu,#shGenBtn")))genMenu(false)});
    // The gear: the settings that refine who may do what.
    if(shGear&&shSettings)shGear.addEventListener("click",function(){
      var open=shSettings.hidden;shSettings.hidden=!open;shGear.setAttribute("aria-expanded",open?"true":"false");
      if(open&&window.mixpanel)mixpanel.track("Share Settings Opened",{space_id:spaceId});
    });
    var shDone=document.getElementById("shDone");
    if(shDone)shDone.addEventListener("click",function(){toggleShare(false);shareBtnEl.focus()});
    // A move says what happened, with an Undo, for ten seconds.
    var shToast=document.getElementById("shToast"),shToastUndo=document.getElementById("shToastUndo"),toastT=0,undoMove=null;
    function moveToast(msg,undo){
      if(!shToast)return;
      shToast.querySelector(".sh-toast-msg").textContent=msg;
      undoMove=undo||null;if(shToastUndo)shToastUndo.hidden=!undo;
      shToast.hidden=false;clearTimeout(toastT);
      toastT=setTimeout(function(){shToast.hidden=true;undoMove=null},10000);
    }
    function teamName(id){var t=teamInfo[id];if(t)return t.name;for(var i=0;i<(V.teams||[]).length;i++)if(V.teams[i].id===id)return V.teams[i].name;return ""}
    function teamWho(id){var d=(teamInfo[id]||{}).domains||[];return d.length?"Anyone who signs in with "+d.map(function(x){return "@"+x}).join(", "):"Everyone on "+teamName(id)}
    // Where the page lives, and at what level, in one write. The route takes a team the
    // owner is in, or null for Personal.
    function place(teamId,tier){
      if(shPlace)shPlace.disabled=true;
      return fetch("/api/space/"+spaceId+"/sharing",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({tier:tier,team_org_id:teamId||null,members_may_invite:!!curMayInvite})}).then(function(r){
        if(shPlace)shPlace.disabled=false;
        if(!r.ok){paintVis();saveFailed(r);return false}
        setVisErr("");
        curTeam=teamId?{id:teamId,name:teamName(teamId),picture:curTeam&&curTeam.id===teamId?curTeam.picture:null}:null;inTeam=!!teamId;curTier=tier;
        // Into a team the route puts the guest list's edit switch back on (a team page
        // has none), so the add row's role is live again.
        if(teamId)curMayEdit=true;
        paintVis();loadSharing();
        return true;
      }).catch(function(){if(shPlace)shPlace.disabled=false;paintVis();saveFailed(null);return false});
    }
    if(shPlace)shPlace.addEventListener("change",function(){
      var to=shPlace.value||null,prev={team:curTeam?curTeam.id:null,tier:curTier,mayEdit:curMayEdit},wasName=curTeam?curTeam.name:"";
      // Into a team the page becomes the team's: the team and the people added, nobody
      // wider (2026-10-10: a public page put in Sheep stayed public). Out of one, to
      // Personal, everyone else keeps what they had and only the team loses access.
      var tier=to?"invite":curTier;
      place(to,tier).then(function(ok){
        if(!ok)return;
        var narrowed=to&&wideTier(prev.tier)?" It’s no longer "+(prev.tier==="link"?"public":"open to anyone signed in")+".":"";
        var msg=to?"Moved to "+teamName(to)+". "+teamWho(to)+" can open it."+narrowed:"Moved to Personal. "+wasName+" can no longer open it.";
        moveToast(msg,function(){
          place(prev.team,prev.tier).then(function(back){
            if(!back)return;
            if(!prev.mayEdit&&curMayEdit)saveEdit(false);
            moveToast(prev.team?"Back in "+teamName(prev.team)+".":"Back to Personal.",null);
            if(window.mixpanel)mixpanel.track("Space Move Undone",{space_id:spaceId});
          });
        });
        if(window.mixpanel)mixpanel.track(to?"Space Moved To Team":"Space Moved To Personal",{space_id:spaceId,from:prev.team?"team":"personal",narrowed:!!narrowed});
      });
    });
    if(shToastUndo)shToastUndo.addEventListener("click",function(){var u=undoMove;undoMove=null;shToast.hidden=true;if(u)u()});
    if(visMayInvite)visMayInvite.addEventListener("change",function(e){saveVis(curTier,!!e.target.checked)});
    if(shGenTeamRole)shGenTeamRole.addEventListener("change",function(){saveTeamEdit(shGenTeamRole.value==="edit",shGenTeamRole)});
    // The team row's Can edit / Can view (team_may_edit) — its own write, like each
    // person's role. The route turns the guest list's edit switch back on with it (a
    // team page has none), so the add row's role is live whichever way it went.
    function saveTeamEdit(mayEdit,sel){
      var prev=curTeamMayEdit;
      curTeamMayEdit=mayEdit;
      function revert(){curTeamMayEdit=prev;if(sel)sel.value=prev?"edit":"view"}
      fetch("/api/space/"+spaceId+"/sharing",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({team_may_edit:mayEdit})}).then(function(r){
        if(!r.ok){revert();saveFailed(r);return}
        setVisErr("");
        curMayEdit=true;if(visMayEdit)visMayEdit.checked=true;paintVis();
        if(window.mixpanel)mixpanel.track("Team Edit Permission Changed",{space_id:spaceId,team_may_edit:mayEdit});
      }).catch(function(){revert();saveFailed(null)});
    }
    // The edit permission is its own write — never bundled with the level, so a
    // failed save here can't undo a level change and vice versa.
    function saveEdit(mayEdit){
      var prev=curMayEdit;
      curMayEdit=mayEdit;paintVis();if(visMayEdit)visMayEdit.checked=!!mayEdit;
      function revert(){curMayEdit=prev;paintVis();if(visMayEdit)visMayEdit.checked=!!prev}
      fetch("/api/space/"+spaceId+"/sharing",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({members_may_edit:mayEdit})}).then(function(r){
        if(!r.ok){revert();saveFailed(r);return}
        setVisErr("");
        if(window.mixpanel)mixpanel.track("Edit Permission Changed",{space_id:spaceId,members_may_edit:mayEdit});
      }).catch(function(){revert();saveFailed(null)});
    }
    if(visMayEdit)visMayEdit.addEventListener("change",function(e){saveEdit(!!e.target.checked)});
    // Listing is its own write too, for the same reason: it is not a level change, and
    // a failed save here must not disturb who can open the document.
    function saveListed(listed){
      var prev=curListed;
      curListed=listed;paintVis();
      function revert(){curListed=prev;paintVis();if(visListed)visListed.checked=!!prev}
      fetch("/api/space/"+spaceId+"/sharing",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({listed:listed})}).then(function(r){
        if(!r.ok){revert();saveFailed(r);return}
        setVisErr("");
        if(window.mixpanel)mixpanel.track("Listing Changed",{space_id:spaceId,listed:listed});
      }).catch(function(){revert();saveFailed(null)});
    }
    if(visListed)visListed.addEventListener("change",function(e){saveListed(!!e.target.checked)});
    // "Let it be picked for the gallery": the owner's veto, its own write. Either way
    // the space is out of the gallery until the team looks again (gallery-review.ts).
    function saveGallery(allowed){
      var prev=curGallery;
      curGallery={allowed:allowed,selected:false};paintVis();
      function revert(){curGallery=prev;paintVis();if(visGallery)visGallery.checked=!!(prev&&prev.allowed)}
      fetch("/api/space/"+spaceId+"/gallery",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({allowed:allowed})}).then(function(r){
        if(!r.ok){revert();saveFailed(r);return}
        setVisErr("");
      }).catch(function(){revert();saveFailed(null)});
    }
    if(visGallery)visGallery.addEventListener("change",function(e){saveGallery(!!e.target.checked)});
    // "Hide the Spacesheep bar": its own write as well. The owner keeps their bar, so
    // nothing on this screen changes; the box is the whole confirmation.
    function saveHideBar(hide){
      var prev=curHideBar;curHideBar=hide;
      function revert(){curHideBar=prev;if(visBar)visBar.checked=!!prev}
      fetch("/api/space/"+spaceId+"/sharing",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({hide_bar:hide})}).then(function(r){
        if(!r.ok){revert();saveFailed(r);return}
        setVisErr("");
        if(window.mixpanel)mixpanel.track("Space Bar Hidden Changed",{space_id:spaceId,hidden:hide});
      }).catch(function(){revert();saveFailed(null)});
    }
    if(visBar)visBar.addEventListener("change",function(e){saveHideBar(!!e.target.checked)});
    // ?share=1 is the dashboard card's "More sharing options…": arrive with the dialog
    // open, and drop the param so a reload or a copied address doesn't reopen it.
    try{
      var shareQ=new URLSearchParams(location.search);
      if(shareQ.get("share")==="1"){
        shareQ.delete("share");var shareQs=shareQ.toString();
        history.replaceState(null,"",location.pathname+(shareQs?"?"+shareQs:"")+location.hash);
        toggleShare(true);
      }
    }catch(_){}

    // Picking a tier is almost always a prelude to sending someone the link, so the
    // click copies it as well, on top of the button that says so. This is a CLICK
    // handler, not the change handler above:
    // change never fires when you re-pick the tier the space is already on, and
    // "click the option, get the link" shouldn't have an exception nobody can see.
    //
    // location.pathname is the canonical share URL on both viewer routes (/@user/slug
    // and /space/<uuid>); query and hash are dropped so a ?comment= deep link or a
    // version banner doesn't ride along into someone else's inbox.
    // window.ssCopy owns the clipboard call, the fallback for a denied permission and
    // the confirmation; this only decides WHAT to copy and WHERE to confirm. The
    // button is the where for both gestures, so a copy is announced in one place.
    var shareCopyBtn=document.getElementById("shareCopyBtn"),lastCopyAt=0;
    function copyShareUrl(){
      // A label click and the click it forwards to its radio both land here; one copy
      // per gesture.
      var now=Date.now();if(now-lastCopyAt<200)return;lastCopyAt=now;
      window.ssCopy(location.origin+location.pathname,shareCopyBtn);
    }
    // The button carries no data-copy, so the delegated handler leaves it to us.
    if(shareCopyBtn)shareCopyBtn.addEventListener("click",copyShareUrl);

    // One of the owner's lists by its exact name (any case, a leading @ allowed), or null.
    function groupNamed(v){
      v=v.replace(/^@/,"");
      for(var i=0;i<myGroups.length;i++)if(myGroups[i].name.toLowerCase()===v)return myGroups[i];
      return null;
    }
    // A teammate or friend whose handle is exactly this "@word".
    function personWithHandle(v){
      if(v.charAt(0)!=="@")return null;
      var h=v.slice(1);
      return mateFor(v)||(sugFriends||[]).filter(function(f){return (f.username||"").toLowerCase()===h})[0]||null;
    }
    // The list the box names right now: the one picked from the suggestions while the
    // box still reads "@<its name>", else a typed name, unless a person you know has
    // that handle (then the person wins, and the suggestions show both to pick from).
    function listInBox(){
      var v=shareEmailInput?shareEmailInput.value.trim().toLowerCase():"";
      if(!v)return null;
      if(pickedList&&v==="@"+pickedList.name.toLowerCase())return pickedList;
      pickedList=null;
      var g=groupNamed(v);
      return g&&!personWithHandle(v)?g:null;
    }
    // A list only ever views, so the role shows Can view, locked, while one is in the box.
    var roleBeforeList=null;
    function syncListRole(){
      if(!shareRole)return;
      var g=listInBox();
      if(g&&roleBeforeList===null){roleBeforeList=shareRole.value;shareRole.value="view";shareRole.disabled=true;shareRole.title="People on a share list can view, comment and fill in forms, but not edit"}
      else if(!g&&roleBeforeList!==null){shareRole.disabled=false;shareRole.value=roleBeforeList;shareRole.title="";roleBeforeList=null}
    }
    // Share with a whole group. Nobody on it is emailed: the note says so, because
    // the owner is the one who sends the link.
    function addGroup(g){
      addBusy=true;syncAdd();addNote("");
      fetch("/api/space/"+spaceId+"/groups",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({group:g.id})}).then(function(r){
        return r.json().catch(function(){return {}}).then(function(d){
          addBusy=false;syncAdd();
          if(!r.ok){addNote(d.message||"That didn\u2019t save. Try again.");return}
          shareEmailInput.value="";pickedList=null;syncAdd();syncListRole();if(sugEl)sugEl.hidden=true;
          var n=d.group&&typeof d.group.count==="number"?d.group.count:g.count;
          addNote(d.already?g.name+" already has it.":(n===1?"The 1 person":"The "+n+" people")+" on "+g.name+" can open it once they sign in with that address. Nobody was emailed, so send them the link.");
          loadSharing();
          
        });
      }).catch(function(){addBusy=false;syncAdd()});
    }
    function addShareEmail(){
      var v=shareEmailInput.value.trim().toLowerCase();if(!v)return;
      addNote("");
      var grp=listInBox();if(grp){addGroup(grp);return}
      // A bare handle ("vsm") means the person, as it does in the suggestions.
      if(/^[a-z0-9][a-z0-9-]*$/.test(v))v="@"+v;
      var mate=mateFor(v);
      if(mate&&viaTeam(mate.email)){shareEmailInput.value="";syncAdd();if(sugEl)sugEl.hidden=true;alreadyViaTeam(mate);return}
      if(!/^@[a-z0-9][a-z0-9-]*$/.test(v)&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){shareEmailInput.style.borderColor="var(--ss-danger)";setTimeout(function(){shareEmailInput.style.borderColor=""},1500);return}
      addBusy=true;syncAdd();
      fetch("/api/space/"+spaceId+"/sharing",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email:v,role:addRole()})}).then(function(r){addBusy=false;syncAdd();if(r.ok){shareEmailInput.value="";syncAdd();listHintAfterAdd=true;loadSharing();}else{shareEmailInput.style.borderColor="var(--ss-danger)";setTimeout(function(){shareEmailInput.style.borderColor=""},1500)}}).catch(function(){addBusy=false;syncAdd()});
    }
    shareAddBtn.onclick=addShareEmail;

    // Friends autocomplete on the "Add people" input: the full friend list drops
    // down on focus, narrows as you type, and picking a friend puts them in the box.
    // Add (or Enter) shares, so the role beside it is chosen first, as for a list.
    var sharedEmails={};
    var sugEl=document.getElementById("shareSuggest"),sugFriends=null,sugItems=[],sugSel=-1;
    function loadFriends(){
      if(sugFriends!==null)return;
      sugFriends=[];
      fetch("/api/friends").then(function(r){return r.ok?r.json():{friends:[]}}).then(function(d){sugFriends=d.friends||[];paintSuggest()}).catch(function(){});
    }
    function friendMatches(f,q){
      if(!q)return true;
      var hay=((f.name||"")+" "+(f.username||"")+" "+f.email).toLowerCase();
      return hay.indexOf(q.replace(/^@/,""))!==-1;
    }
    function paintSuggest(){
      if(!sugEl)return;
      var q=shareEmailInput.value.trim().toLowerCase();
      // Teammates first, then friends. One row a person, whichever list they came
      // from. On a space already shared with the team they still show, marked "Has
      // access", and picking one says so rather than adding them.
      var t=refTeam(),seen={},pool=[];
      var mates=t?teamRosters[t.id]:[];
      mates.concat(sugFriends||[]).forEach(function(f){var k=f.email.toLowerCase();if(seen[k]||k===String(myEmail||"").toLowerCase())return;seen[k]=1;pool.push(f)});
      // The owner's groups lead, by name, unless the space already has them.
      var on={};shareGroups.forEach(function(g){on[g.id]=1});
      var gq=q.replace(/^@/,"");
      var groupSug=myGroups.filter(function(g){return !on[g.id]&&(!gq||g.name.toLowerCase().indexOf(gq)!==-1)}).map(function(g){return {group:g}});
      // A list already in the box doesn't need suggesting again.
      if(pickedList)groupSug=groupSug.filter(function(x){return x.group.id!==pickedList.id});
      sugItems=groupSug.concat(pool.filter(function(f){return !sharedEmails[f.email.toLowerCase()]&&friendMatches(f,q)})).slice(0,8);
      sugSel=-1;
      if(!sugItems.length||document.activeElement!==shareEmailInput){sugEl.hidden=true;sugEl.innerHTML="";return}
      sugEl.innerHTML="";
      // With both kinds on offer, each gets a heading: a list reads as a list at a glance.
      var bothKinds=sugItems.some(function(f){return f.group})&&sugItems.some(function(f){return !f.group});
      function sugHead(t){var h=document.createElement("div");h.className="share-suggest-h";h.textContent=t;sugEl.appendChild(h)}
      sugItems.forEach(function(f,i){
        if(bothKinds&&i===0&&f.group)sugHead("Your share lists");
        if(bothKinds&&!f.group&&(i===0||sugItems[i-1].group))sugHead("People");
        if(f.group){
          var gi=document.createElement("div");gi.className="share-suggest-item";
          gi.insertAdjacentHTML("beforeend",'<span class="ss-av ss-av-xs share-av-group" aria-hidden="true">'+SHARE_GROUP+'</span>');
          var gn=document.createElement("span");gn.className="sug-name";gn.textContent="@"+f.group.name;gi.appendChild(gn);
          var gh=document.createElement("span");gh.className="sug-handle";gh.textContent="Share list \u00b7 "+f.group.count+(f.group.count===1?" person":" people")+" \u00b7 can view";gi.appendChild(gh);
          gi.onmousedown=function(e){e.preventDefault();pickFriend(f)};
          gi.onmouseenter=function(){setSugSel(i)};
          sugEl.appendChild(gi);
          return;
        }
        var it=document.createElement("div");it.className="share-suggest-item"+(viaTeam(f.email)?" via":"");
        // Same avatar as everywhere else: the photo when there is one, otherwise the
        // initial on this person's stable seed colour — a grey circle here made the
        // same face look like a different person than in presence or comments.
        it.insertAdjacentHTML("beforeend",ssAvatar({seed:f.email,name:f.name||f.username||f.email,picture:f.picture,size:"xs"}));
        var nm=document.createElement("span");nm.className="sug-name";nm.textContent=f.name||(f.username?"@"+f.username:f.email);it.appendChild(nm);
        if(f.username&&f.name){var hd=document.createElement("span");hd.className="sug-handle";hd.textContent="@"+f.username;it.appendChild(hd)}
        var st=teamTag(f.email,"sug-team");if(st)it.appendChild(st);
        it.onmousedown=function(e){e.preventDefault();pickFriend(f)};
        it.onmouseenter=function(){setSugSel(i)};
        sugEl.appendChild(it);
      });
      sugEl.hidden=false;
    }
    function setSugSel(i){
      sugSel=i;
      var kids=sugEl.querySelectorAll(".share-suggest-item");
      for(var k=0;k<kids.length;k++)kids[k].classList.toggle("sel",k===sugSel);
      if(sugSel>=0&&kids[sugSel])kids[sugSel].scrollIntoView({block:"nearest"});
    }
    function pickFriend(f){
      if(f.group){
        pickedList=f.group;shareEmailInput.value="@"+f.group.name;sugEl.hidden=true;
        syncAdd();syncListRole();shareEmailInput.focus();
        return;
      }
      if(viaTeam(f.email)){shareEmailInput.value="";syncAdd();sugEl.hidden=true;alreadyViaTeam(f);return}
      shareEmailInput.value=f.username?"@"+f.username:f.email;
      sugEl.hidden=true;
      syncAdd();shareEmailInput.focus();
    }
    shareEmailInput.addEventListener("focus",function(){loadFriends();paintSuggest()});
    shareEmailInput.addEventListener("input",function(){syncAdd();syncListRole();paintSuggest()});
    syncAdd();
    shareEmailInput.addEventListener("blur",function(){setTimeout(function(){if(sugEl)sugEl.hidden=true},150)});
    shareEmailInput.onkeydown=function(e){
      if(!sugEl.hidden&&sugItems.length){
        if(e.key==="ArrowDown"){e.preventDefault();setSugSel((sugSel+1)%sugItems.length);return}
        if(e.key==="ArrowUp"){e.preventDefault();setSugSel((sugSel-1+sugItems.length)%sugItems.length);return}
        if(e.key==="Escape"){sugEl.hidden=true;return}
        if(e.key==="Enter"&&sugSel>=0){e.preventDefault();pickFriend(sugItems[sugSel]);return}
      }
      if(e.key==="Enter")addShareEmail();
    };

    // Init. myEmail is rendered in by the server. This used to ask
    // /cdn-cgi/access/get-identity first, but with Access no longer fronting the
    // viewer that path is answered by Cloudflare's edge ({"err":"no app token set"}),
    // so myEmail stayed "" — own comments lost their Delete button, "mine" never
    // highlighted, and a reaction's local record never merged with its live echo
    // (counted twice). The profile sync that rode along posted empty name/picture
    // on every load; the sign-in flow owns that now.
    var savedSidebarOpen=sidebarState.read();
    if(savedSidebarOpen!==null)toggleSidebar(savedSidebarOpen,"restore");
    connect();
    loadComments().then(function(){
      if(deepCmt){toggleSidebar(true);renderComments()}
    });
    // A backgrounded tab whose socket the network quietly dropped would otherwise sit
    // on a stale rail until reload — re-read on wake, same as on reconnect.
    document.addEventListener("visibilitychange",function(){
      if(document.visibilityState==="visible"&&ws&&ws.readyState===1)loadComments();
    });
  })();
